(function() {
    'use strict';

    angular
      .module('lms', ['oc.lazyLoad', 'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toaster', 'LocalStorageModule', 'angular-ladda', 'oitozero.ngSweetAlert'])

      .service('APIInterceptor', function ($injector) {
          var service = {};
          var isMyDomain = function (url) {
              var $location = $injector.get('$location');
              return url.indexOf($location.protocol() + "://" + $location.host()) >= 0;
          };
          service.modalInstance = null;
          service.loginQueue = [];
          service.responseError = function (response) {
              var $q = $injector.get('$q');
              if (response.status == 401) {
                  if (!response.config.url.startsWith("http") || isMyDomain(response.config.url)) {
                      var deferred = $q.defer();
                      if (!service.modalInstance) {
                          service.loginQueue = [];
                          var $uibModal = $injector.get('$uibModal');
                          service.modalInstance = $uibModal.open({
                              animation: true,
                              templateUrl: 'app/auth/signin.modal.html',
                              controller: 'SignInModalController',
                              controllerAs: 'signinModal',
                              size: 'sm',
                              backdrop: 'static',
                              resolve: {
                                  loginQueue: function () {
                                      return service.loginQueue;
                                  }
                              }
                          });
                          service.modalInstance.result.then(function () {
                              service.modalInstance = null;
                          });
                      }
                      var item = {
                          deferred: deferred,
                          config: response.config
                      };
                      service.loginQueue.push(item);
                      return deferred.promise;
                  }
                  else
                      return $q.reject(response);
              }
              else
                  return $q.reject(response);
          }

          return service;
      })

      .config(function ($httpProvider) {
          $httpProvider.interceptors.push('APIInterceptor');
      })

      .config(function(localStorageServiceProvider) {
          localStorageServiceProvider
            .setStorageType('localStorage')
            .setPrefix('lms');
      });

})();

/*!
 *  opentok-whiteboard (http://github.com/aullman/opentok-whiteboard)
 *
 *  Shared Whiteboard that works with OpenTok
 *
 *  @Author: Adam Ullman (http://github.com/aullman)
 *  @Copyright (c) 2014 Adam Ullman
 *  @License: Released under the MIT license (http://opensource.org/licenses/MIT)
**/
angular.module('lms')
    //.directive('otWhiteboard', function (OTSession, $window) {
    .directive('otWhiteboard', function ($window, $timeout) {
    return {
        restrict: 'E',
        templateUrl: 'app/components/directives/opentok-whiteboard/opentok-whiteboard.html',
        scope: { onDraw: '&' },
        link: function (scope, element, attrs) {
            var OTSession = null,
                p = paper,
                ng = angular,
                canvas = element.context.querySelector("canvas"),
                select = element.context.querySelector("select"),
                input = element.context.querySelector("input"),
                client = {dragging:false},
                count = 0, //Grabs the total count of each continuous stroke
                undoStack = [], //Stores the value of start and count for each continuous stroke
                redoStack = [], //When undo pops, data is sent to redoStack
                pathStack = [],
                drawHistory = [],
                drawHistoryReceivedFrom,
                drawHistoryReceived,
                batchUpdates = [],
                resizeTimeout,
                iOS = /(iPad|iPhone|iPod)/g.test( navigator.userAgent );

            // Create an empty project and a view for the canvas
            p.setup(canvas);

            // Set canvas size
            canvas.width = attrs.width || element.width();
            canvas.height = attrs.height || element.height();
            //canvas.width = element.offsetWidth;
            //canvas.height = element.offsetHeight;

            // Set paper.js view size
            p.view.viewSize = new p.Size(canvas.width, canvas.height);
            p.view.draw();
            scope.captureText = iOS ? 'Email' : 'Capture';

            scope.strokeCap = 'round';
            scope.strokeJoin = 'round';
            scope.lineWidth = 2;

            var clearCanvas = function () {
                p.project.clear();
                p.view.update();
                drawHistory = [];
                pathStack = [];
                undoStack = [];
                redoStack = [];
                count = 0;
            };

            scope.color = '#000';
            scope.fillcolor = '#000';
            scope.drawTool = 'freehand';

            scope.clear = function () {
                clearCanvas();
                if (OTSession && OTSession.session) {
                    OTSession.session.signal({
                        type: 'otWhiteboard_clear'
                    });
                }
            };

            scope.erase = function () {
                scope.erasing = true;
            };

            scope.capture = function () {
                if (iOS) {
                    // On iOS you can put HTML in a mailto: link
                    $window.location.href = "mailto:?subject=Whiteboard&Body=<img src='" + canvas.toDataURL('image/png') + "'>";
                } else {
                    // We just open the image in a new window
                    $window.open(canvas.toDataURL('image/png'));
                }
            };

            scope.undo = function () {
                if (!undoStack.length)
                    return;
                var uuid = undoStack.pop();
                undoWhiteBoard(uuid);
                sendUpdate('otWhiteboard_undo', uuid);
            };

            var undoWhiteBoard = function (uuid) {
                redoStack.push(uuid);
                pathStack.forEach(function(path) {
                    if (path.uuid === uuid) {
                        path.visible = false;
                        p.view.update();
                    }
                });
                drawHistory.forEach(function(update) {
                  if (update.uuid === uuid) {
                    update.visible = false;
                  }
                });
            };

            scope.redo = function () {
                if (!redoStack.length)
                    return;
                var uuid = redoStack.pop();
                redoWhiteBoard(uuid);
                sendUpdate('otWhiteboard_redo', uuid);
            };

            var redoWhiteBoard = function (uuid) {
                undoStack.push(uuid);
                pathStack.forEach(function(path) {
                    if (path.uuid === uuid) {
                        path.visible = true;
                        p.view.update();
                    }
                });
                drawHistory.forEach(function(update) {
                  if (update.uuid === uuid) {
                    update.visible = true;
                  }
                });
            };

            var tempShape = null;

            var getLine = function (update) {
                var from = new p.Point(update.fromX, update.fromY);
                var to = new p.Point(update.toX, update.toY);
                var shape = new p.Path.Line(from, to);
                shape.strokeColor = update.color;
                return shape;
            };

            var getRectangle = function (update) {
                var from = new p.Point(update.fromX, update.fromY);
                var to = new p.Point(update.toX, update.toY);
                var shape = new p.Path.Rectangle(from, to);
                if (update.drawTool == 'rect-fill') shape.fillColor = update.fillcolor;
                shape.strokeColor = update.color;
                return shape;
            };

            var getCircle = function (update) {
                var point = new p.Point(update.fromX, update.fromY);
                var diffX = update.toX - update.fromX;
                var diffY = update.toY - update.fromY;
                var radius = Math.sqrt((diffX * diffX) + (diffY * diffY));
                var shape = new p.Path.Circle({
                    center: point,
                    radius: radius,
                    strokeColor: update.color
                });
                if (update.drawTool == 'circle-fill') shape.fillColor = update.fillcolor;
                return shape;
            };

            var draw = function (update) {
                drawHistory.push(update);

                switch (update.event) {
                    case 'start':
                        if (update.mode == 'shape') {
                            if (tempShape) tempShape.visible = false;
                        } else {
                            var path = new p.Path();

                            path.selected = false;
                            path.strokeColor = update.color;
                            path.strokeWidth = scope.lineWidth;
                            path.strokeCap = scope.strokeCap;
                            path.strokeJoin = scope.strokeJoin;
                            path.uuid = update.uuid;

                            if (update.mode === 'eraser') {
                                path.blendMode = 'destination-out';
                                path.strokeWidth = 50;
                            }

                            if (ng.isDefined(update.visible)) {
                                path.visible = update.visible;
                            }

                            var start = new p.Point(update.fromX, update.fromY);
                            path.moveTo(start);

                            pathStack.push(path);
                            p.view.draw();
                        }
                        break;
                    case 'drag':
                        if (update.mode == 'shape') {
                            if (tempShape) tempShape.visible = false;
                            if (update.drawTool == 'line') {
                                tempShape = getLine(update);
                            } else if (update.drawTool == 'rect' || update.drawTool == 'rect-fill') {
                                tempShape = getRectangle(update);
                            } else if (update.drawTool == 'circle' || update.drawTool == 'circle-fill') {
                                tempShape = getCircle(update);
                            }
                            tempShape.uuid = update.uuid;
                        } else {
                            pathStack.forEach(function (path) {
                                if (path.uuid === update.uuid) {
                                    path.add(update.toX, update.toY);
                                    p.view.draw();
                                }
                            });
                        }
                        break;
                    case 'end':
                        if (update.mode == 'shape') {
                            var finalShape;
                            if (tempShape) tempShape.visible = false;
                            if (update.drawTool == 'line') {
                                finalShape = getLine(update);
                            } else if (update.drawTool == 'rect' || update.drawTool == 'rect-fill') {
                                finalShape = getRectangle(update);
                            } else if (update.drawTool == 'circle' || update.drawTool == 'circle-fill') {
                                finalShape = getCircle(update);
                            }
                            finalShape.uuid = update.uuid;
                            pathStack.push(finalShape);
                            undoStack.push(finalShape.uuid);
                        } else {
                            pathStack.forEach(function (path) {
                                if (path.uuid === update.uuid) {
                                    undoStack.push(path.uuid);
                                    path.simplify();
                                    p.view.draw();
                                }
                            });
                        }
                        break;
                }
            };

            var drawUpdates = function (updates) {
                updates.forEach(function (update) {
                    draw(update);
                });
            };

            var batchSignal = function (type, data, toConnection) {
                // We send data in small chunks so that they fit in a signal
                // Each packet is maximum ~250 chars, we can fit 8192/250 ~= 32 updates per signal
                var dataCopy = data.slice();
                var signalError = function (err) {
                  if (err) {
                    TB.error(err);
                  }
                };
                while(dataCopy.length) {
                    var dataChunk = dataCopy.splice(0, Math.min(dataCopy.length, 32));
                    var signal = {
                        type: type,
                        data: angular.toJson(dataChunk)
                    };
                    if (toConnection) signal.to = toConnection;
                    if (OTSession) OTSession.session.signal(signal, signalError);
                }
            };

            var updateTimeout;
            var updateBuffer = [];
            var sendUpdate = function (type, update, toConnection) {
                updateBuffer.push(update);
                if (update.event == 'end') {
                    scope.onDraw({ drawing: { type: 'freehand', paths: updateBuffer } });
                    updateBuffer = [];
                }
                if (OTSession && OTSession.session) {
                    batchUpdates.push(update);
                    if (!updateTimeout) {
                        updateTimeout = $timeout(function () {
                            batchSignal(type, batchUpdates, toConnection);
                            batchUpdates = [];
                            updateTimeout = null;
                        }, 100);
                    }
                }
            };

            var requestHistory = function() {
                if (OTSession)
                    OTSession.session.signal({
                        type: 'otWhiteboard_request_history'
                    });
            };

            ng.element(document).on('keyup', function (event) {
                if (event.ctrlKey) {
                    if (event.keyCode === 90)
                        scope.undo();
                    if (event.keyCode === 89)
                        scope.redo();
                }
            });

            /*
             *    The Nuts
             *    During the process of drawing, we collect coordinates on every [mouse|touch]move event.
             *    These events occur as fast as the browser can create them, and is computer/browser dependent
             *
             */

            ng.element(canvas).on('mousedown mousemove mouseup mouseout touchstart touchmove touchend touchcancel',

              function (event) {
                if ((event.type === 'mousemove' || event.type === 'touchmove' || event.type === 'mouseout') && !client.dragging) {
                    // Ignore mouse move Events if we're not dragging
                    return;
                }

                event.preventDefault();

                var offset = ng.element(canvas).offset(),
                    scaleX = canvas.width / element.width(),
                    scaleY = canvas.height / element.height(),
                    offsetX = event.offsetX || event.originalEvent.pageX - offset.left ||
                       event.originalEvent.touches[0].pageX - offset.left,
                    offsetY = event.offsetY || event.originalEvent.pageY - offset.top ||
                       event.originalEvent.touches[0].pageY - offset.top,
                    x = offsetX * scaleX,
                    y = offsetY * scaleY,
                    mode = scope.drawTool == 'line' || scope.drawTool == 'rect' || scope.drawTool == 'rect-fill' || scope.drawTool == 'circle' || scope.drawTool == 'circle-fill' ? 'shape' : scope.drawTool == 'eraser' ? 'eraser' : 'pen',
                    drawTool = scope.drawTool,
                    update;

                switch (event.type) {
                case 'mousedown':
                case 'touchstart':
                    // Start dragging
                    client.dragging = true;

                    client.lastX = x;
                    client.lastY = y;

                    client.uuid = parseInt(x) + parseInt(y) + Math.random().toString(36).substring(2);

                    update = {
                        /*id: OTSession && OTSession.session && OTSession.session.connection &&
                            OTSession.session.connection.connectionId,*/
                        uuid: client.uuid,
                        fromX: client.lastX,
                        fromY: client.lastY,
                        mode: mode,
                        drawTool: drawTool,
                        color: scope.color,
                        fillcolor: scope.fillcolor,
                        event: 'start'
                    };

                    draw(update);
                    if (mode != 'shape') sendUpdate('otWhiteboard_update', update);
                    break;
                case 'mousemove':
                case 'touchmove':
                    offsetX = event.offsetX || event.originalEvent.pageX - offset.left ||
                        event.originalEvent.touches[0].pageX - offset.left,
                    offsetY = event.offsetY || event.originalEvent.pageY - offset.top ||
                        event.originalEvent.touches[0].pageY - offset.top,
                    x = offsetX * scaleX,
                    y = offsetY * scaleY;

                    if (client.dragging) {
                        // Build update object
                        if (mode == 'shape')
                            update = {
                                /*id: OTSession && OTSession.session && OTSession.session.connection &&
                                    OTSession.session.connection.connectionId,*/
                                uuid: client.uuid,
                                fromX: client.lastX,
                                fromY: client.lastY,
                                toX: x,
                                toY: y,
                                mode: mode,
                                drawTool: drawTool,
                                color: scope.color,
                                fillcolor: scope.fillcolor,
                                event: 'drag'
                            };
                        else {
                            update = {
                                /*id: OTSession && OTSession.session && OTSession.session.connection &&
                                    OTSession.session.connection.connectionId,*/
                                uuid: client.uuid,
                                fromX: client.lastX,
                                fromY: client.lastY,
                                toX: x,
                                toY: y,
                                event: 'drag'
                            };
                            client.lastX = x;
                            client.lastY = y;
                        }
                        count++;
                        redoStack = [];
                        draw(update);
                        if (mode != 'shape') sendUpdate('otWhiteboard_update', update);
                    }
                    break;
                case 'touchcancel':
                case 'mouseup':
                case 'touchend':
                case 'mouseout':
                    if (count) {
                        if (mode == 'shape')
                            update = {
                                /*id: OTSession && OTSession.session && OTSession.session.connection &&
                                    OTSession.session.connection.connectionId,*/
                                uuid: client.uuid,
                                fromX: client.lastX,
                                fromY: client.lastY,
                                toX: x,
                                toY: y,
                                mode: mode,
                                drawTool: drawTool,
                                color: scope.color,
                                fillcolor: scope.fillcolor,
                                event: 'end'
                            };
                        else
                            update = {
                                /*id: OTSession && OTSession.session && OTSession.session.connection &&
                                    OTSession.session.connection.connectionId,*/
                                uuid: client.uuid,
                                event: 'end'
                            };

                        draw(update);
                        sendUpdate('otWhiteboard_update', update);
                    }

                    client.dragging = false;
                    client.uuid = false;
                }
            });

            scope.$on('apply-drawings', function (event, args) {
                _.each(_.pluck(args.drawings, "drawingJson"), function (item) {
                    var drawing = angular.fromJson(item);
                    drawUpdates(drawing.paths);
                });
            });

            if (OTSession && OTSession.session) {
                if (OTSession.session.isConnected()) {
                  requestHistory();
                }
                OTSession.session.on({
                    sessionConnected: function() {
                      requestHistory();
                    },
                    'signal:otWhiteboard_update': function (event) {
                        if (event.from.connectionId !== OTSession.session.connection.connectionId) {
                            drawUpdates(angular.fromJson(event.data));
                            scope.$emit('otWhiteboardUpdate');
                        }
                    },
                    'signal:otWhiteboard_undo': function (event) {
                        if (event.from.connectionId !== OTSession.session.connection.connectionId) {
                            angular.fromJson(event.data).forEach(function (data) {
                                undoWhiteBoard(data);
                            });
                            scope.$emit('otWhiteboardUpdate');
                        }
                    },
                    'signal:otWhiteboard_redo': function (event) {
                        if (event.from.connectionId !== OTSession.session.connection.connectionId) {
                            angular.fromJson(event.data).forEach(function (data) {
                                redoWhiteBoard(data);
                            });
                            scope.$emit('otWhiteboardUpdate');
                        }
                    },
                    'signal:otWhiteboard_history': function (event) {
                        // We will receive these from everyone in the room, only listen to the first
                        // person. Also the data is chunked together so we need all of that person's
                        if (!drawHistoryReceivedFrom || drawHistoryReceivedFrom === event.from.connectionId) {
                            drawHistoryReceivedFrom = event.from.connectionId;
                            drawUpdates(angular.fromJson(event.data));
                            scope.$emit('otWhiteboardUpdate');
                        }
                    },
                    'signal:otWhiteboard_clear': function (event) {
                        if (event.from.connectionId !== OTSession.session.connection.connectionId) {
                            clearCanvas();
                        }
                    },
                    'signal:otWhiteboard_request_history': function (event) {
                        if (drawHistory.length > 0) {
                            batchSignal('otWhiteboard_history', drawHistory, event.connection);
                        }
                    }
                });
            }
        }
    };
});

'use strict';

angular.module('lms')
    .controller('StudentModalController', function ($uibModalInstance, $state, ManageService, user, departments) {
        var vm = this;
        vm.genders = ['', 'M', 'F'];
        vm.titles = ManageService.getTitles();
        vm.isEducator = false;
        vm.user = angular.copy(user);
        vm.departments = departments;
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (vm.user.departments) delete vm.user.departments;
            if (vm.user.groups) delete vm.user.groups;
            if (!user.userId) {
                ManageService.createStudent(vm.user).then(function (resp) {
                    vm.saving = false;
                    vm.user.userId = resp.id;
                    vm.user.departments = _.filter(vm.departments, function (dept) { return vm.user.departmentIds.indexOf(dept.departmentId) >= 0; });
                    vm.user.groups = _.filter(vm.groups, function (group) { return vm.user.groupIds.indexOf(group.departmentGroupId) >= 0; });
                    form.$submitted = false;
                    $uibModalInstance.close({ student: vm.user });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editStudent(vm.user).then(function (resp) {
                    vm.saving = false;
                    vm.user.departments = _.filter(vm.departments, function (dept) { return vm.user.departmentIds.indexOf(dept.departmentId) >= 0; });
                    vm.user.groups = _.filter(vm.groups, function (group) { return vm.user.groupIds.indexOf(group.departmentGroupId) >= 0; });
                    form.$submitted = false;
                    $uibModalInstance.close({ student: vm.user });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.onDepartmentsChanged = function () {
            if (!vm.user.departmentIds || (vm.user.departmentIds && vm.user.departmentIds.length == 0)) {
                vm.groups = [];
                vm.user.groups = [];
                vm.user.groupIds = [];
            } else {
                ManageService.getGroups(vm.user.departmentIds).then(function (groups) {
                    vm.groups = groups;
                    var respGroupIds = _.pluck(vm.groups, "departmentGroupId");
                    vm.user.groups = _.filter(vm.user.groups, function (group) { return respGroupIds.indexOf(group.departmentGroupId) >= 0; });
                    vm.user.groupIds = _.pluck(vm.user.groups, "departmentGroupId");
                }, function () {

                });
            }
        };
        vm.onDepartmentsChanged();
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('ParentsModalController', function ($uibModalInstance, $state, SweetAlert, ManageService, studentId) {
        var vm = this;
        vm.genders = ['', 'M', 'F'];
        vm.addParent = function () {
            vm.parents.push({ inEdit: true, gender: '' });
        };
        vm.loaded = false;
        vm.studentId = studentId;
        ManageService.getParents(studentId).then(function (parents) {
            if (parents) vm.parents = parents; else vm.parents = [];
            if (vm.parents.length == 0) vm.addParent();
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
        });
        vm.parentBackups = {};
        vm.editParent = function (parent) {
            if (parent.parentId) vm.parentBackups[parent.parentId] = angular.copy(parent);
            parent.inEdit = true;
        };
        vm.cancelEditParent = function (index, parent) {
            parent.inEdit = false;
            if (parent.parentId && vm.parentBackups[parent.parentId]) vm.parents[index] = angular.copy(vm.parentBackups[parent.parentId]);
        };
        vm.removeParent = function (index, parent) {
            SweetAlert.swal({
                title: "Are you sure you wish to remove this parent/guardian?",
                text: "This is an irreversible process",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, remove it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    parent.deleting = true;
                    if (parent.parentId) {
                        ManageService.deleteParent(vm.studentId, parent.parentId).then(function (resp) {
                            vm.parents.splice(index, 1);
                        }, function () {
                        });
                    } else vm.parents.splice(index, 1);
                }
            });
        };
        vm.saveParent = function (form, parent) {
            if (!form.$valid) return;
            parent.saving = true;
            if (parent.parentId) {
                ManageService.editParent(vm.studentId, parent).then(function (resp) {
                    parent.saving = false;
                    parent.inEdit = false;
                    vm.parentBackups[parent.parentId] = angular.copy(parent);
                }, function () {
                    parent.saving = false;
                });
            } else {
                ManageService.createParent(vm.studentId, parent).then(function (resp) {
                    parent.parentId = resp.id;
                    parent.saving = false;
                    parent.inEdit = false;
                    vm.parentBackups[parent.parentId] = angular.copy(parent);
                }, function () {
                    parent.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageUsersController', function ($uibModal, $timeout, ManageService) {
        var vm = this;
        vm.pageSize = 10;
        vm.opening = false;
        vm.openSection = "";
        vm.closeSection = function () {
            vm.openSection = "";
        };
        vm.historyStack = [];
        vm.goBack = function () {
            if (vm.historyStack.length)
                vm.openSection = vm.historyStack.pop();
        };

        vm.currentPage = {
            Department: { Educators: 1, Groups: 1, Students: 1 },
            Educator: { Departments: 1 },
            Group: { Students: 1 },
            Student: { Departments: 1 }
        };

        vm.loadPage = function (tab, id, list) {
            ManageService.loadPage(tab, id, list, vm.currentPage[tab][list]).then(function (resp) {
                vm[tab.toLowerCase()][list.toLowerCase()] = resp.list;
                vm[tab.toLowerCase()][list.toLowerCase() + "Count"] = resp.count;
            }, function () {
            });
        };

        vm.uploading = { };
        vm.uploadCsv = function (type) {
            vm.uploading[type] = true;
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/csv.import.modal.html',
                controller: 'CsvImportModalController',
                controllerAs: 'csvModalCtrl',
                backdrop: 'static',
                resolve: {
                    type: function () { return type },
                    file: function () { return vm[type.toLowerCase() + 'Csv'] }
                }
            });
            modal.result.then(function (result) {
                delete vm[type.toLowerCase() + 'Csv'];
                vm.uploading[type] = false;
                vm['get' + type](true);
            });
        };

        //Department tab functions
        vm.loadingDepartments = true;
        vm.getDepartments = function () {
            ManageService.getDepartments().then(function (departments) {
                vm.departments = departments;
                vm.loadingDepartments = false;
            }, function () {
                vm.loadingDepartments = false;
            });
        };
        vm.getDepartments();
        vm.department = null;
        vm.openDepartment = function (id) {
            vm.openSection = "Department";
            if (vm.department && vm.department.departmentId == id)
                return;
            vm.opening = true;
            ManageService.getDepartment(id).then(function (department) {
                vm.department = department;
                vm.opening = false;
            }, function () {
                vm.opening = false;
            });
        };
        vm.newDepartment = function () {
            vm.editDepartment({});
        };
        vm.editDepartment = function (department) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/department.modal.html',
                controller: 'DepartmentModalController',
                controllerAs: 'deptCtrl',
                resolve: {
                    department: function () { return department }
                }
            });
            modal.result.then(function (result) {
                vm.department = result.department;
                var listItem = _.find(vm.departments, function (item) {
                    return item.departmentId == vm.department.departmentId;
                });
                if (listItem) vm.departments[vm.departments.indexOf(listItem)] = vm.department;
                else vm.departments.push(vm.department);
            });
        };

        //Educator tab functions
        vm.loadingEducators = true;
        vm.getEducators = function (force) {
            if (force || !vm.educators) {
                ManageService.getEducators().then(function (educators) {
                    vm.educators = educators;
                    vm.loadingEducators = false;
                }, function () {
                    vm.loadingEducators = false;
                });
            }
        };
        vm.educator = null;
        vm.openEducator = function (id) {
            vm.openSection = "Educator";
            if (vm.educator && vm.educator.userId == id)
                return;
            vm.opening = true;
            ManageService.getEducator(id).then(function (educator) {
                vm.educator = educator;
                vm.opening = false;
            }, function () {
                vm.opening = false;
            });
        };
        vm.newEducator = function () {
            vm.editEducator({});
        };
        vm.editEducator = function (educator) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/user.modal.html',
                controller: 'EducatorModalController',
                controllerAs: 'userCtrl',
                resolve: {
                    user: function () { return educator },
                    departments: function () { return vm.departments },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                vm.educator = result.educator;
                var listItem = _.find(vm.educators, function (item) {
                    return item.userId == vm.educator.userId;
                });
                if (listItem) vm.educators[vm.educators.indexOf(listItem)] = vm.educator;
                else vm.educators.push(vm.educator);
            });
        };

        //Classes/Batches tab functions
        vm.loadingGroups = true;
        vm.getGroups = function (force) {
            if (force || !vm.groups) {
                ManageService.getGroups().then(function (groups) {
                    vm.groups = groups;
                    vm.loadingGroups = false;
                }, function () {
                    vm.loadingGroups = false;
                });
            }
        };
        vm.group = null;
        vm.openGroup = function (id) {
            vm.openSection = "Group";
            if (vm.group && vm.group.departmentGroupId == id)
                return;
            vm.opening = true;
            ManageService.getGroup(id).then(function (group) {
                vm.group = group;
                vm.opening = false;
            }, function () {
                vm.opening = false;
            });
        };
        vm.newGroup = function () {
            vm.editGroup({});
        };
        vm.editGroup = function (group) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/group.modal.html',
                controller: 'GroupModalController',
                controllerAs: 'groupCtrl',
                resolve: {
                    group: function () { return group },
                    departments: function () { return vm.departments },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'ui.select',
                                files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                            },
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                vm.group = result.group;
                var listItem = _.find(vm.groups, function (item) {
                    return item.departmentGroupId == vm.group.departmentGroupId;
                });
                if (listItem) vm.groups[vm.groups.indexOf(listItem)] = vm.group;
                else vm.groups.push(vm.group);
            });
        };

        //Student tab functions
        vm.loadingStudents = true;
        vm.getStudents = function (force) {
            if (force || !vm.students) {
                ManageService.getStudents().then(function (students) {
                    vm.students = students;
                    vm.loadingStudents = false;
                }, function () {
                    vm.loadingStudents = false;
                });
            }
        };
        vm.student = null;
        vm.openStudent = function (id) {
            vm.openSection = "Student";
            if (vm.student && vm.student.userId == id)
                return;
            vm.opening = true;
            ManageService.getStudent(id).then(function (student) {
                vm.student = student;
                vm.opening = false;
            }, function () {
                vm.opening = false;
            });
        };
        vm.newStudent = function () {
            vm.editStudent({});
        };
        vm.editStudent = function (student) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/user.modal.html',
                controller: 'StudentModalController',
                controllerAs: 'userCtrl',
                resolve: {
                    user: function () { return student },
                    departments: function () { return vm.departments },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'ui.select',
                                files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                            },
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                vm.student = result.student;
                var listItem = _.find(vm.students, function (item) {
                    return item.userId == vm.student.userId;
                });
                if (listItem) vm.students[vm.students.indexOf(listItem)] = vm.student;
                else vm.students.push(vm.student);
            });
        };
        vm.editParents = function (studentId) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/parents.modal.html',
                controller: 'ParentsModalController',
                controllerAs: 'parentsCtrl',
                resolve: {
                    studentId: function () { return studentId },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                
            });
        };
        vm.editAddresses = function (studentId) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/addresses.modal.html',
                controller: 'AddressesModalController',
                controllerAs: 'addressesCtrl',
                resolve: {
                    studentId: function () { return studentId },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {

            });
        };

        //Educators Autocomplete
        vm.taEducatorsCache = {};
        vm.taEducators = [];
        vm.taEducatorsSearchTimeout = null;
        vm.latesttaEducatorsSearchTerm = "";
        vm.taDeptEducators = [];
        vm.getTAEducators = function (searchTerm) {
            if (searchTerm) {
                vm.latesttaEducatorsSearchTerm = searchTerm;
                if (vm.taEducatorsSearchTimeout) $timeout.cancel(vm.taEducatorsSearchTimeout);
                if (vm.taEducatorsCache[searchTerm]) vm.taEducators = vm.taEducatorsCache[searchTerm];
                else {
                    vm.taEducatorsSearchTimeout = $timeout(function (searchTerm) {
                        ManageService.getTAEducators(searchTerm).then(function (resp) {
                            if (vm.latesttaEducatorsSearchTerm == searchTerm)
                                vm.taEducators = resp;
                            vm.taEducatorsCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };

        vm.onTAEducatorSelect = function () {
            var existIds = _.pluck(vm.department.educators, "userId");
            var taDeptEducators = _.filter(vm.taDeptEducators, function (educ) { return existIds.indexOf(educ.userId) < 0; });
            if (taDeptEducators.length > 0) {
                var userIds = _.pluck(taDeptEducators, "userId");
                vm.department.educators = vm.department.educators.concat(taDeptEducators);
                vm.department.educatorsCount += taDeptEducators.length;
                ManageService.addDepartmentEducators(vm.department.departmentId, userIds).then(function (resp) {
                }, function () {
                });
            }
            vm.taDeptEducators = [];
        };

        //Students Autocomplete
        vm.taStudentsCache = {};
        vm.taStudents = [];
        vm.taStudentsSearchTimeout = null;
        vm.latesttaStudentsSearchTerm = "";
        vm.taDeptStudents = [];
        vm.getTAStudents = function (searchTerm) {
            if (searchTerm) {
                vm.latesttaStudentsSearchTerm = searchTerm;
                if (vm.taStudentsSearchTimeout) $timeout.cancel(vm.taStudentsSearchTimeout);
                if (vm.taStudentsCache[searchTerm]) vm.taStudents = vm.taStudentsCache[searchTerm];
                else {
                    vm.taStudentsSearchTimeout = $timeout(function (searchTerm) {
                        ManageService.getTAStudents(searchTerm).then(function (resp) {
                            if (vm.latesttaStudentsSearchTerm == searchTerm)
                                vm.taStudents = resp;
                            vm.taStudentsCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };

        vm.onDeptTAStudentSelect = function () {
            var existIds = _.pluck(vm.department.students, "userId");
            var taDeptStudents = _.filter(vm.taDeptStudents, function (stud) { return existIds.indexOf(stud.userId) < 0; });
            if (taDeptStudents.length > 0) {
                var userIds = _.pluck(taDeptStudents, "userId");
                vm.department.students = vm.department.students.concat(taDeptStudents);
                vm.department.studentsCount += taDeptStudents.length;
                ManageService.addDepartmentStudents(vm.department.departmentId, userIds).then(function (resp) {
                }, function () {
                });
            }
            vm.taDeptStudents = [];
        };

        vm.onGroupTAStudentSelect = function () {
            var existIds = _.pluck(vm.group.students, "userId");
            var taDeptStudents = _.filter(vm.taDeptStudents, function (stud) { return existIds.indexOf(stud.userId) < 0; });
            if (taDeptStudents.length > 0) {
                var userIds = _.pluck(taDeptStudents, "userId");
                vm.group.students = vm.group.students.concat(taDeptStudents);
                vm.group.studentsCount += taDeptStudents.length;
                if (vm.department.departmentId == vm.group.departmentId) {
                    var existIdsInDept = _.pluck(vm.department.students, "userId");
                    var taNewStudents = _.filter(vm.taDeptStudents, function (stud) { return existIdsInDept.indexOf(stud.userId) < 0; });
                    if (taNewStudents.length > 0) {
                        vm.department.students = vm.department.students.concat(taNewStudents);
                        vm.department.studentsCount += taNewStudents.length;
                    }
                }
                ManageService.addGroupStudents(vm.group.departmentGroupId, userIds).then(function (resp) {
                }, function () {
                });
            }
            vm.taDeptStudents = [];
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageAdminsController', function ($uibModal, ManageService) {
        var vm = this;
        vm.loadingAdmins = true;
        vm.getAdmins = function () {
            if (!vm.admins) {
                ManageService.getAdmins().then(function (admins) {
                    vm.admins = admins;
                    vm.loadingAdmins = false;
                }, function () {
                    vm.loadingAdmins = false;
                });
            }
        };
        vm.getAdmins();
        vm.admin = null;
        vm.openAdmin = function (id) {
            vm.opening = true;
            ManageService.getAdmin(id).then(function (admin) {
                vm.admin = admin;
                vm.editAdmin(admin);
                vm.opening = false;
            }, function () {
                vm.opening = false;
            });
        };
        vm.newAdmin = function () {
            vm.editAdmin({});
        };
        vm.editAdmin = function (admin) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/users/user.modal.html',
                controller: 'AdminModalController',
                controllerAs: 'userCtrl',
                resolve: {
                    user: function () { return admin }
                }
            });
            modal.result.then(function (result) {
                vm.admin = result.admin;
                var listItem = _.find(vm.admins, function (item) {
                    return item.userId == vm.admin.userId;
                });
                if (listItem) vm.admins[vm.admins.indexOf(listItem)] = vm.admin;
                else vm.admins.push(vm.admin);
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('GroupModalController', function ($uibModalInstance, $state, ManageService, CourseService, group, departments) {
        var vm = this;
        vm.group = angular.copy(group);
        if (vm.group.courses) {
            vm.group.courseIds = _.pluck(vm.group.courses, "courseId");
            delete vm.group.courses;
        }
        else vm.group.courseIds = [];
        vm.departments = departments;
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (!group.departmentGroupId) {
                ManageService.createGroup(vm.group).then(function (resp) {
                    vm.saving = false;
                    vm.group.departmentGroupId = resp.id;
                    vm.group.studentCount = 0;
                    vm.group.departmentName = _.filter(vm.departments, function (dept) { return vm.group.departmentId == dept.departmentId; })[0].name;
                    vm.group.courses = _.filter(vm.courses, function (course) { return vm.group.courseIds.indexOf(course.courseId) >= 0; });
                    form.$submitted = false;
                    $uibModalInstance.close({ group: vm.group });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editGroup(vm.group).then(function (resp) {
                    vm.saving = false;
                    vm.group.departmentName = _.filter(vm.departments, function (dept) { return vm.group.departmentId == dept.departmentId; })[0].name;
                    vm.group.courses = _.filter(vm.courses, function (course) { return vm.group.courseIds.indexOf(course.courseId) >= 0; });
                    form.$submitted = false;
                    $uibModalInstance.close({ group: vm.group });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.onDepartmentChanged = function () {
            if (!vm.group.departmentId)
                vm.courses = [];
            else {
                CourseService.getAllInDepartment(vm.group.departmentId).then(function (courses) {
                    vm.courses = courses;
                }, function () {

                });
            }
        };
        vm.onDepartmentChanged();
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('EducatorModalController', function ($uibModalInstance, $state, ManageService, user, departments) {
        var vm = this;
        vm.genders = ['', 'M', 'F'];
        vm.titles = ManageService.getTitles();
        vm.isEducator = true;
        vm.user = angular.copy(user);
        vm.departments = departments;
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (vm.user.departments) delete vm.user.departments;
            if (!user.userId) {
                ManageService.createEducator(vm.user).then(function (resp) {
                    vm.saving = false;
                    vm.user.userId = resp.id;
                    vm.user.departments = _.filter(vm.departments, function (dept) { return vm.user.departmentIds.indexOf(dept.departmentId) >= 0; });
                    form.$submitted = false;
                    $uibModalInstance.close({ educator: vm.user });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editEducator(vm.user).then(function (resp) {
                    vm.saving = false;
                    vm.user.departments = _.filter(vm.departments, function (dept) { return vm.user.departmentIds.indexOf(dept.departmentId) >= 0; });
                    form.$submitted = false;
                    $uibModalInstance.close({ educator: vm.user });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('DepartmentModalController', function ($uibModalInstance, $state, ManageService, department) {
        var vm = this;
        vm.department = angular.copy(department);
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (!department.departmentId) {
                ManageService.createDepartment(vm.department).then(function (resp) {
                    vm.saving = false;
                    vm.department.departmentId = resp.id;
                    form.$submitted = false;
                    $uibModalInstance.close({ department: vm.department });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editDepartment(vm.department).then(function (resp) {
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close({ department: vm.department });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('CsvImportModalController', function ($uibModalInstance, $state, ManageService, type, file) {
        var vm = this;
        vm.uploading = true;
        ManageService.uploadCsv(type, file).then(function (resp) {
            vm.result = resp;
            vm.uploading = false;
        }, function () {
            vm.uploading = false;
        });
        vm.cancel = function () {
            $uibModalInstance.close();
        };
    });
'use strict';

angular.module('lms')
    .controller('AdminModalController', function ($uibModalInstance, $state, ManageService, user) {
        var vm = this;
        vm.isAdmin = true;
        vm.user = angular.copy(user);
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (!user.userId) {
                ManageService.createAdmin(vm.user).then(function (resp) {
                    vm.saving = false;
                    vm.user.userId = resp.id;
                    form.$submitted = false;
                    $uibModalInstance.close({ admin: vm.user });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editAdmin(vm.user).then(function (resp) {
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close({ admin: vm.user });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('AddressesModalController', function ($uibModalInstance, $state, SweetAlert, ManageService, studentId) {
        var vm = this;
        vm.addAddress = function () {
            vm.addresses.push({ inEdit: true });
        };
        vm.loaded = false;
        vm.studentId = studentId;
        ManageService.getAddresses(studentId).then(function (addresses) {
            if (addresses) vm.addresses = addresses; else vm.addresses = [];
            if (vm.addresses.length == 0) vm.addAddress();
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
        });
        vm.addressBackups = {};
        vm.editAddress = function (address) {
            if (address.userAddressId) vm.addressBackups[address.userAddressId] = angular.copy(address);
            address.inEdit = true;
        };
        vm.cancelEditAddress = function (index, address) {
            address.inEdit = false;
            if (address.userAddressId && vm.addressBackups[address.userAddressId]) vm.addresses[index] = angular.copy(vm.addressBackups[address.userAddressId]);
        };
        vm.removeAddress = function (index, address) {
            SweetAlert.swal({
                title: "Are you sure you wish to remove this address?",
                text: "This is an irreversible process",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, remove it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    address.deleting = true;
                    if (address.userAddressId) {
                        ManageService.deleteAddress(vm.studentId, address.userAddressId).then(function (resp) {
                            vm.addresses.splice(index, 1);
                        }, function () {
                        });
                    } else vm.addresses.splice(index, 1);
                }
            });
        };
        vm.saveAddress = function (form, address) {
            if (!form.$valid) return;
            address.saving = true;
            if (address.userAddressId) {
                ManageService.editAddress(vm.studentId, address).then(function (resp) {
                    address.saving = false;
                    address.inEdit = false;
                    vm.addressBackups[address.userAddressId] = angular.copy(address);
                }, function () {
                    address.saving = false;
                });
            } else {
                ManageService.createAddress(vm.studentId, address).then(function (resp) {
                    address.userAddressId = resp.id;
                    address.saving = false;
                    address.inEdit = false;
                    vm.addressBackups[address.userAddressId] = angular.copy(address);
                }, function () {
                    address.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('NewTimetableModalController', function ($uibModalInstance, $state, TimetableService) {
        var vm = this;
        vm.saving = false;
        vm.timetable = {
            label: ""
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (vm.timetable.startDate) vm.timetable.startDate = moment(vm.timetable.startDate).format("YYYY-MM-DD");
            if (vm.timetable.endDate) vm.timetable.endDate = moment(vm.timetable.endDate).format("YYYY-MM-DD");
            TimetableService.create(vm.timetable).then(function (resp) {
                vm.timetable.timetableId = resp.id;
                vm.saving = false;
                form.$submitted = false;
                $uibModalInstance.close(vm.timetable);
            }, function () {
                vm.saving = false;
            });
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageTimetablesController', function ($uibModal, SweetAlert, $timeout, ManageService, TimetableService, CourseService) {
        var vm = this;
        vm.loaded = false;
        TimetableService.getAll().then(function (timetables) {
            timetables.push({timetableId:0,label:'Create new timetable...'});
            vm.timetables = timetables;
            ManageService.getDepartments().then(function (departments) {
                vm.departments = departments;
                vm.loaded = true;
            }, function () {
            });
        }, function () {
        });
        var loadTimeSlots = function (onSuccess) {
            TimetableService.getTimeSlots().then(function (timeSlots) {
                _.each(timeSlots, function (slot) {
                    if (slot.startTime.length > 5) slot.startTime = slot.startTime.substring(0, 5);
                    if (slot.endTime.length > 5) slot.endTime = slot.endTime.substring(0, 5);
                });
                vm.timeSlots = timeSlots;
                onSuccess();
            }, function () {
                vm.loadingTimetable = false;
            });
        }
        vm.timetableIdChanged = function () {
            if (vm.timetableId && vm.departmentId) vm.loadTimetable();
            else if (vm.timetableId == 0) {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/manage/timetables/new.timetable.modal.html',
                    controller: 'NewTimetableModalController',
                    controllerAs: 'newTimetableCtrl',
                    resolve: {
                        loadPlugin: function ($ocLazyLoad) {
                            return $ocLazyLoad.load([
                                {
                                    name: 'datePicker',
                                    files: ['/Styles/plugins/datapicker/angular-datapicker.css', '/Scripts/plugins/datapicker/angular-datepicker.min.js']
                                }
                            ]);
                        }
                    }
                });
                modal.result.then(function (result) {
                    vm.timetables.unshift(result);
                    vm.timetableId = result.timetableId;
                    if (vm.timetableId && vm.departmentId) vm.loadTimetable();
                });
            }
        };
        vm.departmentIdChanged = function () {
            if (vm.timetableId && vm.departmentId) vm.loadTimetable();
        };
        var doTimeslotMove = function (ui, source, dest) {
            var item = ui.item.sortable.moved;
            //var sourceIndex = ui.item.sortable.index;
            //var destIndex = ui.item.sortable.dropindex;
            TimetableService.updateCourseTime(item.courseTimeSlotId, { institutionTimeSlotId: dest.id, dayOfWeek: dest.day }).then(function (resp) {
            }, function () {
            });
        };
        vm.loadTimetable = function () {
            vm.loadingTimetable = true;
            if (vm.timeSlots) {
                TimetableService.getForDepartment(vm.timetableId, vm.departmentId).then(function (resp) {
                    vm.timetable = [];
                    _.each(vm.timeSlots, function (slot) {
                        var obj = {
                            id: slot.institutionTimeSlotId,
                            text: slot.startTime + " - " + slot.endTime,
                            shortName: slot.shortName,
                            nonAcademic: slot.nonAcademic,
                            days: []
                        };
                        for (var i = 0; i < 7; i++) {
                            obj.days.push({
                                day: i,
                                courses: [],
                                sortableOptions: {
                                    connectWith: ".items-container",
                                    items: "> .sortable",
                                    stop: (function (institutionTimeSlotId, day) {
                                        return function (e, ui) {
                                            doTimeslotMove(ui, { id: institutionTimeSlotId, day: day }, { id: parseInt(ui.item.sortable.droptarget[0].attributes["data-row-id"].value), day: parseInt(ui.item.sortable.droptarget[0].attributes["data-day"].value) });
                                        };
                                    })(slot.institutionTimeSlotId, i)
                                }
                            });
                        }
                        vm.timetable.push(obj);
                    });
                    var timetableDict = _.indexBy(vm.timetable, "id");
                    _.each(resp, function (item) {
                        if (item.groups.length) item.groupNames = _.pluck(item.groups, "name").join(', ');
                        timetableDict[item.institutionTimeSlotId].days[item.dayOfWeek].courses.push(item);
                    });
                    vm.loadingTimetable = false;
                }, function () {
                    vm.loadingTimetable = false;
                });
            } else {
                loadTimeSlots(vm.loadTimetable);
            }
        };
        vm.courses = {};
        vm.loadCourses = function () {
            if (!vm.courses[vm.departmentId]) {
                vm.loadingCourses = true;
                CourseService.getAllInDepartment(vm.departmentId).then(function (resp) {
                    vm.courses[vm.departmentId] = resp;
                    vm.loadingCourses = false;
                }, function () {
                    vm.loadingCourses = false;
                });
            }
        };
        vm.loadCourseNodes = function (course) {
            course.showNodes = true;
            if (!course.courseNodes) {
                course.loadingNodes = true;
                CourseService.getStructure(course.courseId).then(function (resp) {
                    var nodeArray = CourseService.parseStructure(resp);
                    course.courseNodes = CourseService.getFlatStructure(nodeArray);
                    course.loadingNodes = false;
                }, function () {
                    course.loadingNodes = false;
                });
            }
        };
        vm.addCourse = function (course, timeRow, day) {
            if (_.filter(day.courses, function (item) { return item.courseId == course.courseId && !item.courseNodeId }).length == 0) {
                var slot = { courseId: course.courseId, dayOfWeek: day.day, institutionTimeSlotId: timeRow.id };
                TimetableService.addCourseTime(vm.timetableId, slot).then(function (resp) {
                    slot.courseTimeSlotId = resp.id;
                    slot.courseName = course.name;
                    day.courses.push(slot);
                }, function () {
                });
            }
        };
        vm.addCourseNode = function (course, courseNode, timeRow, day) {
            if (_.filter(day.courses, function (item) { return item.courseNodeId && item.courseNodeId == courseNode.id }).length == 0) {
                var slot = { courseId: course.courseId, courseNodeId: courseNode.id, dayOfWeek: day.day, institutionTimeSlotId: timeRow.id };
                TimetableService.addCourseTime(vm.timetableId, slot).then(function (resp) {
                    slot.courseTimeSlotId = resp.id;
                    slot.courseName = course.name;
                    slot.node = courseNode;
                    day.courses.push(slot);
                }, function () {
                });
            }
        };
        vm.removeItem = function (list, index, courseTime) {
            SweetAlert.swal({
                title: "Are you sure you wish to delete this entry?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    TimetableService.removeCourseTime(courseTime.courseTimeSlotId).then(function (resp) {
                        list.splice(index, 1);
                    }, function () {
                    });
                }
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageThemesController', function (ManageService) {
        var vm = this;
        vm.newScript = {
            rawContent: '(function () {\n})();',
            enabled: true
        };
        vm.scriptTypes = [
            { text: "From Url", value: "Url" },
            { text: "Code Snippet", value: "Code" },
            { text: "Upload File", value: "File" }
        ];
        vm.codeEditorOptions = {
            lineNumbers: true,
            matchBrackets: true,
            styleActiveLine: true
        };
        vm.frequencyOptions = {
            min: 0,
            max: 99,
            step: 1,
            decimals: 0
        };
        vm.loaded = false;
        vm.loadingScripts = true;
        ManageService.getScripts().then(function (scripts) {
            vm.scripts = scripts;
            vm.loadingScripts = false;
            vm.loaded = true;
        }, function () {
            vm.loadingScripts = false;
            vm.loaded = true;
        });
        vm.scriptTypeSelected = function (selectedItem) {
            if (selectedItem.value == 'Url') {
                if (!vm.newScript.updateFrequencyDays) vm.newScript.updateFrequencyDays = 0;
            } else if (selectedItem.value == 'Code') {
                if (!vm.newScript.rawContent) vm.newScript.rawContent = '(function () {\n})();';
            }
        }
        vm.addNew = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (vm.newScript.type == 'Url') {
                delete vm.newScript.rawContent;
                delete vm.newScript.file;
                ManageService.saveUrlScript(vm.newScript).then(function (resp) {
                    vm.scripts.push(angular.extend({}, vm.newScript, resp));
                    vm.newScript = {
                        rawContent: '(function () {\n})();'
                    };
                    vm.saving = false;
                    form.$submitted = false;
                }, function () {
                    vm.saving = false;
                });
            } else if (vm.newScript.type == 'Code') {
                delete vm.newScript.externalUrl;
                delete vm.newScript.file;
                ManageService.saveRawScript(vm.newScript).then(function (resp) {
                    vm.scripts.push(angular.extend({}, vm.newScript, resp));
                    vm.newScript = {
                        rawContent: '(function () {\n})();'
                    };
                    vm.saving = false;
                    form.$submitted = false;
                }, function () {
                    vm.saving = false;
                });
            } else if (vm.newScript.type == 'File') {
                delete vm.newScript.externalUrl;
                delete vm.newScript.rawContent;
                var formdata = new FormData();
                formdata.append('file', vm.newScript.file);
                ManageService.uploadScript(formdata, vm.newScript, true).then(function (resp) {
                    vm.scripts.push(angular.extend({}, vm.newScript, resp));
                    vm.newScript = {
                        rawContent: '(function () {\n})();'
                    };
                    vm.saving = false;
                    form.$submitted = false;
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.editScript = function (item) {
            item.editing = true;
        };
        vm.cancelEditScript = function (item) {
            item.editing = false;
        };
        vm.saveScript = function (form, item) {
            if (!form.$valid) return;
            item.saving = true;
            if (item.type == 'Url') {
                ManageService.updateUrlScript(item.externalScriptId, { enabled: item.enabled, updateFrequencyDays: item.updateFrequencyDays, externalUrl: item.externalUrl }).then(function (resp) {
                    item.editing = false;
                    item.saving = false;
                    form.$submitted = false;
                }, function () {
                    item.saving = false;
                });
            } else if (item.type == 'Code') {
                ManageService.updateRawScript(item.externalScriptId, { enabled: item.enabled, rawContent: item.rawContent }).then(function (resp) {
                    item.editing = false;
                    item.saving = false;
                    form.$submitted = false;
                }, function () {
                    item.saving = false;
                });
            } else if (item.type == 'File') {
                var formdata = new FormData();
                if (item.file) formdata.append('file', item.file);
                ManageService.uploadScript(formdata, item, false).then(function (resp) {
                    item.fileSize = resp.fileSize;
                    item.editing = false;
                    item.saving = false;
                    form.$submitted = false;
                }, function () {
                    item.saving = false;
                });
            }
        };
        vm.uploadLogo = function ($event, main) {
            vm.savingLogo = true;
            ManageService.uploadLogo(vm.file).then(function (resp) {
                vm.logoUrl = resp.logoUrl;
                main.logo = resp.logoUrl;
                delete vm.file;
                vm.savingLogo = true;
            }, function () {
                vm.savingLogo = true;
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageSettingsController', function ($window, ManageService, DTOptionsBuilder, DTColumnDefBuilder, SweetAlert, toaster, $timeout, GlobalService) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDisplayLength(100)
            .withDOM('<"html5buttons"B>lTfgitp')
            .withButtons([
                { extend: 'copy' },
                { extend: 'csv', title: 'Grading' },
                { extend: 'excel', title: 'Grading' },
                { extend: 'pdf', title: 'Grading' },
                {
                    extend: 'print',
                    customize: function (win) {
                        angular.element(win.document.body).addClass('white-bg');
                        angular.element(win.document.body).css('font-size', '10px');
                        angular.element(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                }
            ]);
        vm.dtLiteOptions = DTOptionsBuilder.newOptions()
            .withDisplayLength(100);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable()
        ];
        vm.dtTSColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable().notVisible(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable()
        ];
        vm.spinOptions = {
            min: 0,
            max: 100,
            step: 1,
            boostat: 5,
            maxboostedstep: 10,
            postfix: '%'
        };
        vm.timeZones = [
            { id: 1, name: "Indian Standard Time (GMT +0530)" }
            /*{ id: 2, name: "Alaskan Standard Time (GMT -9)" },
            { id: 3, name: "Pacific Standard Time (GMT -8)" },
            { id: 4, name: "Mountain Standard Time (GMT -7)" },
            { id: 5, name: "Central Standard Time (GMT -6)" },
            { id: 6, name: "Eastern Standard Time (GMT -5)" }*/
        ];
        vm.locales = GlobalService.locales;
        vm.codeEditorOptions = {
            lineNumbers: true,
            matchBrackets: true,
            styleActiveLine: true
        };
        vm.loadingSettings = true;
        ManageService.getSettings().then(function (resp) {
            vm.settings = resp;
            vm.settingsBackup = angular.copy(resp);
            setGradeMinPoints();
            _.each(vm.settings.institutionTimeSlots, function (slot) {
                if (slot.startTime.length > 5) slot.startTime = slot.startTime.substring(0, 5);
                if (slot.endTime.length > 5) slot.endTime = slot.endTime.substring(0, 5);
            });
            if (vm.settings.institutionTimeSlots.length == 0)
                vm.addTimeSlot();
            vm.loadingSettings = false;
        }, function () {
            vm.loadingSettings = false;
        });
        var setGradeMinPoints = function () {
            _.each(vm.settings.institutionGrades, function (item, index) { item.minPoints = index == 0 ? 0 : vm.settings.institutionGrades[index - 1].maxPoints; });
        };
        vm.uploadLogo = function ($event, main) {
            vm.savingLogo = true;
            ManageService.uploadLogo(vm.file).then(function (resp) {
                vm.logoUrl = resp.logoUrl;
                main.logo = resp.logoUrl;
                delete vm.file;
                vm.savingLogo = true;
            }, function () {
                vm.savingLogo = true;
            });
        };
        vm.saveSettings = function (isValid) {
            if (!isValid) return;
            var localeChanged = vm.settingsBackup.defaultLocale != vm.settings.defaultLocale;
            vm.savingSettings = true;
            ManageService.saveSettings(vm.settings).then(function (resp) {
                vm.settingsBackup = angular.copy(vm.settings);
                toaster.pop({
                    type: 'success',
                    title: 'Settings saved',
                    body: 'Your settings have been saved successfully',
                    showCloseButton: true
                });
                vm.savingSettings = false;
                if (resp.newTimeSlotIds && resp.newTimeSlotIds.length) {
                    _.each(resp.newTimeSlotIds, function (row) {
                        vm.settings.institutionTimeSlots[row.index].institutionTimeSlotId = row.id;
                    });
                }
                if (localeChanged) {
                    $window.location.reload();
                }
            }, function () {
                vm.savingSettings = false;
            });
        };
        vm.addGrading = function () {
            vm.settings.institutionGrades.push({});
        };
        vm.removeGrading = function (index, grading) {
            SweetAlert.swal({
                title: "Are you sure you wish to remove this grade?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, remove it",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    vm.settings.institutionGrades.splice(index, 1);
                }
            });
        };
        var maxPointsChangedTimeout;
        var maxPointsChangedEntity;
        var swapGrading = function (grading) {
            var index = vm.settings.institutionGrades.indexOf(grading);
            var lastIndex = vm.settings.institutionGrades.length - 1;
            var new_index = index;
            while (new_index > 0 && grading.maxPoints < vm.settings.institutionGrades[new_index - 1].maxPoints)
                new_index--;
            while (new_index < lastIndex && grading.maxPoints > vm.settings.institutionGrades[new_index + 1].maxPoints)
                new_index++;
            vm.settings.institutionGrades.splice(new_index, 0, vm.settings.institutionGrades.splice(index, 1)[0]);
            setGradeMinPoints();
        };
        vm.maxPointsChanged = function (grading) {
            if (maxPointsChangedTimeout && maxPointsChangedEntity) {
                $timeout.cancel(maxPointsChangedTimeout);
                if (maxPointsChangedEntity != grading)
                    swapGrading(maxPointsChangedEntity);
                maxPointsChangedEntity = null;
            }
            var index = vm.settings.institutionGrades.indexOf(grading);
            var lastIndex = vm.settings.institutionGrades.length - 1;
            if ((index > 0 && grading.maxPoints < vm.settings.institutionGrades[index - 1].maxPoints) ||
                (index < lastIndex && grading.maxPoints > vm.settings.institutionGrades[index + 1].maxPoints)) {
                maxPointsChangedEntity = grading;
                maxPointsChangedTimeout = $timeout(function () {
                    swapGrading(maxPointsChangedEntity);
                }, 400);
            } else {
                if (index < lastIndex)
                    vm.settings.institutionGrades[index + 1].minPoints = grading.maxPoints;
            }
        };
        vm.addTimeSlot = function () {
            vm.settings.institutionTimeSlots.push({});
        };
        vm.removeTimeSlot = function (index, timeSlot) {
            SweetAlert.swal({
                title: "Are you sure you wish to remove this period / time slot?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, remove it",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    vm.settings.institutionTimeSlots.splice(index, 1);
                }
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('EmailTemplatesController', function (toaster, FileService, ManageService, GlobalService) {
        var vm = this;
        vm.summernoteOptions = {
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'hr']],
                    ['view', ['codeview']]
            ]
        };
        vm.imageUpload = function (files) {
            toaster.pop({
                type: 'wait',
                title: 'Adding Images',
                body: 'Your images are being added...',
                timeout: 0
            });
            var editor = vm.editor;
            FileService.uploadWysiwygFiles(files, "MailTemplate").then(function (resp) {
                for (var key in resp.files) {
                    editor.summernote('insertImage', GlobalService.CdnBase + "/Api/File/Public/" + resp.files[key], key);
                }
                toaster.clear();
                toaster.pop({
                    type: 'success',
                    title: 'Images added',
                    body: 'Your images have been added successfully',
                    showCloseButton: true
                });
            }, function () {
            });
        };
        vm.templateKeys = [
            {
                value: 'main',
                text: 'General email template for all emails. Includes branding, header, footer.'
            },
            {
                value: 'new_student',
                text: 'Email sent after adding a new student'
            },
            {
                value: 'new_educator',
                text: 'Email sent after adding a new educator'
            },
            {
                value: 'new_admin',
                text: 'Email sent after adding a new system admin'
            },
            {
                value: 'forgot_password',
                text: 'Email sent when user requests for a password reset'
            },
            {
                value: 'assignment_publish',
                text: 'Email sent to students when an assignment is available to take'
            },
            {
                value: 'assignment_submit',
                text: 'Email sent to course faculty when a student submits an assignment'
            },
            {
                value: 'assessment_publish',
                text: 'Email sent to students when an assessment is available to take'
            },
            {
                value: 'assessment_submit',
                text: 'Email sent to course faculty when a student submits an assessment'
            },
            {
                value: 'media_processed',
                text: 'Email sent to course faculty when a video upload has been processed and ready for viewing'
            }
        ];
        vm.templateKeySelected = function ($item) {
            vm.waiting = true;
            ManageService.getTemplate(vm.templateKey).then(function (resp) {
                vm.template = resp;
                vm.waiting = false;
            }, function () {
                vm.waiting = false;
            });
        };
        vm.save = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            ManageService.saveTemplate(vm.templateKey, vm.template).then(function (resp) {
                form.$submitted = false;
                vm.saving = false;
            }, function () {
                vm.saving = false;
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('OAuthUserModalController', function ($uibModalInstance, $state, $window, SweetAlert, ManageService, user, GlobalService) {
        var vm = this;
        vm.permissionTypes = [
            { value: "Course", name: "Course" },
            { value: "Structure", name: "Course Structure" },
            { value: "Content", name: "Course Content" },
            { value: "Gradebook", name: "Gradebook" }
        ];
        vm.accessLevels = [
            { value: 0, name: "No access" },
            { value: 1, name: "Read-only" },
            { value: 2, name: "Full access" }
        ];
        vm.user = angular.copy(user);
        vm.loading = false;
        if (vm.user.oAuthId) {
            vm.loading = true;
            ManageService.getOAuthUser(vm.user.oAuthId).then(function (resp) {
                vm.loading = false;
                vm.user = resp;
                vm.permissions = _.indexBy(resp.permissions, "accessType");
            }, function () {

            });
        }
        vm.resetOAuth = function () {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Are you sure you wish to reset this user's OAuth Key and Secret?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, reset it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    vm.resetting = true;
                    ManageService.changeOAuthUserKeys(vm.user.oAuthId).then(function (resp) {
                        vm.resetting = false;
                        SweetAlert.swal({
                            title: "This user's credentials have been reset",
                            text: "Ensure that the OAuth Key and Secret are sent to the external user using secure means. If the Key/Secret are compromised, they should be Reset once again. Do you wish to download the new key/secret now?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, download it",
                            cancelButtonText: "No. I'll download it later.",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $window.open(GlobalService.ApiBase + '/Api/ManageOAuth/User/' + vm.user.oAuthId + '/Credentials', '_blank');
                            }
                        });
                    }, function () {

                    });
                }
            });
        }
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            vm.user.oAuthUserPermissions = [];
            for (var key in vm.permissions) {
                vm.user.oAuthUserPermissions.push({ accessType: key, accessLevel: vm.permissions[key].accessLevel });
            }
            if (!user.oAuthId) {
                ManageService.createOAuthUser(vm.user).then(function (resp) {
                    vm.saving = false;
                    vm.user.oAuthId = resp.id;
                    form.$submitted = false;
                    $uibModalInstance.close({ user: vm.user });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editOAuthUser(vm.user).then(function (resp) {
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close({ user: vm.user });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageOAuthUsersController', function ($uibModal, ManageService) {
        var vm = this;
        vm.loading = true;
        vm.getUsers = function () {
            if (!vm.users) {
                ManageService.getOAuthUsers().then(function (users) {
                    vm.users = users;
                    vm.loading = false;
                }, function () {
                    vm.loading = false;
                });
            }
        };
        vm.getUsers();
        vm.user = null;
        vm.openUser = function (id) {
            vm.editUser({ oAuthId: id });
        };
        vm.newUser = function () {
            vm.editUser({});
        };
        vm.editUser = function (user) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/oauthusers/oauth.user.modal.html',
                controller: 'OAuthUserModalController',
                controllerAs: 'oauthUserCtrl',
                resolve: {
                    user: function () { return user },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                vm.user = result.user;
                var listItem = _.find(vm.users, function (item) {
                    return item.oAuthId == vm.user.oAuthId;
                });
                if (listItem) vm.users[vm.users.indexOf(listItem)] = vm.user;
                else vm.users.push(vm.user);
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageAppsModalController', function ($uibModalInstance, $state, ManageService, app) {
        var vm = this;
        vm.app = angular.copy(app);
        vm.loading = false;
        if (vm.app.ltiAppId) {
            vm.loading = true;
            ManageService.getLtiApp(vm.app.ltiAppId).then(function (resp) {
                vm.loading = false;
                vm.app = resp;
            }, function () {
                
            });
        }
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (!app.ltiAppId) {
                ManageService.createLtiApp(vm.app).then(function (resp) {
                    vm.saving = false;
                    vm.app.ltiAppId = resp.id;
                    form.$submitted = false;
                    $uibModalInstance.close({ app: vm.app });
                }, function () {
                    vm.saving = false;
                });
            } else {
                ManageService.editLtiApp(vm.app).then(function (resp) {
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close({ app: vm.app });
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('ManageAppsController', function ($uibModal, $location, ManageService) {
        var vm = this;
        vm.baseUrl = 'https://' + $location.host();
        //if ($location.port() != 443) vm.baseUrl += ":" + $location.port();
        vm.baseUrl += "/DirectLti/";
        vm.loadingLtiApps = true;
        ManageService.getLtiApps().then(function (ltiApps) {
            vm.ltiApps = ltiApps;
            vm.loadingLtiApps = false;
        }, function () {
            vm.loadingLtiApps = false;
        });
        vm.addNewApp = function () {
            vm.openApp({})
        };
        vm.openApp = function (app) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/manage/apps/manage.apps.modal.html',
                controller: 'ManageAppsModalController',
                controllerAs: 'appModalCtrl',
                resolve: {
                    app: function () { return app }
                }
            });
            modal.result.then(function (result) {
                var listItem = _.find(vm.ltiApps, function (item) {
                    return item.ltiAppId == result.app.ltiAppId;
                });
                if (listItem) vm.ltiApps[vm.ltiApps.indexOf(listItem)] = result.app;
                else vm.ltiApps.push(result.app);
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('ShareCourseModalController', function ($uibModalInstance, $state, $timeout, toaster, CourseService, MailboxService, course) {
        var vm = this;
        vm.loaded = false;
        vm.course = course;
        CourseService.getSyllabus(course.courseId).then(function (resp) {
            vm.loaded = true;
            //vm.syllabus = resp;
            vm.courseTitle = resp.name;
            vm.message = {
                recipients: [
                    { id: course.courseId, name: vm.courseTitle + ': Students', type: 'CS' }
                ],
                subject: 'Syllabus for ' + vm.courseTitle,
                body: ''
            };
            vm.message.body = resp.bodyHtml
        }, function () {

        });
        vm.sharing = false;
        vm.summernoteOptions = {
            height: 200,
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'hr']]
            ]
        };
        vm.peopleCache = {};
        vm.people = [];
        vm.peopleSearchTimeout = null;
        vm.latestSearchTerm = "";
        vm.getPeople = function (searchTerm) {
            if (searchTerm) {
                vm.latestSearchTerm = searchTerm;
                if (vm.peopleSearchTimeout) $timeout.cancel(vm.peopleSearchTimeout);
                if (vm.peopleCache[searchTerm]) vm.people = vm.peopleCache[searchTerm];
                else {
                    vm.peopleSearchTimeout = $timeout(function (searchTerm) {
                        MailboxService.getPeople(searchTerm).then(function (resp) {
                            if (vm.latestSearchTerm == searchTerm)
                                vm.people = resp;
                            vm.peopleCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.sharing = true;
            CourseService.createSyllabusAttachment(vm.course.courseId).then(function (file) {
                vm.message.attachments = [{ messageAttachmentId: 0, fileName: file.fileName, filePath: file.filePath }];
                MailboxService.postMessageFinal(vm.message, "Send").then(function (resp) {
                    vm.sharing = false;
                    form.$submitted = false;
                    toaster.pop({
                        type: 'success',
                        title: 'Course shared',
                        body: 'Your course has been shared successfully',
                        showCloseButton: true
                    });
                    $uibModalInstance.close();
                }, function () {
                    vm.sharing = false;
                    toaster.pop({
                        type: 'error',
                        title: 'Error sharing your course',
                        body: 'An error occurred while sharing your course. Please try again.',
                        showCloseButton: true
                    });
                });
            }, function () {
                vm.sharing = false;
                toaster.pop({
                    type: 'error',
                    title: 'Error sharing your course',
                    body: 'An error occurred while sharing your course. Please try again.',
                    showCloseButton: true
                });
            });
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('CourseEditModalController', function ($uibModalInstance, $state, CourseService, ManageService, course) {
        var vm = this;
        vm.loaded = false;
        vm.course = {
            courseId: course.courseId,
            courseCode: course.courseCode,
            name: course.name,
            departmentId: course.departmentId,
            primaryEducator: course.primaryEducator,
            classes: course.classes,
            classIds: course.classIds,
            description: course.description,
            startDate: course.startDate,
            endDate: course.endDate,
            roEducators: _.pluck(_.filter(course.educators, function (educator) { return educator.accessLevel == 1; }), 'userId'),
            wrEducators: _.pluck(_.filter(course.educators, function (educator) { return educator.accessLevel == 2; }), 'userId')
        };
        ManageService.getDepartments().then(function (departments) {
            vm.departments = departments;
            vm.loaded = true;
        }, function () {

        });
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (vm.course.classes) delete vm.course.classes;
            vm.course.startDate = moment(vm.course.startDate).format("YYYY-MM-DD");
            vm.course.endDate = moment(vm.course.endDate).format("YYYY-MM-DD");
            CourseService.save(vm.course).then(function (resp) {
                vm.saving = false;
                vm.course.currentRevision = resp.newVersion;
                vm.course.numStudents = resp.numStudents;
                vm.course.departmentName = _.filter(vm.departments, function (dept) { return vm.course.departmentId == dept.departmentId; })[0].name;
                vm.course.classes = _.filter(vm.groups, function (group) { return vm.course.classIds.indexOf(group.departmentGroupId) >= 0; });
                var allUserIds = vm.course.roEducators.concat(vm.course.wrEducators);
                vm.course.educators = _.filter(vm.educators, function (educator) { return allUserIds.indexOf(educator.userId) >= 0; });
                form.$submitted = false;
                $uibModalInstance.close({ course: vm.course });
            }, function () {
                vm.saving = false;
            });
        };
        vm.onDepartmentsChanged = function () {
            if (vm.course.departmentId == 0) {
                vm.groups = [];
                vm.educators = [];
            } else {
                ManageService.getGroups([vm.course.departmentId]).then(function (groups) {
                    vm.groups = groups;
                }, function () {

                });
                ManageService.getDepartmentEducators(vm.course.departmentId).then(function (educators) {
                    vm.educators = educators;
                }, function () {

                });
            }
        };
        vm.onDepartmentsChanged();
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('CourseController', function ($scope, $state, $stateParams, $uibModal, SweetAlert, toaster, CourseService, AuthenticationService) {
        var vm = this;
        vm.contentTypes = {
            Assessment: "Assessment",
            Assignment: "Assignment",
            Audio: "Audio",
            LtiApp: "From LTI Tool",
            Javascript: "Javascript",
            Pdf: "PDF Upload",
            RichTextFormat: "Text / HTML",
            ExternalVideo: "Video"
        };
        vm.spinOptions = {
            min: 1,
            step: 1,
            decimals: 0,
            verticalbuttons: true
        };
        vm.loaded = false;
        vm.courseId = $stateParams.id;
        CourseService.get($stateParams.id).then(function (course) {
            vm.course = course;
            CourseService.setCurrentCourse(course);
            vm.nodeTypes = course.nodeTypes;
            vm.structure.loadItems(vm.course.structure);
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
            toaster.pop({
                type: 'error',
                title: 'Access denied',
                body: 'You do not have access to view this course',
                showCloseButton: true
            });
        });
        vm.lastActivityId = 0;
        vm.getCourseActivity = function () {
            CourseService.getActivity(vm.courseId, vm.lastActivityId).then(function (resp) {
                if (vm.courseActivity)
                    vm.courseActivity = resp.concat(vm.courseActivity);
                else
                    vm.courseActivity = resp;
                if (resp.length > 0) vm.lastActivityId = resp[0].editNotificationId;
            }, function () {

            });
        };
        vm.lastStudentNodeActivityId = 0;
        vm.getStudentNodeActivity = function () {
            CourseService.getStudentNodeActivity(vm.courseId, vm.lastStudentNodeActivityId).then(function (resp) {
                if (vm.studentNodeActivity)
                    vm.studentNodeActivity = resp.concat(vm.studentNodeActivity);
                else
                    vm.studentNodeActivity = resp;
                if (resp.length > 0) vm.lastStudentNodeActivityId = resp[0].userCourseNodeViewId;
            }, function () {

            });
        };
        vm.lastStudentContentActivityId = 0;
        vm.getStudentContentActivity = function () {
            CourseService.getStudentContentActivity(vm.courseId, vm.lastStudentContentActivityId).then(function (resp) {
                if (vm.studentContentActivity)
                    vm.studentContentActivity = resp.concat(vm.studentContentActivity);
                else
                    vm.studentContentActivity = resp;
                if (resp.length > 0) vm.lastStudentContentActivityId = resp[0].userContentViewId;
            }, function () {

            });
        };
        vm.getStudents = function () {
            vm.loadingStudents = true;
            CourseService.getStudents(vm.courseId).then(function (resp) {
                vm.students = resp;
                vm.loadingStudents = false;
            }, function () {
                vm.loadingStudents = false;
            });
        };
        vm.edit = function (afterEdit) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/courses/view/course.edit.modal.html',
                controller: 'CourseEditModalController',
                controllerAs: 'courseEditCtrl',
                resolve: {
                    course: function () { return vm.course },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            },
                            {
                                name: 'ui.select',
                                files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                            },
                            {
                                name: 'datePicker',
                                files: ['/Styles/plugins/datapicker/angular-datapicker.css', '/Scripts/plugins/datapicker/angular-datepicker.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                vm.course.courseCode = result.course.courseCode;
                vm.course.name = result.course.name;
                vm.course.departmentId = result.course.departmentId;
                vm.course.departmentName = result.course.departmentName;
                vm.course.classes = result.course.classes;
                vm.course.classIds = result.course.classIds;
                vm.course.description = result.course.description;
                vm.course.startDate = result.course.startDate;
                vm.course.endDate = result.course.endDate;
                vm.course.currentRevision = result.course.currentRevision;
                vm.course.isDirty = true;
                if (afterEdit) afterEdit();
            });
        };
        vm.publish = function (publishSettings) {
            if (!publishSettings) publishSettings = {title:"", text:""};
            if (!vm.course.classIds.length || !vm.course.startDate || !vm.course.endDate) {
                SweetAlert.swal({
                    title: publishSettings.title || "Please add students and/or course dates",
                    text: publishSettings.text + "Edit the course now to assign batches of students to this course and set a start and end date before you publish the course.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, Edit the Course",
                    cancelButtonText: "Publish Later",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.edit(vm.publish);
                    }
                });
            } else if (!vm.course.structure.length) {
                SweetAlert.swal({
                    title: publishSettings.title || "Please add some lessons to your course",
                    text: publishSettings.text + "We've noticed that you have not added any lessons or units to your course. Please add a course structure before you publish the course.",
                    type: "warning",
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                });
            } else {
                SweetAlert.swal({
                    title: publishSettings.title || "Are you sure you wish to publish this course?",
                    text: publishSettings.text + "You cannot unpublish a course once it is published and live. You can however make changes and re-publish new changes. New changes made after publishing do not go live until you re-publish the course.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, publish it!",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        if (publishSettings && publishSettings.afterPublish)
                            doPublish(publishSettings.afterPublish);
                        else
                            doPublish();
                    }
                });
            }
        };
        var doPublish = function (afterPublish) {
            vm.isPublishing = true;
            CourseService.publish(vm.courseId).then(function (resp) {
                vm.course.status = 2;
                vm.course.currentRevision = resp.version;
                vm.course.publishedRevision = resp.version;
                vm.course.isDirty = false;
                vm.isPublishing = false;
                if (afterPublish) afterPublish();
            }, function () {
                vm.isPublishing = false;
            });
        }
        vm.openShare = function () {
            var openModal = function () {
                var modal = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/courses/view/course.share.modal.html',
                    controller: 'ShareCourseModalController',
                    controllerAs: 'shareCourseModal',
                    resolve: {
                        course: function () { return vm.course },
                        loadPlugin: function ($ocLazyLoad) {
                            return $ocLazyLoad.load([
                                {
                                    name: 'bootstrap',
                                    files: ['/Scripts/plugins/bootstrap/bootstrap.min.js']
                                },
                                {
                                    name: 'chosen',
                                    files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                                },
                                {
                                    name: 'ui.select',
                                    files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                                },
                                {
                                    name: 'summernote',
                                    files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                                }
                            ]);
                        }
                    }
                });
            };
            if (vm.course.status == 1) {
                vm.publish({
                    afterPublish: openModal,
                    title: "This course has not been published yet",
                    text: "You need to publish this course before sharing it. "
                });
                /*SweetAlert.swal({
                    title: "This course has not been published yet",
                    text: "You need to publish this course before sharing it. Would you like to publish your course now? You cannot unpublish a course once it is published and live. You can however make changes and re-publish new changes. New changes made after publishing do not go live until you re-publish the course.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, publish it!",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        doPublish(openModal);
                    }
                });*/
            } else
                openModal();
        };
        vm.copy = function () {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/courses/new/course.copy.modal.html',
                controller: 'CourseCopyModalController',
                controllerAs: 'copycourse',
                resolve: {
                    courseId: function () { return vm.courseId; },
                    courseCode: function () { return vm.course.courseCode; },
                    name: function () { return vm.course.name; },
                    departmentId: function () { return vm.course.departmentId; },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
            modal.result.then(function (result) {
                toaster.pop({
                    type: 'success',
                    title: 'Course Copy Success',
                    body: 'A copy of your course has been successfully created. You will now be redirected to the new course page.',
                    showCloseButton: true
                });
                $state.go("base.course.index", { id: result.courseId });
            });
        };
        vm.addNewNodeType = function (typeStr) {
            if (typeStr && vm.nodeTypes.indexOf(typeStr) < 0)
                vm.nodeTypes.push(typeStr);
            return typeStr;
        };
        vm.saveStructure = function () {
            vm.structure.saving = true;
            var tree = angular.copy(vm.structure.data);
            var deleteParent = function (node) {
                if (node.myParent) delete node.myParent;
                _.each(node.nodes, function (child) { deleteParent(child) });
            };
            _.each(tree, function (node) { deleteParent(node) });
            var objToSave = _.filter(tree, function (item) {
                return !item.isNew;
            });
            CourseService.saveStructure(vm.courseId, objToSave).then(function (resp) {
                vm.course.structure = resp.courseNodes;
                vm.course.currentRevision = resp.version;
                vm.course.isDirty = true;
                CourseService.setCurrentCourse(vm.course);
                vm.structure.loadItems(vm.course.structure);
                vm.structure.isTransient = false;
                vm.structure.saving = false;
            }, function () {
                vm.structure.saving = false;
            });
        };
        vm.treeOptions = {
            dropped: function (event) {
                vm.structure.isTransient = true;
            }
        };
        vm.structure = {
            remove: function (scope) {
                scope.remove();
            },
            toggle: function (scope) {
                scope.toggle();
            },
            moveLastToTheBeginning: function () {
                var a = vm.structure.data.pop();
                vm.structure.data.splice(0, 0, a);
            },
            loadItems: function(list) {
                var nodeMappings = {};
                vm.structure.data = [];
                _.each(list, function (node) {
                    var nodeObj = {
                        id: node.courseNodeId,
                        nodeType: node.nodeType,
                        number: node.nodeNumber,
                        title: node.nodeTitle,
                        isHidden: node.isHidden,
                        inEdit: false,
                        nodes: []
                    };
                    nodeMappings[node.courseNodeId] = nodeObj;
                    if (node.parentNodeId) {
                        nodeObj.myParent = nodeMappings[node.parentNodeId];
                        nodeMappings[node.parentNodeId].nodes.push(nodeObj);
                    } else
                        vm.structure.data.push(nodeObj);
                });
                if (AuthenticationService.isUserAdmin() || AuthenticationService.isUserEducator()) vm.structure.newTopItem();
            },
            flatten: function (list) {
                var flatlist = [];
                var traverse = function (item) {
                    if (item.id) {
                        flatlist.push(item);
                        _.each(item.nodes, function (node) { traverse(node); });
                    }
                };
                _.each(list, function (node) { traverse(node); });
                return flatlist;
            },
            newTopItem: function () {
                vm.structure.data.push({
                    id: null,
                    nodeType: vm.structure.data.length ? vm.structure.data[0].nodeType : "",
                    number: vm.structure.data.length + 1,
                    title: "",
                    inEdit: true,
                    isNew: true,
                    nodes: []
                });
            },
            newSubItem: function (scope) {
                var nodeData = scope.$modelValue;
                nodeData.nodes.push({
                    id: null,
                    nodeType: nodeData.nodes.length ? nodeData.nodes[0].nodeType : "",
                    number: nodeData.nodes.length + 1,
                    title: "",
                    inEdit: true,
                    nodes: [],
                    myParent: nodeData
                });
            },
            saveItem: function (scope) {
                var nodeData = scope.$modelValue;
                if (nodeData.isNew) {
                    nodeData.isNew = false;
                    vm.structure.newTopItem();
                }
                nodeData.inEdit = false;
                vm.structure.isTransient = true;
            },
            collapseAll: function () {
                $scope.$broadcast('collapseAll');
            },
            expandAll: function () {
                $scope.$broadcast('expandAll');
            },
            setHide: function (scope, isHidden) {
                var nodeData = scope.$modelValue;
                nodeData.isHidden = isHidden;
                if (isHidden) {
                    var hideChildren = function (nodes) {
                        _.each(nodes, function (node) { node.isHidden = true; hideChildren(node.nodes); });
                    };
                    hideChildren(nodeData.nodes);
                } else {
                    var unHideAncestors = function (node) {
                        node.isHidden = false;
                        if (node.myParent) unHideAncestors(node.myParent);
                    };
                    unHideAncestors(nodeData);
                }
                vm.structure.isTransient = true;
            },
            data: []
        };

        vm.addFiles = function (value) {
            var fileNames = { };
            var formdata = new FormData();
            if (value instanceof FileList)
                _.each(value, function (file, i) { formdata.append('file-' + i, file); fileNames['file-' + i] = file.name; });
            else {
                formdata.append('file-0', value);
                fileNames['file-0'] = value.name;
            }
            CourseService.uploadFiles(vm.courseId, formdata).then(function (resp) {
                if (!vm.course.resources) vm.course.resources = [];
                for (var key in resp.files) {
                    if (resp.files.hasOwnProperty(key)) {
                        vm.course.resources.push({
                            courseResourceId: resp.files[key],
                            name: fileNames[key],
                            type: 'File'
                        });
                    }
                }
            }, function () {
            });
        };
        vm.deleteFile = function (resource) {
            SweetAlert.swal({
                title: "Are you sure you wish to delete this resource?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    CourseService.deleteResource(vm.courseId, resource.courseResourceId).then(function (resp) {
                        vm.course.resources.splice(vm.course.resources.indexOf(resource), 1);
                    }, function () {
                    });
                }
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('YoutubeToolModalController', function ($uibModalInstance, $state, toaster, UrlToolsService) {
        var vm = this;
        vm.search = function (pageToken) {
            if (vm.searchText) {
                vm.searching = true;
                vm.lastSearchText = "";
                UrlToolsService.searchYoutube(vm.searchText, pageToken).then(function (resp) {
                    vm.searching = false;
                    vm.lastSearchText = vm.searchText;
                    vm.resp = resp;
                }, function () {
                    vm.searching = false;
                    toaster.pop({
                        type: 'error',
                        title: 'Search Failed',
                        body: 'There was an unexpected error while searching. Please try again.',
                        showCloseButton: true
                    });
                });
            }
        };
        vm.select = function (item) {
            $uibModalInstance.close({
                name: item.snippet.title,
                description: item.snippet.description,
                url: UrlToolsService.getYoutubeVideoUrl(item.id.videoId),
                widthValue: '100',
                widthUnit: '%',
                heightValue: '480',
                heightUnit: 'px'
            });
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('WikipediaToolModalController', function ($uibModalInstance, $state, toaster, UrlToolsService) {
        var vm = this;
        vm.truncateOptions = {
            watch: 'window'
        };
        vm.search = function (page) {
            if (vm.searchText) {
                vm.searching = true;
                vm.lastSearchText = "";
                UrlToolsService.searchWikipedia(vm.searchText, page).then(function (resp) {
                    vm.searching = false;
                    vm.lastSearchText = vm.searchText;
                    var keys = Object.keys(resp.query.pages);
                    if (keys.length == 1 && keys[0] == -1) {
                        resp.total = 0;
                    } else {
                        resp.total = keys.length;
                        if (keys.length == 1)
                            resp.query.pages[keys[0]].showPreview = true;
                    }
                    vm.resp = resp;
                }, function () {
                    vm.searching = false;
                    toaster.pop({
                        type: 'error',
                        title: 'Search Failed',
                        body: 'There was an unexpected error while searching. Please try again.',
                        showCloseButton: true
                    });
                });
            }
        };
        vm.select = function (item) {
            $uibModalInstance.close({
                name: item.title,
                url: item.fullurl,
                widthValue: '100',
                widthUnit: '%',
                heightValue: '500',
                heightUnit: 'px'
            });
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;

        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('VimeoToolModalController', function ($uibModalInstance, $state, toaster, UrlToolsService) {
        var vm = this;
        vm.search = function (page) {
            if (vm.searchText) {
                vm.searching = true;
                vm.lastSearchText = "";
                UrlToolsService.searchVimeo(vm.searchText, page).then(function (resp) {
                    vm.searching = false;
                    vm.lastSearchText = vm.searchText;
                    vm.resp = resp;
                }, function () {
                    vm.searching = false;
                    toaster.pop({
                        type: 'error',
                        title: 'Search Failed',
                        body: 'There was an unexpected error while searching. Please try again.',
                        showCloseButton: true
                    });
                });
            }
        };
        vm.select = function (item) {
            var url = UrlToolsService.extractVimeoUrl(item.embed.html);
            $uibModalInstance.close({
                name: item.name,
                description: item.description,
                url: url,
                widthValue: '100',
                widthUnit: '%',
                heightValue: '480',
                heightUnit: 'px'
            });
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;

        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

/**
    * iboxTools - Directive for iBox tools elements in right corner of ibox
    */
angular.module('lms')
    .directive('youtubeSnippet', function () {
        return {
            scope: {
                item: '=',
                compressed: '='
            },
            transclude: true,
            templateUrl: 'app/courses/urltools/youtube.snippet.html',
            controller: function ($scope, $element, $attrs) {
                
            }
        };
    })
    .directive('vimeoSnippet', function (UrlToolsService) {
        return {
            scope: {
                item: '=',
                compressed: '='
            },
            transclude: true,
            templateUrl: 'app/courses/urltools/vimeo.snippet.html',
            controller: function ($scope, $element, $attrs) {
                $scope.truncateOptions = {
                    watch: 'window'
                };
                $scope.extractUrl = function (html) {
                    return UrlToolsService.extractVimeoUrl(html);
                };
            }
        };
    })
    .directive('wikipediaSnippet', function () {
        return {
            scope: {
                item: '=',
                compressed: '='
            },
            transclude: true,
            templateUrl: 'app/courses/urltools/wikipedia.snippet.html',
            controller: function ($scope, $element, $attrs) {

            }
        };
    });
'use strict';

angular.module('lms')
    .controller('NewCourseModalController', function ($uibModalInstance, $state, CourseService, ManageService) {
        var vm = this;
        vm.loaded = false;
        ManageService.getDepartments().then(function (departments) {
            vm.departments = departments;
            vm.loaded = true;
        }, function () {

        });
        vm.saving = false;
        vm.course = {
            name: ""
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            CourseService.create(vm.course).then(function (resp) {
                vm.saving = false;
                form.$submitted = false;
                $state.go('base.course.index', { id: resp.id });
                $uibModalInstance.close();
            }, function () {
                vm.saving = false;
            });
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('CourseCopyModalController', function ($uibModalInstance, $state, CourseService, ManageService, courseId, courseCode, name, departmentId) {
        var vm = this;
        vm.loaded = false;
        vm.courseId = courseId;
        ManageService.getDepartments().then(function (departments) {
            vm.departments = departments;
            vm.loaded = true;
        }, function () {

        });
        vm.saving = false;
        vm.course = {
            courseCode: courseCode,
            name: name + " - Copy",
            departmentId: departmentId
        };
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            CourseService.copy(vm.courseId, vm.course).then(function (resp) {
                vm.saving = false;
                form.$submitted = false;
                $uibModalInstance.close({ courseId: resp.id });
            }, function () {
                vm.saving = false;
            });
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('CourseListController', function (CourseService) {
        var vm = this;
        vm.loaded = false;
        CourseService.getAll().then(function (courses) {
            vm.courses = courses;
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
        });
    });

'use strict';

angular.module('lms')
    .controller('TakeAssessmentModalController', function ($uibModalInstance, $scope, $timeout, content, resumeLogId, AssessmentService, SweetAlert, toaster) {
        MathJax.Hub.Config({
            skipStartupTypeset: true,
            messageStyle: "none",
            "HTML-CSS": {
                showMathMenu: false
            },
            MathML: {
                useMathMLspacing: true
            }
        });
        MathJax.Hub.Configured();
        var vm = this;
        vm.summernoteAnswerOptions = {
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']]
            ]
        };
        vm.loaded = false;
        vm.content = content;
        vm.first = true;
        vm.ticks = 0;
        if (resumeLogId) {
            AssessmentService.getResumeAssessment(resumeLogId).then(function (resp) {
                vm.userAssessment = resp;
                vm.start();
                vm.loaded = true;
            }, function () {
                vm.loaded = true;
            });
        } else {
            AssessmentService.getNewTake(vm.content.contentId).then(function (resp) {
                vm.userAssessment = resp;
                vm.start();
                vm.loaded = true;
            }, function () {
                vm.loaded = true;
            });
        }
        vm.start = function () {
            _.each(vm.userAssessment.sections, function (section) {
                section.questionCount = 0;
                _.each(section.screens, function (screen) {
                    if (screen.screenLayout == 'Question')
                        screen.questionNumber = ++section.questionCount;
                    if (screen.assessmentScreenId == vm.userAssessment.activeScreenId)
                        vm.activeScreen = screen;
                });
                if (section.assessmentSectionId == vm.userAssessment.activeSectionId)
                    vm.activeSection = section;
            });
            if (vm.content.durationType == 'Assessment')
                vm.timeLeft = (vm.content.duration * 60) - vm.userAssessment.timeSpent;
            else if (vm.content.durationType == 'Section')
                vm.timeLeft = (vm.activeSection.duration * 60) - vm.activeSection.timeTaken;
            vm.loadScreen(vm.activeSection, vm.activeScreen);
        };
        vm.showSection = function (section, $index) {
            vm.userAssessment.activeSectionId = section.assessmentSectionId;
            vm.activeSection = section;
        };
        vm.showScreen = function (section, screen, $index) {
            if (vm.userAssessment.activeScreenId != screen.assessmentScreenId) {
                vm.loadingScreen = true;
                $scope.$broadcast('timer-stop');
                var ticks = vm.ticks;
                vm.ticks = 0;
                AssessmentService.getAnswerToSubmit(vm.activeScreen, vm.recordings).then(function (answer) {
                    AssessmentService.changeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, screen.assessmentScreenId, ticks, answer).then(function (resp) {
                        if (vm.activeScreen.contentQuestion.questionType == 'Recording' && resp.url) vm.activeScreen.contentQuestion.answerGiven = resp.url;
                        vm.loadScreen(section, screen);
                    }, function () {

                    });
                });
            }
        };
        vm.nextScreen = function () {
            var index = vm.activeSection.screens.indexOf(vm.activeScreen) + 1;
            if (index >= vm.activeSection.screens.length) {
                var secindex = vm.userAssessment.sections.indexOf(vm.activeSection) + 1;
                if (secindex >= vm.userAssessment.sections.length) {
                    if (vm.content.forwardOnly) {
                        vm.showEnd = true;
                        vm.submitting = true;
                        $scope.$broadcast('timer-stop');
                        var ticks = vm.ticks;
                        vm.ticks = 0;
                        AssessmentService.getAnswerToSubmit(vm.activeScreen, vm.recordings).then(function (answer) {
                            AssessmentService.changeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, 0, ticks, answer).then(function (resp) {
                                if (vm.activeScreen.contentQuestion.questionType == 'Recording' && resp.url) vm.activeScreen.contentQuestion.answerGiven = resp.url;
                                $timeout(function () {
                                    doSubmit();
                                }, 2000);
                            }, function () {
                                $timeout(function () {
                                    doSubmit();
                                }, 2000);
                            });
                        });
                    } else return;
                }
                vm.showSection(vm.userAssessment.sections[secindex], secindex);
                index = 0;
            }
            vm.showScreen(vm.activeSection, vm.activeSection.screens[index], index);
        };
        vm.loadScreen = function (section, screen) {
            var exec = function () {
                if (screen.loaded) {
                    vm.userAssessment.activeScreenId = screen.assessmentScreenId;
                    vm.activeScreen = screen;
                    vm.loadingScreen = false;
                    $scope.$broadcast('timer-resume');
                    vm.first = false;
                } else {
                    vm.loadingScreen = true;
                    var onScreen = function (resp) {
                        if (screen.screenLayout == 'Question') {
                            screen.contentQuestion = resp;
                            if (resp.answerGiven) {
                                if (screen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer' || screen.contentQuestion.questionType == 'MultipleChoiceMultipleAnswers') {
                                    _.each(screen.contentQuestion.contentMultipleChoiceAnswers, function (a, index) {
                                        if (a.answerNumber <= resp.answerGiven.length) {
                                            a.isCorrect = resp.answerGiven[a.answerNumber - 1] == '1';
                                            if (a.isCorrect) screen.contentQuestion.selectedAnswer = index;
                                        }
                                    });
                                } else if (screen.contentQuestion.questionType == 'Matching') {
                                    var answerDict = angular.fromJson(resp.answerGiven);
                                    _.each(screen.contentQuestion.contentMatchingOptions, function (opt, index) {
                                        if (answerDict && answerDict[index + 1] && answerDict[index + 1] != '')
                                            opt.contentMatchingAnswer = { matchingAnswerKey: answerDict[index + 1] };
                                        else
                                            opt.contentMatchingAnswer = { matchingAnswerKey: "" };
                                    });
                                }
                            }
                        } else
                            angular.extend(screen, resp);
                        screen.loaded = true;
                        vm.userAssessment.activeScreenId = screen.assessmentScreenId;
                        vm.activeScreen = screen;
                        vm.loadingScreen = false;
                        //if (vm.content.durationType !== 'NonTimed') {
                        if (vm.first)
                            $scope.$broadcast('timer-start');
                        else
                            $scope.$broadcast('timer-resume');
                        //}
                        vm.first = false;
                    };
                    if (screen.screenLayout == 'Question')
                        AssessmentService.getUserQuestionScreen(vm.userAssessment.userAssessmentLogId, screen.assessmentScreenId).then(function (resp) { onScreen(resp) }, function () { });
                    else
                        AssessmentService.getScreen(screen.assessmentScreenId, 'TextScreen').then(function (resp) { onScreen(resp) }, function () { });
                }
            }
            if (!vm.first && vm.activeSection.screens.indexOf(vm.activeScreen) < 0 && vm.content.durationType == 'Section') {
                vm.timeLeft = (vm.activeSection.duration * 60) - vm.activeSection.timeTaken;
                $timeout(function () {
                    $scope.$broadcast('timer-reset');
                    exec();
                }, 200);
            } else exec();
        };
        vm.recordings = {};
        vm.onRecordingDone = function (data, contentQuestion) {
            vm.recordings[contentQuestion.questionId] = {
                meta: {
                    fileName: data.name,
                    fileSize: data.size,
                    fileType: data.type
                },
                data: data
            };
        };
        vm.reRecord = function (contentQuestion) {
            contentQuestion.rerecord = true;
        };
        vm.cancelReRecord = function (contentQuestion) {
            contentQuestion.rerecord = false;
        };
        $scope.$on('timer-tick', function (event, args) {
            $timeout(function () {
                vm.timeRemain = args.millis;
                vm.activeSection.timeTaken++;
                vm.userAssessment.timeSpent++;
                vm.ticks++;
                if (vm.content.durationType !== 'NonTimed' && vm.timeRemain == 0) {
                    $scope.$broadcast('timer-stop');
                    var ticks = vm.ticks;
                    vm.ticks = 0;
                    var answer;
                    if (vm.content.durationType == 'Assessment') {
                        if (!vm.showEnd) {
                            vm.showEnd = true;
                            vm.submitting = true;
                            toaster.pop({
                                type: 'error',
                                title: 'Timed Out!',
                                body: 'Your assessment has timed out. It will now be submitted.',
                                showCloseButton: true
                            });
                            AssessmentService.getAnswerToSubmit(vm.activeScreen, vm.recordings).then(function (answer) {
                                AssessmentService.changeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, 0, ticks, answer).then(function (resp) {
                                    if (vm.activeScreen.contentQuestion.questionType == 'Recording' && resp.url) vm.activeScreen.contentQuestion.answerGiven = resp.url;
                                    doSubmit(true);
                                }, function () {
                                    doSubmit(true);
                                });
                            });
                        }
                    } else if (vm.content.durationType == 'Section') {
                        vm.loadingScreen = true;
                        toaster.pop({
                            type: 'error',
                            title: 'Section Timed Out!',
                            body: 'This section has timed out.',
                            showCloseButton: true
                        });
                        var sectionId = vm.activeSection.assessmentSectionId;
                        var timeOutHandler = function (resp) {
                            vm.activeSection.timedOut = true;
                            if (resp.assessmentTimedOut) {
                                toaster.pop({
                                    type: 'error',
                                    title: 'Timed Out!',
                                    body: 'Your assessment has timed out. It will now be submitted.',
                                    showCloseButton: true
                                });
                                $uibModalInstance.close({
                                    userAssessmentLogId: vm.userAssessment.userAssessmentLogId,
                                    status: 'Ended',
                                    dateStarted: vm.userAssessment.dateStarted
                                });
                            } else {
                                vm.userAssessment.activeScreenId = resp.nextScreenId;
                                vm.userAssessment.activeSectionId = resp.nextSectionId;
                                _.each(vm.userAssessment.sections, function (section) {
                                    _.each(section.screens, function (screen) {
                                        if (screen.assessmentScreenId == vm.userAssessment.activeScreenId)
                                            vm.activeScreen = screen;
                                    });
                                    if (section.assessmentSectionId == vm.userAssessment.activeSectionId)
                                        vm.activeSection = section;
                                });
                                vm.timeLeft = (vm.activeSection.duration * 60) - vm.activeSection.timeTaken;
                                $timeout(function () {
                                    $scope.$broadcast('timer-reset');
                                    vm.loadScreen(vm.activeSection, vm.activeScreen);
                                }, 200);
                            }
                        };
                        AssessmentService.getAnswerToSubmit(vm.activeScreen, vm.recordings).then(function (answer) {
                            AssessmentService.changeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, 0, ticks, answer).then(function (resp) {
                                if (vm.activeScreen.contentQuestion.questionType == 'Recording' && resp.url) vm.activeScreen.contentQuestion.answerGiven = resp.url;
                                AssessmentService.sectionTimeOut(vm.userAssessment.userAssessmentLogId, sectionId).then(function (resp) {
                                    timeOutHandler(resp);
                                }, function () {

                                });
                            }, function () {
                                AssessmentService.sectionTimeOut(vm.userAssessment.userAssessmentLogId, sectionId).then(function (resp) {
                                    timeOutHandler(resp);
                                }, function () {

                                });
                            });
                        });
                    }
                } else {
                    if (vm.ticks == 5) {
                        vm.ticks = 0;
                        AssessmentService.sendUserTime(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, 5);
                    }
                }
            });
        });
        vm.submit = function () {
            SweetAlert.swal({
                title: "Are you sure you wish to submit this assessment?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, submit it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $scope.$broadcast('timer-stop');
                    var ticks = vm.ticks;
                    vm.ticks = 0;
                    AssessmentService.getAnswerToSubmit(vm.activeScreen, vm.recordings).then(function (answer) {
                        AssessmentService.changeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, 0, ticks, answer).then(function (resp) {
                            if (vm.activeScreen.contentQuestion.questionType == 'Recording' && resp.url) vm.activeScreen.contentQuestion.answerGiven = resp.url;
                            doSubmit();
                        }, function () {
                            doSubmit();
                        });
                    });
                }
            });
        };
        var doSubmit = function (isTimedOut) {
            vm.submitting = true;
            AssessmentService.submit(vm.userAssessment.userAssessmentLogId, isTimedOut).then(function (resp) {
                vm.submitting = false;
                $uibModalInstance.close({
                    userAssessmentLogId: vm.userAssessment.userAssessmentLogId,
                    status: 'Ended',
                    dateStarted: vm.userAssessment.dateStarted
                });
            }, function () {
                $scope.$broadcast('timer-resume');
                vm.submitting = false;
            });
        };
        vm.close = function () {
            if (vm.content.allowResume) {
                vm.loadingScreen = true;
                var ticks = vm.ticks;
                var sectionId = vm.activeSection.assessmentSectionId;
                AssessmentService.getAnswerToSubmit(vm.activeScreen, vm.recordings).then(function (answer) {
                    AssessmentService.changeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.assessmentScreenId, vm.activeScreen.assessmentScreenId, ticks, answer).then(function (resp) {
                        if (vm.activeScreen.contentQuestion.questionType == 'Recording' && resp.url) vm.activeScreen.contentQuestion.answerGiven = resp.url;
                        vm.loadingScreen = false;
                        $uibModalInstance.close({
                            userAssessmentLogId: vm.userAssessment.userAssessmentLogId,
                            status: 'InProgress',
                            dateStarted: vm.userAssessment.dateStarted
                        });
                    }, function () {
                        vm.loadingScreen = false;
                        $uibModalInstance.close({
                            userAssessmentLogId: vm.userAssessment.userAssessmentLogId,
                            status: 'InProgress',
                            dateStarted: vm.userAssessment.dateStarted
                        });
                    });
                });
            }
        };
        $scope.$on('$destroy', function () {
            $scope.$broadcast('timer-clear');
        });
    });

'use strict';

angular.module('lms')
    .controller('ReviewAssessmentModalController', function ($uibModalInstance, $scope, $timeout, content, userId, AssessmentService, SweetAlert, toaster) {
        MathJax.Hub.Config({
            skipStartupTypeset: true,
            messageStyle: "none",
            "HTML-CSS": {
                showMathMenu: false
            },
            MathML: {
                useMathMLspacing: true
            }
        });
        MathJax.Hub.Configured();
        var vm = this;
        vm.loaded = false;
        vm.content = content;
        vm.first = true;
        vm.numberOptions = {
            min: -1000,
            max: 1000,
            step: 1,
            decimals: 0
        };
        AssessmentService.getReviewAssessment(content.contentId, userId).then(function (resp) {
            vm.userAssessment = resp;
            vm.start();
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
        });
        vm.resultBackups = {};
        vm.start = function () {
            if (vm.userAssessment.sections.length) {
                vm.activeSection = vm.userAssessment.sections[0];
                if (vm.activeSection.screens)
                    vm.activeScreen = vm.activeSection.screens[0];
            }
            _.each(vm.userAssessment.sections, function (section) {
                section.questionCount = 0;
                _.each(section.screens, function (screen) {
                    if (screen.screenLayout == 'Question')
                        screen.questionNumber = ++section.questionCount;
                });
            });
            vm.loadScreen(vm.activeSection, vm.activeScreen);
        };
        vm.showSection = function (section, $index) {
            vm.userAssessment.activeSectionId = section.assessmentSectionId;
            vm.activeSection = section;
        };
        vm.showScreen = function (section, screen, $index) {
            if (vm.userAssessment.activeScreenId != screen.assessmentScreenId) {
                vm.loadingScreen = true;
                vm.loadScreen(section, screen);
            }
        };
        vm.nextScreen = function () {
            var index = vm.activeSection.screens.indexOf(vm.activeScreen) + 1;
            if (index >= vm.activeSection.screens.length) {
                var secindex = vm.userAssessment.sections.indexOf(vm.activeSection) + 1;
                if (secindex >= vm.userAssessment.sections.length) {
                    if (vm.content.forwardOnly) {
                        vm.showEnd = true;
                    } else return;
                }
                vm.showSection(vm.userAssessment.sections[secindex], secindex);
                index = 0;
            }
            vm.showScreen(vm.activeSection, vm.activeSection.screens[index], index);
        };
        vm.isDirty = function (screenId, result) {
            return vm.resultBackups[screenId].isCorrect != result.isCorrect
                || vm.resultBackups[screenId].score != result.score;
        };
        vm.gradeScreen = function () {
            vm.submitting = true;
            AssessmentService.gradeUserAssessmentScreen(vm.userAssessment.userAssessmentLogId, vm.activeScreen.contentQuestion.result.userQuestionLogId, vm.activeScreen.contentQuestion.result).then(function (resp) {
                vm.resultBackups[vm.activeScreen.assessmentScreenId] = angular.copy(vm.activeScreen.contentQuestion.result);
                vm.submitting = false;
            }, function () {
                vm.submitting = false;
            });
        };
        vm.loadScreen = function (section, screen) {
            if (screen.loaded) {
                vm.userAssessment.activeScreenId = screen.assessmentScreenId;
                vm.activeScreen = screen;
                vm.loadingScreen = false;
                vm.first = false;
            } else {
                vm.loadingScreen = true;
                var onScreen = function (resp) {
                    if (screen.screenLayout == 'Question') {
                        screen.contentQuestion = resp;
                        vm.resultBackups[screen.assessmentScreenId] = angular.copy(resp.result);
                        if (resp.answerGiven) {
                            if (screen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer' || screen.contentQuestion.questionType == 'MultipleChoiceMultipleAnswers') {
                                _.each(screen.contentQuestion.contentMultipleChoiceAnswers, function (a, index) {
                                    if (a.answerNumber <= resp.answerGiven.length) {
                                        a.isCorrect = resp.answerGiven[a.answerNumber - 1] == '1';
                                        if (a.isCorrect) screen.contentQuestion.selectedAnswer = index;
                                    }
                                });
                            } else if (screen.contentQuestion.questionType == 'Matching') {
                                var answerDict = angular.fromJson(resp.answerGiven);
                                _.each(screen.contentQuestion.contentMatchingOptions, function (opt, index) {
                                    if (answerDict && answerDict[index + 1] && answerDict[index + 1] != '')
                                        opt.contentMatchingAnswer = { matchingAnswerKey: answerDict[index + 1] };
                                    else
                                        opt.contentMatchingAnswer = { matchingAnswerKey: "" };
                                });
                            }
                        }
                    } else
                        angular.extend(screen, resp);
                    screen.loaded = true;
                    vm.userAssessment.activeScreenId = screen.assessmentScreenId;
                    vm.activeScreen = screen;
                    vm.loadingScreen = false;
                    vm.first = false;
                };
                if (screen.screenLayout == 'Question')
                    AssessmentService.getReviewUserQuestionScreen(vm.userAssessment.userAssessmentLogId, screen.assessmentScreenId).then(function (resp) { onScreen(resp) }, function () { });
                else
                    AssessmentService.getScreen(screen.assessmentScreenId, 'TextScreen').then(function (resp) { onScreen(resp) }, function () { });
            }
        };
        vm.close = function () {
            vm.loadingScreen = true;
            AssessmentService.getUserAssessmentResult(content.contentId, userId).then(function (resp) {
                vm.loadingScreen = false;
                $uibModalInstance.close({
                    userAssessmentLogId: vm.userAssessment.userAssessmentLogId,
                    summary: resp
                });
            }, function () {
                vm.loadingScreen = false;
            });
        };
    });

'use strict';

angular.module('lms')
  .controller('CourseContentController', function ($window, $interval, $timeout, $scope, $stateParams, $location, AuthenticationService, CourseService, LogService, StatsService, AzureStorage, SweetAlert, toaster) {
        var vm = this;
        $scope.$on('$destroy', function () {
            $window.removeEventListener('message', windowMessageHandler);
            _.each(vm.contentIntervals, function (interval) {
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                    interval = undefined;
                }
            });
            _.each(vm.pageIntervals, function (interval) {
                if (angular.isDefined(interval)) {
                    $interval.cancel(interval);
                    interval = undefined;
                }
            });
        });
        vm.contentIdList = [];
        vm.sortableOptions = {
            connectWith: ".connectPanels",
            handle: ".ibox-title",
            stop: function (event, ui) {
                var idList = _.pluck(vm.node.content, "contentId");
                vm.dragDirty = vm.contentIdList.join(",") != idList.join(",");
            }
        };
        vm.saveDragOrder = function () {
            vm.saving = true;
            var idList = _.pluck(vm.node.content, "contentId");
            var toSave = [];
            _.each(idList, function (id, i) {
                var pos = i + 1;
                if (vm.contentIdList.length > i) {
                    if (vm.contentIdList[i] != id)
                        toSave.push({ contentId: id, sequenceNo: pos });
                } else toSave.push({ contentId: id, sequenceNo: pos });
            });
            CourseService.saveContentSequence(toSave).then(function (resp) {
                vm.contentIdList = idList;
                vm.dragDirty = false;
                vm.saving = false;
            }, function () {
                vm.saving = false;
            });
        };
        vm.loaded = false;
        vm.newContent = {};
        vm.contentTypes = [
            { text: "Text / Images", desc: 'Rich text editor for you to insert free text, articles and images', value: "RichTextFormat", icon: "file-text-o" },
            { text: "Video", desc: 'Upload a video file for students to watch. Videos are protected and cannot be downloaded.', value: "VideoFile", icon: "film" },
            { text: "Audio", desc: 'Upload an audio file for students to listen to. Audios are protected and cannot be downloaded.', value: "AudioFile", icon: "microphone" },
            { text: "Assessment", desc: 'Create an assessment comprising sections and questions. Assessments can be time based.', value: "Assessment", icon: "question" },
            { text: "Assignment", desc: 'Create assignments and homework for students, so they can submit answers in the form of text or uploaded files', value: "Assignment", icon: "check-square-o" },
            { text: "PDF Upload", desc: 'Upload PDF files for students to view', value: "Pdf", icon: "book" },
            { text: "External Web Page", desc: 'Give a url to an external page for students to refer to', value: "ExternalUrl", icon: "link" }
            /*{ text: "From LTI Tool", desc: 'Embed content from other learning portals', value: "LtiApp", icon: "key" }
            { text: "Javascript", desc: '', value: "Javascript", icon: "code" }*/
        ];
        vm.courseId = $stateParams.id;
        vm.nodeId = $stateParams.nodeId;
        vm.locationContentId = $location.search().contentId;
        if (!CourseService.currentCourse || CourseService.currentCourse.courseId != vm.courseId) {
            CourseService.get(vm.courseId).then(function (course) {
                CourseService.setCurrentCourse(course);
            });
        }
        vm.contentIntervals = {};
        vm.pageIntervals = {};
        vm.pageLogIds = {};
        vm.contentLogIds = {};
        vm.currentViewContent = "";
        var getContentLogInterval = function (viewLogId) {
            return $interval(function () {
                LogService.postContentTime(viewLogId, 10);
            }, 10000);
        };
        var getPageLogInterval = function (pdfLogId) {
            return $interval(function () {
                LogService.postPdfPageTime(pdfLogId, 10);
            }, 10000);
        };
        CourseService.getNode(vm.nodeId).then(function (node) {
            vm.node = node;
            vm.contentStats = _.indexBy(node.contentStats, "contentId");
            vm.userContentStats = _.indexBy(node.userContentStats, "contentId");
            vm.contentIdList = _.pluck(vm.node.content, "contentId");
          _.each(node.content, function (item) {
                if (item.type != 'Javascript' && vm.currentViewContent == "") vm.currentViewContent = item.contentId;
                if (item.type == 'Assessment' || item.type == 'Javascript') {
                    vm.openContent(item);
                } else {
                    if (item.type == 'Pdf')
                        vm.pdfPageNoDict[item.contentId] = -1;
                    if ((vm.locationContentId && vm.locationContentId == item.contentId) || item.autoLoad)
                        vm.openContent(item);
                }
                if (!item.autoLoad && vm.locationContentId && vm.locationContentId != item.contentId) {
                    item.defaultStyle = { display: 'none' };
                    item.defaultHidden = true;
                }
            });
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
            toaster.pop({
                type: 'error',
                title: 'Access denied',
                body: 'You do not have access to view content for this course',
                showCloseButton: true
            });
        });
        vm.viewPrevContent = function (index) {
          if (index > 0) {
            var item = vm.node.content[index - 1];
            vm.currentViewContent = item.contentId;
            if (!item.loaded) vm.openContent(item);
          }
        };
        vm.viewNextContent = function (index) {
          if (index < vm.node.content.length - 1) {
            var item = vm.node.content[index + 1];
            vm.currentViewContent = item.contentId;
            if (!item.loaded) vm.openContent(item);
          }
        };
        vm.openContent = function (item, onComplete) {
          if (AuthenticationService.isUserStudent() && item.contentId != vm.currentViewContent) return;
            item.loading = true;
            CourseService.getContent(item.contentId).then(function (content) {
                item.loading = false;
                if (item.type == 'Assignment' && content.submission) {
                    content.submission.essays = _.indexBy(content.submission.essays, 'assignmentPartId');
                    content.submission.uploads = _.indexBy(content.submission.uploads, 'assignmentPartId');
                    content.submission.recordings = _.indexBy(content.submission.recordings, 'assignmentPartId');
                }
                angular.copy(content, item);
                if (item.type == 'Assignment' && !AuthenticationService.isUserStudent()) {
                    item.submissions = [];
                    CourseService.getAssignmentSubmissions(item.contentId, 1).then(function (resp) {
                        item.submissions[1] = resp.list;
                    }, function () {
                    });
                }
                if (vm.contentStats[item.contentId]) item.contentStats = vm.contentStats[item.contentId];
                if (vm.userContentStats[item.contentId]) item.userContentStats = vm.userContentStats[item.contentId];
                if (AuthenticationService.isUserEducator() || AuthenticationService.isUserAdmin()) {
                    if ((item.type == 'VideoFile' || item.type == 'AudioFile') && ((item.upload && item.upload.done && !item.published) || (!item.upload && !item.published))) {
                        checkMediaPublished(item);
                    }
                }
                if (item.type == 'Pdf' || item.type == 'LtiApp') {
                    AuthenticationService.getUserOtp().then(function (otp) {
                        item.userOtp = otp;
                        item.loaded = true;
                    });
                } else
                    item.loaded = true;
                if (AuthenticationService.isUserStudent() && item.type != 'Assessment' && item.type != 'Javascript') {
                    vm.contentIntervals[item.contentId] = getContentLogInterval(content.viewLogId);
                    vm.contentLogIds[item.contentId] = content.viewLogId;
                }
                if (onComplete) onComplete(item);
            }, function () {
                item.loading = false;
            });
        };
        vm.pdfPageNoDict = {};
        var windowMessageHandler = function (event) {
            if (typeof (event.data) !== 'undefined') {
                var message = angular.fromJson(event.data);
                if (message.callback == 'pageview') {
                    if (vm.pdfPageNoDict[message.data.contentId] != message.data.pageNo) {
                        vm.pdfPageNoDict[message.data.contentId] = message.data.pageNo;
                        if (AuthenticationService.isUserStudent()) {
                            if (message.data.viewLogId == vm.contentLogIds[message.data.contentId]) {
                                if (angular.isDefined(vm.pageIntervals[message.data.contentId])) {
                                    $interval.cancel(vm.pageIntervals[message.data.contentId]);
                                    vm.pageIntervals[message.data.contentId] = undefined;
                                }
                                LogService.postPdfPageView(message.data.viewLogId, message.data.contentId, message.data.pageNo).then(function (resp) {
                                    var pdfLogId = resp.id;
                                    vm.pageLogIds[message.data.contentId] = pdfLogId;
                                    vm.pageIntervals[message.data.contentId] = getPageLogInterval(pdfLogId);
                                }, function () {
                                });
                            }
                        } else {
                            var mycontent = _.filter(vm.node.content, function (item) {
                                return item.contentId == message.data.contentId;
                            })[0];
                            StatsService.getPdfPageStats(message.data.contentId, mycontent.revisionNumber, message.data.pageNo, message.data.totalPages).then(function (resp) {
                                mycontent.pageStats = resp;
                                mycontent.pageStats.pageNo = message.data.pageNo;
                            }, function () {
                            });
                        }
                    }
                }
            }
        };
        $window.addEventListener('message', windowMessageHandler);
        vm.pdfStatsOptions = {
            grid: {
                hoverable: true,
                clickable: true,
                tickColor: "#d5d5d5",
                borderWidth: 0,
                color: '#d5d5d5'
            },
            colors: ["#1ab394", "#464f88"],
            tooltip: true,
            xaxis: {
                mode: "categories",
                axisLabel: "Page No.",
                axisLabelUseCanvas: true,
                axisLabelFontSizePixels: 12,
                axisLabelFontFamily: 'Arial',
                axisLabelPadding: 10,
                color: "#d5d5d5"
            },
            yaxes: [
                {
                    position: "left",
                    color: "#d5d5d5",
                    axisLabelUseCanvas: true,
                    axisLabelFontSizePixels: 12,
                    axisLabelFontFamily: 'Arial',
                    axisLabelPadding: 3
                },
                {
                    position: "right",
                    color: "#d5d5d5",
                    axisLabelUseCanvas: true,
                    axisLabelFontSizePixels: 12,
                    axisLabelFontFamily: ' Arial',
                    axisLabelPadding: 67
                }
            ],
            legend: {
                noColumns: 1,
                labelBoxBorderColor: "#d5d5d5",
                position: "nw"
            }
        };
        vm.showMoreStats = function (content) {
            if (!content.moreStatsShown) {
                content.moreStatsShown = true;
                StatsService.getPdfStats(content.contentId).then(function (resp) {
                    var pages = [];
                    for (var i = 0; i < resp.pages; i++) {
                        pages[i] = i + 1;
                    }
                    var dataset = [
                        {
                            label: "Number of views",
                            grow: { stepMode: "linear" },
                            data: resp.general.count,
                            color: "#1ab394",
                            bars: {
                                show: true,
                                align: "center",
                                barWidth: 0.2,
                                lineWidth: 0
                            }
                        },
                        {
                            label: "Average Time Spent",
                            grow: { stepMode: "linear" },
                            data: resp.general.avgTime,
                            yaxis: 2,
                            color: "#1C84C6",
                            lines: {
                                lineWidth: 1,
                                show: true,
                                fill: true,
                                fillColor: {
                                    colors: [
                                        {
                                            opacity: 0.2
                                        },
                                        {
                                            opacity: 0.2
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            label: "Max Time Spent",
                            grow: { stepMode: "linear" },
                            data: resp.general.maxTime,
                            yaxis: 2,
                            color: "#464f88",
                            lines: {
                                lineWidth: 1,
                                show: true,
                                fill: true,
                                fillColor: {
                                    colors: [
                                        {
                                            opacity: 0.2
                                        },
                                        {
                                            opacity: 0.2
                                        }
                                    ]
                                }
                            }
                        }
                    ];
                    content.pdfStats = dataset;
                }, function () {
                    content.moreStatsShown = false;
                });
            }
        };
        vm.newContentTypeSelected = function (selectedItem) {
            if (selectedItem.value == 'Assessment' && !vm.newContent.durationType) {
                vm.newContent.label = 'Assessment';
                vm.newContent.correctAnswerPoints = 1;
                vm.newContent.wrongAnswerPoints = 0;
                vm.newContent.durationType = 'Assessment';
                vm.newContent.duration = 120;
                vm.newContent.maxAttempts = 1;
                vm.newContent.scoreType = 1;
            } else if (selectedItem.value == 'LtiApp' || selectedItem.value == 'ExternalUrl') {
                if (!vm.newContent.widthUnit) vm.newContent.widthUnit = "px";
                if (!vm.newContent.heightUnit) vm.newContent.heightUnit = "px";
            }
        };
        vm.addNew = function (form) {
            if (!form.$valid) return;
            var run = function () {
                vm.newContent.sequenceNo = vm.node.content.length + 1;
                vm.newContent.autoLoad = true;
                vm.newContent.showHeader = true;
                vm.newContent.saving = true;
                CourseService.addContent(vm.nodeId, vm.newContent).then(function (resp) {
                    var contentObj = {
                        contentId: resp.contentId,
                        name: vm.newContent.name,
                        preInstructions: vm.newContent.preInstructions,
                        description: vm.newContent.description,
                        postInstructions: vm.newContent.postInstructions,
                        type: vm.newContent.type,
                        revisionNumber: 1,
                        available: false,
                        autoLoad: true,
                        showHeader: true,
                        loaded: true
                    };
                    if (vm.contentProcessors[contentObj.type]) vm.contentProcessors[contentObj.type](contentObj, vm.newContent, resp);
                    vm.node.content.push(contentObj);
                    vm.contentIdList.push(resp.contentId);
                    vm.newContent.saving = false;
                    vm.newContent = {};
                    form.$submitted = false;
                }, function () {
                    vm.newContent.saving = false;
                    toaster.pop({
                        type: 'error',
                        title: 'Save Failed',
                        body: 'There was an unexpected error while saving this content. Please try again.',
                        showCloseButton: true
                    });
                });
            };
            if (vm.newContent.type == 'Assignment') {
                vm.newContent = vm.contentSavePreProcessors['Assignment'](vm.newContent);
                var uploads = _.filter(vm.newContent.parts, function (part) { return part.type == 'File' && part.assignmentPartFile.file; });
                if (uploads.length > 0) {
                    vm.newContent.saving = true;
                    CourseService.uploadAssignmentFiles(uploads).then(function (resp) {
                        vm.newContent.files = resp.files;
                        run();
                    }, function () {
                    });
                } else run();
            } else if (vm.newContent.type == 'Pdf') {
                vm.newContent.saving = true;
                CourseService.uploadPdfFile(vm.newContent.file).then(function (resp) {
                    vm.newContent.path = resp.files.file;
                    run();
                }, function () {
                });
            } else if (vm.newContent.type == 'VideoFile' || vm.newContent.type == 'AudioFile') {
                var file = vm.newContent.file;
                vm.newContent.fileName = file.name;
                vm.newContent.fileSize = file.size;
                vm.newContent.fileType = file.type;
                run();
            } else run();
        };
        var mediaFunc = function (contentObj, newContent, resp) {
            contentObj.upload = {
                done: false,
                progress: 0,
                alert: ""
            };
            AzureStorage.uploadFile(contentObj.type, contentObj.contentId, newContent.file, resp.asset).then(function (uploadResp) {
                contentObj.upload.progress = 100;
                contentObj.upload.done = true;
                $timeout(function () { checkMediaPublished(contentObj) }, 5000);
            }, function (error) {
            }, function (progress) {
                if (progress.type == 'upload-progress')
                    contentObj.upload.progress = progress.progress;
                else if (progress.type == 'message')
                    contentObj.upload.alert = progress.msg;
            });
        };
        var checkMediaPublished = function (contentObj) {
            AzureStorage.checkPublishStatus(contentObj.type, contentObj.contentId).then(function (statusResp) {
                if (statusResp.isPublished) {
                    contentObj.published = true;
                    if (contentObj.type == 'VideoFile')
                        contentObj.videoUrl = statusResp.url;
                    else if (contentObj.type == 'AudioFile')
                        contentObj.audioUrl = statusResp.url;
                    toaster.pop({
                        type: 'success',
                        title: contentObj.name + ' has been processed successfully',
                        showCloseButton: true
                    });
                } else {
                    $timeout(function () { checkMediaPublished(contentObj) }, 5000);
                }
            });
        }
        vm.contentProcessors = {
            RichTextFormat: function (contentObj, newContent) {
                contentObj.contentHtml = newContent.contentHtml;
            },
            Javascript: function (contentObj, newContent) {
                contentObj.externalScriptId = newContent.externalScriptId;
            },
            LtiApp: function (contentObj, newContent, resp) {
                contentObj.ltiAppId = newContent.ltiAppId;
                contentObj.endpointExtension = newContent.endpointExtension;
                contentObj.widthValue = newContent.widthValue;
                contentObj.widthUnit = newContent.widthUnit;
                contentObj.heightValue = newContent.heightValue;
                contentObj.heightUnit = newContent.heightUnit;
                contentObj.popout = resp.popout;
            },
            ExternalUrl: function (contentObj, newContent, resp) {
                contentObj.url = newContent.url;
                contentObj.widthValue = newContent.widthValue;
                contentObj.widthUnit = newContent.widthUnit;
                contentObj.heightValue = newContent.heightValue;
                contentObj.heightUnit = newContent.heightUnit;
                contentObj.popout = resp.popout;
            },
            Assessment: function (contentObj, newContent, resp) {
                contentObj.label = newContent.label;
                contentObj.correctAnswerPoints = newContent.correctAnswerPoints;
                contentObj.wrongAnswerPoints = newContent.wrongAnswerPoints;
                contentObj.durationType = newContent.durationType;
                contentObj.duration = newContent.duration;
                contentObj.forwardOnly = newContent.forwardOnly;
                contentObj.allowViewSolutions = newContent.allowViewSolutions;
                contentObj.allowResume = newContent.allowResume;
                contentObj.maxAttempts = newContent.maxAttempts;
                contentObj.scoreType = newContent.scoreType;
                contentObj.editing = true;
                contentObj.sections = resp.sections;
            },
            Assignment: function (contentObj, newContent, resp) {
                contentObj.dueDate = newContent.dueDate;
                contentObj.maximumPoints = newContent.maximumPoints;
                contentObj.parts = newContent.parts;
                vm.contentSavePostProcessors['Assignment'](contentObj, resp);
            },
            Pdf: function (contentObj, newContent, resp) {
                contentObj.fileSize = resp.fileSize;
                contentObj.description = newContent.description;
                contentObj.watermark = newContent.watermark;
            },
            VideoFile: mediaFunc,
            AudioFile: mediaFunc
        };
        vm.contentSavePreProcessors = {
            Assessment: function (item) {
                _.each(item.sections, function (section, index) {
                    section.sectionNumber = index + 1;
                    _.each(section.screens, function (screen, sindex) {
                        screen.screenNumber = sindex + 1;
                        if (screen.screenLayout == 'Question' && screen.contentQuestion) {
                            if (screen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer' || screen.contentQuestion.questionType == 'MultipleChoiceMultipleAnswers') {
                                _.each(screen.contentQuestion.contentMultipleChoiceAnswers, function (answer, aindex) {
                                    answer.answerNumber = aindex + 1;
                                    if (screen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer')
                                        answer.isCorrect = aindex == screen.contentQuestion.selectedAnswer;
                                });
                            } else if (screen.contentQuestion.questionType == 'Matching') {
                                _.each(screen.contentQuestion.contentMatchingOptions, function (option, oindex) {
                                    option.optionNumber = oindex + 1;
                                });
                            }
                        }
                    });
                });
                var contentObj = angular.copy(item);
                if (contentObj.activeScreen) delete contentObj.activeScreen;
                if (contentObj.submissions) delete contentObj.submissions;
                /*_.each(contentObj.sections, function (section) {
                    section.screens = _.filter(section.screens, function (screen) {
                        return !screen.assessmentScreenId || screen.textContent || screen.contentQuestion;
                    });
                });*/
                return contentObj;
            },
            Assignment: function (item) {
                _.each(item.parts, function (part, index) {
                    part.sequenceNumber = index + 1;
                });
                var contentObj = angular.copy(item);
                contentObj.dueDate = moment(contentObj.dueDate).format("YYYY-MM-DD");
                if (contentObj.submissions) delete contentObj.submissions;
                return contentObj;
            }
        };
        vm.contentSavePostProcessors = {
            Assessment: function (item, resp) {
                _.each(item.sections, function (section) {
                    var sectionResult = resp.idResults.sections[section.sectionNumber];
                    section.assessmentSectionId = sectionResult.sectionId;
                    section.questionCount = 0;
                    _.each(section.screens, function (screen) {
                        var screenResult = sectionResult.screens[screen.screenNumber];
                        screen.assessmentScreenId = screenResult.screenId;
                        if (screen.screenLayout == 'Question') {
                            screen.questionNumber = ++section.questionCount;
                            if (screen.contentQuestion) {
                                screen.contentQuestion.questionId = screenResult.questionId;
                                if (screenResult.answers) {
                                    if (screen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer' || screen.contentQuestion.questionType == 'MultipleChoiceMultipleAnswers') {
                                        _.each(screen.contentQuestion.contentMultipleChoiceAnswers, function (answer) {
                                            var answerResult = screenResult.answers[answer.answerNumber];
                                            answer.answerId = answerResult.answerId;
                                        });
                                    } else if (screen.contentQuestion.questionType == 'Matching') {
                                        _.each(screen.contentQuestion.contentMatchingOptions, function (option) {
                                            var optionResult = screenResult.matchingOptions[option.optionNumber];
                                            option.matchingOptionId = optionResult.optionId;
                                            if (!option.contentMatchingAnswer) option.contentMatchingAnswer = {};
                                            option.contentMatchingAnswer.matchingAnswerId = optionResult.answerId;
                                        });
                                    }
                                }
                            }
                        }
                    });
                });
            },
            Assignment: function (item, resp) {
                _.each(item.parts, function (part) {
                    part.assignmentPartId = resp.idResults[part.sequenceNumber];
                    if (resp.files && resp.files[part.sequenceNumber]) {
                        part.assignmentPartFile.fileName = resp.files[part.sequenceNumber].fileName;
                        part.assignmentPartFile.fileType = resp.files[part.sequenceNumber].fileType;
                        part.assignmentPartFile.fileSize = resp.files[part.sequenceNumber].fileSize;
                    }
                });
            },
            Pdf: function (item, resp) {
                if (resp.fileSize) item.fileSize = resp.fileSize;
                AuthenticationService.getUserOtp().then(function (otp) {
                    item.userOtp = otp;
                });
            },
            VideoFile: function (item, resp) {
                if (item.file) mediaFunc(item, item, resp);
            },
            AudioFile: function (item, resp) {
                if (item.file) mediaFunc(item, item, resp);
            },
            LtiApp: function (item, resp) {
                item.popout = resp.popout;
                AuthenticationService.getUserOtp().then(function (otp) {
                    item.userOtp = otp;
                });
            },
            ExternalUrl: function (item, resp) {
                item.popout = resp.popout;
            }
        };
        vm.deleteContent = function (item) {
            SweetAlert.swal({
                title: "Are you sure you wish to delete this content?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                closeOnConfirm: false,
                closeOnCancel: true },
                function (isConfirm) {
                    if (isConfirm) {
                        SweetAlert.swal("Deleted!", "This content has been deleted.", "success");
                    }
                });
        };
        vm.contentBackups = {};
        vm.editContent = function (item) {
            vm.contentBackups[item.contentId] = angular.copy(item);
            item.editing = true;
            if (!item.loaded)
                vm.openContent(item, function (item) { item.editing = true; });
        };
        vm.cancelEditContent = function (item, index) {
            item.editing = false;
            vm.node.content[index] = angular.copy(vm.contentBackups[item.contentId]);
        };
        vm.saveContent = function (form, item) {
            if (!form.$valid) return;
            item.saving = true;
            var itemToSave;
            if (vm.contentSavePreProcessors[item.type]) itemToSave = vm.contentSavePreProcessors[item.type](item);
            else itemToSave = angular.copy(item);
            if (itemToSave.contentStats) delete itemToSave.contentStats;
            if (itemToSave.userContentStats) delete itemToSave.userContentStats;
            if (itemToSave.pageStats) delete itemToSave.pageStats;
            if (itemToSave.pdfStats) delete itemToSave.pdfStats;
            var run = function (itemToSave) {
                CourseService.saveContent(itemToSave).then(function (resp) {
                    if (vm.contentBackups[item.contentId]) delete vm.contentBackups[item.contentId];
                    if (vm.contentSavePostProcessors[item.type]) vm.contentSavePostProcessors[item.type](item, resp);
                    item.revisionNumber = resp.revision;
                    item.editing = false;
                    item.saving = false;
                    form.$submitted = false;
                }, function () {
                    item.saving = false;
                });
            }
            if (itemToSave.type == 'Assignment') {
                var uploads = _.filter(item.parts, function (part) { return part.type == 'File' && part.assignmentPartFile.file; });
                if (uploads.length > 0) {
                    CourseService.uploadAssignmentFiles(uploads).then(function (resp) {
                        itemToSave.files = resp.files;
                        run(itemToSave);
                    }, function () {
                    });
                } else run(itemToSave);
            } else if (itemToSave.type == 'Pdf') {
                if (item.file) {
                    CourseService.uploadPdfFile(item.file).then(function (resp) {
                        itemToSave.path = resp.files.file;
                        run(itemToSave);
                    }, function () {
                    });
                } else run(itemToSave);
            } else if (itemToSave.type == 'VideoFile' || itemToSave.type == 'AudioFile') {
                if (item.file) {
                    var file = item.file;
                    itemToSave.fileName = file.name;
                    itemToSave.fileSize = file.size;
                    itemToSave.fileType = file.type;
                }
                run(itemToSave);
            } else run(itemToSave);
        };
        vm.onContentExpanded = function (isExpanded, content) {
            if (!content.loaded) vm.openContent(content);
        };
        vm.onContentToggled = function (isHidden, content) {
            if (AuthenticationService.isUserStudent() && content.type != 'Assessment' && content.type != 'Javascript' && content.loaded) {
                if (isHidden) {
                    $interval.cancel(vm.contentIntervals[content.contentId]);
                    vm.contentIntervals[content.contentId] = undefined;
                    if (angular.isDefined(vm.pageIntervals[content.contentId])) {
                        $interval.cancel(vm.pageIntervals[content.contentId]);
                        vm.pageIntervals[content.contentId] = undefined;
                    }
                } else {
                    vm.contentIntervals[content.contentId] = getContentLogInterval(content.viewLogId);
                    if (content.type == 'Pdf' && vm.pageLogIds[content.contentId]) {
                        vm.pageIntervals[content.contentId] = getPageLogInterval(vm.pageLogIds[content.contentId]);
                    }
                }
            }
        };
    });

'use strict';

/**
    * videoJs - Directive to encapsulate videojs - https://www.npmjs.com/package/videojs-record
    */
angular.module('lms')
    .directive('videoJs', function () {
        return {
            scope: {
                maxLength: '=',
                onRecorded: '&'
            },
            templateUrl: 'app/components/directives/videojs.html',
            link: function (scope, element) {
                var maxlen = scope.maxLength || 0;
                var options = {
                    controls: true,
                    width: 640,
                    height: 480,
                    fluid: true,
                    plugins: {
                        record: {
                            audio: true,
                            video: true,
                            maxLength: maxlen,
                            videoMimeType: 'video/webm;codecs=H264', //'video/mp4',
                            debug: true
                        }
                    }
                };
                scope.player = videojs(element.context, options, function () {
                    // print version information at startup
                    var msg = 'Using video.js ' + videojs.VERSION +
                        ' with videojs-record ' + videojs.getPluginVersion('record') +
                        ' and recordrtc ' + RecordRTC.version;
                    videojs.log(msg);
                });
                // error handling
                scope.player.on('deviceError', function () {
                    //console.log('device error:', player.deviceErrorCode);
                });

                scope.player.on('error', function (error) {
                    //console.log('error:', error);
                });

                // user clicked the record button and started recording
                scope.player.on('startRecord', function () {
                    //console.log('started recording!');
                });

                // user completed recording and stream is available
                scope.player.on('finishRecord', function () {
                    // the blob object contains the recorded data that
                    // can be downloaded by the user, stored on server etc.
                    //console.log('finished recording:', scope.player.recordedData);

                    //scope.player.saveAs();

                    var data = scope.player.recordedData;
                    if (scope.player.recordedData.video) {
                        // for chrome for audio+video
                        data = scope.player.recordedData.video;
                    }

                    //data.name = data.name.replace(".webm", ".mp4");

                    scope.onRecorded({data: data});
                });
            }
        };
    });
'use strict';

/**
    * validationResult - Wrapper for displaying validation errors
    */
angular.module('lms')
    .directive('validationResult', function () {
        return {
            restrict: 'EA',
            scope: {
                myform: '=',
                element: '@',
                requiredText: '@',
                emailText: '@',
                urlText: '@',
                fileText: '@',
                arrayText: '@',
                matchingText: '@'
            },
            templateUrl: 'app/components/directives/validation.result.html',
            controller: function ($scope, $element, $attrs) {
            }
        };
    });
'use strict';

/**
    * summernoteEditor - Wrapper for summernote
    */
angular.module('lms')
    .directive('summernoteEditor', function (FileService, GlobalService, toaster) {
        return {
            restrict: 'A',
            scope: {
                summernoteEditor: '=',
                config: '='
            },
            templateUrl: 'app/components/directives/summernote.editor.html',
            controller: function ($scope, $element, $attrs) {
                $scope.imageUpload = function (files) {
                    toaster.pop({
                        type: 'wait',
                        title: 'Adding Images',
                        body: 'Your images are being added...',
                        timeout: 0
                    });
                    var editor = $scope.editor;
                    FileService.uploadWysiwygFiles(files, "Content").then(function (resp) {
                        for (var key in resp.files) {
                            editor.summernote('insertImage', GlobalService.CdnBase + "/Api/File/Public/" + resp.files[key], key);
                        }
                        toaster.clear();
                        toaster.pop({
                            type: 'success',
                            title: 'Images added',
                            body: 'Your images have been added successfully',
                            showCloseButton: true
                        });
                    }, function () {
                    });
                }
            }
        };
    });

'use strict';

/**
    * iboxTools - Directive for iBox tools elements in right corner of ibox
    */
angular.module('lms')
    .directive('spinnerWave', function () {
        return {
            restrict: 'A',
            transclude: true,
            templateUrl: 'app/components/directives/spinner.wave.html',
            controller: function () { }
        };
    });
'use strict';

/**
    * iboxTools - Directive for iBox tools elements in right corner of ibox
    */
angular.module('lms')
    .directive('spinnerCircle', function () {
        return {
            restrict: 'A',
            templateUrl: 'app/components/directives/spinner.circle.html',
            controller: function () { }
        };
    });
'use strict';

/**
    * recipients - Directive for providing autocomplete of mailbox recipient box
    */
angular.module('lms')
    .directive('recipients', function ($timeout, MailboxService) {
        return {
            restrict: 'A',
            scope: {
                recipientList: '='
            },
            templateUrl: 'app/components/directives/recipients.html',
            controller: function ($scope, $element, $attrs) {
                $scope.peopleCache = {};
                $scope.people = [];
                $scope.peopleSearchTimeout = null;
                $scope.latestSearchTerm = "";
                $scope.getPeople = function (searchTerm) {
                    if (searchTerm) {
                        $scope.latestSearchTerm = searchTerm;
                        if ($scope.peopleSearchTimeout) $timeout.cancel($scope.peopleSearchTimeout);
                        if ($scope.peopleCache[searchTerm]) $scope.people = $scope.peopleCache[searchTerm];
                        else {
                            $scope.peopleSearchTimeout = $timeout(function (searchTerm) {
                                MailboxService.getPeople(searchTerm).then(function (resp) {
                                    if ($scope.latestSearchTerm == searchTerm)
                                        $scope.people = resp;
                                    $scope.peopleCache[searchTerm] = resp;
                                }, function () {
                                });
                            }(searchTerm), 400);
                        }
                    }
                };
            }
        };
    });
'use strict';

/**
    * pdfViewer
    */
angular.module('lms')
    .directive('pdfViewer', function () {
        return {
            scope: {
                pdfUrl: '=',
                pdfPassword: '='
            },
            templateUrl: 'app/components/directives/pdf.viewer.html',
            controller: function ($scope, $element, $attrs) {
              $scope.getNavStyle = function (scroll) {
                if (scroll > 100) return 'pdf-controls fixed';
                else return 'pdf-controls';
              };
              /*$scope.onError = function (error) {
                console.log(error);
              }*/

              $scope.onLoad = function () {
                $scope.loading = '';
              }

              /*$scope.onProgress = function (progressData) {
                console.log(progressData);
              };*/

              $scope.onPassword = function (updatePasswordFn, passwordResponse) {
                if (passwordResponse === PDFJS.PasswordResponses.NEED_PASSWORD) {
                  updatePasswordFn($scope.pdfPassword);
                } else if (passwordResponse === PDFJS.PasswordResponses.INCORRECT_PASSWORD) {
                  //console.log('Incorrect password')
                }
              };
            }
        };
    });

'use strict';

/**
    * iboxTools - Directive for iBox tools elements in right corner of ibox
    */
angular.module('lms')
    .directive('iboxTools', function ($timeout, $document) {
        return {
            restrict: 'A',
            scope: {
                closebox: '&',
                disableClose: '=',
                onExpand: '&',
                onToggle: '&',
                defaultHidden: '='
            },
            transclude: true,
            templateUrl: 'app/components/directives/iboxtools.html',
            controller: function ($scope, $element, $attrs) {
                $scope.canExpand = $attrs.canExpand;
                // Function for collapse ibox
                $scope.showhide = function () {
                    var ibox = $element.closest('div.ibox');
                    var icon = $element.find('i.fa-chevron-up:first,i.fa-chevron-down:first');
                    $scope.isHidden = icon.hasClass('fa-chevron-up');
                    $scope.onToggle({ isHidden: $scope.isHidden });
                    var content = ibox.find('div.ibox-content');
                    content.slideToggle(200);
                    // Toggle icon from up to down
                    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                    ibox.toggleClass('').toggleClass('border-bottom');
                    if (!$scope.isHidden) {
                        var iframeObj = ibox.find('.ibox-content iframe');
                        if (iframeObj && iframeObj[0])
                            iframeObj[0].contentWindow.postMessage(angular.toJson({ callback: 'resetView' }), "*");
                    }
                    $timeout(function () {
                        ibox.resize();
                        ibox.find('[id^=map-]').resize();
                    }, 50);
                };
                // Function for full screen
                $scope.fullscreen = function () {
                    var ibox = $element.closest('div.ibox');
                    var button = $element.find('i.fa-expand,i.fa-compress');
                    var hasExpanded = button.hasClass('fa-expand');
                    angular.element('body').toggleClass('fullscreen-ibox-mode');
                    button.toggleClass('fa-expand').toggleClass('fa-compress');
                    ibox.toggleClass('fullscreen');
                    $timeout(function () {
                        angular.element(window).trigger('resize');
                        $scope.onExpand({ isExpanded: hasExpanded });
                    }, 100);
                }
                // Function for close ibox
                if (!$attrs.closebox)
                    $scope.closebox = function () {
                        var ibox = $element.closest('div.ibox');
                        ibox.remove();
                    }
            }
        };
    });
'use strict';

/**
    * Course content view directive
    */
angular.module('lms')
    .directive('contentView', function ($uibModal, SweetAlert, toaster, CourseService, AuthenticationService, AzureStorage, GlobalService, FileService) {
        return {
            restrict: 'A',
            scope: {
                content: '='
            },
            templateUrl: 'app/components/directives/course.content.view.html',
            controller: function ($scope, $element, $attrs, $window) {
                $scope.$on('onMediaPublished', function (event, item) {
                    if ($scope.content.contentId == item.id) {
                        $scope.content.published = true;
                        if (item.data.type == 'VideoFile')
                            $scope.content.videoUrl = item.data.url;
                        else if (item.data.type == 'AudioFile')
                            $scope.content.audioUrl = item.data.url;
                    }
                });
                $scope.summernoteOptions = {
                    toolbar: [
                            ['edit', ['undo', 'redo']],
                            ['headline', ['style']],
                            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                            ['fontface', ['fontname']],
                            ['textsize', ['fontsize']],
                            ['fontclr', ['color']],
                            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                            ['height', ['height']],
                            ['table', ['table']],
                            ['insert', ['link', 'hr']]
                    ]
                };
                $scope.userEmail = AuthenticationService.getSignedInUser().userEmail;
                $scope.userId = AuthenticationService.getSignedInUser().userId;
                $scope.isStudent = AuthenticationService.isUserStudent();
                $scope.isEduAdmin = AuthenticationService.isUserEducator() || AuthenticationService.isUserAdmin();
                $scope.cdnBase = GlobalService.CdnBase;
                $scope.ts = new Date().getTime();
                $scope.getPdfUrl = function() { return $scope.cdnBase + '/Api/File/Pdf/' + $scope.content.contentId },
                $scope.startAssessment = function (logId) {
                    var openModal = function () {
                        var modal = $uibModal.open({
                            animation: true,
                            templateUrl: 'app/courses/content/take.assessment.modal.html',
                            size: 'lg',
                            backdrop: 'static',
                            controller: 'TakeAssessmentModalController',
                            controllerAs: 'takeAssessmentCtrl',
                            resolve: {
                                content: function () { return $scope.content; },
                                resumeLogId: function () { return logId; },
                                loadPlugin: function ($ocLazyLoad) {
                                    return $ocLazyLoad.load([
                                        {
                                            name: 'ui.select',
                                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                                        },
                                        {
                                            name: 'chosen',
                                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                                        },
                                        {
                                            name: 'angular-timer',
                                            files: ['/Scripts/plugins/humanize-duration/humanize-duration.js', '/Scripts/plugins/angular-timer/dist/angular-timer.min.js']
                                        },
                                        {
                                            name: 'MathJax',
                                            files: ['/Scripts/plugins/MathJax/MathJax.js?config=MML_HTMLorMML-full']
                                        }
                                    ]);
                                }
                            }
                        });
                        modal.result.then(function (result) {
                            if (!$scope.content.attempts) $scope.content.attempts = [];
                            var log = _.filter($scope.content.attempts, function (attempt) {
                                return attempt.userAssessmentLogId == result.userAssessmentLogId;
                            });
                            if (log.length) angular.extend(log[0], result);
                            else $scope.content.attempts.push(result);
                        });
                    };
                    if (logId) openModal();
                    else {
                        SweetAlert.swal({
                            title: "Are you sure you wish to start this assessment?",
                            text: "",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, start it!",
                            cancelButtonText: "No",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                openModal();
                            }
                        });
                    }
                };
                $scope.reviewAssessment = function (submission) {
                    var openModal = function () {
                        var modal = $uibModal.open({
                            animation: true,
                            templateUrl: 'app/courses/content/review.assessment.modal.html',
                            size: 'lg',
                            backdrop: 'static',
                            controller: 'ReviewAssessmentModalController',
                            controllerAs: 'reviewAssessmentCtrl',
                            resolve: {
                                content: function () { return $scope.content; },
                                userId: function () { return submission.userId; },
                                loadPlugin: function ($ocLazyLoad) {
                                    return $ocLazyLoad.load([
                                        {
                                            name: 'ui.select',
                                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                                        },
                                        {
                                            name: 'chosen',
                                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                                        },
                                        {
                                            name: 'MathJax',
                                            files: ['/Scripts/plugins/MathJax/MathJax.js?config=MML_HTMLorMML-full']
                                        }
                                    ]);
                                }
                            }
                        });
                        modal.result.then(function (result) {
                            if (!$scope.content.submissions) $scope.content.submissions = [];
                            var log = _.filter($scope.content.submissions, function (submission) {
                                return submission.userId == result.summary.userId;
                            });
                            if (log.length) angular.extend(log[0], result.summary);
                            else $scope.content.submissions.push(result.summary);
                        });
                    };
                    openModal();
                };
                $scope.assignmentScope = {
                    recordings: {},
                    shareSubmission: function (submissionId, partId) {
                        $scope.assignmentScope.copyingImage = true;
                        CourseService.shareAssignmentImage(submissionId, partId).then(function (resp) {
                            $scope.assignmentScope.copyingImage = false;
                            var modal = $uibModal.open({
                                animation: true,
                                templateUrl: 'app/feed/create.feed.post.modal.html',
                                controller: 'CreateFeedPostModalController',
                                controllerAs: 'createFeedPostCtrl',
                                resolve: {
                                    images: function () { return [resp] },
                                    loadPlugin: function ($ocLazyLoad) {
                                        return $ocLazyLoad.load([
                                            {
                                                name: 'summernote',
                                                files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                                            }
                                        ]);
                                    }
                                }
                            });
                        }, function () {
                            $scope.assignmentScope.copyingImage = false;
                        });
                    },
                    onRecordingDone: function (data, partId) {
                        if (!$scope.content.submission) {
                            $scope.content.submission = {};
                        }
                        if (!$scope.content.submission.recordings) {
                            $scope.content.submission.recordings = {};
                        }
                        $scope.content.submission.recordings[partId] = {
                            fileName: data.name,
                            fileSize: data.size,
                            fileType: data.type
                        };
                        $scope.assignmentScope.recordings[partId] = data;
                    },
                    reRecord: function (partId) {
                        $scope.content.submission.recordings[partId].rerecord = true;
                    },
                    cancelReRecord: function (partId) {
                        $scope.content.submission.recordings[partId].rerecord = false;
                    },
                    save: function () {
                        if (!$scope.content.submission) {
                            toaster.pop({
                                type: 'warning',
                                title: 'Nothing to submit',
                                body: 'Please enter some answers before submitting',
                                showCloseButton: true
                            });
                            return false;
                        }
                        $scope.content.saving = true;
                        CourseService.saveAssignment($scope.content.contentId, $scope.content.submission, $scope.assignmentScope.recordings, 'Save').then(function (resp) {
                            $scope.assignmentScope.processAfterSave($scope.content.submission, resp);
                            $scope.content.saving = false;
                        }, function () {
                            $scope.content.saving = false;
                        });
                    },
                    submit: function () {
                        if (!$scope.content.submission) {
                            toaster.pop({
                                type: 'warning',
                                title: 'Nothing to submit',
                                body: 'Please enter some answers before submitting',
                                showCloseButton: true
                            });
                            return false;
                        }
                        SweetAlert.swal({
                            title: "Are you sure you wish to submit your assignment?",
                            text: "You will not be able to make any further edits after submitting the assignment",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, submit it!",
                            cancelButtonText: "No",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $scope.content.submitting = true;
                                CourseService.saveAssignment($scope.content.contentId, $scope.content.submission, $scope.assignmentScope.recordings, 'Submit').then(function (resp) {
                                    $scope.content.submission.submitted = true;
                                    $scope.assignmentScope.processAfterSave($scope.content.submission, resp);
                                    $scope.content.submitting = false;
                                }, function () {
                                    $scope.content.submitting = false;
                                });
                            }
                        });
                    },
                    processAfterSave: function (submission, resp) {
                        for (var key in submission.uploads) {
                            if (resp.files && resp.files[key]) {
                                var upload = submission.uploads[key];
                                var file = resp.files[key];
                                upload.fileName = file.fileName;
                                upload.fileType = file.fileType;
                                upload.fileSize = file.fileSize;
                                $scope.ts = new Date().getTime();
                                if (upload.file) delete upload.file;
                            }
                        }
                        for (var reckey in submission.recordings) {
                            if (resp.recordings && resp.recordings[reckey]) {
                                var recording = submission.recordings[reckey];
                                var recfile = resp.recordings[reckey];
                                recording.fileName = recfile.fileName;
                                recording.fileType = recfile.fileType;
                                recording.fileSize = recfile.fileSize;
                                recording.url = recfile.url;
                                if (recording.rerecord) recording.rerecord = false;
                            }
                            /*if (resp.recordings && resp.recordings[reckey]) {
                                var recording = submission.recordings[reckey];
                                var azureAsset = resp.recordings[reckey].azureAsset;
                                submission.recordings[reckey].upload = {
                                    done: false,
                                    progress: 0,
                                    alert: ""
                                };
                                AzureStorage.uploadFile("Recording", resp.recordings[reckey].recordingSubmissionId, $scope.assignmentScope.recordings[reckey], azureAsset).then(function (uploadResp) {
                                    submission.recordings[reckey].upload.progress = 100;
                                    submission.recordings[reckey].upload.done = true;
                                    $scope.assignmentScope.recordings[reckey] = null;
                                }, function (error) {
                                }, function (progress) {
                                    if (progress.type == 'upload-progress')
                                        submission.recordings[reckey].upload.progress = progress.progress;
                                    else if (progress.type == 'message')
                                        submission.recordings[reckey].upload.alert = progress.msg;
                                });
                            }*/
                        }
                    },
                    currentSubmissionPage: 1,
                    loadSubmissions: function () {
                        if (!$scope.content.submissions[$scope.assignmentScope.currentSubmissionPage]) {
                            $scope.assignmentScope.loadingSubmissions = true;
                            CourseService.getAssignmentSubmissions($scope.content.contentId, $scope.assignmentScope.currentSubmissionPage).then(function (resp) {
                                $scope.content.submissions[$scope.assignmentScope.currentSubmissionPage] = resp.list;
                                $scope.assignmentScope.loadingSubmissions = false;
                            }, function () {
                                $scope.assignmentScope.loadingSubmissions = false;
                            });
                        }
                    },
                    openSubmission: function (id, row) {
                        $scope.assignmentScope.loadingSubmission = true;
                        CourseService.getAssignmentSubmission($scope.content.contentId, id).then(function (resp) {
                            $scope.assignmentScope.currentSubmission = resp;
                            $scope.assignmentScope.currentSubmissionRow = row;
                            $scope.assignmentScope.currentSubmission.essays = _.indexBy($scope.assignmentScope.currentSubmission.essays, 'assignmentPartId');
                            $scope.assignmentScope.currentSubmission.uploads = _.indexBy($scope.assignmentScope.currentSubmission.uploads, 'assignmentPartId');
                            $scope.assignmentScope.loadingSubmission = false;
                        }, function () {
                            $scope.assignmentScope.loadingSubmission = false;
                        });
                    },
                    saveReview: function () {
                        var review = {
                            assignmentSubmissionId: $scope.assignmentScope.currentSubmission.assignmentSubmissionId,
                            pointsAwarded: $scope.assignmentScope.currentSubmission.pointsAwarded,
                            reviewerNotes: $scope.assignmentScope.currentSubmission.reviewerNotes,
                            parts: { }
                        }
                        _.each($scope.assignmentScope.currentSubmission.essays, function (essay) {
                            review.parts[essay.assignmentPartId] = { pointsAwarded: essay.pointsAwarded, reviewerNotes: essay.reviewerNotes };
                        });
                        _.each($scope.assignmentScope.currentSubmission.uploads, function (upload) {
                            review.parts[upload.assignmentPartId] = { pointsAwarded: upload.pointsAwarded, reviewerNotes: upload.reviewerNotes };
                        });
                        $scope.assignmentScope.savingReview = true;
                        CourseService.saveAssignmentReview($scope.content.contentId, $scope.assignmentScope.currentSubmission.assignmentSubmissionId, review).then(function (resp) {
                            toaster.pop({
                                type: 'success',
                                title: 'Review saved',
                                body: 'Your review has been saved successfully and will be available to the student',
                                showCloseButton: true
                            });
                            $scope.assignmentScope.currentSubmissionRow.reviewer = "Me";
                            $scope.assignmentScope.currentSubmissionRow.pointsAwarded = review.pointsAwarded;
                            $scope.assignmentScope.savingReview = false;
                        }, function () {
                            $scope.assignmentScope.savingReview = false;
                        });
                    }
                };
            }
        };
    });

'use strict';

/**
    * iboxTools - Directive for iBox tools elements in right corner of ibox
    */
angular.module('lms')
    .directive('contentEdit', function ($uibModal, ManageService, AssessmentService, CourseService, FileService, toaster) {
        return {
            restrict: 'A',
            scope: {
                content: '=',
                myform: '='
            },
            templateUrl: 'app/components/directives/course.content.edit.html',
            controller: function ($scope, $element, $attrs, SweetAlert) {
                $scope.loading = false;
                $scope.summernoteOptions = {
                    toolbar: [
                            ['edit', ['undo', 'redo']],
                            ['headline', ['style']],
                            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                            ['fontface', ['fontname']],
                            ['textsize', ['fontsize']],
                            ['fontclr', ['color']],
                            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                            ['height', ['height']],
                            ['table', ['table']],
                            ['insert', ['link', 'picture', 'hr']],
                            ['view', ['codeview']]
                    ]
                };
                $scope.summernoteQuestionOptions = {
                    toolbar: [
                            ['edit', ['undo', 'redo']],
                            ['headline', ['style']],
                            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                            ['fontface', ['fontname']],
                            ['textsize', ['fontsize']],
                            ['fontclr', ['color']],
                            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                            ['height', ['height']],
                            ['table', ['table']],
                            ['insert', ['link', 'picture', 'hr']]
                    ]
                };
                $scope.htmlScope = {
                    importUrl: function () {
                        SweetAlert.swal({
                            title: "Do you wish to continue?",
                            text: "Importing from HTML will overwrite any content you may already have in the editor. Do you wish to continue?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes",
                            cancelButtonText: "No",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $scope.htmlScope.saving = true;
                                CourseService.getHtmlFromUrl($scope.htmlScope.url).then(function (resp) {
                                    $scope.content.contentHtml = resp;
                                    $scope.htmlScope.url = "";
                                    $scope.htmlScope.showUrl = false;
                                    $scope.htmlScope.saving = false;
                                }, function () {
                                    $scope.htmlScope.saving = false;
                                });
                            }
                        });
                    },
                    uploadFile: function () {
                        SweetAlert.swal({
                            title: "Do you wish to continue?",
                            text: "Importing from HTML will overwrite any content you may already have in the editor. Do you wish to continue?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes",
                            cancelButtonText: "No",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $scope.htmlScope.saving = true;
                                var formdata = new FormData();
                                formdata.append('file', $scope.htmlScope.file);
                                CourseService.getHtmlFromUpload(formdata).then(function (resp) {
                                    $scope.content.contentHtml = resp;
                                    delete $scope.htmlScope.file;
                                    $scope.htmlScope.saving = false;
                                }, function () {
                                    $scope.htmlScope.saving = false;
                                });
                            }
                        });
                    }
                };
                $scope.ltiScope = {
                    getLtiApps: function () {
                        if ($scope.ltiApps) return $scope.ltiApps;
                        else if (!$scope.loading) {
                            $scope.loading = true;
                            ManageService.getLtiApps().then(function (ltiApps) {
                                $scope.ltiApps = ltiApps;
                                $scope.loading = false;
                                if ($scope.content.ltiAppId)
                                    $scope.ltiApp = _.filter($scope.ltiApps, function (item) { return item.ltiAppId == $scope.content.ltiAppId })[0];
                                return $scope.ltiApps;
                            }, function () {
                                $scope.loading = false;
                            });
                        }
                    },
                    onLtiSelected: function (selectedItem) {
                        $scope.ltiApp = selectedItem;
                    },
                    dimensionsOptions: {
                        min: 0,
                        max: 10000,
                        step: 1,
                        boostat: 100,
                        maxboostedstep: 100,
                        decimals: 0
                    },
                    dimensionUnits: ["px", "%"]
                };
                $scope.scriptScope = {
                    getScripts: function () {
                        if ($scope.scripts) return $scope.scripts;
                        else if (!$scope.loading) {
                            $scope.loading = true;
                            ManageService.getScripts().then(function (scripts) {
                                $scope.scripts = scripts;
                                $scope.loading = false;
                                return $scope.scripts;
                            }, function () {
                                $scope.loading = false;
                            });
                        }
                    },
                    onScriptSelected: function (selectedItem) {
                        $scope.script = selectedItem;
                    }
                };
                $scope.assessmentScope = {
                    durationTypeOptions: [
                    { text: 'Non-Timed', value: 'NonTimed' },
                    { text: 'Assessment', value: 'Assessment' },
                    { text: 'Section-Based', value: 'Section' }
                    //{ text: 'Question-Based', value: 'Question' }
                    ],
                    maxAttemptsOptions: {
                        min: 0,
                        max: 99,
                        step: 1,
                        decimals: 0
                    },
                    durationOptions: {
                        min: 1,
                        max: 99999,
                        step: 1,
                        boostat: 10,
                        maxboostedstep: 60,
                        decimals: 0
                    },
                    scoreTypeOptions: [
                        { text: 'Latest Score', value: 1 },
                        { text: 'Best Score', value: 2 },
                        { text: 'Average Score', value: 3 }
                    ],
                    screenLayoutOptions: [
                        { text: 'Informational', value: 'TextOnly' },
                        { text: 'Question', value: 'Question' }
                    ],
                    questionTypeOptions:[
                        { text: 'Multiple Choice Single Answer', value: 'MultipleChoiceSingleAnswer' },
                        { text: 'Multiple Choice Multiple Answers', value: 'MultipleChoiceMultipleAnswers' },
                        { text: 'Open Ended', value: 'OpenEnded' },
                        { text: 'Matching', value: 'Matching' },
                        { text: 'Recording', value: 'Recording' }
                    ],
                    matchingOrderByOptions: [
                        { text: 'Randomly', value: 1 },
                        { text: 'Ascending (A-Z, 0-9)', value: 2 },
                        { text: 'Descending (Z-A, 9-0)', value: 3 }
                    ],
                    assessmentTabSelected: function (tabName, section) {
                        if (section.activeScreenId == undefined) section.activeScreenId = -1;
                        if (tabName == 'Section' && section.assessmentSectionId && !section.loaded) {
                            section.loading = true;
                            AssessmentService.getSection(section.assessmentSectionId).then(function (resp) {
                                angular.extend(section, resp);
                                section.questionCount = 0;
                                _.each(section.screens, function (screen) {
                                    if (screen.screenLayout == 'Question')
                                        screen.questionNumber = ++section.questionCount;
                                });
                                section.loaded = true;
                                section.loading = false;
                            }, function () {
                                section.loading = false;
                            });
                        }
                    },
                    addAssessmentSection: function () {
                        $scope.content.sections.push({
                            assessmentSectionId: 0,
                            title: 'New Section',
                            correctAnswerPoints: $scope.content.correctAnswerPoints,
                            wrongAnswerPoints: $scope.content.wrongAnswerPoints,
                            duration: $scope.content.duration,
                            screens: []
                        });
                        $scope.assessmentScope.activeTab = $scope.content.sections.length;
                    },
                    activeTab: 0,
                    addSectionScreen: function (section) {
                        var newScreen = {
                            assessmentScreenId: 0,
                            screenLayout: 'Question'
                        };
                        section.screens.push(newScreen);
                        section.activeScreen = newScreen;
                        section.activeScreenId = section.screens.length - 1;
                    },
                    showScreen: function (section, screen, index) {
                        if (screen.assessmentScreenId && !screen.textContent && !screen.contentQuestion) {
                            screen.loading = true;
                            if (screen.screenLayout == 'Question') {
                                AssessmentService.getScreen(screen.assessmentScreenId, 'QuestionScreen').then(function (resp) {
                                    screen.contentQuestion = resp;
                                    if (screen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer') {
                                        _.each(screen.contentQuestion.contentMultipleChoiceAnswers, function (answer, aindex) {
                                            if (answer.isCorrect) screen.contentQuestion.selectedAnswer = aindex;
                                        });
                                    } else if (screen.contentQuestion.questionType == 'Recording') {
                                        screen.contentQuestion.assessmentRecordings = [{ maxLength: screen.contentQuestion.recordingMaxLength }];
                                    }
                                    section.activeScreen = screen;
                                    section.activeScreenId = index;
                                    screen.loading = false;
                                }, function () {
                                    screen.loading = false;
                                });
                            } else if (screen.screenLayout == 'TextOnly') {
                                AssessmentService.getScreen(screen.assessmentScreenId, 'TextScreen').then(function (resp) {
                                    angular.extend(screen, resp);
                                    section.activeScreen = screen;
                                    section.activeScreenId = index;
                                    screen.loading = false;
                                }, function () {
                                    screen.loading = false;
                                });
                            }
                        } else {
                            section.activeScreen = screen;
                            section.activeScreenId = index;
                        }
                    },
                    questiontypeSelected: function (selectedItem, section) {
                        if (selectedItem.value == 'MultipleChoiceSingleAnswer' || selectedItem.value == 'MultipleChoiceMultipleAnswers') {
                            if (section.activeScreen.contentQuestion.contentMatchingOptions) section.activeScreen.contentQuestion.contentMatchingOptions = null;
                            if (section.activeScreen.contentQuestion.assessmentRecordings) section.activeScreen.contentQuestion.assessmentRecordings = null;
                            if (section.activeScreen.contentQuestion.contentMultipleChoiceAnswers) {
                                if (selectedItem.value == 'MultipleChoiceSingleAnswer') {
                                    var correctAnswers = _.filter(section.activeScreen.contentQuestion.contentMultipleChoiceAnswers, function (item) { return item.isCorrect; });
                                    if (correctAnswers.length > 1) {
                                        for (var i = 1; i < correctAnswers.length; i++)
                                            correctAnswers[i].isCorrect = false;
                                    }
                                }
                            } else
                                section.activeScreen.contentQuestion.contentMultipleChoiceAnswers = [{ isCorrect: true }, {}, {}, {}];
                        } else if (selectedItem.value == 'Matching') {
                            if (section.activeScreen.contentQuestion.contentMultipleChoiceAnswers) section.activeScreen.contentQuestion.contentMultipleChoiceAnswers = null;
                            if (section.activeScreen.contentQuestion.assessmentRecordings) section.activeScreen.contentQuestion.assessmentRecordings = null;
                            section.activeScreen.contentQuestion.contentMatchingOptions = [{}, {}, {}, {}];
                            section.activeScreen.contentQuestion.matchingOrderBy = 1;
                        } else if (selectedItem.value == 'OpenEnded') {
                            if (section.activeScreen.contentQuestion.contentMultipleChoiceAnswers) section.activeScreen.contentQuestion.contentMultipleChoiceAnswers = null;
                            if (section.activeScreen.contentQuestion.contentMatchingOptions) section.activeScreen.contentQuestion.contentMatchingOptions = null;
                            if (section.activeScreen.contentQuestion.assessmentRecordings) section.activeScreen.contentQuestion.assessmentRecordings = null;
                        } else if (selectedItem.value == 'Recording') {
                            if (section.activeScreen.contentQuestion.contentMultipleChoiceAnswers) section.activeScreen.contentQuestion.contentMultipleChoiceAnswers = null;
                            if (section.activeScreen.contentQuestion.contentMatchingOptions) section.activeScreen.contentQuestion.contentMatchingOptions = null;
                            if (!section.activeScreen.contentQuestion.assessmentRecordings) {
                                section.activeScreen.contentQuestion.assessmentRecordings = [{ maxLength: 0 }];
                            }
                        }
                    },
                    addMultipleChoiceAnswer: function (answers) {
                        answers.push({});
                    },
                    addMatchingOption: function (options) {
                        options.push({});
                    },
                    removeAnswerChoice: function (answers, index) {
                        SweetAlert.swal({
                            title: "Are you sure you wish to delete this answer choice?",
                            text: "",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, delete it!",
                            cancelButtonText: "No",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                answers.splice(index, 1);
                            }
                        });
                    }
                };
                $scope.assignmentScope = {
                    addPart: function (type) {
                        if (!$scope.content.parts) $scope.content.parts = [];
                        var newPart = { type: type };
                        if (type == 'Number') {
                            var count = _.filter($scope.content.parts, function (part) { return part.type && part.type == 'Number'; }).length;
                            newPart.assignmentPartNumber = { partNumber: count + 1 };
                        } else if (type == 'Recording') {
                            newPart.assignmentPartRecording = { maxLength: 10 };
                        }
                        $scope.content.parts.push(newPart);
                    },
                    pointsOptions: {
                        min: 0,
                        max: 100000,
                        step: 1,
                        boostat: 10,
                        maxboostedstep: 10,
                        decimals: 0
                    },
                    numberOptions: {
                        min: 1,
                        max: 1000,
                        step: 1,
                        decimals: 0
                    },
                    fileTypeOptions: [
                        { text: 'Image', value: 'Image' },
                        { text: 'Document (Text/Word/PDF)', value: 'Document' },
                        { text: 'Spreadsheet', value: 'Spreadsheet' },
                        { text: 'Other', value: 'Other' }
                    ]
                };
                $scope.urlScope = {
                    openTool: function (type) {
                        var typelower = type.toLowerCase();
                        var modal = $uibModal.open({
                            animation: true,
                            templateUrl: 'app/courses/urltools/' + typelower + '.tool.modal.html',
                            size: 'lg',
                            controller: type + 'ToolModalController',
                            controllerAs: typelower + 'ToolCtrl',
                            resolve: {
                                loadPlugin: function ($ocLazyLoad) {
                                    return $ocLazyLoad.load([
                                        {
                                            name: 'slimscroll',
                                            files: ['/Scripts/plugins/slimscroll/jquery.slimscroll.min.js']
                                        },
                                        {
                                            name: 'dotdotdot',
                                            files: ['/Scripts/plugins/dotdotdot/jquery.dotdotdot.min.js']
                                        }
                                    ]);
                                }
                            }
                        });
                        modal.result.then(function (result) {
                            angular.extend($scope.content, result);
                        });
                    }
                };
            }
        };
    });
'use strict';

/**
    * commentBlock - Directive for providing comment box with submit button
    */
angular.module('lms')
    .directive('commentBlock', function () {
        return {
            restrict: 'A',
            scope: {
                onSubmit: '&',
                commentText: '=',
                isDisabled: '='
            },
            templateUrl: 'app/components/directives/comment.block.html',
            controller: function ($scope, $element, $attrs) {
                $scope.submitClicked = function () {
                    $scope.onSubmit({});
                };
            }
        };
    });
'use strict';

angular.module('lms')
    .controller('TimetablesController', function ($uibModal, SweetAlert, $timeout, ManageService, TimetableService) {
        var vm = this;
        vm.loaded = false;
        TimetableService.getAll().then(function (timetables) {
            vm.timetables = timetables;
            if (vm.timetables.length == 1) vm.timetableId = vm.timetables[0].timetableId;
            ManageService.getDepartments().then(function (departments) {
                vm.departments = departments;
                if (vm.departments.length == 1) vm.departmentId = vm.departments[0].departmentId;
                vm.loaded = true;
                if (vm.timetableId && vm.departmentId) vm.loadTimetable();
            }, function () {
            });
        }, function () {
        });
        var loadTimeSlots = function (onSuccess) {
            TimetableService.getTimeSlots().then(function (timeSlots) {
                _.each(timeSlots, function (slot) {
                    if (slot.startTime.length > 5) slot.startTime = slot.startTime.substring(0, 5);
                    if (slot.endTime.length > 5) slot.endTime = slot.endTime.substring(0, 5);
                });
                vm.timeSlots = timeSlots;
                onSuccess();
            }, function () {
                vm.loadingTimetable = false;
            });
        }
        vm.timetableIdChanged = function () {
            if (vm.timetableId && vm.departmentId) vm.loadTimetable();
        };
        vm.departmentIdChanged = function () {
            if (vm.timetableId && vm.departmentId) vm.loadTimetable();
        };
        vm.loadTimetable = function () {
            vm.loadingTimetable = true;
            if (vm.timeSlots) {
                TimetableService.getForDepartment(vm.timetableId, vm.departmentId).then(function (resp) {
                    vm.timetable = [];
                    _.each(vm.timeSlots, function (slot) {
                        var obj = {
                            id: slot.institutionTimeSlotId,
                            text: slot.startTime + " - " + slot.endTime,
                            shortName: slot.shortName,
                            nonAcademic: slot.nonAcademic,
                            days: []
                        };
                        for (var i = 0; i < 7; i++) {
                            obj.days.push({ day: i, courses: [] });
                        }
                        vm.timetable.push(obj);
                    });
                    var timetableDict = _.indexBy(vm.timetable, "id");
                    _.each(resp, function (item) {
                        if (item.groups.length) item.groupNames = _.pluck(item.groups, "name").join(', ');
                        timetableDict[item.institutionTimeSlotId].days[item.dayOfWeek].courses.push(item);
                    });
                    vm.loadingTimetable = false;
                }, function () {
                    vm.loadingTimetable = false;
                });
            } else {
                loadTimeSlots(vm.loadTimetable);
            }
        };
    });

(function () {
    'use strict';

    angular.module('lms').factory('UrlToolsService', function ($http, $q) {
        var UrlToolsService;
        UrlToolsService = {};

        UrlToolsService.searchYoutube = function (term, page) {
            var key = "AIzaSyD0tzYcgR9_Ve2oNb1EIeJUFk0L4mP3uCY";
            var url = "https://www.googleapis.com/youtube/v3/search";
            var callurl = url + "?key=" + key + "&part=id,snippet&type=video&maxResults=20&q=" + encodeURI(term);
            if (page) callurl += "&pageToken=" + page;
            return UrlToolsService.get(callurl);
        };

        UrlToolsService.searchVimeo = function (term, page) {
            var key = "5517ac45f6311726dcfa583c24b7c731";
            var url = "https://api.vimeo.com";
            var callurl;
            if (page) callurl = url + page;
            else callurl = url + "/videos?access_token=" + key + "&per_page=20&query=" + encodeURI(term);
            return UrlToolsService.get(callurl);
        };

        UrlToolsService.getYoutubeVideoUrl = function (videoId) {
            return "https://www.youtube.com/embed/" + videoId + "?rel=0";
        };

        UrlToolsService.extractVimeoUrl = function (html) {
            var startpos = html.indexOf("src=\"") + 5;
            return html.substring(startpos, html.indexOf("\"", startpos));
        };

        UrlToolsService.searchWikipedia = function (term, page) {
            var url = "https://en.wikipedia.org/w/api.php";
            var callurl = url + "?action=query&prop=info&inprop=url&format=json&titles=" + encodeURI(term) + '&callback=?';
            return UrlToolsService.getUsingJq(callurl);
        };

        UrlToolsService.get = function (url) {
            var defer;
            defer = $q.defer();
            $http.get(url).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        UrlToolsService.getUsingJq = function (url) {
            var defer;
            defer = $q.defer();
            $.ajax({
                type: "GET",
                url: url,
                contentType: "application/json; charset=utf-8",
                async: false,
                dataType: "json",
                success: function (data, textStatus, jqXHR) {
                    defer.resolve(data);
                },
                error: function (errorMessage) {
                    defer.reject(errorMessage);
                }
            });
            return defer.promise;
        };

        return UrlToolsService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('TimetableService', function ($http, $q, GlobalService) {
        var TimetableService;
        TimetableService = {};
        TimetableService.getAll = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Timetables').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.getForDate = function (date) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Timetables?date=' + date.format('YYYY-MM-DD')).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.create = function (timetable) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Timetable', timetable).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.getForDepartment = function (id, departmentId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Timetable/' + id + '/Department/' + departmentId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.getForGroup = function (id, groupId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Timetable/' + id + '/Group/' + groupId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.getTimeSlots = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Institute/TimeSlots').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.addCourseTime = function (id, timeSlot) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Timetable/' + id + '/CourseTime', timeSlot).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.updateCourseTime = function (id, timeSlot) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Timetable/CourseTime/' + id, timeSlot).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        TimetableService.removeCourseTime = function (id) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Timetable/CourseTime/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return TimetableService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('StatsService', function ($http, $q, GlobalService) {
        var StatsService;
        StatsService = {};
        StatsService.getSummary = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Stats/Summary').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        StatsService.getAssessmentSummary = function (courseId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Stats/Assessments/' + courseId).then(function (resp) {
                var results = {
                    totalPoints: [],
                    maxResults: [],
                    avgResults: [],
                    minResults: []
                };
                _.each(resp.data.list, function (item) {
                    results.totalPoints.push([item.name, item.totalPoints]);
                    results.maxResults.push([item.name, item.avgScore]);
                    results.avgResults.push([item.name, item.maxScore]);
                    results.minResults.push([item.name, item.minScore]);
                });
                defer.resolve(results);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        StatsService.getContentViewSummary = function (courseId, freq, filters) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Stats/ContentViews/' + courseId + '/' + freq + '?startDate=' + filters.startDate.format('YYYY-MM-DD') + '&endDate=' + filters.endDate.format('YYYY-MM-DD')).then(function (resp) {
                var results = resp.data;
                results.views = [];
                if (freq == 'Annual') {
                    _.each(resp.data.list, function (item) {
                        results.views.push([item.year, item.count]);
                    });
                } else if (freq == 'Monthly') {
                    _.each(resp.data.list, function (yearitem) {
                        _.each(yearitem.months, function (item) {
                            results.views.push([moment.monthsShort()[item.month-1] + " " + yearitem.year, item.count]);
                        });
                    });
                } else if (freq == 'Daily') {
                    _.each(resp.data.list, function (item) {
                        results.views.push([new Date(item.date), item.count]);
                    });
                }
                defer.resolve(results);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        StatsService.getPdfPageStats = function (pdfId, revisionNumber, page, totalPages) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Stats/PdfPage/' + pdfId + '/' + revisionNumber + '/' + page + '/' + totalPages).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        StatsService.getPdfStats = function (pdfId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Stats/Pdf/' + pdfId).then(function (resp) {
                var maxPageNo = 1;
                var genResults = {
                    maxTime: [],
                    avgTime: [],
                    count: []
                };
                var userResults = {
                    maxTime: [],
                    avgTime: [],
                    count: []
                };
                _.each(resp.data.general, function (item) {
                    genResults.maxTime.push([item.pageNo, item.maxTimeSpent]);
                    genResults.avgTime.push([item.pageNo, item.avgTimeSpent]);
                    genResults.count.push([item.pageNo, item.viewCount]);
                    if (item.pageNo > maxPageNo) maxPageNo = item.pageNo;
                });
                _.each(resp.data.userStats, function (item) {
                    userResults.maxTime.push([item.pageNo, item.maxTimeSpent]);
                    userResults.avgTime.push([item.pageNo, item.avgTimeSpent]);
                    userResults.count.push([item.pageNo, item.viewCount]);
                    if (item.pageNo > maxPageNo) maxPageNo = item.pageNo;
                });
                defer.resolve({ pages: maxPageNo, general: genResults, user: userResults });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return StatsService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('signalRHubProxy', function ($rootScope, $q, GlobalService) {
        var signalRHubProxy;
        signalRHubProxy = {};
        signalRHubProxy.create = function (hubName, startOptions) {
            var defer;
            defer = $q.defer();
            var connection = $.hubConnection();
            var proxy = connection.createHubProxy(hubName);
            connection.start(startOptions).done(function () {
                defer.resolve({
                    on: function (eventName, callback) {
                        proxy.on(eventName, function (result) {
                            $rootScope.$apply(function () {
                                if (callback) {
                                    callback(result);
                                }
                            });
                        });
                    },
                    off: function (eventName, callback) {
                        proxy.off(eventName, function (result) {
                            $rootScope.$apply(function () {
                                if (callback) {
                                    callback(result);
                                }
                            });
                        });
                    },
                    invoke: function (methodName, attr, callback) {
                        if (attr)
                            proxy.invoke(methodName, attr)
                                .done(function (result) {
                                    $rootScope.$apply(function () {
                                        if (callback) {
                                            callback(result);
                                        }
                                    });
                                });
                        else
                            proxy.invoke(methodName)
                                .done(function (result) {
                                    $rootScope.$apply(function () {
                                        if (callback) {
                                            callback(result);
                                        }
                                    });
                                });
                    },
                    connection: connection
                });
            }).fail(function () { defer.reject(); });
            return defer.promise;
        }
        return signalRHubProxy;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('SearchService', function ($http, $q, GlobalService) {
        var SearchService;
        SearchService = {};

        SearchService.get = function (term) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Search?q=' + term).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        return SearchService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('ProfileService', function ($http, $q, GlobalService) {
        var ProfileService;
        ProfileService = {};

        ProfileService.get = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Me').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.save = function (details) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Me', details).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.saveParent = function (parent) {
            var defer;
            defer = $q.defer();
            if (parent.parentId) {
                $http.put(GlobalService.ApiBase + '/Api/Me/Parent/' + parent.parentId, parent).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            } else {
                $http.post(GlobalService.ApiBase + '/Api/Me/Parent', parent).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };

        ProfileService.deleteParent = function (parentId) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Me/Parent/' + parentId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.saveAddress = function (address) {
            var defer;
            defer = $q.defer();
            if (address.userAddressId) {
                $http.put(GlobalService.ApiBase + '/Api/Me/Address/' + address.userAddressId, address).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            } else {
                $http.post(GlobalService.ApiBase + '/Api/Me/Address', address).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };

        ProfileService.deleteAddress = function (addressId) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Me/Address/' + addressId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.saveQualification = function (qualification) {
            var defer;
            defer = $q.defer();
            if (qualification.userQualificationId) {
                $http.put(GlobalService.ApiBase + '/Api/Me/Qualification/' + qualification.userQualificationId, qualification).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            } else {
                $http.post(GlobalService.ApiBase + '/Api/Me/Qualification', qualification).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };

        ProfileService.deleteQualification = function (qualificationId) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Me/Qualification/' + qualificationId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.uploadProfilePic = function (file) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            formdata.append('profilePic', file);
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/Me/ProfilePic',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.getTodos = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Todos').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.createTodo = function (todo) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Todo', todo).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.updateTodo = function (todo) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Todo/' + todo.todoItemId, todo).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.getActivities = function (lastId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Me/Activities?lastId=' + lastId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.postNavigation = function (stateName, stateParams) {
            $http.post(GlobalService.ApiBase + '/Api/Me/Navigation', { stateName: stateName, stateParams: stateParams });
        };

        ProfileService.putLocale = function (locale) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Me/Locale', { userLocale: locale }).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ProfileService.getNextContent = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Me/NextContent').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        return ProfileService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('PlannerService', function ($http, $q, GlobalService) {
        var PlannerService;
        PlannerService = {};
        PlannerService.getAll = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Events').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        PlannerService.getForDate = function (date) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Events?date=' + date.format('YYYY-MM-DD')).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        PlannerService.get = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Event/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        PlannerService.create = function (event) {
            return saveEvent(event, function (defer, event) {
                $http.post(GlobalService.ApiBase + '/Api/Event', event).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            });
        };
        PlannerService.update = function (event) {
            return saveEvent(event, function (defer, event) {
                $http.put(GlobalService.ApiBase + '/Api/Event/' + event.eventId, event).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            });
        };
        var saveEvent = function (event, ajaxFunc) {
            var defer;
            defer = $q.defer();
            var eventToSend = angular.copy(event);
            var existFiles = _.filter(event.eventAttachments, function (file) { return file.eventAttachmentId; });
            var newFiles = _.filter(event.eventAttachments, function (file) { return !file.eventAttachmentId; });
            if (newFiles.length > 0) {
                var formdata = new FormData();
                _.each(newFiles, function (file, i) { formdata.append('file-' + i, file); });
                var request = {
                    method: 'POST',
                    url: GlobalService.ApiBase + '/Api/File/Private/Attachments',
                    data: formdata,
                    headers: {
                        'Content-Type': undefined
                    }
                };
                $http(request).then(function (resp) {
                    _.each(newFiles, function (file, i) {
                        var upload = {
                            fileName: file.name,
                            filePath: resp.data.files['file-' + i]
                        };
                        existFiles.push(upload);
                    });
                    eventToSend.eventAttachments = existFiles;
                    ajaxFunc(defer, eventToSend);
                }, function () {
                    defer.reject();
                });
            } else ajaxFunc(defer, eventToSend);
            return defer.promise;
        };
        PlannerService.remove = function (id) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Event/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        PlannerService.getPeople = function (term) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Message/People/' + encodeURI(term) + '?exclude=C').then(function (resp) {
                var list = resp.data.users.concat(resp.data.groups);
                defer.resolve(list);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return PlannerService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('ManageService', function ($http, $q, GlobalService) {
        var ManageService;
        ManageService = {};
        ManageService.uploadCsv = function (type, file) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            formdata.append('file', file);
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/' + type + '/Csv',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //LTI App services
        ManageService.getLtiApps = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/LtiApps').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getLtiApp = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/LtiApp/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createLtiApp = function (ltiApp) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/LtiApp', ltiApp).then(function (resp) {
                defer.resolve({ id: resp.data.ltiAppId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editLtiApp = function (ltiApp) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/LtiApp', ltiApp).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Titles for dropdown

        ManageService.getTitles = function () {
            return ["Dr.", "Prof.", "Mr.", "Mrs.", "Ms."];
        };

        //Department services
        ManageService.getDepartments = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Departments').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getDepartment = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Department/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createDepartment = function (department) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Department', department).then(function (resp) {
                defer.resolve({ id: resp.data.departmentId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editDepartment = function (department) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Department', department).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.addDepartmentEducators = function (id, userIds) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Department/' + id + '/Educators', userIds).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.addDepartmentStudents = function (id, userIds) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Department/' + id + '/Students', userIds).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getDepartmentEducators = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/DepartmentEducators/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getDepartmentStudents = function (id, page) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Department/' + id + '/Students/' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Educator services
        ManageService.getEducators = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Educators').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getTAEducators = function (term) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Educators/Lookup?term=' + term).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getEducator = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Educator/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createEducator = function (educator) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Educator', educator).then(function (resp) {
                defer.resolve({ id: resp.data.userId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editEducator = function (educator) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Educator', educator).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //DepartmentGroup services
        ManageService.getGroups = function (departmentIds) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/Groups?DepartmentIds=';
            if (departmentIds) url += departmentIds.join(',');
            $http.get(url).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getGroup = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Group/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createGroup = function (group) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Group', group).then(function (resp) {
                defer.resolve({ id: resp.data.departmentGroupId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editGroup = function (group) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Group', group).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.addGroupStudents = function (id, userIds) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Group/' + id + '/Students', userIds).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getGroupStudents = function (id, page) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Group/' + id + '/Students/' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Student services
        ManageService.getStudents = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Students').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getTAStudents = function (term) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Students/Lookup?term=' + term).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getCourseStudents = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseStudents/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getStudent = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Student/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getParents = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Student/' + id + '/Parents').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getAddresses = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Student/' + id + '/Addresses').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createStudent = function (student) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Student', student).then(function (resp) {
                defer.resolve({ id: resp.data.userId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editStudent = function (student) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Student', student).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createParent = function (studentId, parent) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Student/' + studentId + '/Parent', parent).then(function (resp) {
                defer.resolve({ id: resp.data.parentId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editParent = function (studentId, parent) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Student/' + studentId + '/Parent/' + parent.parentId, parent).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.deleteParent = function (studentId, parent) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Student/' + studentId + '/Parent/' + parent.parentId).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createAddress = function (studentId, address) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Student/' + studentId + '/Address', address).then(function (resp) {
                defer.resolve({ id: resp.data.userAddressId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editAddress = function (studentId, address) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Student/' + studentId + '/Address/' + address.userAddressId, address).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.deleteAddress = function (studentId, address) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Student/' + studentId + '/Address/' + address.userAddressId).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Themes and Scripts

        ManageService.getScripts = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/ExternalScripts').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ManageService.saveRawScript = function (newScript) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/ExternalScript/Raw', newScript).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ManageService.uploadScript = function (formdata, newScript, isNew) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/ExternalScript/Upload?';
            if (isNew) url += 'title=' + encodeURI(newScript.title) + '&enabled=' + newScript.enabled;
            else url += 'id=' + newScript.externalScriptId + '&enabled=' + newScript.enabled;
            var method = isNew ? 'POST' : 'PUT';
            var request = {
                method: method,
                url: url,
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ManageService.saveUrlScript = function (newScript) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/ExternalScript/Url', newScript).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ManageService.updateRawScript = function (id, item) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/ExternalScript/Raw/' + id, item).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ManageService.updateUrlScript = function (id, item) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/ExternalScript/Url/' + id, item).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ManageService.uploadLogo = function (file) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            formdata.append('logo', file);
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/Institute/Logo',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Settings
        ManageService.getSettings = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Institute/Settings').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.saveSettings = function (settings) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Institute/Settings', settings).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Pagination
        ManageService.loadPage = function (tab, id, list, page) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/' + tab + '/' + id + '/' + list + '/' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Admin User services
        ManageService.getAdmins = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Admins').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getAdmin = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Admin/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createAdmin = function (admin) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Admin', admin).then(function (resp) {
                defer.resolve({ id: resp.data.userId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editAdmin = function (admin) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Admin', admin).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //Email Templates
        ManageService.getTemplate = function (key) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/EmailTemplate/' + key).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.saveTemplate = function (key, template) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/EmailTemplate/' + key, template).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        //OAuth User services
        ManageService.getOAuthUsers = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/ManageOAuth/Users').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.getOAuthUser = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/ManageOAuth/User/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.createOAuthUser = function (user) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/ManageOAuth/User', user).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.editOAuthUser = function (user) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/ManageOAuth/User', user).then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        ManageService.changeOAuthUserKeys = function (id) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/ManageOAuth/User/' + id + '/Credentials').then(function (resp) {
                defer.resolve();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        return ManageService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('MailboxService', function ($http, $q, GlobalService) {
        var MailboxService;
        MailboxService = {};

        MailboxService.getSummary = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Mailbox/Summary').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.getUnread = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Mailbox/Unread').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.getMessages = function (type, page) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Mailbox/' + type + '?page=' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.searchMessages = function (type, text, page) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Mailbox/Search/' + type + '?keywords=' + encodeURI(text) + '&page=' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.getMessage = function (type, id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Message/' + type + '/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.getPeople = function (term) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Message/People/' + encodeURI(term)).then(function (resp) {
                var list = resp.data.users;
                _.each(resp.data.groups, function (group) {
                    if (group.type == 'D' || group.type == 'C') {
                        list.push({ id: group.id, name: group.name + ': Educators', type: group.type + 'E' });
                        list.push({ id: group.id, name: group.name + ': Students', type: group.type + 'S' });
                    } else
                        list.push(group);
                });
                defer.resolve(list);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.postMessageFinal = function (messageToSend, action) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Message/' + action, messageToSend).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        }

        MailboxService.postMessage = function (message, action) {
            var defer;
            defer = $q.defer();
            var messageToSend = angular.copy(message);
            var run = function () {
                $http.post(GlobalService.ApiBase + '/Api/Message/' + action, messageToSend).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            }
            var existFiles = _.filter(message.attachments, function (file) { return file.messageAttachmentId; });
            var newFiles = _.filter(message.attachments, function (file) { return !file.messageAttachmentId; });
            if (newFiles.length > 0) {
                var formdata = new FormData();
                _.each(newFiles, function (file, i) { formdata.append('file-' + i, file); });
                var request = {
                    method: 'POST',
                    url: GlobalService.ApiBase + '/Api/File/Private/Attachments',
                    data: formdata,
                    headers: {
                        'Content-Type': undefined
                    }
                };
                $http(request).then(function (resp) {
                    _.each(newFiles, function (file, i) {
                        var upload = {
                            fileName: file.name,
                            filePath: resp.data.files['file-' + i]
                        };
                        existFiles.push(upload);
                    });
                    messageToSend.attachments = existFiles;
                    run();
                }, function () {
                    defer.reject();
                });
            } else run();
            return defer.promise;
        };

        MailboxService.getDraftMessage = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Message/Draft/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        MailboxService.deleteMessage = function (type, id) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Message/' + type + '/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        return MailboxService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('LogService', function ($http, $q, GlobalService) {
        var LogService;
        LogService = {};

        LogService.postContentTime = function (logId, seconds) {
            $http.post(GlobalService.ApiBase + '/Api/Log/' + logId + '/ContentTime/' + seconds);
        };

        LogService.postPdfPageView = function (logId, pdfId, page) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Log/' + logId + '/PdfPageView/' + pdfId + '/' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        LogService.postPdfPageTime = function (pdfLogId, seconds) {
            $http.post(GlobalService.ApiBase + '/Api/Log/' + pdfLogId + '/PdfPageTime/' + seconds);
        };

        return LogService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('GradebookService', function ($http, $q, GlobalService) {
        var GradebookService;
        GradebookService = {};
        GradebookService.getGradebook = function (courseId) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/Gradebook';
            if (courseId)
                url += '/Course/' + courseId;
            $http.get(url).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        GradebookService.getUserGradebook = function (userId, courseId) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/Gradebook';
            if (courseId)
                url += '/Course/' + courseId;
            url += '/' + userId;
            $http.get(url).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        GradebookService.getGradebookEntry = function (contentId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Gradebook/Entry/' + contentId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        GradebookService.getGradebookUserEntry = function (userId, contentId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Gradebook/UserEntry/' + userId + '/' + contentId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        GradebookService.updateGradebookUserEntry = function (userId, entry) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Gradebook/UserEntry/' + userId, entry).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        GradebookService.getGradings = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Institute/Gradings').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return GradebookService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('GlobalService', function () {
        var GlobalService;
        GlobalService = {};
        GlobalService.ApiBase = 'https://poojagokulclassesapi.azurewebsites.net';
        GlobalService.CdnBase = 'https://poojagokulclassesapi.azurewebsites.net';
        GlobalService.setOptions = function (initOptions) {
            GlobalService.options = initOptions;
        };
        var colourPalette = ['#493B2A', '#8499B1', '#822E81', '#AA6373', '#392061', '#F5853F', '#FFCDBC', '#80DED9', '#FF3366', '#011627'];
        GlobalService.getColourFromPalette = function (index) {
            return colourPalette[index % colourPalette.length];
        };
        GlobalService.locales = [
            { key: 'en-gb', name: 'English (UK)', short: 'EN' }//,
            //{ key: 'fr-fr', name: 'French (FR)', short: 'FR' }
        ];
        GlobalService.states = {
            "India": [
                { code: "AP", name: "Andhra Pradesh" },
                { code: "AR", name: "Arunachal Pradesh" },
                { code: "AS", name: "Assam" },
                { code: "BR", name: "Bihar" },
                { code: "CH", name: "Chandigarh" },
                { code: "CG", name: "Chhattisgarh" },
                { code: "DN", name: "Dadra and Nagar Haveli" },
                { code: "DD", name: "Daman and Diu" },
                { code: "DL", name: "Delhi" },
                { code: "GA", name: "Goa" },
                { code: "GJ", name: "Gujarat" },
                { code: "HR", name: "Haryana" },
                { code: "HM", name: "Himachal Pradesh" },
                { code: "JK", name: "Jammu and Kashmir" },
                { code: "JH", name: "Jharkhand" },
                { code: "KA", name: "Karnataka" },
                { code: "KL", name: "Kerala" },
                { code: "MP", name: "Madhya Pradesh" },
                { code: "MH", name: "Maharashtra" },
                { code: "MN", name: "Manipur" },
                { code: "ML", name: "Meghalaya" },
                { code: "MZ", name: "Mizoram" },
                { code: "NL", name: "Nagaland" },
                { code: "OD", name: "Orissa" },
                { code: "PY", name: "Pondicherry" },
                { code: "PB", name: "Punjab" },
                { code: "RJ", name: "Rajasthan" },
                { code: "SK", name: "Sikkim" },
                { code: "TN", name: "Tamil Nadu" },
                { code: "TS", name: "Telangana" },
                { code: "TR", name: "Tripura" },
                { code: "UP", name: "Uttar Pradesh" },
                { code: "UK", name: "Uttarakhand" },
                { code: "WB", name: "West Bengal" }
            ]
        };
        return GlobalService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('FileService', function ($http, $q, GlobalService) {
        var FileService;
        FileService = {};
        FileService.uploadWysiwygFiles = function (files, folder) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            _.each(files, function (file, index) {
                formdata.append('file-' + index, file);
            });
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/File/Wysiwyg/' + folder,
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return FileService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('FeedService', function ($http, $q, GlobalService) {
        var FeedService;
        FeedService = {};

        FeedService.getFeeds = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Feeds').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.getFeed = function (type, id, lastId) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/Feed/' + type;
            if (id) url += '/' + id;
            if (!lastId) lastId = '';
            url += '?lastId=' + lastId + '&fromId=';
            $http.get(url).then(function (resp) {
                var newLastId = null;
                if (resp.data.length) newLastId = resp.data[resp.data.length - 1].postId;
                var respdata = {
                    name: resp.data.name,
                    list: resp.data.posts,
                    lastId: newLastId
                };
                defer.resolve(respdata);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.getLatestFeed = function (type, id, postId) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/Feed/' + type;
            if (id) url += '/' + id;
            url += '?fromId=' + postId + '&lastId=';
            $http.get(url).then(function (resp) {
                defer.resolve(resp.data.posts);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.submitPost = function (type, id, newPost) {
            var defer;
            defer = $q.defer();
            var url = GlobalService.ApiBase + '/Api/Post/' + type;
            if (id) url += '/' + id;
            $http.post(url, newPost).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.postPollChoice = function (postId, choiceIds) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Post/' + postId + '/Poll/Vote', choiceIds).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.postComment = function (postId, comment) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Post/' + postId + '/Comment', comment).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.likePost = function (postId) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Post/' + postId + '/Like').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.dislikePost = function (postId) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Post/' + postId + '/Dislike').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.getComments = function (postId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Post/' + postId + '/Comments?page=1&maxId=').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.getMoreComments = function (postId, maxId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Post/' + postId + '/Comments?page=&maxId=' + maxId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.getLatestComments = function (type, posts, lastId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Post/Comments?postIds=' + posts.join() + '&fromId=' + lastId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.likeComment = function (commentId) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Post/Comment/' + commentId + '/Like').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        FeedService.dislikeComment = function (commentId) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Post/Comment/' + commentId + '/Dislike').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        return FeedService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('CourseService', function ($http, $q, GlobalService) {
        var CourseService;
        CourseService = {};
        CourseService.currentCourse = undefined;
        CourseService.setCurrentCourse = function (course) {
            var nodeArray = CourseService.parseStructure(course.structure);
            var flatlist = CourseService.getFlatStructure(nodeArray);
            CourseService.currentCourseStructure = flatlist;
            CourseService.currentCourse = course;
        };
        CourseService.parseStructure = function (list) {
            var nodeMappings = {};
            var nodeArray = [];
            _.each(list, function (node) {
                var nodeObj = {
                    id: node.courseNodeId,
                    nodeType: node.nodeType,
                    number: node.nodeNumber,
                    title: node.nodeTitle,
                    nodes: []
                };
                nodeMappings[node.courseNodeId] = nodeObj;
                if (node.parentNodeId)
                    nodeMappings[node.parentNodeId].nodes.push(nodeObj);
                else
                    nodeArray.push(nodeObj);
            });
            return nodeArray;
        };
        CourseService.getFlatStructure = function (nodeArray, withContent) {
            var flatlist = [];
            var traverse = function (item) {
                if (item.id || item.courseNodeId) {
                    if (withContent) {
                        item.id = item.courseNodeId;
                        item.idType = "courseNodeId";
                    }
                    flatlist.push(item);
                    if (withContent && item.contents) {
                        _.each(item.contents, function (content) {
                            content.nodeLevel = item.nodeLevel;
                            content.id = content.contentId;
                            content.idType = "contentId";
                        });
                        flatlist = flatlist.concat(item.contents);
                    }
                    _.each(item.nodes, function (node) { traverse(node); });
                }
            };
            _.each(nodeArray, function (node) { traverse(node); });
            return flatlist;
        };
        CourseService.getAll = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Courses').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getAllInDepartment = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Department/' + id + '/Courses').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getAllCompressed = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Courses/Compressed').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.get = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getStudents = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/Students').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getStructure = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/Structure').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getSyllabus = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/Syllabus').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getOutline = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/Outline').then(function (resp) {
                var nodeMappings = {};
                var nodeArray = [];
                _.each(resp.data, function (node) {
                    var nodeObj = node;
                    nodeObj.nodes = [];
                    nodeMappings[node.courseNodeId] = nodeObj;
                    if (node.parentNodeId)
                        nodeMappings[node.parentNodeId].nodes.push(nodeObj);
                    else
                        nodeArray.push(nodeObj);
                });
                defer.resolve(nodeArray);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.create = function (course) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Course', course).then(function (resp) {
                defer.resolve({ id: resp.data.courseId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.copy = function (courseId, course) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Course/' + courseId + '/Copy', course).then(function (resp) {
                defer.resolve({ id: resp.data.courseId });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.save = function (course) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Course', course).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.publish = function (courseId) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Course/' + courseId + '/Publish').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.saveStructure = function (courseId, courseNodes) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/CourseNodes/' + courseId, courseNodes).then(function (resp) {
                defer.resolve({ version: resp.data.newVersion, courseNodes: resp.data.nodes });
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getNode = function (nodeId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseNode/' + nodeId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getNodeContentList = function (nodeId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseNode/' + nodeId + '/ContentList').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getContent = function (contentId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseContent/' + contentId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getContentPoints = function (contentId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseContent/' + contentId + '/Points').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.addContent = function (nodeId, content) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/CourseContent/' + nodeId, content).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.saveContent = function (content) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/CourseContent/' + content.contentId, content).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.saveContentSequence = function (obj) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/CourseContent/Sequence', obj).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.postExternalUrls = function (nodeId, list, sequences) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/CourseContent/' + nodeId + '/ExternalUrls', { items: list, sequences: sequences }).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getScriptsDropdown = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseContent/Scripts').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getHtmlFromUrl = function (url) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/CourseContent/HtmlFromUrl?url=' + url).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getHtmlFromUpload = function (formdata) {
            var defer;
            defer = $q.defer();
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/CourseContent/HtmlFromUpload',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.uploadAssignmentFiles = function (uploads) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            _.each(uploads, function (upload) {
              formdata.append('file-' + upload.sequenceNumber, upload.assignmentPartFile.file);
            });
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/File',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.saveAssignment = function (contentId, submission, recordings, saveType) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            var filespushed = false;
            for (var key in submission.uploads) {
                var upload = submission.uploads[key];
                formdata.append('file-' + key, upload.file);
                filespushed = true;
            }
            for (var reckey in submission.recordings) {
                if (recordings[reckey]) {
                    formdata.append('recording-' + reckey, recordings[reckey], submission.recordings[reckey].fileName);
                    filespushed = true;
                }
            }
            if (filespushed) {
                var request = {
                    method: 'POST',
                    url: GlobalService.ApiBase + '/Api/File',
                    data: formdata,
                    headers: {
                        'Content-Type': undefined
                    }
                };
                $http(request).then(function (resp) {
                    submission.files = resp.data.files;
                    $http.post(GlobalService.ApiBase + '/Api/Assignment/' + contentId + '/' + saveType, submission).then(function (submissionResp) {
                        defer.resolve(submissionResp.data);
                    }, function () {
                        defer.reject();
                    });
                }, function () {
                    defer.reject();
                });
            } else {
                $http.post(GlobalService.ApiBase + '/Api/Assignment/' + contentId + '/' + saveType, submission).then(function (submissionResp) {
                    defer.resolve(submissionResp.data);
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };
        CourseService.uploadWysiwygFiles = function (files, folder) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            _.each(files, function (file, index) {
                formdata.append('file-' + index, file);
            });
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/File/Wysiwyg/' + folder,
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getAssignmentSubmissions = function (id, page) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assignment/' + id + '/Submissions?page=' + page).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getAssignmentSubmission = function (contentId, id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assignment/' + contentId + '/Submission/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.shareAssignmentImage = function (submissionId, partId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/File/ShareAssignmentSubmission/' + submissionId + '/' + partId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.saveAssignmentReview = function (contentId, submissionId, review) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Assignment/' + contentId + '/Submission/' + submissionId + '/Review', review).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.uploadPdfFile = function (file) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            formdata.append('file', file);
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/File/Private/Pdf',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.uploadFiles = function (courseId, formdata) {
            var defer;
            defer = $q.defer();
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/Course/' + courseId + '/Resources',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.deleteResource = function (courseId, resourceId) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Course/' + courseId + '/Resource/' + resourceId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getActivity = function (id, lastActivityId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/Activity?lastId=' + lastActivityId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getStudentNodeActivity = function (id, lastActivityId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/StudentNodeActivity?lastId=' + lastActivityId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getAllStudentContentActivity = function (lastViewId, lastAssignId, lastAssessId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Courses/StudentContentActivity?lastViewId=' + lastViewId + '&lastAssignId=' + lastAssignId + '&lastAssessId=' + lastAssessId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getStudentContentActivity = function (id, lastActivityId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Course/' + id + '/StudentContentActivity?lastId=' + lastActivityId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.getLastViewedNode = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/CourseNode/LastViewed').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        CourseService.createSyllabusAttachment = function (id) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Course/' + id + '/Syllabus/Attachment').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return CourseService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('ChatroomService', function ($http, $q, GlobalService) {
        var ChatroomService;
        ChatroomService = {};

        ChatroomService.getChatrooms = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Chatrooms').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.getChatroom = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Chatroom/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.getQuickChatroom = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Quick').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.createChatroom = function (chatroom) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Chatroom', chatroom).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.submitMessage = function (id, message) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Message', { message: message }).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.getUpdates = function (id, fromId, drawingId, timestamp) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Updates?fromId=' + fromId + '&drawingId=' + drawingId + '&timestamp=' + timestamp).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.getMessages = function (id, lastId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Messages?lastId=' + lastId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.addMembers = function (id, memberIds) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Members', memberIds).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.getPeople = function (term) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Chatroom/People/' + encodeURI(term)).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.submitDrawing = function (id, drawing) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Drawing', { drawing: angular.toJson(drawing) }).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        ChatroomService.deleteDrawing = function (id, drawingId) {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Chatroom/' + id + '/Drawing/' + drawingId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };

        return ChatroomService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('AzureStorage', function ($http, $q, $window, GlobalService) {
        var AzureStorage;
        AzureStorage = {};

        AzureStorage.uploadFile = function (contentType, contentId, file, asset) {
            var defer = $q.defer();
            if ($window.File && $window.FileReader && $window.FileList && $window.Blob) {
                var maxBlockSize = 1024 * 512; // Each file will be split into 512 KB chunks.
                var maxFileSize = 1073741824; // Bytes
                var blockIds = new Array();
                var blockIdPrefix = "block-";
                var blockIdLength = 10;
                var bytesUploaded = 0;
                var currentFilePointer = 0;
                var totalBytesRemaining = 0;
                var selectedFile = file;
                var submitUri = null;
                var assetId = null;
                var fileReader = new FileReader();

                // Creates commit block list request body
                var getCommitRequestBody = function () {
                    var requestBody = "<?xml version='1.0' encoding='utf-8'?><BlockList>";
                    for (var i = 0; i < blockIds.length; i++) {
                        requestBody += "<Latest>" + blockIds[i] + "</Latest>";
                    }
                    requestBody += "</BlockList>";
                    return requestBody;
                }

                // Adds zeros (padding) to blockId
                var addPaddingToBlockId = function (blockIdPosition, paddingLength) {
                    var paddedBlockId = "" + blockIdPosition;
                    while (paddedBlockId.length < paddingLength) {
                        paddedBlockId = "0" + paddedBlockId;
                    }
                    return paddedBlockId;
                }

                // Calls WAMS service PublishWAMSAsset which sets the uploaded video
                // as default, creates video locator and returns video public link
                var publishWAMSAsset = function () {
                    $http.post(GlobalService.ApiBase + '/Api/Media/PublishAsset', { contentType: contentType, contentId: contentId, assetId: assetId, fileName: selectedFile.name }).then(function (resp) {
                        defer.resolve(resp.data);
                    }, function () {
                        defer.reject();
                    });
                }

                // Commits file block (chunk) list to Azure
                var commitBlockList = function () {
                    var uri = submitUri + "&comp=blocklist";
                    var requestBody = getCommitRequestBody();

                    $.ajax({
                        url: uri,
                        type: "PUT",
                        headers: { "x-ms-blob-content-type": selectedFile.type },
                        data: requestBody
                    })
                    .done(function (data, status) {
                        defer.notify({ type: 'message', msg: "Upload complete, processing your video. This might take a while, please wait..." });
                        publishWAMSAsset();
                    })
                    .fail(function (xhr, status, err) {
                        defer.reject(err);
                    });
                }

                // Reads file chunks or commits block list if all chunks have been uploaded already
                var uploadFileInBlocks = function () {
                    //Upload progress started
                    if (totalBytesRemaining > 0) {
                        var fileContent = selectedFile.slice(currentFilePointer, currentFilePointer + maxBlockSize);
                        var blockId = blockIdPrefix + addPaddingToBlockId(blockIds.length, blockIdLength);

                        blockIds.push(btoa(blockId));
                        fileReader.readAsArrayBuffer(fileContent);

                        currentFilePointer += maxBlockSize;
                        totalBytesRemaining -= maxBlockSize;
                        if (totalBytesRemaining < maxBlockSize) {
                            maxBlockSize = totalBytesRemaining;
                        }
                    }
                    else {
                        commitBlockList();
                    }
                }

                // Initializes FileReader onloadend event handler
                // Uploads a chunk of a file on file loaded
                fileReader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) { // DONE == 2
                        var uri = submitUri + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
                        var requestData = new Uint8Array(evt.target.result);

                        $.ajax({
                            url: uri,
                            type: "PUT",
                            headers: { 'x-ms-blob-type': 'BlockBlob' },
                            data: requestData,
                            processData: false
                        })
                        .done(function (data, status) {
                            bytesUploaded += requestData.length;
                            var percentComplete = ((parseFloat(bytesUploaded) / parseFloat(selectedFile.size)) * 100).toFixed(2);
                            defer.notify({ type: 'upload-progress', progress: percentComplete });
                            uploadFileInBlocks();
                        })
                        .fail(function (xhr, status, err) {
                            defer.reject(err);
                        });
                    }
                };

                var fileSize = selectedFile.size;
                //if (fileSize < maxFileSize) {
                if (fileSize < maxBlockSize) {
                    maxBlockSize = fileSize;
                }
                totalBytesRemaining = fileSize;
                assetId = asset.id;
                var baseUri = asset.uri;
                var indexOfQueryStart = baseUri.indexOf("?");
                submitUri = baseUri.substring(0, indexOfQueryStart) + '/' + selectedFile.name + baseUri.substring(indexOfQueryStart);
                uploadFileInBlocks();
                //}
                //else {
                    //defer.reject("File too big.");
                //}
            }
            else
                defer.reject("Not all File APIs are fully supported in this browser.");
            return defer.promise;
        }

        AzureStorage.checkPublishStatus = function (contentType, contentId) {
            var defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Media/PublishStatus/' + contentType + '/' + contentId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        }
        
        return AzureStorage;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('AuthenticationService', function ($http, $q, $rootScope, localStorageService, CourseService, GlobalService) {
        var AuthenticationService;
        AuthenticationService = {};
        AuthenticationService.defaultLandingPage = 'base.main';
        AuthenticationService.loginPage = 'signin';
        AuthenticationService.logoutPage = 'signout';
        AuthenticationService.nextState = null;
        AuthenticationService.getInstitute = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Institute').then(function (resp) {
                return defer.resolve(resp.data);
            });
            return defer.promise;
        };
        AuthenticationService.setHttpHeaders = function () {
            var token = localStorageService.get('authToken');
            $http.defaults.headers.common.Authorization = token ? 'Bearer ' + token : '';
        };
        AuthenticationService.signIn = function (email, password, rememberMe) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Auth/Session', {
                emailId: email.toLowerCase(),
                password: password,
                rememberMe: rememberMe
            }).then(function (authresp) {
                if (authresp.data) {
                    localStorageService.set('authToken', authresp.data);
                    AuthenticationService.setHttpHeaders();
                    $http.get(GlobalService.ApiBase + '/Api/Auth').then(function (resp) {
                        $rootScope.config.loggedIn = true;
                        localStorageService.set('sessionUser', {
                            firstName: resp.data.firstName,
                            lastName: resp.data.lastName,
                            userId: resp.data.userId,
                            userEmail: email.toLowerCase(),
                            role: resp.data.role,
                            profilePic: resp.data.profilePic,
                            studentId: resp.data.studentId
                        });
                        if (CourseService.currentCourse) delete CourseService.currentCourse;
                        if (CourseService.currentCourseStructure) delete CourseService.currentCourseStructure;
                        return defer.resolve(resp.data);
                    }, function () {
                        defer.reject();
                    });
                } else defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AuthenticationService.getUserOtp = function () {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Auth/Otp').then(function (resp) {
                return defer.resolve(resp.data.otp);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        }
        AuthenticationService.clearUser = function () {
            $rootScope.config.loggedIn = false;
            if (CourseService.currentCourse) delete CourseService.currentCourse;
            if (CourseService.currentCourseStructure) delete CourseService.currentCourseStructure;
            $http.defaults.headers.common.Authorization = '';
            localStorageService.set('authToken', null);
            localStorageService.set('sessionUser', null);
        };
        AuthenticationService.signOut = function () {
            var defer;
            defer = $q.defer();
            $http.delete(GlobalService.ApiBase + '/Api/Auth/Session').then(function () {
                AuthenticationService.clearUser();
                return defer.resolve({});
            });
            return defer.promise;
        };
        AuthenticationService.resetUser = function () {
            $http.defaults.headers.common.Authorization = '';
            localStorageService.set('authToken', null);
            return localStorageService.set('sessionUser', null);
        };
        AuthenticationService.getSignedInUser = function () {
            if ($rootScope.config && !$rootScope.config.loggedIn) AuthenticationService.clearUser();
            return localStorageService.get('sessionUser');
        };
        AuthenticationService.isUserAdmin = function () {
            return localStorageService.get('sessionUser').role == 'SuperAdmin';
        };
        AuthenticationService.isUserEducator = function () {
            return localStorageService.get('sessionUser').role == 'Educator';
        };
        AuthenticationService.isUserStudent = function () {
            var role = localStorageService.get('sessionUser').role;
            return !role || role == '';
        };
        AuthenticationService.setNextState = function (name, params) {
            if (name) {
                return AuthenticationService.nextState = {
                    name: name,
                    params: params
                };
            } else {
                return AuthenticationService.nextState = null;
            }
        };
        AuthenticationService.getNextState = function () {
            return AuthenticationService.nextState;
        };
        AuthenticationService.processQueueItem = function (item) {
            $http(item.config).then(
                function (resp) {
                    item.deferred.resolve(resp);
                },
                function () {
                    item.deferred.reject();
                });
        };
        AuthenticationService.setUserAttr = function (attrName, attrValue) {
            var user = localStorageService.get('sessionUser');
            user[attrName] = attrValue;
            localStorageService.set('sessionUser', user);
        };
        AuthenticationService.sendForgotPwd = function (emailId) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Auth/Password/Forgot', { emailId: emailId }).then(function () {
                return defer.resolve({});
            },
            function () {
                defer.reject();
            });
            return defer.promise;
        };
        AuthenticationService.resetPassword = function (emailId, key, password) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Auth/Password/Reset', { emailId: emailId, key: key, password: password }).then(function () {
                return defer.resolve({});
            },
            function () {
                defer.reject();
            });
            return defer.promise;
        };
        AuthenticationService.changePassword = function (password, newPassword) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/Auth/Password/Change', { currentPassword: password, newPassword: newPassword }).then(function () {
                return defer.resolve({});
            },
            function () {
                defer.reject();
            });
            return defer.promise;
        };
        return AuthenticationService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('AttendanceService', function ($http, $q, GlobalService) {
        var AttendanceService;
        AttendanceService = {};
        AttendanceService.getForGroupByDate = function (groupId, date) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Attendance/Group/' + groupId + '?date=' + date.format('YYYY-MM-DD')).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AttendanceService.saveForGroup = function (groupId, date, listToSave) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Attendance/Group/' + groupId + '?date=' + date.format('YYYY-MM-DD'), listToSave).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return AttendanceService;
    });

})();

(function () {
    'use strict';

    angular.module('lms').factory('AssessmentService', function ($http, $q, GlobalService) {
        var AssessmentService;
        AssessmentService = {};
        AssessmentService.getSection = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assessment/Section/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getScreen = function (id, type) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assessment/' + type + '/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getReviewAssessment = function (id, userId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assessment/' + id + '/User/' + userId + '/Review').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getReviewUserQuestionScreen = function (logId, screenId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assessment/Log/' + logId + '/QuestionScreen/' + screenId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.gradeUserAssessmentScreen = function (logId, questionLogId, qLog) {
            var defer;
            defer = $q.defer();
            $http.put(GlobalService.ApiBase + '/Api/Assessment/Log/' + logId + '/Question/' + questionLogId, qLog).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getUserAssessmentResult = function (id, userId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/Assessment/' + id + '/User/' + userId + '/Result').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getNewTake = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/UserAssessment?assessmentId=' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getResumeAssessment = function (id) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/UserAssessment/' + id).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getAnswerToSubmit = function (activeScreen, recordings) {
            var defer;
            defer = $q.defer();
            var answer = null;
            if (activeScreen.screenLayout == 'Question') {
                answer = {};
                if (activeScreen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer' || activeScreen.contentQuestion.questionType == 'MultipleChoiceMultipleAnswers') {
                    answer.contentMultipleChoiceAnswers = [];
                    _.each(activeScreen.contentQuestion.contentMultipleChoiceAnswers, function (a, index) {
                        if (activeScreen.contentQuestion.questionType == 'MultipleChoiceSingleAnswer')
                            a.isCorrect = index == activeScreen.contentQuestion.selectedAnswer;
                        answer.contentMultipleChoiceAnswers.push({ answerNumber: a.answerNumber, isCorrect: a.isCorrect });
                    });
                    defer.resolve(answer);
                } else if (activeScreen.contentQuestion.questionType == 'Matching') {
                    answer.contentMatchingOptions = [];
                    _.each(activeScreen.contentQuestion.contentMatchingOptions, function (opt, index) {
                        if (opt.contentMatchingAnswer && opt.contentMatchingAnswer.matchingAnswerKey)
                            answer.contentMatchingOptions.push({ optionNumber: opt.optionNumber, contentMatchingAnswer: { matchingAnswerKey: opt.contentMatchingAnswer.matchingAnswerKey } });
                        else
                            answer.contentMatchingOptions.push({ optionNumber: opt.optionNumber });
                    });
                    defer.resolve(answer);
                } else if (activeScreen.contentQuestion.questionType == 'OpenEnded') {
                    answer.openAnswerText = activeScreen.contentQuestion.answerGiven;
                    defer.resolve(answer);
                } else if (activeScreen.contentQuestion.questionType == 'Recording' && recordings[activeScreen.contentQuestion.questionId]) {
                    answer.recording = recordings[activeScreen.contentQuestion.questionId].meta;
                    AssessmentService.saveRecording(recordings[activeScreen.contentQuestion.questionId].data, answer.recording.fileName).then(function (resp) {
                        answer.recordingFileName = resp;
                        defer.resolve(answer);
                    });
                } else {
                    defer.resolve(answer);
                }
            } else {
                defer.resolve(answer);
            }
            return defer.promise;
        }
        AssessmentService.saveRecording = function (recording, filename) {
            var defer;
            defer = $q.defer();
            var formdata = new FormData();
            formdata.append('recording', recording, filename);
            var request = {
                method: 'POST',
                url: GlobalService.ApiBase + '/Api/File',
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };
            $http(request).then(function (resp) {
                defer.resolve(resp.data.files["recording"]);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.changeUserAssessmentScreen = function (userAssessmentId, currentId, nextId, timeTaken, answer) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/UserAssessment/' + userAssessmentId + '/Screen', { currentId: currentId, nextId: nextId, timeTaken: timeTaken, answer: answer }).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.getUserQuestionScreen = function (logId, screenId) {
            var defer;
            defer = $q.defer();
            $http.get(GlobalService.ApiBase + '/Api/UserAssessment/' + logId + '/QuestionScreen/' + screenId).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.sendUserTime = function (userAssessmentId, screenId, ticks) {
            var defer;
            defer = $q.defer();
            if (ticks == 0)
                defer.resolve();
            else {
                $http.post(GlobalService.ApiBase + '/Api/UserAssessment/' + userAssessmentId + '/Timer/' + screenId + '/' + ticks).then(function (resp) {
                    defer.resolve(resp.data);
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };
        AssessmentService.sectionTimeOut = function (userAssessmentId, sectionId) {
            var defer;
            defer = $q.defer();
            $http.post(GlobalService.ApiBase + '/Api/UserAssessment/' + userAssessmentId + '/Section/' + sectionId + '/TimedOut').then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        AssessmentService.submit = function (userAssessmentId, isTimedOut) {
            var defer;
            defer = $q.defer();
            var action = isTimedOut ? 'TimedOut' : 'Submit';
            $http.post(GlobalService.ApiBase + '/Api/UserAssessment/' + userAssessmentId + '/' + action).then(function (resp) {
                defer.resolve(resp.data);
            }, function () {
                defer.reject();
            });
            return defer.promise;
        };
        return AssessmentService;
    });

})();

'use strict';

angular.module('lms')
    .controller('SearchController', function ($location, SearchService, UrlToolsService, CourseService) {
        var vm = this;
        vm.truncateOptions = {
            watch: 'window'
        };
        /*vm.sortableOptions = {
            connectWith: ".connectPanels",
            handler: ".draggable-object",
            helper: function (e, ui) {
                
            },
            update: function (e, ui) {
                if (ui.item.sortable.droptarget.hasClass('drag-source')) {
                    ui.item.sortable.cancel();
                }
            },
            stop: function (e, ui) {
                if ($(e.target).hasClass('drag-source') &&
                    e.target != ui.item.sortable.droptarget[0]) {
                    $scope.sourceScreens = originalScreens.slice();
                }
            }
        };*/
        vm.searchText = $location.search().term;
        if (vm.searchText) {
            vm.loading = true;
            vm.totalResults = 0;
            SearchService.get(vm.searchText).then(function (resp) {
                vm.results = resp;
                vm.totalLocal = resp.count;
                vm.totalResults += resp.count;
                vm.loading = false;
            }, function () {
                vm.loading = false;
            });
            UrlToolsService.searchYoutube(vm.searchText).then(function (resp) {
                vm.youtubeResults = resp;
                vm.totalResults += resp.pageInfo.totalResults;
            });
            UrlToolsService.searchVimeo(vm.searchText).then(function (resp) {
                vm.vimeoResults = resp;
                vm.totalResults += resp.total;
            });
            UrlToolsService.searchWikipedia(vm.searchText).then(function (resp) {
                vm.wikipediaResults = resp;
                vm.totalWikipedia = 1;
                vm.totalResults += 1;
            });
        }
        vm.moreYoutube = function (pageToken) {
            vm.loadingMoreYoutube = true;
            UrlToolsService.searchYoutube(vm.searchText, pageToken).then(function (resp) {
                var newList = vm.youtubeResults.items.concat(resp.items);
                vm.youtubeResults = resp;
                vm.youtubeResults.items = newList;
                vm.loadingMoreYoutube = false;
            });
        };
        vm.moreVimeo = function (page) {
            vm.loadingMoreVimeo = true;
            UrlToolsService.searchVimeo(vm.searchText, page).then(function (resp) {
                var newList = vm.vimeoResults.data.concat(resp.data);
                vm.vimeoResults = resp;
                vm.vimeoResults.data = newList;
                vm.loadingMoreVimeo = false;
            });
        };
        vm.unsavedList = false;
        vm.addOpen = false;
        vm.add = function (type, item) {
            vm.addOpen = true;
            item.selected = true;
            if (!vm.courses) {
                CourseService.getAllCompressed().then(function (resp) {
                    vm.courses = resp;
                }, function () {
                });
            }
        };
        vm.courseSelected = function (item) {
            if (vm.courseNodes) delete vm.courseNodes;
            var courseId = item.courseId;
            CourseService.getStructure(courseId).then(function (resp) {
                vm.currentCourseId = courseId;
                var nodeArray = CourseService.parseStructure(resp);
                vm.courseNodes = CourseService.getFlatStructure(nodeArray);
            }, function () {
            });
        };
        vm.courseNodeSelected = function (item) {
            vm.loadingContent = true;
            if (vm.contentList) delete vm.contentList;
            var nodeId = item.id;
            CourseService.getNodeContentList(nodeId).then(function (resp) {
                vm.currentNodeId = nodeId;
                vm.contentList = resp;
                vm.loadingContent = false;
            }, function () {
                vm.loadingContent = false;
            });
        };
        vm.addSelected = function () {
            _.each(_.filter(vm.youtubeResults.items, function (item) { return item.selected; }), function (content) {
                vm.contentList.push({
                    contentId: '',
                    type: 'ExternalUrl',
                    name: content.snippet.title,
                    description: content.snippet.description,
                    available: false,
                    url: UrlToolsService.getYoutubeVideoUrl(content.id.videoId),
                    widthValue: '100',
                    widthUnit: '%',
                    heightValue: '480',
                    heightUnit: 'px'
                });
                vm.unsavedList = true;
                content.selected = false;
            });
            _.each(_.filter(vm.vimeoResults.data, function (item) { return item.selected; }), function (content) {
                vm.contentList.push({
                    contentId: '',
                    type: 'ExternalUrl',
                    name: content.name,
                    description: content.description,
                    available: false,
                    url: UrlToolsService.extractVimeoUrl(content.embed.html),
                    widthValue: '100',
                    widthUnit: '%',
                    heightValue: '480',
                    heightUnit: 'px'
                });
                vm.unsavedList = true;
                content.selected = false;
            });
            for (var key in vm.wikipediaResults.query.pages) {
                if (vm.wikipediaResults.query.pages.hasOwnProperty(key) && vm.wikipediaResults.query.pages[key].selected) {
                    var content = vm.wikipediaResults.query.pages[key];
                    vm.contentList.push({
                        type: 'ExternalUrl',
                        name: content.title,
                        available: false,
                        url: content.fullurl,
                        widthValue: '100',
                        widthUnit: '%',
                        heightValue: '500',
                        heightUnit: 'px'
                    });
                    vm.unsavedList = true;
                    content.selected = false;
                }
            }
        };
        vm.save = function () {
            vm.saving = true;
            var sequences = [];
            _.each(vm.contentList, function (content, i) {
                var seq = i + 1;
                if (content.contentId) {
                    if (content.sequenceNo != seq) sequences.push({ contentId: content.contentId, sequenceNo: seq });
                } else
                    content.sequenceNo = seq;
            });
            var newList = _.filter(vm.contentList, function (content) { return !content.contentId; });
            CourseService.postExternalUrls(vm.currentNodeId, newList, sequences).then(function (resp) {
                var respDict = _.indexBy(resp, "sequenceNo");
                _.each(vm.contentList, function (content, i) {
                    var seq = i + 1;
                    content.sequenceNo = seq;
                    if (!content.contentId)
                        content.contentId = respDict[seq].contentId;
                });
                vm.unsavedList = false;
                vm.saving = false;
            }, function () {
                vm.saving = false;
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('ProfileController', function ($uibModal, GlobalService, ProfileService, AuthenticationService, SweetAlert) {
        var vm = this;
        vm.relationships = [
            { name: 'Not Specified' },
            { name: 'Father' },
            { name: 'Mother' },
            { name: 'Guardian' }
        ];
        vm.addressTypes = [
            { label: 'Present' },
            { label: 'Permanent' },
            { label: 'Other' }
        ];
        vm.states = GlobalService.states['India'];
        vm.passYears = [];
        var yearmax = new Date().getFullYear() + 6;
        for (var y = 2010; y <= yearmax; y++) {
            vm.passYears.push({year: y});
        }
        vm.loaded = false;
        vm.editProfileMode = false;
        vm.saving = false;
        ProfileService.get().then(function (resp) {
            vm.me = resp;
            vm.loaded = true;
            vm.getActivities();
        }, function () {
        });
        vm.openEdit = function () {
            vm.meBackup = angular.copy(vm.me);
            vm.editProfileMode = true;
        };
        vm.cancelEdit = function () {
            vm.editProfileMode = false;
            vm.me = angular.copy(vm.meBackup);
        };
        vm.saveProfile = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            if (vm.me.dateOfBirth) vm.me.dateOfBirth = moment(vm.me.dateOfBirth).format("YYYY-MM-DD");
            ProfileService.save(vm.me).then(function (resp) {
                vm.meBackup = angular.copy(vm.me);
                vm.editProfileMode = false;
                vm.saving = false;
            }, function () {
                vm.saving = false;
            });
        };
        vm.addParent = function () {
            vm.me.parents.push({ inEdit: true });
        };
        vm.parentBackups = {};
        vm.openParentEdit = function (parent) {
            vm.parentBackups[parent.parentId] = angular.copy(parent);
            parent.inEdit = true;
        };
        vm.cancelEditParent = function (parent) {
            angular.extend(parent, vm.parentBackups[parent.parentId]);
            parent.inEdit = false;
        };
        vm.saveParent = function (form, parent) {
            if (!form.$valid) return;
            parent.saving = true;
            ProfileService.saveParent(parent).then(function (resp) {
                parent.parentId = resp.parentId;
                vm.parentBackups[parent.parentId] = angular.copy(parent);
                parent.inEdit = false;
                parent.saving = false;
            }, function () {
                parent.saving = false;
            });
        };
        vm.deleteParent = function (parent) {
            SweetAlert.swal({
                title: "Are you sure you wish to delete this parent?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    parent.deleting = true;
                    ProfileService.deleteParent(parent.parentId).then(function (resp) {
                        if (vm.parentBackups[parent.parentId]) delete vm.parentBackups[parent.parentId];
                        vm.me.parents.splice(vm.me.parents.indexOf(parent), 1);
                    }, function () {
                        parent.deleting = false;
                    });
                }
            });
        };
        vm.addAddress = function () {
            vm.me.addresses.push({ inEdit: true });
        };
        vm.addressBackups = {};
        vm.openAddressEdit = function (address) {
            vm.addressBackups[address.userAddressId] = angular.copy(address);
            address.inEdit = true;
        };
        vm.cancelEditAddress = function (address) {
            angular.extend(address, vm.addressBackups[address.userAddressId]);
            address.inEdit = false;
        };
        vm.saveAddress = function (form, address) {
            if (!form.$valid) return;
            address.saving = true;
            ProfileService.saveAddress(address).then(function (resp) {
                address.userAddressId = resp.id;
                vm.addressBackups[address.userAddressId] = angular.copy(address);
                address.inEdit = false;
                address.saving = false;
            }, function () {
                address.saving = false;
            });
        };
        vm.deleteAddress = function (address) {
            SweetAlert.swal({
                title: "Are you sure you wish to delete this address?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    address.deleting = true;
                    ProfileService.deleteAddress(address.userAddressId).then(function (resp) {
                        if (vm.addressBackups[address.userAddressId]) delete vm.addressBackups[address.userAddressId];
                        vm.me.addresses.splice(vm.me.addresses.indexOf(address), 1);
                    }, function () {
                        address.deleting = false;
                    });
                }
            });
        };
        vm.addQualification = function () {
            vm.me.qualifications.push({ inEdit: true });
        };
        vm.qualificationBackups = {};
        vm.openQualificationEdit = function (qualification) {
            vm.qualificationBackups[qualification.userQualificationId] = angular.copy(qualification);
            qualification.inEdit = true;
        };
        vm.cancelEditQualification = function (qualification) {
            angular.extend(qualification, vm.qualificationBackups[qualification.userQualificationId]);
            qualification.inEdit = false;
        };
        vm.saveQualification = function (form, qualification) {
            if (!form.$valid) return;
            qualification.saving = true;
            ProfileService.saveQualification(qualification).then(function (resp) {
                qualification.userQualificationId = resp.id;
                vm.qualificationBackups[qualification.userQualificationId] = angular.copy(qualification);
                qualification.inEdit = false;
                qualification.saving = false;
            }, function () {
                qualification.saving = false;
            });
        };
        vm.deleteQualification = function (qualification) {
            SweetAlert.swal({
                title: "Are you sure you wish to delete this qualification?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    qualification.deleting = true;
                    ProfileService.deleteQualification(qualification.userQualificationId).then(function (resp) {
                        if (vm.qualificationBackups[qualification.userQualificationId]) delete vm.qualificationBackups[qualification.userQualificationId];
                        vm.me.qualifications.splice(vm.me.qualifications.indexOf(qualification), 1);
                    }, function () {
                        qualification.deleting = false;
                    });
                }
            });
        };
        vm.lastFeedId = 0;
        vm.activities = [];
        vm.showMorePosts = false;
        vm.getActivities = function () {
            ProfileService.getActivities(vm.lastFeedId).then(function (resp) {
                vm.activities = vm.activities.concat(resp.posts);
                if (resp.posts.length > 0) vm.lastFeedId = resp.posts[resp.posts.length - 1].postId;
                vm.showMorePosts = resp.posts.length > 0;
                vm.loaded = true;
            }, function () {
            });
        };
        vm.uploadPic = function () {
            vm.savingPic = true;
            ProfileService.uploadProfilePic(vm.file).then(function (resp) {
                vm.me.profilePicUrl = resp.profilePicUrl;
                AuthenticationService.setUserAttr('profilePic', resp.profilePicUrl);
                delete vm.file;
                vm.savingPic = false;
            }, function () {
                vm.savingPic = false;
            });
        };
        vm.changePassword = function () {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'app/profile/change.password.modal.html',
                controller: 'ChangePasswordModalController',
                controllerAs: 'changePwdModalCtrl',
                size: 'sm'
            });
            /*modal.result.then(function (result) {

            });*/
        };
    });

'use strict';

angular.module('lms')
    .controller('ChangePasswordModalController', function ($uibModalInstance, toaster, AuthenticationService) {
        var vm = this;
        vm.changing = false;
        vm.change = function (form) {
            if (!form.$valid) return;
            vm.changing = true;
            AuthenticationService.changePassword(vm.password, vm.newpassword).then(function () {
                form.$submitted = false;
                vm.changing = false;
                toaster.pop({
                    type: 'success',
                    title: 'Password Changed',
                    body: 'Your password has been changed successfully',
                    showCloseButton: true
                });
                $uibModalInstance.close();
            }, function () {
                vm.changing = false;
                toaster.pop({
                    type: 'error',
                    title: 'Password Error',
                    body: 'Your password could not be changed. Your current password is not correct.',
                    showCloseButton: true
                });
            });
        }
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }
    });

'use strict';

angular.module('lms')
    .controller('PlannerController', function ($uibModal, $scope, SweetAlert, $timeout, ManageService, PlannerService, AuthenticationService) {
        var vm = this;
        /*var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();*/

        vm.eventSources = [[]];
        vm.loadingEvents = true;
        var setStartEnd = function (ev) {
            ev.start = moment(ev.eventDate).toDate();
            if (ev.endDate) ev.end = moment(ev.endDate).toDate();
        };
        PlannerService.getAll().then(function (events) {
            _.each(events, function (ev) {
                setStartEnd(ev);
            });
            vm.eventSources = [events];
            vm.loadingEvents = false;
        }, function () {
            vm.loadingEvents = false;
        });

        $scope.$on('onEventAdded', function (event, item) {
            PlannerService.get(item.id).then(function (resp) {
                vm.eventSources[0].push(resp);
            }, function () {
            });
        });

        // Events
        /*vm.events = [
            { title: 'All Day Event', start: new Date(y, m, 1) },
            { title: 'Long Event', start: new Date(y, m, d - 5), end: new Date(y, m, d - 2) },
            { id: 999, title: 'Repeating Event', start: new Date(y, m, d - 3, 16, 0), allDay: false },
            { id: 999, title: 'Repeating Event', start: new Date(y, m, d + 4, 16, 0), allDay: false },
            { title: 'Birthday Party', start: new Date(y, m, d + 1, 19, 0), end: new Date(y, m, d + 1, 22, 30), allDay: false },
            { title: 'Click for Google', start: new Date(y, m, 28), end: new Date(y, m, 29), url: 'http://google.com/' }
        ];*/

        vm.onDayClick = function (date, jsEvent, view, resourceObj) {
            if (AuthenticationService.isUserStudent()) return;
            vm.newEvent(moment(date).format("YYYY-MM-DD[T]HH:mm"));
        };
        vm.onEventClick = function (event, allDay, jsEvent, view) {
          vm.editEvent(event);
        };
        vm.onDrop = function (event, dayDelta, minuteDelta, allDay, revertFunc, jsEvent, ui, view) {
            if (AuthenticationService.isUserStudent()) return;
            event.allDay = allDay;
            if (allDay) {
                event.eventDate = moment(event.start).format("YYYY-MM-DD");
                if (event.end) event.endDate = moment(event.end).format("YYYY-MM-DD");
            } else {
                event.eventDate = moment(event.start).format("YYYY-MM-DD[T]HH:mm");
                if (event.end) event.endDate = moment(event.end).format("YYYY-MM-DD[T]HH:mm");
            }
            saveEvent(event, revertFunc);
        };
        vm.onResize = function (event, dayDelta, minuteDelta, revertFunc, jsEvent, ui, view) {
            if (AuthenticationService.isUserStudent()) return;
            event.eventDate = moment(event.start).format("YYYY-MM-DD[T]HH:mm");
            if (event.end) event.endDate = moment(event.end).format("YYYY-MM-DD[T]HH:mm");
            saveEvent(event, revertFunc);
        };
        var saveEvent = function (event, revertFunc) {
            var eventObj = {
                eventId: event.eventId,
                allDay: event.allDay,
                eventDate: event.eventDate,
                endDate: event.endDate,
                description: event.description,
                showTime: event.showTime,
                title: event.title,
                url: event.eventUrl
            };
            PlannerService.update(eventObj).then(function (resp) {
            }, function () {
                revertFunc();
            });
        };

        /* calendar config object */
        vm.calendarConfig = {
            height: 450,
            editable: !AuthenticationService.isUserStudent(),
            header: {
                left: 'prev,next',
                center: 'title',
                right: 'month,agendaWeek,agendaDay'
            },
            eventClick: vm.onEventClick,
            eventDrop: vm.onDrop,
            eventResize: vm.onResize,
            dayClick: vm.onDayClick
        };

        vm.newEvent = function (eventDate) {
            if (!eventDate) eventDate = moment().format("YYYY-MM-DD[T]HH:[00]");
            var modal = openEventModal({ allDay: false, eventDate: eventDate });
            modal.result.then(function (result) {
                setStartEnd(result);
                vm.eventSources[0].push(result);
            });
        };
        vm.editEvent = function (event) {
            var modal = openEventModal({
                eventId: event.eventId,
                createdBy: event.createdBy,
                allDay: event.allDay,
                eventDate: event.eventDate,
                endDate: event.endDate,
                description: event.description,
                showTime: event.showTime,
                title: event.title,
                eventUrl: event.eventUrl
            });
            modal.result.then(function (result) {
                setStartEnd(result);
                angular.extend(event, result);
            });
        };
        var openEventModal = function (event) {
            return $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: AuthenticationService.isUserStudent() ? 'app/planner/event.view.modal.html' : 'app/planner/event.modal.html',
                controller: AuthenticationService.isUserStudent() ? 'EventViewModalController' : 'EventModalController',
                controllerAs: 'eventCtrl',
                resolve: {
                    event: function () { return event; },
                    loadPlugin: function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            {
                                name: 'datePicker',
                                files: ['/Styles/plugins/datapicker/angular-datapicker.css', '/Scripts/plugins/datapicker/angular-datepicker.min.js']
                            },
                            {
                                name: 'clockpicker',
                                files: ['/Styles/plugins/clockpicker/clockpicker.css', '/Scripts/plugins/clockpicker/clockpicker.js']
                            },
                            {
                                name: 'bootstrap',
                                files: ['/Scripts/plugins/bootstrap/bootstrap.min.js']
                            },
                            {
                                name: 'summernote',
                                files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                            },
                            {
                                name: 'ui.select',
                                files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                            },
                            {
                                name: 'jasny',
                                files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                            },
                            {
                                name: 'bootstrap.touchspin',
                                files: ['/Styles/plugins/touchspin/jquery.bootstrap-touchspin.min.css', '/Scripts/plugins/touchspin/jquery.bootstrap-touchspin.min.js']
                            },
                            {
                                name: 'chosen',
                                files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                            }
                        ]);
                    }
                }
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('EventViewModalController', function ($uibModalInstance, $state, $timeout, AuthenticationService, PlannerService, event) {
        var vm = this;
        vm.myUserId = AuthenticationService.getSignedInUser().userId;
        vm.summernoteOptions = {
            height: 100,
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'hr']]
            ]
        };
        vm.repeatFreqs = [{ value: 'D', text: 'Daily' }, { value: 'W', text: 'Weekly' }, { value: 'M', text: 'Monthly' }, { value: 'Y', text: 'Annually' }];
        vm.repeatEvery = { 'D': 'days', 'W': 'weeks', 'M': 'months', 'Y': 'years' };
        vm.dimensionsOptions = {
            min: 0,
            max: 1000,
            step: 1,
            decimals: 0
        };
        vm.event = angular.copy(event);
        var mntDate = moment(vm.event.eventDate);
        vm.event.eventDateDate = mntDate.format("YYYY-MM-DD");
        vm.event.eventDateTime = mntDate.format("HH:mm");
        if (vm.event.endDate) {
            var mntEndDate = moment(vm.event.endDate);
            vm.event.endDateDate = mntEndDate.format("YYYY-MM-DD");
            vm.event.endDateTime = mntEndDate.format("HH:mm");
        }
        vm.loaded = !event.eventId;
        var setRecurDefaults = function () {
            vm.event.isRecurring = false;
            vm.event.recurParamsJson = {
                frequency: 'W',
                repeatEvery: 1,
                repeatBy: 'DM',
                repeatEnds: 'On'
            };
            vm.event.recurParamsJson['repeat' + moment(vm.event.eventDate).format("ddd")] = true;
        };
        if (event.eventId) {
            PlannerService.get(event.eventId).then(function (resp) {
                vm.event.createdBy = resp.createdBy;
                vm.event.description = resp.description;
                vm.event.inviteeJson = resp.inviteeJson;
                vm.event.eventAttachments = resp.eventAttachments;
                if (resp.recurParamsJson) {
                    vm.event.isRecurring = true;
                    vm.event.recurParamsJson = resp.recurParamsJson;
                    if (vm.event.recurParamsJson.repeatEndsOn) vm.event.recurParamsJson.repeatEndsOnDate = moment(vm.event.recurParamsJson.repeatEndsOn).toDate();
                } else setRecurDefaults();
                vm.loaded = true;
            }, function () {
                vm.cancel();
            });
        } else {
            setRecurDefaults();
        }
        vm.addAttachments = function (value) {
            if (!vm.event.eventAttachments) vm.event.eventAttachments = [];
            if (value instanceof FileList)
                _.each(value, function (file) { vm.event.eventAttachments.push(file); });
            else
                vm.event.eventAttachments.push(value);
        };
        vm.removeAttachment = function (file) {
            vm.event.eventAttachments.splice(vm.event.eventAttachments.indexOf(file), 1);
        };
        vm.peopleCache = {};
        vm.people = [];
        vm.peopleSearchTimeout = null;
        vm.latestSearchTerm = "";
        vm.getPeople = function (searchTerm) {
            if (searchTerm) {
                vm.latestSearchTerm = searchTerm;
                if (vm.peopleSearchTimeout) $timeout.cancel(vm.peopleSearchTimeout);
                if (vm.peopleCache[searchTerm]) vm.people = vm.peopleCache[searchTerm];
                else {
                    vm.peopleSearchTimeout = $timeout(function (searchTerm) {
                        PlannerService.getPeople(searchTerm).then(function (resp) {
                            resp.unshift({ id: '', name: 'Entire Institute', type: 'I' });
                            if (vm.latestSearchTerm == searchTerm)
                                vm.people = resp;
                            vm.peopleCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            vm.endDateError = false;
            vm.event.eventDate = moment(vm.event.eventDateDate).format("YYYY-MM-DD");
            if (!vm.event.allDay && vm.event.eventDateTime) vm.event.eventDate += "T" + vm.event.eventDateTime;
            if (vm.event.endDateDate || (!vm.event.allDay && vm.event.endDateTime)) {
                if (vm.event.endDateDate) vm.event.endDate = moment(vm.event.endDateDate).format("YYYY-MM-DD");
                else if (!vm.event.allDay && vm.event.endDateTime) vm.event.endDate = moment(vm.event.eventDateDate).format("YYYY-MM-DD");
                if (!vm.event.allDay && vm.event.endDateTime) vm.event.endDate += "T" + vm.event.endDateTime;
                if (moment(vm.event.endDate).isBefore(moment(vm.event.eventDate))) {
                    vm.endDateError = true;
                    return;
                }
            } else vm.event.endDate = null;
            if (vm.event.isRecurring && vm.event.recurParamsJson.repeatEndsOnDate) vm.event.recurParamsJson.repeatEndsOn = moment(vm.event.recurParamsJson.repeatEndsOnDate).format("YYYY-MM-DD");
            if (!vm.event.isRecurring) delete vm.event.recurParamsJson;
            if (vm.event.eventId) {
                PlannerService.update(vm.event).then(function (resp) {
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close(vm.event);
                }, function () {
                    vm.saving = false;
                });
            } else {
                PlannerService.create(vm.event).then(function (resp) {
                    vm.event.eventId = resp.id;
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close(vm.event);
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('EventModalController', function ($uibModalInstance, $state, $timeout, AuthenticationService, PlannerService, event) {
        var vm = this;
        vm.myUserId = AuthenticationService.getSignedInUser().userId;
        vm.summernoteOptions = {
            height: 100,
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'hr']]
            ]
        };
        vm.repeatFreqs = [{ value: 'D', text: 'Daily' }, { value: 'W', text: 'Weekly' }, { value: 'M', text: 'Monthly' }, { value: 'Y', text: 'Annually' }];
        vm.repeatEvery = { 'D': 'days', 'W': 'weeks', 'M': 'months', 'Y': 'years' };
        vm.dimensionsOptions = {
            min: 0,
            max: 1000,
            step: 1,
            decimals: 0
        };
        vm.event = angular.copy(event);
        var mntDate = moment(vm.event.eventDate);
        vm.event.eventDateDate = mntDate.toDate();
        vm.event.eventDateTime = mntDate.format("HH:mm");
        if (vm.event.endDate) {
            var mntEndDate = moment(vm.event.endDate);
            vm.event.endDateDate = mntEndDate.toDate();
            vm.event.endDateTime = mntEndDate.format("HH:mm");
        }
        vm.loaded = !event.eventId;
        var setRecurDefaults = function () {
            vm.event.isRecurring = false;
            vm.event.recurParamsJson = {
                frequency: 'W',
                repeatEvery: 1,
                repeatBy: 'DM',
                repeatEnds: 'On'
            };
            vm.event.recurParamsJson['repeat' + moment(vm.event.eventDate).format("ddd")] = true;
        };
        if (event.eventId) {
            PlannerService.get(event.eventId).then(function (resp) {
                vm.event.createdBy = resp.createdBy;
                vm.event.description = resp.description;
                vm.event.inviteeJson = resp.inviteeJson;
                vm.event.eventAttachments = resp.eventAttachments;
                if (resp.recurParamsJson) {
                    vm.event.isRecurring = true;
                    vm.event.recurParamsJson = resp.recurParamsJson;
                    if (vm.event.recurParamsJson.repeatEndsOn) vm.event.recurParamsJson.repeatEndsOnDate = moment(vm.event.recurParamsJson.repeatEndsOn).toDate();
                } else setRecurDefaults();
                vm.loaded = true;
            }, function () {
                vm.cancel();
            });
        } else {
            setRecurDefaults();
        }
        vm.addAttachments = function (value) {
            if (!vm.event.eventAttachments) vm.event.eventAttachments = [];
            if (value instanceof FileList)
                _.each(value, function (file) { vm.event.eventAttachments.push(file); });
            else
                vm.event.eventAttachments.push(value);
        };
        vm.removeAttachment = function (file) {
            vm.event.eventAttachments.splice(vm.event.eventAttachments.indexOf(file), 1);
        };
        vm.peopleCache = {};
        vm.people = [];
        vm.peopleSearchTimeout = null;
        vm.latestSearchTerm = "";
        vm.getPeople = function (searchTerm) {
            if (searchTerm) {
                vm.latestSearchTerm = searchTerm;
                if (vm.peopleSearchTimeout) $timeout.cancel(vm.peopleSearchTimeout);
                if (vm.peopleCache[searchTerm]) vm.people = vm.peopleCache[searchTerm];
                else {
                    vm.peopleSearchTimeout = $timeout(function (searchTerm) {
                        PlannerService.getPeople(searchTerm).then(function (resp) {
                            resp.unshift({ id: '', name: 'Entire Institute', type: 'I' });
                            if (vm.latestSearchTerm == searchTerm)
                                vm.people = resp;
                            vm.peopleCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };
        vm.saving = false;
        vm.ok = function (form) {
            if (!form.$valid) return;
            vm.saving = true;
            vm.endDateError = false;
            vm.event.eventDate = moment(vm.event.eventDateDate).format("YYYY-MM-DD");
            if (!vm.event.allDay && vm.event.eventDateTime) vm.event.eventDate += "T" + vm.event.eventDateTime;
            if (vm.event.endDateDate || (!vm.event.allDay && vm.event.endDateTime)) {
                if (vm.event.endDateDate) vm.event.endDate = moment(vm.event.endDateDate).format("YYYY-MM-DD");
                else if (!vm.event.allDay && vm.event.endDateTime) vm.event.endDate = moment(vm.event.eventDateDate).format("YYYY-MM-DD");
                if (!vm.event.allDay && vm.event.endDateTime) vm.event.endDate += "T" + vm.event.endDateTime;
                if (moment(vm.event.endDate).isBefore(moment(vm.event.eventDate))) {
                    vm.endDateError = true;
                    return;
                }
            } else vm.event.endDate = null;
            if (vm.event.isRecurring && vm.event.recurParamsJson.repeatEndsOnDate) vm.event.recurParamsJson.repeatEndsOn = moment(vm.event.recurParamsJson.repeatEndsOnDate).format("YYYY-MM-DD");
            if (!vm.event.isRecurring) delete vm.event.recurParamsJson;
            if (vm.event.eventId) {
                PlannerService.update(angular.extend({}, vm.event, { url: vm.event.eventUrl })).then(function (resp) {
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close(vm.event);
                }, function () {
                    vm.saving = false;
                });
            } else {
                PlannerService.create(angular.extend({}, vm.event, { url: vm.event.eventUrl })).then(function (resp) {
                    vm.event.eventId = resp.id;
                    vm.saving = false;
                    form.$submitted = false;
                    $uibModalInstance.close(vm.event);
                }, function () {
                    vm.saving = false;
                });
            }
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('MainController', function ($rootScope, $state, $scope, $sce, $uibModal, $window, AuthenticationService, CourseService, GlobalService, ProfileService) {

        var vm = this;
        vm.locales = GlobalService.locales;
        vm.currentLocale = null;
        vm.currentYear = new Date().getFullYear();

        AuthenticationService.setHttpHeaders();
        if (!$rootScope.config) {
            AuthenticationService.getInstitute().then(function (initOptions) {
                $rootScope.config = initOptions;
                angular.extend(vm, initOptions);
                GlobalService.setOptions(initOptions);
                vm.currentLocale = _.filter(GlobalService.locales, function (l) {
                    return l.key == initOptions.lang;
                })[0];
            }, function () {
            });
        }

        vm.setUser = function () {
            var user = AuthenticationService.getSignedInUser();
            var designation = "";
            if (user.role) {
                if (user.role == 'Educator')
                    designation = "Educator / Faculty";
                else if (user.role.indexOf("Admin") >= 0)
                    designation = "Admin";
            } else designation = "Student";
            var profilePic = "";
            if (user.profilePic) profilePic = user.profilePic;
            vm.user = {
                userId: user.userId,
                userName: user.firstName + ' ' + user.lastName,
                profilePic: profilePic,
                designation: designation,
                role: user.role,
                studentId: user.studentId
            };
        };

        vm.load = function () {
            vm.setUser();
        };

        $scope.$on('onSignedIn', function () {
            vm.load();
        });

        if (AuthenticationService.getSignedInUser()) {
            vm.load();
        }

        vm.currentCourse = function () {
            if (CourseService.currentCourse)
                return CourseService.currentCourse;
            else
                return null;
        };

        vm.currentCourseStructure = function () {
            if (CourseService.currentCourseStructure)
                return CourseService.currentCourseStructure;
            else
                return null;
        };

        vm.changeMyLocale = function (locale) {
            if (locale != vm.currentLocale.key) {
                ProfileService.putLocale(locale).then(function () {
                    $window.location.reload();
                }, function () {
                });
            }
        };

        vm.signOut = function () {
            $state.go(AuthenticationService.logoutPage);
        };

    });

'use strict';

angular.module('lms')
    .controller('DashboardController', function ($scope, AuthenticationService, CourseService, MailboxService, ProfileService, StatsService) {

        var vm = this;
        vm.courseLoaded = false;
        vm.statsLoaded = false;
        vm.statsType = 'Assessment';
        vm.contentIcons = {
            RichTextFormat: "file-text-o",
            VideoFile: "film",
            AudioFile: "microphone",
            Assessment: "question",
            Assignment: "check-square-o",
            Pdf: "book",
            ExternalUrl: "link"
        };
        CourseService.getAll().then(function (courses) {
            vm.courses = courses;
            vm.courseLoaded = true;
            if ((AuthenticationService.isUserAdmin() || AuthenticationService.isUserEducator()) && courses.length > 0) {
                vm.statsCourseId = courses[0].courseId;
                if (!vm.statsType) vm.statsType = 'Assessment';
                if (vm["load" + vm.statsType + "Stats"]) vm["load" + vm.statsType + "Stats"]();
            }
        }, function () {
            vm.courseLoaded = true;
        });
        vm.lastStudentActivityViewId = 0;
        vm.lastStudentActivityAssignId = 0;
        vm.lastStudentActivityAssessId = 0;
        vm.getStudentContentActivity = function () {
            CourseService.getAllStudentContentActivity(vm.lastStudentActivityViewId, vm.lastStudentActivityAssignId, vm.lastStudentActivityAssessId).then(function (resp) {
                if (vm.studentContentActivity)
                    vm.studentContentActivity = resp.concat(vm.studentContentActivity);
                else
                    vm.studentContentActivity = resp;
                if (resp.length > 0) {
                    var viewFilter = _.filter(vm.studentContentActivity, function(item) {
                        return item.eventType=='View';
                    });
                    vm.lastStudentActivityViewId = viewFilter.length ? viewFilter[0].Id : 0;
                    var assignFilter = _.filter(vm.studentContentActivity, function(item) {
                        return item.eventType=='Submission' && item.type=='Assignment';
                    });
                    vm.lastStudentActivityAssignId = assignFilter.length ? assignFilter[0].Id : 0;
                    var assessFilter = _.filter(vm.studentContentActivity, function(item) {
                        return item.eventType=='Submission' && item.type=='Assessment';
                    });
                    vm.lastStudentActivityAssessId = assessFilter.length ? assessFilter[0].Id : 0;
                }
            }, function () {

            });
        };
        if (AuthenticationService.isUserAdmin() || AuthenticationService.isUserEducator()) vm.getStudentContentActivity();
        var loadSummary = function () {
            if (AuthenticationService.getSignedInUser() && (AuthenticationService.isUserAdmin() || AuthenticationService.isUserEducator())) {
                StatsService.getSummary().then(function (summary) {
                    vm.summary = summary;
                    var viewsDiff = summary.contentViews - summary.monthAverageViews;
                    vm.summary.viewsPct = (viewsDiff / summary.monthAverageViews) * 100;
                    var loginsDiff = summary.logins - summary.monthAverageLogins;
                    vm.summary.loginsPct = (loginsDiff / summary.monthAverageLogins) * 100;
                });
            }
        };
        loadSummary();
        vm.loadLastNode = function () {
            if (AuthenticationService.getSignedInUser() && AuthenticationService.isUserStudent()) {
                CourseService.getLastViewedNode().then(function (node) {
                    if (node) {
                        vm.lastViewedNode = node;
                    }
                });
                ProfileService.getNextContent().then(function (list) {
                    vm.nextContent = list;
                });
            }
        };
        vm.loadLastNode();
        $scope.$on('onSignedIn', function () {
            vm.loadLastNode();
            loadSummary();
        });
        vm.statsTitles = [
            { value: 'Assessment', text: 'Assessment Summary' },
            { value: 'ContentView', text: 'Content View Summary' }
        ];
        vm.loadStats = function () {
            if (!vm.statsType) vm.statsType = 'Assessment';
            if (vm["load" + vm.statsType + "Stats"]) vm["load" + vm.statsType + "Stats"]();
        };
        vm.loadAssessmentStats = function () {
            vm.statsLoaded = false;
            StatsService.getAssessmentSummary(vm.statsCourseId).then(function (resp) {
                var dataset = [
                    {
                        label: "Assessment Total",
                        grow: { stepMode: "linear" },
                        data: resp.totalPoints,
                        color: "#1ab394",
                        bars: {
                            show: true,
                            align: "center",
                            barWidth: 0.2,
                            lineWidth: 0
                        }

                    },
                    {
                        label: "Highest Score",
                        grow: { stepMode: "linear" },
                        data: resp.maxResults,
                        color: "#1C84C6",
                        lines: {
                            lineWidth: 1,
                            show: true,
                            fill: true,
                            fillColor: {
                                colors: [
                                    {
                                        opacity: 0.2
                                    },
                                    {
                                        opacity: 0.2
                                    }
                                ]
                            }
                        }
                    },
                    {
                        label: "Average Score",
                        grow: { stepMode: "linear" },
                        data: resp.avgResults,
                        color: "#FFF200",
                        lines: {
                            lineWidth: 1,
                            show: true,
                            fill: true,
                            fillColor: {
                                colors: [
                                    {
                                        opacity: 0.2
                                    },
                                    {
                                        opacity: 0.2
                                    }
                                ]
                            }
                        }
                    },
                    {
                        label: "Lowest Score",
                        grow: { stepMode: "linear" },
                        data: resp.minResults,
                        color: "#FF0000",
                        lines: {
                            lineWidth: 1,
                            show: true,
                            fill: true,
                            fillColor: {
                                colors: [
                                    {
                                        opacity: 0.2
                                    },
                                    {
                                        opacity: 0.2
                                    }
                                ]
                            }
                        }
                    }
                ];


                var options = {
                    grid: {
                        hoverable: true,
                        clickable: true,
                        tickColor: "#d5d5d5",
                        borderWidth: 0,
                        color: '#d5d5d5'
                    },
                    colors: ["#1ab394", "#464f88"],
                    tooltip: true,
                    xaxis: {
                        mode: "categories",
                        axisLabel: "Assessment",
                        axisLabelUseCanvas: true,
                        axisLabelFontSizePixels: 12,
                        axisLabelFontFamily: 'Arial',
                        axisLabelPadding: 10,
                        color: "#d5d5d5"
                    },
                    yaxes: [
                        {
                            position: "left",
                            color: "#d5d5d5",
                            axisLabelUseCanvas: true,
                            axisLabelFontSizePixels: 12,
                            axisLabelFontFamily: 'Arial',
                            axisLabelPadding: 3
                        }
                    ],
                    legend: {
                        noColumns: 1,
                        labelBoxBorderColor: "#d5d5d5",
                        position: "nw"
                    }
                };
                vm.chart = {
                    flotData: dataset,
                    flotOptions: options
                };
                vm.statsLoaded = true;
            }, function () {
                vm.statsLoaded = true;
            });
        }
        vm.statsFreq = 'Daily';
        vm.daterange = { startDate: new moment().subtract(7, 'days'), endDate: new moment() };
        vm.dateRangeOptions = { eventHandlers: { 'apply.daterangepicker': function (ev, picker) { vm.loadContentViewStats(); } } };
        vm.loadContentViewStats = function () {
            vm.statsLoaded = false;
            StatsService.getContentViewSummary(vm.statsCourseId, vm.statsFreq, vm.daterange).then(function (resp) {
                var dataset;
                var options;
                vm.contentViews = resp;
                if (vm.statsFreq == 'Daily') {
                    dataset = [
                        {
                            label: "Content Views",
                            grow: { stepMode: "linear" },
                            data: resp.views,
                            color: "#1C84C6",
                            lines: {
                                lineWidth: 1,
                                show: true,
                                fill: true,
                                fillColor: {
                                    colors: [
                                        {
                                            opacity: 0.2
                                        },
                                        {
                                            opacity: 0.2
                                        }
                                    ]
                                }
                            }
                        }
                    ];

                    options = {
                        grid: {
                            hoverable: true,
                            clickable: true,
                            tickColor: "#d5d5d5",
                            borderWidth: 0,
                            color: '#d5d5d5'
                        },
                        colors: ["#1ab394", "#464f88"],
                        tooltip: true,
                        xaxis: {
                            mode: "time",
                            tickSize: [1, "day"],
                            tickLength: 0,
                            axisLabel: "Date",
                            axisLabelUseCanvas: true,
                            axisLabelFontSizePixels: 12,
                            axisLabelFontFamily: 'Arial',
                            axisLabelPadding: 10,
                            color: "#d5d5d5"
                        },
                        yaxes: [
                            {
                                color: "#d5d5d5",
                                axisLabelUseCanvas: true,
                                axisLabelFontSizePixels: 12,
                                axisLabelFontFamily: ' Arial',
                                axisLabelPadding: 67
                            }
                        ],
                        legend: {
                            noColumns: 1,
                            labelBoxBorderColor: "#d5d5d5",
                            position: "nw"
                        }

                    };
                } else {
                    dataset = [
                        {
                            label: "Content Views",
                            grow: { stepMode: "linear" },
                            data: resp.views,
                            color: "#1C84C6",
                            lines: {
                                lineWidth: 1,
                                show: true,
                                fill: true,
                                fillColor: {
                                    colors: [
                                        {
                                            opacity: 0.2
                                        },
                                        {
                                            opacity: 0.2
                                        }
                                    ]
                                }
                            }
                        }
                    ];

                    options = {
                        grid: {
                            hoverable: true,
                            clickable: true,
                            tickColor: "#d5d5d5",
                            borderWidth: 0,
                            color: '#d5d5d5'
                        },
                        colors: ["#1ab394", "#464f88"],
                        tooltip: true,
                        xaxis: {
                            mode: "categories",
                            axisLabel: "Period",
                            axisLabelUseCanvas: true,
                            axisLabelFontSizePixels: 12,
                            axisLabelFontFamily: 'Arial',
                            axisLabelPadding: 10,
                            color: "#d5d5d5"
                        },
                        yaxes: [
                            {
                                position: "left",
                                color: "#d5d5d5",
                                axisLabelUseCanvas: true,
                                axisLabelFontSizePixels: 12,
                                axisLabelFontFamily: 'Arial',
                                axisLabelPadding: 3
                            }
                        ],
                        legend: {
                            noColumns: 1,
                            labelBoxBorderColor: "#d5d5d5",
                            position: "nw"
                        }
                    };
                }
                vm.chart = {
                    flotData: dataset,
                    flotOptions: options
                };
                vm.statsLoaded = true;
            }, function () {
                vm.statsLoaded = true;
            });
        }
        vm.mailLoaded = false;
        MailboxService.getUnread().then(function (resp) {
            vm.mailUnread = resp;
            vm.mailLoaded = true;
        }, function () {
            vm.mailLoaded = true;
        });
        vm.todosLoaded = false;
        ProfileService.getTodos().then(function (resp) {
            vm.todos = resp;
            vm.todosLoaded = true;
        }, function () {
            vm.todosLoaded = true;
        });
        vm.addTodo = function () {
            vm.savingTodo = true;
            ProfileService.createTodo(vm.newTodo).then(function (resp) {
                var todo = angular.copy(vm.newTodo);
                todo.todoItemId = resp.id;
                todo.sequenceNo = resp.sequenceNo;
                vm.todos.push(todo);
                vm.newTodo = { };
                vm.savingTodo = false;
            }, function () {
                vm.savingTodo = false;
            });
        };
        vm.todoDone = function (todo, index) {
            if (todo.isDone) {
                ProfileService.updateTodo({ todoItemId: todo.todoItemId, isDone: todo.isDone }).then(function (resp) {
                }, function () {
                });
            }
        }

    });

'use strict';

angular.module('lms')
    .controller('BaseController', function ($rootScope, $scope, $state, AuthenticationService, FeedService, ChatroomService, signalRHubProxy, toaster) {
        var vm = this;
        vm.setUser = function () {
            vm.user = AuthenticationService.getSignedInUser();
            if (vm.user) {
                vm.isAdmin = vm.user.role == 'SuperAdmin';
                vm.isEducator = vm.user.role == 'Educator';
                vm.isStudent = !vm.user.role || vm.user.role == '';
            }
        }
        vm.setUser();

        vm.activeChats = {};
        vm.chatUsers = {};
        vm.sendMessage = function (chat) {
            if (!chat.newMessage) return;
            chat.sending = true;
            ChatroomService.submitMessage(chat.id, chat.newMessage).then(function (resp) {
                chat.newMessage = "";
                chat.sending = false;
            }, function () {
                chat.sending = false;
            });
        };

        vm.myState = $state.current;
        var stateChangeSuccessCallback = $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
            vm.myState = toState;
            vm.myParams = toParams;
        });
        $scope.$on('$destroy', stateChangeSuccessCallback);

        var clientPushHubProxy;
        $scope.$on('onSignedOut', function (event, args) {
            clientPushHubProxy.invoke('unsubscribe', '|' + args.userId);
        });
        vm.setNotifications = function () {
            signalRHubProxy.create('notificationHub').then(function (hub) {
                clientPushHubProxy = hub;

                clientPushHubProxy.invoke('subscribe', '|');

                clientPushHubProxy.on('invite', function (item) {
                    clientPushHubProxy.invoke('subscribe', item.type + '|' + item.id);
                    var nBody = '';
                    if (item.type == 'Chat') {
                        nBody = ('{0} has invited you to chat').replace('{0}', item.sender);
                        $rootScope.$broadcast('onChatInvite', item.chatroom);
                    }
                    toaster.pop({
                        type: 'success',
                        title: "You've been invited",
                        body: nBody,
                        showCloseButton: true
                    });
                });

                clientPushHubProxy.on('notify', function (item) {
                    //var connId = clientPushHubProxy.connection.id;
                    var eventName = item.itemType ? 'on' + item.type + item.itemType : 'on' + item.type;
                    $rootScope.$broadcast(eventName, item);
                    var nTitle = '';
                    var nBody = '';
                    if (item.senderId && item.senderId != vm.user.userId) {
                        if (item.type == 'Chat') {
                            if (item.itemType == 'Message') {
                                nTitle = ('{0} says:').replace('{0}', item.sender);
                                nBody = item.data.message;
                            }
                            else if (item.itemType == 'Members') {
                                nTitle = ('{0} added these people to the chatroom:').replace('{0}', item.sender);
                                nBody = _.pluck(item.data, 'name').join(", ");
                            }
                            else if (item.itemType == 'Drawing') {
                                nTitle = ('{0} drew on the whiteboard').replace('{0}', item.sender);
                            }
                        }
                        else if (item.type == 'Message') {
                            nTitle = ('{0} sent a message:').replace('{0}', item.sender);
                            nBody = item.data.subject;
                        }
                        else if (item.type == 'Feed') {
                            if (item.itemType == 'Post') {
                                nTitle = ('{0} posted in {1}:').replace('{0}', item.sender).replace('{0}', item.subName);
                                nBody = item.data.text;
                            }
                            else if (item.itemType == 'Comment') {
                                nTitle = ('{0} commented on a post in {1}:').replace('{0}', item.sender).replace('{0}', item.subName);
                                nBody = item.data.comment;
                            }
                        }
                        else if (item.type == 'Post') {
                            if (item.itemType == 'Poll') {
                                nTitle = ('{0} voted in the poll:').replace('{0}', item.sender);
                                nBody = item.name;
                            }
                        }
                        else if (item.type == 'Event') {
                            nTitle = ('{0} added an event:').replace('{0}', item.sender);
                            var dateFormat = item.data.allDay ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm";
                            nBody = item.data.title + '<br />' + moment(item.data.eventDate).format(dateFormat);
                            if (item.data.endDate) nBody += ' - ' + moment(item.data.endDate).format(dateFormat);
                        }
                    } else {
                        if (item.type == 'MediaPublished') {
                            nTitle = ('{0} has been processed successfully').replace('{0}', item.data.name);
                        }
                        else if (item.type == 'General') {
                            nTitle = ('{0}').replace('{0}', item.data.msg);
                        }
                    }
                    if (nTitle || nBody) {
                        toaster.pop({
                            type: 'success',
                            title: nTitle,
                            body: nBody,
                            showCloseButton: true
                        });
                    }
                    if (item.type == 'Chat') {
                        if (item.itemType == 'Message') {
                            var activeChat;
                            if (vm.activeChats[item.id]) {
                                activeChat = vm.activeChats[item.id];
                                activeChat.messages.push(item.data);
                                if (!activeChat.newCount) activeChat.newCount = 0;
                                if ((vm.myState.name != 'base.chatroom' || (vm.myState.name == 'base.chatroom' && vm.myParams.id != item.id)) && (!vm.activeChat || vm.activeChat.id != item.id))
                                    activeChat.newCount++;
                            } else {
                                ChatroomService.getQuickChatroom(item.id).then(function (resp) {
                                    activeChat = resp;
                                    activeChat.id = item.id;
                                    if (vm.myState.name != 'base.chatroom' || (vm.myState.name == 'base.chatroom' && vm.myParams.id != item.id))
                                        activeChat.newCount = 1;
                                    vm.activeChats[item.id] = activeChat;
                                    _.each(activeChat.members, function (member) {
                                        if (!vm.chatUsers[member.userId])
                                            vm.chatUsers[member.userId] = member;
                                    });
                                    if (activeChat.messages && activeChat.messages.length) {
                                        activeChat.messages = activeChat.messages.reverse();
                                        vm.activeChat.lastMessageId = activeChat.messages.length < 20 ? 0 : activeChat.messages[0].chatroomMessageId;
                                    }
                                }, function () {
                                });
                            }
                        }
                        else if (item.itemType == 'Members') {
                            _.each(item.data, function (member) {
                                if (!vm.chatUsers[member.userId])
                                    vm.chatUsers[member.userId] = member;
                            });
                        }
                    }
                });
            }, function () {
            });
        };

        vm.feeds = null;
        vm.feedUser = null;
        vm.loadingFeeds = false;
        vm.loadFeeds = function () {
            var user = AuthenticationService.getSignedInUser();
            if (!vm.loadingFeeds && user && (!vm.feedUser || vm.feedUser != user.userId || !vm.feeds)) {
                vm.loadingFeeds = true;
                vm.feedUser = user.userId;
                FeedService.getFeeds().then(function (resp) {
                    vm.feeds = resp;
                    vm.loadingFeeds = false;
                }, function () {
                    vm.feeds = {};
                    vm.loadingFeeds = false;
                });
            }
        };

        vm.chatrooms = null;
        vm.chatUser = null;
        vm.loadingChatrooms = false;
        vm.loadChatrooms = function () {
            var user = AuthenticationService.getSignedInUser();
            if (!vm.loadingChatrooms && user && (!vm.chatUser || vm.chatUser != user.userId || !vm.chatrooms)) {
                vm.loadingChatrooms = true;
                vm.chatUser = user.userId;
                ChatroomService.getChatrooms().then(function (resp) {
                    vm.chatrooms = resp;
                    vm.loadingChatrooms = false;
                }, function () {
                    vm.chatrooms = {};
                    vm.loadingChatrooms = false;
                });
            }
        };

        $scope.$on('onChatInvite', function (event, chatroom) {
            chatroom.members = _.filter(chatroom.members, function (member) { return member.userId != vm.user.userId; });
            vm.chatrooms.push(chatroom);
        });

        vm.loadData = function () {
            vm.setNotifications();
            vm.loadFeeds();
            vm.loadChatrooms();
        };

        $scope.$on('onSignedIn', function () {
            vm.setUser();
            vm.loadData();
        });
        if (vm.user)
            vm.loadData();
        vm.onGlobalSearch = function () {
            $state.go('base.search', { term: vm.globalSearch });
        };
    });
'use strict';

angular.module('lms')
    .controller('MessageViewController', function ($stateParams, $state, MailboxService) {
        var vm = this;
        vm.type = $stateParams.type;
        vm.id = $stateParams.id;
        MailboxService.getMessage(vm.type, vm.id).then(function (resp) {
            vm.message = resp;
        }, function () {
        });
        vm.delete = function () {
            MailboxService.deleteMessage(vm.type, vm.id).then(function (resp) {
                if (vm.type == 'Inbox') $state.go("base.mailbox.inbox");
                else $state.go("base.mailbox.sent");
            }, function () {
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('MessageComposeController', function ($state, $timeout, $location, toaster, MailboxService, FileService, AuthenticationService, GlobalService) {
        var vm = this;
        vm.summernoteOptions = {
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'hr']]
            ]
        };
        vm.loading = false;
        vm.sending = false;
        vm.message = {
            recipients: [],
            recipientsCc: [],
            recipientsBcc: [],
            attachments: []
        };
        vm.addAttachments = function (value) {
            if (value instanceof FileList)
                _.each(value, function (file) { vm.message.attachments.push(file); });
            else
                vm.message.attachments.push(value);
        };
        vm.removeAttachment = function (file) {
            vm.message.attachments.splice(vm.message.attachments.indexOf(file), 1);
        };
        vm.imageUpload = function (files) {
            toaster.pop({
                type: 'wait',
                title: 'Adding Images',
                body: 'Your images are being added...',
                timeout: 0
            });
            var editor = vm.editor;
            FileService.uploadWysiwygFiles(files, "Mail").then(function (resp) {
                for (var key in resp.files) {
                    editor.summernote('insertImage', GlobalService.CdnBase + "/Api/File/Public/" + resp.files[key], key);
                }
                toaster.clear();
                toaster.pop({
                    type: 'success',
                    title: 'Images added',
                    body: 'Your images have been added successfully',
                    showCloseButton: true
                });
            }, function () {
            });
        };
        if ($location.search().id) {
            vm.loading = true;
            MailboxService.getMessage("Draft", $location.search().id).then(function (resp) {
                vm.loading = false;
                vm.message = resp;
            }, function () {
                vm.loading = false;
            });
        } else if ($location.search().replyto) {
            vm.loading = true;
            MailboxService.getMessage($location.search().type, $location.search().replyto).then(function (resp) {
                vm.loading = false;
                if ($location.search().type == 'Inbox') {
                    vm.message = {
                        subject: resp.subject,
                        body: resp.body,
                        recipients: [],
                        recipientsCc: [],
                        recipientsBcc: []
                    };
                    vm.message.recipients.push({
                        id: resp.senderId,
                        name: resp.sender,
                        type: 'U'
                    });
                } else
                    vm.message = resp;
                vm.message.subject = 'RE: ' + vm.message.subject;
                vm.message.body = '<br /><br />------------------------- Original Message -------------------------<br /><br />' + vm.message.body;
            }, function () {
                vm.loading = false;
            });
        } else if ($location.search().replyall) {
            vm.loading = true;
            MailboxService.getMessage($location.search().type, $location.search().replyall).then(function (resp) {
                vm.loading = false;
                vm.message = resp;
                if ($location.search().type == 'Inbox') {
                    var myuser = AuthenticationService.getSignedInUser();
                    vm.message.recipients = _.filter(vm.message.recipients, function (user) { return user.id != myuser.userId; });
                    vm.message.recipients.push({
                        id: resp.senderId,
                        name: resp.sender,
                        type: 'U'
                    });
                }
                vm.message.subject = 'RE: ' + vm.message.subject;
                vm.message.body = '<br /><br />------------------------- Original Message -------------------------<br /><br />' + vm.message.body;
            }, function () {
                vm.loading = false;
            });
        } else if ($location.search().forward) {
            vm.loading = true;
            MailboxService.getMessage($location.search().type, $location.search().forward).then(function (resp) {
                vm.loading = false;
                vm.message = {
                    subject: 'FWD: ' + resp.subject,
                    body: '<br /><br />------------------------- Forwarded Message -------------------------<br /><br />' + resp.body,
                    recipients: [],
                    recipientsCc: [],
                    recipientsBcc: []
                };
            }, function () {
                vm.loading = false;
            });
        }
        vm.peopleCache = {};
        vm.people = [];
        vm.peopleSearchTimeout = null;
        vm.latestSearchTerm = "";
        vm.getPeople = function (searchTerm) {
            if (searchTerm) {
                vm.latestSearchTerm = searchTerm;
                if (vm.peopleSearchTimeout) $timeout.cancel(vm.peopleSearchTimeout);
                if (vm.peopleCache[searchTerm]) vm.people = vm.peopleCache[searchTerm];
                else {
                    vm.peopleSearchTimeout = $timeout(function (searchTerm) {
                        MailboxService.getPeople(searchTerm).then(function (resp) {
                            if (vm.latestSearchTerm == searchTerm)
                                vm.people = resp;
                            vm.peopleCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };
        vm.saveDraft = function () {
            MailboxService.postMessage(vm.message, "Draft").then(function (resp) {
                toaster.pop({
                    type: 'success',
                    title: 'Message Saved',
                    body: 'Your message has been saved successfully',
                    showCloseButton: true
                });
                vm.message.messageId = resp.messageId;
                vm.message.attachments = resp.attachments;
            }, function () {
            });
        };
        vm.send = function () {
            vm.sending = true;
            MailboxService.postMessage(vm.message, "Send").then(function (resp) {
                vm.sending = false;
                toaster.pop({
                    type: 'success',
                    title: 'Message Sent',
                    body: 'Your message has been sent successfully',
                    showCloseButton: true
                });
                $state.go("base.mailbox.inbox");
            }, function () {
                vm.sending = false;
                toaster.pop({
                    type: 'error',
                    title: 'Error sending your message',
                    body: 'An error occurred while sending your message. Please try again.',
                    showCloseButton: true
                });
            });
        };
        vm.discard = function () {
            if (vm.message.messageId) {
                MailboxService.deleteMessage('Draft', vm.messageId).then(function (resp) {
                    toaster.pop({
                        type: 'success',
                        title: 'Message Discarded',
                        body: 'Your message has been discarded',
                        showCloseButton: true
                    });
                    $state.go("base.mailbox.inbox");
                }, function () {
                });
            } else $state.go("base.mailbox.inbox");
        }
    });

'use strict';

angular.module('lms')
    .controller('MailboxBaseController', function (MailboxService) {
        var vm = this;
        vm.loaded = false;
        MailboxService.getSummary().then(function (resp) {
            vm.mailSummary = resp;
            vm.loaded = true;
        }, function () {
            vm.loaded = true;
        });
    });

'use strict';

angular.module('lms')
    .controller('InboxController', function (MailboxService, inboxType, $state, $location) {
        var vm = this;
        vm.truncateOptions = {
            watch: 'window'
        };
        vm.stateName = $state.current.name;
        vm.pageTitle = $state.current.data.pageTitle;
        vm.inboxType = inboxType;
        vm.page = 1;
        vm.loaded = false;
        vm.showSearch = false;
        vm.searchText = $location.search().search;
        vm.getMessages = function () {
            MailboxService.getMessages(vm.inboxType, vm.page).then(function (resp) {
                vm.pages = resp.pages;
                if (vm.page > 1 && vm.list.length == 0) {
                    if (vm.page > resp.pages) vm.page = resp.pages; else vm.page--;
                    vm.getMessages();
                } else {
                    vm.count = resp.count;
                    if (resp.unreadCount) vm.unreadCount = resp.unreadCount;
                    vm.list = resp.list;
                    if (inboxType == 'Sent') {
                        _.each(vm.list, function (item) {
                            item.recipients = angular.fromJson(item.recipients);
                        });
                    }
                    vm.loaded = true;
                }
            }, function () {
                vm.loaded = true;
            });
        };
        vm.loadPrev = function () {
            if (vm.page > 1) {
                vm.page--;
                vm.getMessages();
            }
        };
        vm.loadNext = function () {
            if (vm.page < vm.pages) {
                vm.page++;
                vm.getMessages();
            }
        };
        vm.refresh = function () {
            if (vm.showSearch) {
                vm.search({ $valid: true });
            } else {
                vm.loaded = false;
                vm.getMessages();
            }
        };
        vm.search = function () {
            //if (!form.$valid) return;
            vm.loaded = false;
            MailboxService.searchMessages(vm.inboxType, vm.searchText).then(function (resp) {
                if (!vm.showSearch)
                    vm.backup = {
                        pages: vm.pages,
                        count: vm.count,
                        list: angular.copy(vm.list)
                    };
                vm.pages = resp.pages;
                vm.count = resp.count;
                vm.list = resp.list;
                if (inboxType == 'Sent') {
                    _.each(vm.list, function (item) {
                        item.recipients = angular.fromJson(item.recipients);
                    });
                }
                vm.showSearch = true;
                vm.loaded = true;
            }, function () {
                vm.loaded = true;
            });
        };
        if (vm.searchText) vm.search();
        else vm.getMessages();
        vm.resetSearch = function () {
            vm.pages = vm.backup.pages;
            vm.count = vm.backup.count;
            vm.list = vm.backup.list;
            vm.showSearch = false;
        };
    });

'use strict';

angular.module('lms')
    .controller('GradebookController', function ($scope, $stateParams, SweetAlert, DTOptionsBuilder, DTColumnDefBuilder, GradebookService, CourseService, AuthenticationService, ManageService) {
        var vm = this;
        vm.numberArrays = {};
        vm.getArray = function (num) {
            if (!vm.numberArrays[num]) {
                vm.numberArrays[num] = [];
                for (var i = 0; i < num; i++) vm.numberArrays[num][i] = i;
            }
            return vm.numberArrays[num];
        };
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDisplayLength(100)
            .withDOM('<"html5buttons"B>lTfgitp')
            .withButtons([
                { extend: 'copy' },
                { extend: 'csv', title: 'Gradebook' },
                { extend: 'excel', title: 'Gradebook' },
                { extend: 'pdf', title: 'Gradebook' },
                {
                    extend: 'print',
                    customize: function (win) {
                        angular.element(win.document.body).addClass('white-bg');
                        angular.element(win.document.body).css('font-size', '10px');
                        angular.element(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                }
            ]);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notVisible(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable()
        ];
        vm.courseOutline = {};
        CourseService.getAll().then(function (courses) {
            //courses.unshift({ courseId: 0, name: 'All courses' });
            vm.courses = courses;
        }, function () {
        });
        GradebookService.getGradings().then(function (gradings) {
            vm.gradings = gradings;
        }, function () {
        });
        vm.loadStudents = function () {
            if (AuthenticationService.isUserAdmin() || AuthenticationService.isUserEducator()) {
                if (vm.courseId) {
                    ManageService.getCourseStudents(vm.courseId).then(function (users) {
                        vm.users = users;
                        afterStudentsLoad();
                    }, function () {
                    });
                } else {
                    ManageService.getStudents().then(function (users) {
                        vm.users = users;
                        afterStudentsLoad();
                    }, function () {
                    });
                }
            }
        };
        var afterStudentsLoad = function () {
            if (vm.users && vm.users.length && vm.userId) {
                if (_.filter(vm.users, function (user) { return user.userId == vm.userId; }).length)
                    vm.loadGradebook();
                else {
                    vm.userId = null;
                    //vm.list = null;
                    //vm.listBackup = null;
                }
            }
        };
        vm.courseIdChanged = function () {
            if (AuthenticationService.isUserStudent()) vm.loadGradebook(); else vm.loadStudents();
        };
        var processGradebook = function (courseId, list) {
            var doFinal = function (courseId, list) {
                vm.currentOutline = vm.courseOutline[courseId];
                var dict = {
                    contentId: _.indexBy(_.filter(list, function (item) { return item.contentId }), "contentId"),
                    courseNodeId: _.indexBy(_.filter(list, function (item) { return item.courseNodeId }), "courseNodeId")
                };
                _.each(vm.currentOutline, function (item, index) {
                    item.index = index;
                    if (dict[item.idType][item.id]) {
                        item.gradeRow = dict[item.idType][item.id];
                        item.gradeRowBackup = angular.copy(item.gradeRow);
                    }// else {
                    //    item.gradeRow = {};
                    //}
                });
                //vm.listBackup = angular.copy(vm.list);
                vm.loading = false;
            };
            if (vm.courseOutline[courseId])
                doFinal(courseId, list);
            else {
                CourseService.getOutline(courseId).then(function (outline) {
                    vm.courseOutline[courseId] = CourseService.getFlatStructure(outline, true);
                    doFinal(courseId, list);
                }, function () {
                    //vm.list = _.indexBy(list, "contentId");
                    //vm.listBackup = angular.copy(vm.list);
                    vm.loading = false;
                });
            }
        };
        vm.loadGradebook = function () {
            var courseId = vm.courseId;
            if (AuthenticationService.isUserAdmin() || AuthenticationService.isUserEducator()) {
                if (vm.userId) {
                    vm.loading = true;
                    GradebookService.getUserGradebook(vm.userId, courseId).then(function (list) {
                        processGradebook(courseId, list);
                    }, function () {
                        vm.loading = false;
                    });
                } else
                    SweetAlert.swal({
                        title: "No student selected",
                        text: "Please select a student in order to view that student's gradebook",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Ok",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    });
            } else {
                vm.loading = true;
                GradebookService.getGradebook(courseId).then(function (list) {
                    processGradebook(courseId, list);
                }, function () {
                    vm.loading = false;
                });
            }
        };
        vm.edit = function (content) {
            var contentId = content.contentId;
            if (content.gradeRow) content.gradeRow.inEdit = true;
            else {
                if (content.type == 'Assessment' || content.type == 'Assignment' || content.type == 'Pdf') {
                    CourseService.getContentPoints(contentId).then(function (resp) {
                        content.gradeRow = {
                            contentId: contentId,
                            name: content.name,
                            type: content.type,
                            entryType: content.type == 'Assessment' || content.type == 'Assignment' ? 'Competitive' : 'Reading',
                            contentTotal: resp.points,
                            inEdit: true
                        };
                    }, function () {
                        content.gradeRow = {
                            contentId: contentId,
                            name: content.name,
                            type: content.type,
                            entryType: 'Reading',
                            contentTotal: 1,
                            inEdit: true
                        };
                    });
                } else
                    content.gradeRow = {
                        contentId: contentId,
                        name: content.name,
                        type: content.type,
                        entryType: 'Reading',
                        contentTotal: 1,
                        inEdit: true
                    };
            }
        };
        vm.save = function (content) {
            var entry = content.gradeRow;
            entry.contentId = content.contentId;
            entry.courseNodeId = content.courseNodeId;
            if (entry.entryType == 'Reading' && entry.type != 'Pdf') {
                if (entry.viewed) entry.score = entry.contentTotal;
                else entry.score = 0;
            }
            GradebookService.updateGradebookUserEntry(vm.userId, entry).then(function (resp) {
                content.gradeRow.percentage = resp.percentage;
                content.gradeRow.inEdit = false;
                content.gradeRowBackup = angular.copy(content.gradeRow);
            }, function () {
            });
        };
        vm.cancelEdit = function (content) {
            var contentId = content.contentId;
            content.gradeRow.inEdit = false;
            if (content.gradeRowBackup)
                content.gradeRow = angular.copy(content.gradeRowBackup);
            else
                delete content.gradeRow;
        };
        $scope.$on('onSignedIn', function () {
            vm.loadStudents();
        });
        vm.toggleOutline = function (scope) {
            scope.toggle();
        };
    });
'use strict';

angular.module('lms')
    .controller('FeedController', function ($scope, $stateParams, $interval, SweetAlert, toaster, FeedService, FileService, GlobalService, AuthenticationService) {
        var vm = this;

        vm.myUserId = AuthenticationService.getSignedInUser().userId;

        vm.flotPieOptions = {
            series: {
                pie: {
                    show: true
                }
            },
            grid: {
                hoverable: true
            },
            tooltip: true,
            tooltipOpts: {
                content: "%p.0%, %s", // show percentages, rounding to 2 decimal places
                shifts: {
                    x: 20,
                    y: 0
                },
                defaultTheme: false
            }
        };

        $scope.$on('$destroy', function () {
            if (angular.isDefined(vm.refreshInterval)) {
                $interval.cancel(vm.refreshInterval);
                vm.refreshInterval = undefined;
            }
        });

        $scope.$on('onPostPoll', function (e, item) {
            var pollposts = _.filter(vm.posts, function (pollpost) { return pollpost.postId == item.id; });
            if (pollposts.length) {
                var post = pollposts[0];
                var results = _.indexBy(post.poll.pollResults, "pollChoiceId");
                _.each(item.data.addIds, function (id) {
                    if (results[id]) results[id].count++; else {
                        post.poll.pollResults.push({ pollChoiceId: id, count: 1 });
                    }
                });
                _.each(item.data.removeIds, function (id) {
                    if (results[id]) results[id].count--;
                });
                results = _.indexBy(post.poll.pollResults, "pollChoiceId");
                var tickdata = [];
                post.poll.flotPieData = [];
                _.each(post.poll.pollChoices, function (choice, index) {
                    var count = 0;
                    if (results[choice.pollChoiceId])
                        count = results[choice.pollChoiceId].count;
                    tickdata.push([count, index]);
                    post.poll.flotPieData.push({
                        label: choice.choiceContent,
                        data: count,
                        color: GlobalService.getColourFromPalette(index)
                    });
                });
                post.poll.flotBarData = [{ label: "Poll", data: tickdata, color: "#E8E800" }];
            }
        });

        vm.choiceOptions = {
            min: 0,
            max: 10000,
            step: 1,
            decimals: 0
        };

        vm.imageUpload = function (files) {
            toaster.pop({
                type: 'wait',
                title: 'Adding Images',
                body: 'Your images are being added...',
                timeout: 0
            });
            var editor = vm.editor;
            FileService.uploadWysiwygFiles(files, "Feed").then(function (resp) {
                for (var key in resp.files) {
                    editor.summernote('insertImage', GlobalService.CdnBase + "/Api/File/Public/" + resp.files[key], key);
                }
                toaster.clear();
                toaster.pop({
                    type: 'success',
                    title: 'Images added',
                    body: 'Your images have been added successfully',
                    showCloseButton: true
                });
            }, function () {
            });
        };

        vm.summernoteOptions = {
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'hr']]
            ]
        };

        vm.loaded = false;

        vm.posts = [];

        vm.refreshInterval = undefined;

        vm.getFeed = function () {
            FeedService.getFeed($stateParams.type, $stateParams.id, vm.lastId).then(function (resp) {
                vm.name = resp.name;
                _.each(resp.list, function (post) {
                    if (post.poll) {
                        post.poll.iVoted = false;
                        post.poll.flotPieData = [];
                        var ticks = [];
                        var tickdata = [];
                        var results = _.indexBy(post.poll.pollResults, "pollChoiceId");
                        _.each(post.poll.pollChoices, function (choice, index) {
                            if (choice.selected) post.poll.iVoted = true;
                            var count = 0;
                            if (results[choice.pollChoiceId])
                                count = results[choice.pollChoiceId].count;
                            tickdata.push([count, index]);
                            ticks.push([index, choice.choiceContent]);
                            post.poll.flotPieData.push({
                                label: choice.choiceContent,
                                data: count,
                                color: GlobalService.getColourFromPalette(index)
                            });
                        });
                        post.poll.flotBarData = [{ label: "Poll", data: tickdata, color: "#E8E800" }];
                        post.poll.flotBarOptions = {
                            series: {
                                bars: {
                                    show: true
                                }
                            },
                            bars: {
                                align: "center",
                                barWidth: 0.5,
                                horizontal: true,
                                fillColor: { colors: [{ opacity: 0.5 }, { opacity: 1 }] },
                                lineWidth: 1
                            },
                            xaxis: {
                                min: 0,
                                minTickSize: 1,
                                tickSize: 1,
                                tickDecimals: 0,
                                tickColor: "#5E5E5E",
                                color: "black"
                            },
                            yaxis: {
                                tickColor: "#5E5E5E",
                                ticks: ticks,
                                color: "black"
                            },
                            legend: false,
                            grid: {
                                hoverable: true,
                                borderWidth: 2,
                                backgroundColor: { colors: ["#171717", "#4F4F4F"] }
                            }
                        };
                    }
                });
                vm.posts = vm.posts.concat(resp.list);
                vm.lastId = resp.lastId;
                vm.loaded = true;
                if (!vm.refreshInterval) vm.refreshInterval = $interval(vm.getLatestFeed, 5000);
            }, function () {
                vm.loaded = true;
            });
        };
        vm.getFeed();

        vm.newPost = { postMessageType: 'Text' };
        vm.pollSelected = function () {
            vm.newPost.postMessageType = 'Poll';
            if (!vm.newPost.poll)
                vm.newPost.poll = { pollChoices: [] };
            if (!vm.newPost.poll.maxChoices) vm.newPost.poll.maxChoices = 1;
        };
        vm.addPollChoice = function () {
            if (vm.newPollChoiceMessage) {
                if (!vm.newPost.poll)
                    vm.newPost.poll = { pollChoices: [] };
                vm.newPost.poll.pollChoices.push({ choiceContent: vm.newPollChoiceMessage });
                vm.newPollChoiceMessage = "";
            }
        };
        vm.submitPost = function () {
            vm.saving = true;
            if (vm.newPost.postMessageType == 'Poll') {
                vm.addPollChoice();
                vm.newPost.poll.pollChoices = _.filter(vm.newPost.poll.pollChoices, function (choice) { return choice.choiceContent });
                _.each(vm.newPost.poll.pollChoices, function (choice, index) { choice.choiceNumber = index + 1; });
            }
            FeedService.submitPost($stateParams.type, $stateParams.id, vm.newPost).then(function (resp) {
                vm.newPost = { postMessageType: vm.newPost.postMessageType };
                if (vm.newPost.postMessageType == 'Poll') vm.pollSelected();
                vm.saving = false;
            }, function () {
                vm.saving = false;
            });
        };
        vm.selectPollChoice = function (post, choice) {
            var poll = post.poll;
            var count = _.filter(poll.pollChoices, function (c) { return c.selected; }).length;
            if (!poll.isTransient && count > 0 && !poll.allowEdit) {
                SweetAlert.swal({
                    title: "This poll does not allow changes to votes once they are submitted",
                    text: "",
                    type: "error",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK",
                    closeOnConfirm: true });
                return;
            }
            if (choice.selected) choice.selected = false;
            else {
                if (poll.maxChoices == 1) {
                    if (count > 0) {
                        _.each(poll.pollChoices, function (c) { c.selected = false; });
                        count = 0;
                    }
                } else if (count == poll.maxChoices) {
                    SweetAlert.swal({
                        title: ("This poll only allows a maximum of {0} choices. Please unselect another choice by clicking it again.").replace('{0}', poll.maxChoices),
                        text: "",
                        type: "error",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "OK",
                        closeOnConfirm: true
                    });
                    return;
                }
                choice.selected = true;
                count++;
            }
            poll.isTransient = true;
            if (choice.selected) {
                if (count == poll.maxChoices) {
                    SweetAlert.swal({
                        title: "Do you wish to submit your vote for this poll",
                        text: "",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes, submit it!",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            vm.submitPollChoices(post);
                        }
                    });
                }
            }
        };
        vm.submitPollChoices = function (post) {
            var choiceIds = _.pluck(_.filter(post.poll.pollChoices, function (choice) { return choice.selected }), "pollChoiceId");
            if (choiceIds.length > 0) {
                post.voting = true;
                FeedService.postPollChoice(post.postId, choiceIds).then(function (resp) {
                    post.poll.isTransient = false;
                    post.poll.iVoted = true;
                    toaster.pop({
                        type: 'success',
                        title: 'Vote submitted',
                        body: 'Your vote has been submitted successfully',
                        showCloseButton: true
                    });
                    post.voting = false;
                }, function () {
                    toaster.pop({
                        type: 'error',
                        title: 'Error',
                        body: 'An error occured while submitting your vote',
                        showCloseButton: true
                    });
                    post.voting = false;
                });
            } else {
                SweetAlert.swal({
                    title: "Please select at least one choice",
                    text: "",
                    type: "error",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                });
            }
        };
        vm.getLatestFeed = function () {
            var postId = 0;
            if (vm.posts.length) postId = vm.posts[0].postId;
            FeedService.getLatestFeed($stateParams.type, $stateParams.id, postId).then(function (resp) {
                if (resp.length) vm.posts = resp.concat(vm.posts);
            }, function () {
            });
            if (vm.commentPosts.length) {
                FeedService.getLatestComments($stateParams.type, vm.commentPosts, vm.lastCommentId).then(function (resp) {
                    if (resp.length) {
                        if (resp[0].postCommentId > vm.lastCommentId) vm.lastCommentId = resp[0].postCommentId;
                        var postDict = _.indexBy(vm.posts, 'postId');
                        _.each(resp, function (item) {
                            postDict[item.postId].comments.push(item);
                            postDict[item.postId].commentCount++;
                        });
                    }
                }, function () {
                });
            }
        };
        vm.postComment = function (post) {
            post.savingComment = true;
            var text = post.newComment;
            FeedService.postComment(post.postId, { comment: text }).then(function (resp) {
                //if (post.comments) post.comments.push({
                //    comment: text,
                //    postCommentId: resp.commentId,
                //    likeCount: 0
                //});
                //post.commentCount++;
                post.newComment = '';
                post.savingComment = false;
            }, function () {
                post.savingComment = false;
            });
        };
        vm.likePost = function (post) {
            if (!post.iLike) {
                post.likeSaving = true;
                FeedService.likePost(post.postId).then(function (resp) {
                    post.iLike = true;
                    post.likeCount++;
                    if (post.iDislike) {
                        post.iDislike = false;
                        post.dislikeCount--;
                    }
                    post.likeSaving = false;
                }, function () {
                    post.likeSaving = false;
                });
            }
        };
        vm.dislikePost = function (post) {
            if (!post.iDislike) {
                post.likeSaving = true;
                FeedService.dislikePost(post.postId).then(function (resp) {
                    post.iDislike = true;
                    post.dislikeCount++;
                    if (post.iLike) {
                        post.iLike = false;
                        post.likeCount--;
                    }
                    post.likeSaving = false;
                }, function () {
                    post.likeSaving = false;
                });
            }
        };
        vm.commentPosts = [];
        vm.lastCommentId = 0;
        vm.loadComments = function (post) {
            post.loadingComments = true;
            post.showComments = true;
            FeedService.getComments(post.postId).then(function (resp) {
                if (resp.list.length && resp.list[0].postCommentId > vm.lastCommentId) vm.lastCommentId = resp.list[0].postCommentId;
                if (vm.commentPosts.indexOf(post.postId) < 0) vm.commentPosts.push(post.postId);
                post.comments = resp.list.reverse();
                post.commentCount = resp.total;
                post.loadingComments = false;
            }, function () {
                post.loadingComments = false;
            });
        };
        vm.loadMoreComments = function (post) {
            post.loadingComments = true;
            FeedService.getMoreComments(post.postId, post.comments[0].postCommentId).then(function (resp) {
                post.comments = resp.list.reverse().concat(post.comments);
                post.commentCount = resp.total;
                post.loadingComments = false;
            }, function () {
                post.loadingComments = false;
            });
        };
        vm.likeComment = function (comment) {
            if (!comment.iLike) {
                comment.likeSaving = true;
                FeedService.likeComment(comment.postCommentId).then(function (resp) {
                    comment.iLike = true;
                    comment.likeCount++;
                    if (comment.iDislike) {
                        comment.iDislike = false;
                        comment.dislikeCount--;
                    }
                    comment.likeSaving = false;
                }, function () {
                    comment.likeSaving = false;
                });
            }
        };
    });
'use strict';

angular.module('lms')
    .controller('CreateFeedPostModalController', function ($uibModalInstance, $state, $timeout, toaster, FeedService, FileService, GlobalService, images) {
        var vm = this;
        vm.summernoteOptions = {
            toolbar: [
                    ['edit', ['undo', 'redo']],
                    ['headline', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                    ['fontface', ['fontname']],
                    ['textsize', ['fontsize']],
                    ['fontclr', ['color']],
                    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'hr']]
            ]
        };
        vm.images = images;
        $timeout(function() {
            if (vm.images) {
                var editor = vm.editor;
                vm.images.forEach(function(image){
                    editor.summernote('insertImage', GlobalService.CdnBase + "/Api/File/Public/" + image.path, image.name);
                });
            }
        }, 0);
        vm.saving = false;
        vm.newPost = { postMessageType: 'Text' };
        vm.feedType = "Institution";
        vm.feedId = "";
        vm.imageUpload = function (files) {
            toaster.pop({
                type: 'wait',
                title: 'Adding Images',
                body: 'Your images are being added...',
                timeout: 0
            });
            var editor = vm.editor;
            FileService.uploadWysiwygFiles(files, "Feed").then(function (resp) {
                for (var key in resp.files) {
                    editor.summernote('insertImage', GlobalService.CdnBase + "/Api/File/Public/" + resp.files[key], key);
                }
                toaster.clear();
                toaster.pop({
                    type: 'success',
                    title: 'Images added',
                    body: 'Your images have been added successfully',
                    showCloseButton: true
                });
            }, function () {
            });
        };
        vm.ok = function () {
            vm.saving = true;
            FeedService.submitPost(vm.feedType, vm.feedId, vm.newPost).then(function (resp) {
                $uibModalInstance.close();
                toaster.pop({
                    type: 'success',
                    title: 'Image shared',
                    body: 'Your image has been shared successfully to the feed',
                    showCloseButton: true
                });
                vm.saving = false;
            }, function () {
                toaster.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'An error occured while submitting your post',
                    showCloseButton: true
                });
                vm.saving = false;
            });
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    });

'use strict';

angular.module('lms')
    .controller('ChatroomController', function ($rootScope, $scope, $state, $stateParams, $timeout, toaster, AuthenticationService, ChatroomService) {
        var vm = this;

        /*$scope.$on('$destroy', function () {
            if (angular.isDefined(vm.refreshInterval)) {
                $interval.cancel(vm.refreshInterval);
                vm.refreshInterval = undefined;
            }
        });*/

        $scope.$on('onChatMessage', function (event, item) {
            if (item.id == vm.id) vm.chatroom.messages.push(item.data);
        });

        $scope.$on('onChatMembers', function (event, item) {
            if (item.id == vm.id && item.data.length && vm.me != vm.chatroom.ownerId) {
                vm.chatroom.members = vm.chatroom.members.concat(item.data);
                vm.memberDict = _.indexBy(vm.chatroom.members, "userId");
            }
        });

        $scope.$on('onChatDrawing', function (event, item) {
            if (item.id == vm.id) {
                vm.chatroom.drawings.push(item.data);
                if (vm.myDrawings.indexOf(item.data.chatroomDrawingId) < 0) $rootScope.$broadcast('apply-drawings', { drawings: [item.data] });
            }
        });

        vm.loading = false;
        vm.peopleCache = {};
        vm.people = [];
        vm.peopleSearchTimeout = null;
        vm.latestSearchTerm = "";
        vm.getPeople = function (searchTerm) {
            if (searchTerm) {
                vm.latestSearchTerm = searchTerm;
                if (vm.peopleSearchTimeout) $timeout.cancel(vm.peopleSearchTimeout);
                if (vm.peopleCache[searchTerm]) vm.people = vm.peopleCache[searchTerm];
                else {
                    vm.peopleSearchTimeout = $timeout(function (searchTerm) {
                        ChatroomService.getPeople(searchTerm).then(function (resp) {
                            if (vm.latestSearchTerm == searchTerm)
                                vm.people = resp;
                            vm.peopleCache[searchTerm] = resp;
                        }, function () {
                        });
                    }(searchTerm), 400);
                }
            }
        };
        vm.fromId = 0;
        vm.lastId = 0;
        vm.drawingId = 0;
        if ($stateParams.id) {
            vm.id = $stateParams.id;
            ChatroomService.getChatroom(vm.id).then(function (resp) {
                vm.me = AuthenticationService.getSignedInUser().userId;
                vm.myPic = AuthenticationService.getSignedInUser().profilePic;
                vm.chatroom = resp;
                vm.memberDict = _.indexBy(vm.chatroom.members, "userId");
                if (vm.chatroom.messages && vm.chatroom.messages.length) {
                    vm.fromId = vm.chatroom.messages[0].chatroomMessageId;
                    vm.chatroom.messages = vm.chatroom.messages.reverse();
                    vm.lastId = vm.chatroom.messages.length < 20 ? 0 : vm.chatroom.messages[0].chatroomMessageId;
                }
                if (vm.chatroom.drawings && vm.chatroom.drawings.length) {
                    vm.drawingId = vm.chatroom.drawings[vm.chatroom.drawings.length - 1].chatroomDrawingId;
                    $rootScope.$broadcast('apply-drawings', { drawings: vm.chatroom.drawings });
                }
                //vm.setInterval();
            }, function () {
            });
        }
        /*vm.setInterval = function () {
            if (!vm.refreshInterval) vm.refreshInterval = $interval(vm.getLatestUpdates, 3000);
        };*/
        vm.create = function (form) {
            if (!form.$valid) return;
            if (vm.id) return;
            vm.saving = true;
            var chatroom = { name: vm.chatroom.name, memberIds: _.pluck(vm.chatroom.members, "userId") };
            ChatroomService.createChatroom(chatroom).then(function (resp) {
                vm.me = AuthenticationService.getSignedInUser().userId;
                vm.chatroom.ownerId = vm.me;
                vm.myPic = AuthenticationService.getSignedInUser().profilePic;
                vm.id = resp.id;
                vm.fromId = 0;
                vm.lastId = 0;
                vm.memberDict = _.indexBy(vm.chatroom.members, "userId");
                vm.chatroom.messages = [];
                vm.chatroom.timestamp = resp.timestamp;
                //vm.setInterval();
                vm.saving = false;
                form.$submitted = false;
            }, function () {
                vm.saving = false;
            });
        }
        vm.submitMessage = function (form) {
            if (!form.$valid) return;
            vm.sending = true;
            vm.newMessage.messageType = "Text";
            ChatroomService.submitMessage(vm.id, vm.newMessage).then(function (resp) {
                vm.newMessage = "";
                vm.sending = false;
            }, function () {
                vm.sending = false;
            });
        };
        vm.myDrawings = [];
        vm.submitDrawing = function (drawing) {
            ChatroomService.submitDrawing(vm.id, drawing).then(function (resp) {
                vm.myDrawings.push(resp.id);
            }, function () {
            });
        };

        vm.refreshInterval = undefined;
        vm.updating = false;
        /*vm.getLatestUpdates = function () {
            if (vm.updating) return;
            vm.updating = true;
            ChatroomService.getUpdates(vm.id, vm.fromId, vm.drawingId, vm.chatroom.timestamp).then(function (resp) {
                vm.updating = false;
                vm.chatroom.timestamp = resp.timestamp;
                if (resp.messages.length) {
                    vm.fromId = resp.messages[0].chatroomMessageId;
                    var list = resp.messages.reverse();
                    vm.chatroom.messages = vm.chatroom.messages.concat(list);
                }
                if (resp.members.length && vm.me != vm.chatroom.ownerId) {
                    vm.chatroom.members = vm.chatroom.members.concat(resp.members);
                    vm.memberDict = _.indexBy(vm.chatroom.members, "userId");
                }
                if (resp.drawings) {
                    if (resp.drawings.length) vm.drawingId = resp.drawings[resp.drawings.length - 1].chatroomDrawingId;
                    vm.chatroom.drawings = vm.chatroom.drawings.concat(resp.drawings);
                    var drawings = drawings = _.filter(resp.drawings, function (item) { return vm.myDrawings.indexOf(item.chatroomDrawingId) < 0; });
                    if (drawings.length) $rootScope.$broadcast('apply-drawings', { drawings: drawings });
                }
            }, function () {
                vm.updating = false;
            });
        };*/
        vm.getMoreMessages = function () {
            if (vm.lastId == 0) return;
            ChatroomService.getMessages(vm.id, vm.lastId).then(function (resp) {
                if (resp.length) {
                    var list = resp.reverse();
                    vm.chatroom.messages = list.concat(vm.chatroom.messages);
                    vm.lastId = list[0].chatroomMessageId;
                } else vm.lastId = 0;
            }, function () {
            });
        };
        vm.addMembers = function (form) {
            if (!form.$valid) return;
            vm.addingMembers = true;
            ChatroomService.addMembers(vm.id, { memberIds: _.pluck(vm.newMembers, "userId") }).then(function (resp) {
                if (resp.memberIds) {
                    var addedMembers = _.filter(vm.newMembers, function (member) {
                        return resp.memberIds.indexOf(member.userId) >= 0;
                    });
                    vm.chatroom.members = vm.chatroom.members.concat(addedMembers);
                    vm.memberDict = _.indexBy(vm.chatroom.members, "userId");
                }
                vm.newMembers = [];
                vm.addingMembers = false;
            }, function () {
                vm.addingMembers = false;
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('AttendanceController', function ($uibModal, SweetAlert, $timeout, ManageService, TimetableService, AttendanceService) {
        var vm = this;
        vm.statusList = [
            { text: "", value: 0, css: "default" },
            { text: "Present", value: 3, css: "primary" },
            { text: "Late", value: 2, css: "warning" },
            { text: "Absent", value: 1, css: "danger" }
        ];
        vm.statusDict = {
            0: { text: "", css: "default" },
            3: { text: "Present", css: "primary" },
            2: { text: "Late", css: "warning" },
            1: { text: "Absent", css: "danger" }
        };
        var setCurrentTT = function (initLoad) {
            var tt = _.filter(vm.timetables, function (item) { vm.displayDate.isBetween(moment.utc(item.startDate).toDate(), moment.utc(item.endDate).toDate()) });
            if (tt.length) { vm.currentTT = tt[0]; if (!initLoad) vm.getAttendanceForDate(); }
            else if (!initLoad) {
                TimetableService.getForDate(vm.displayDate).then(function (timetable) {
                    if (timetable) {
                        vm.timetables.push(timetable);
                        vm.currentTT = timetable;
                        vm.getAttendanceForDate();
                    } else vm.currentTT = {};
                }, function () {
                });
            }
        };
        vm.setToday = function (initLoad) {
            vm.displayDate = moment();
            vm.displayDateIndex = vm.displayDate.isoWeekday() - 1;
            setCurrentTT(initLoad);
        };
        vm.setToday(true);
        vm.nextDay = function () {
            vm.displayDate.add(1, 'd');
            vm.displayDateIndex = vm.displayDate.isoWeekday() - 1;
            setCurrentTT();
        };
        vm.previousDay = function () {
            vm.displayDate.subtract(1, 'd');
            vm.displayDateIndex = vm.displayDate.isoWeekday() - 1;
            setCurrentTT();
        };
        vm.loaded = false;
        TimetableService.getAll().then(function (timetables) {
            vm.timetables = timetables;
            setCurrentTT();
            vm.loaded = true;
        }, function () {
        });
        ManageService.getDepartments().then(function (departments) {
            vm.departments = departments;
            if (vm.departments.length == 1) {
                vm.departmentId = vm.departments[0].departmentId;
                vm.departmentIdChanged();
            }
        }, function () {
        });
        vm.departmentIdChanged = function () {
            if (vm.departmentId) {
                ManageService.getGroups([vm.departmentId]).then(function (groups) {
                    vm.groups = groups;
                    if (vm.groups.length == 1) {
                        vm.groupId = vm.groups[0].departmentGroupId;
                        vm.groupIdChanged();
                    }
                }, function () {
                });
            }
        };
        var rowTemplates;
        vm.groupIdChanged = function () {
            if (vm.groupId) {
                vm.loading = true;
                TimetableService.getForGroup(vm.currentTT.timetableId, vm.groupId).then(function (timeRows) {
                    vm.dayTimeRows = [[], [], [], [], [], [], []];
                    rowTemplates = [[], [], [], [], [], [], []];
                    vm.timeRows = timeRows;
                    _.each(vm.timeRows, function (item) {
                        if (item.takeAttendance) {
                            item.timeDisplay = item.startTime.substring(0, 5) + " - " + item.endTime.substring(0, 5);
                            vm.dayTimeRows[item.dayOfWeek].push(item);
                            rowTemplates[item.dayOfWeek].push({ courseTimeSlotId: item.courseTimeSlotId });
                        }
                    });
                    vm.getStudents(1);
                }, function () {
                    vm.loading = false;
                });
            }
        };
        vm.getStudents = function (page) {
            ManageService.getGroupStudents(vm.groupId, page).then(function (students) {
                vm.students = students.list;
                _.each(vm.students, function (student) {
                    student.rows = angular.copy(rowTemplates);
                    student.dateResults = {};
                });
                setStudentRow();
                vm.getAttendanceForDate();
            }, function () {
                vm.loading = false;
            });
        };
        var setStudentRow = function () {
            _.each(vm.students, function (student) {
                student.row = student.rows[vm.displayDateIndex];
                student.rowDict = _.indexBy(student.row, "courseTimeSlotId");
                if (!student.dateResults[vm.displayDate]) student.dateResults[vm.displayDate] = {};
                student.result = student.dateResults[vm.displayDate];
            });
        };
        vm.getAttendanceForDate = function () {
            AttendanceService.getForGroupByDate(vm.groupId, vm.displayDate).then(function (results) {
                var studentsDict = _.indexBy(vm.students, "userId");
                setStudentRow();
                _.each(results, function (result) {
                    if (!result.status) result.status = "";
                    if (result.courseTimeSlotId) studentsDict[result.studentId].rowDict[result.courseTimeSlotId].result = result;
                    else {
                        studentsDict[result.studentId].dateResults[vm.displayDate] = result;
                        studentsDict[result.studentId].result = studentsDict[result.studentId].dateResults[vm.displayDate];
                    }
                });
                vm.loading = false;
            }, function () {
                vm.loading = false;
            });
        };
        vm.setBulkForTime = function (status, timeRow) {
            _.each(vm.students, function (student) {
                if (timeRow) {
                    if (!student.rowDict[timeRow.courseTimeSlotId].result) student.rowDict[timeRow.courseTimeSlotId].result = {};
                    student.rowDict[timeRow.courseTimeSlotId].result.status = status;
                } else {
                    if (!student.dateResults[vm.displayDate]) student.dateResults[vm.displayDate] = {};
                    student.dateResults[vm.displayDate].status = status;
                }
            });
        };
        vm.setBulkForStudent = function (status, student) {
            if (!student.dateResults[vm.displayDate]) student.dateResults[vm.displayDate] = {};
            student.dateResults[vm.displayDate].status = status;
            _.each(student.row, function (item) {
                if (!item.result) item.result = {};
                item.result.status = status;
            });
        };
        vm.save = function () {
            vm.saving = true;
            var listToSave = [];
            _.each(vm.students, function (student) {
                if (student.dateResults[vm.displayDate]) {
                    student.dateResults[vm.displayDate].studentId = student.userId;
                    listToSave.push(student.dateResults[vm.displayDate]);
                }
                _.each(student.row, function (item) {
                    if (item.result) {
                        item.result.studentId = student.userId;
                        item.result.courseTimeSlotId = item.courseTimeSlotId;
                        listToSave.push(item.result);
                    }
                });
            });
            AttendanceService.saveForGroup(vm.groupId, vm.displayDate, listToSave).then(function (results) {
                vm.saving = false;
            }, function () {
                vm.saving = false;
            });
        };
    });

'use strict';

angular.module('lms')
    .controller('SignOutController', function ($rootScope, $state, AuthenticationService) {
        var userId = AuthenticationService.getSignedInUser().userId;
        AuthenticationService.signOut().then(function () {
            $rootScope.$broadcast('onSignedOut', { userId: userId });
            $state.go(AuthenticationService.loginPage);
        });
    });

'use strict';

angular.module('lms')
    .controller('SignInModalController', function ($rootScope, $uibModalInstance, $state, toaster, AuthenticationService, loginQueue) {
        var vm = this;
        vm.isSigningIn = false;
        vm.email = "";
        vm.password = "";
        var oldUser = AuthenticationService.getSignedInUser();
        AuthenticationService.resetUser();
        vm.signIn = function (form) {
            if (!form.$valid) return;
            vm.isSigningIn = true;
            AuthenticationService.signIn(vm.email, vm.password, vm.rememberMe).then(function () {
                vm.isSigningIn = false;
                form.$submitted = false;
                $uibModalInstance.close();
                toaster.pop({
                    type: 'success',
                    title: 'Sign In Success',
                    body: 'You have been successfully logged in',
                    showCloseButton: true
                });
                _.each(loginQueue, function (item) { AuthenticationService.processQueueItem(item) });
                $rootScope.$broadcast('onSignedIn');
            }, function () {
                vm.isSigningIn = false;
                toaster.pop({
                    type: 'error',
                    title: 'Sign In Failed',
                    body: 'Incorrect email and/or password',
                    showCloseButton: true
                });
            });
        }
    });

'use strict';

angular.module('lms')
  .controller('SignInController', function ($rootScope, $state, $location, $window, toaster, AuthenticationService, GlobalService) {
        var vm = this;
        var returnUrl = $location.search().ReturnUrl;
        vm.isSigningIn = false;
        vm.signIn = function (form) {
            if (!form.$valid) return;
            vm.isSigningIn = true;
            AuthenticationService.signIn(vm.email, vm.password, vm.rememberMe).then(function () {
                form.$submitted = false;
                if (returnUrl)
                    $window.location.href = returnUrl;
                else {
                    var next = AuthenticationService.getNextState();
                    AuthenticationService.setNextState();
                    if (next)
                        $state.go(next.name, next.params);
                    else
                        $state.go(AuthenticationService.defaultLandingPage);
                    $rootScope.$broadcast('onSignedIn');
                }
            }, function () {
                vm.isSigningIn = false;
                toaster.pop({
                    type: 'error',
                    title: 'Sign In Failed',
                    body: 'Incorrect email and/or password',
                    showCloseButton: true
                });
            });
        }
    });

'use strict';

angular.module('lms')
    .controller('ResetPwdController', function ($state, $location, toaster, AuthenticationService) {
        var vm = this;
        vm.email = $location.search().email;
        vm.key = $location.search().key;
        vm.sending = false;
        vm.send = function (form) {
            if (!form.$valid) return;
            vm.sending = true;
            AuthenticationService.resetPassword(vm.email, vm.key, vm.password).then(function () {
                form.$submitted = false;
                vm.sending = false;
                toaster.pop({
                    type: 'success',
                    title: 'Password Reset',
                    body: 'Your password has been reset successfully',
                    showCloseButton: true
                });
                $state.go("signin");
            }, function () {
                vm.sending = false;
            });
        }
    });

'use strict';

angular.module('lms')
    .controller('ForgotPwdController', function ($state, toaster, AuthenticationService) {
        var vm = this;
        vm.sending = false;
        vm.send = function (form) {
            if (!form.$valid) return;
            vm.sending = true;
            AuthenticationService.sendForgotPwd(vm.email).then(function () {
                form.$submitted = false;
                vm.sending = false;
                toaster.pop({
                    type: 'success',
                    title: 'Email Sent',
                    body: 'We have emailed the instructions for resetting your password',
                    showCloseButton: true
                });
            }, function () {
                vm.sending = false;
            });
        }
    });

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
    'use strict';

    angular
    .module('lms')
    .run(runBlock);

    /** @ngInject */
    function runBlock(AuthenticationService, ProfileService, $rootScope, $state, $sce) {
        var onStateChangeStart = function (event, toState, toParams) {
            var user = AuthenticationService.getSignedInUser();
            if (user && toState.name == AuthenticationService.loginPage) {
                if (toParams.ReturnUrl)
                    AuthenticationService.clearUser();
                else {
                    event.preventDefault();
                    $state.go(AuthenticationService.defaultLandingPage);
                }
            }

            var requireLogin = toState.data.requireLogin;
            if (requireLogin) {
                if (user) {
                    var rolesAllowed = toState.data.rolesAllowed;
                    if (rolesAllowed && rolesAllowed.indexOf(user.role) < 0)
                        $state.go(AuthenticationService.defaultLandingPage);
                } else {
                    event.preventDefault();
                    AuthenticationService.setNextState(toState.name, _.clone(toParams));
                    $state.go(AuthenticationService.loginPage);
                }
            }
        };
        var stateChangeStartCallback = $rootScope.$on('$stateChangeStart', onStateChangeStart);
        var stateChangeSuccessCallback = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if (AuthenticationService.getSignedInUser())
                ProfileService.postNavigation(toState.name, angular.toJson(toParams));
        });
        $rootScope.$on('$destroy', stateChangeStartCallback);
        $rootScope.$on('$destroy', stateChangeSuccessCallback);

        $rootScope.trustHtml = function (html_code) {
            return $sce.trustAsHtml(html_code);
        };
        $rootScope.trustUrl = function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }

})();

(function() {
    'use strict';

    angular
    .module('lms')
    .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider

        .state('signin', {
            url: "/signin?ReturnUrl",
            templateUrl: "app/auth/signin.html",
            controller: 'SignInController',
            controllerAs: 'signin',
            data: {
                requireLogin: false
            }
        })
        .state('signout', {
            url: "/signout",
            templateUrl: "app/auth/signout.html",
            controller: 'SignOutController',
            controllerAs: 'signout',
            data: {
                requireLogin: false
            }
        })
        .state('forgotpassword', {
            url: "/forgotpassword",
            templateUrl: "app/auth/forgot.password.html",
            controller: 'ForgotPwdController',
            controllerAs: 'forgotpwd',
            data: {
                requireLogin: false
            }
        })
        .state('resetpassword', {
            url: "/resetpassword?email&key",
            templateUrl: "app/auth/reset.password.html",
            controller: 'ResetPwdController',
            controllerAs: 'resetpwd',
            data: {
                requireLogin: false
            }
        })
        .state('base', {
            abstract: true,
            url: "/",
            templateUrl: "app/components/common/content.html",
            controller: 'BaseController',
            controllerAs: 'global',
            data: {
                requireLogin: true
            },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'slimscroll',
                            files: ['/Scripts/plugins/slimscroll/jquery.slimscroll.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.main', {
            url: "main",
            templateUrl: "app/main/dashboard.html",
            data: { pageTitle: 'My Dashboard' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            serie: true,
                            name: 'angular-flot',
                            files: ['/Scripts/plugins/flot/jquery.flot.js', '/Scripts/plugins/flot/jquery.flot.time.js', '/Scripts/plugins/flot/jquery.flot.tooltip.min.js', '/Scripts/plugins/flot/jquery.flot.spline.js', '/Scripts/plugins/flot/jquery.flot.resize.js', '/Scripts/plugins/flot/jquery.flot.pie.js', '/Scripts/plugins/flot/jquery.flot.categories.js', '/Scripts/plugins/flot/curvedLines.js', '/Scripts/plugins/flot/angular-flot.js']
                        },
                        {
                            name: 'ui.checkbox',
                            files: ['/Scripts/plugins/bootstrap/angular-bootstrap-checkbox.js']
                        },
                        {
                            name: 'chosen',
                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                        },
                        {
                            name: 'angular-daterangepicker',
                            files: ['/Styles/plugins/daterangepicker/daterangepicker-bs3.css', '/Scripts/plugins/daterangepicker/daterangepicker.js', '/Scripts/plugins/daterangepicker/angular-daterangepicker.js']
                        }
                    ]);
                }
            }
        })
        .state('base.manage', {
            abstract: true,
            url: "manage/",
            template: '<div ui-view=""></div>',
            data: { allowRoles: ['SuperAdmin'] },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'slimscroll',
                            files: ['/Scripts/plugins/slimscroll/jquery.slimscroll.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.manage.themes', {
            url: "themes",
            templateUrl: "app/manage/themes/manage.themes.html",
            controller: 'ManageThemesController',
            controllerAs: 'themesCtrl',
            data: { pageTitle: 'Themes and Scripts' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'bootstrap.touchspin',
                            files: ['/Styles/plugins/touchspin/jquery.bootstrap-touchspin.min.css', '/Scripts/plugins/touchspin/jquery.bootstrap-touchspin.min.js']
                        },
                        {
                            name: 'codemirror',
                            serie: true,
                            files: ['/Styles/plugins/codemirror/codemirror.css', '/Scripts/plugins/codemirror/codemirror.js', '/Scripts/plugins/codemirror/mode/javascript/javascript.js']
                        },
                        {
                            name: 'ui.codemirror',
                            files: ['/Scripts/plugins/ui-codemirror/ui-codemirror.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.manage.apps', {
            url: "apps",
            templateUrl: "app/manage/apps/manage.apps.html",
            controller: 'ManageAppsController',
            controllerAs: 'appsCtrl',
            data: { pageTitle: 'External Apps' }
        })
        .state('base.manage.users', {
            url: "users",
            templateUrl: "app/manage/users/manage.users.html",
            controller: 'ManageUsersController',
            controllerAs: 'users',
            data: { pageTitle: 'Departments and Users' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.manage.admins', {
            url: "admins",
            templateUrl: "app/manage/users/manage.admins.html",
            controller: 'ManageAdminsController',
            controllerAs: 'adminsCtrl',
            data: { pageTitle: 'System Admins' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.manage.settings', {
            url: "settings",
            templateUrl: "app/manage/settings/manage.settings.html",
            controller: 'ManageSettingsController',
            controllerAs: 'settingsCtrl',
            data: { pageTitle: 'Institution Settings' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'chosen',
                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                        },
                        {
                            name: 'codemirror',
                            serie: true,
                            files: ['/Styles/plugins/codemirror/codemirror.css', '/Scripts/plugins/codemirror/codemirror.js', '/Scripts/plugins/codemirror/mode/javascript/javascript.js']
                        },
                        {
                            name: 'ui.codemirror',
                            files: ['/Scripts/plugins/ui-codemirror/ui-codemirror.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        },
                        {
                            name: 'bootstrap.touchspin',
                            files: ['/Styles/plugins/touchspin/jquery.bootstrap-touchspin.min.css', '/Scripts/plugins/touchspin/jquery.bootstrap-touchspin.min.js']
                        },
                        {
                            serie: true,
                            files: ['/Scripts/plugins/dataTables/datatables.min.js', '/Styles/plugins/dataTables/datatables.min.css']
                        },
                        {
                            serie: true,
                            name: 'datatables',
                            files: ['/Scripts/plugins/dataTables/angular-datatables.min.js']
                        },
                        {
                            serie: true,
                            name: 'datatables.buttons',
                            files: ['/Scripts/plugins/dataTables/angular-datatables.buttons.min.js']
                        },
                        {
                            name: 'clockpicker',
                            files: ['/Styles/plugins/clockpicker/clockpicker.css', '/Scripts/plugins/clockpicker/clockpicker.js']
                        }
                    ]);
                }
            }
        })
        .state('base.manage.emailtemplates', {
            url: "emailtemplates",
            templateUrl: "app/manage/settings/email.templates.html",
            controller: 'EmailTemplatesController',
            controllerAs: 'templatesCtrl',
            data: { pageTitle: 'Email Templates' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'bootstrap',
                            files: ['/Scripts/plugins/bootstrap/bootstrap.min.js']
                        },
                        {
                            name: 'summernote',
                            files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                        },
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.manage.oauthusers', {
            url: "oauthusers",
            templateUrl: "app/manage/oauthusers/manage.oauth.users.html",
            controller: 'ManageOAuthUsersController',
            controllerAs: 'oauthUsersCtrl',
            data: { pageTitle: 'External OAuth Users' }
        })
        .state('base.manage.timetables', {
            url: "timetables",
            templateUrl: "app/manage/timetables/manage.timetables.html",
            controller: 'ManageTimetablesController',
            controllerAs: 'timetablesCtrl',
            data: { pageTitle: 'Class Timetables' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'chosen',
                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        },
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'jquery-ui',
                            files: ['/Scripts/plugins/ui-sortable/jquery-ui-1.10.4.sortable.min.js']
                        },
                        {
                            name: 'ui.sortable',
                            files: ['/Scripts/plugins/ui-sortable/sortable.js']
                        }
                    ]);
                }
            }
        })
        .state('base.profile', {
            url: "profile",
            templateUrl: "app/profile/profile.html",
            controller: 'ProfileController',
            controllerAs: 'profileCtrl',
            data: { pageTitle: 'My Profile' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        },
                        {
                            name: 'datePicker',
                            files: ['/Styles/plugins/datapicker/angular-datapicker.css', '/Scripts/plugins/datapicker/angular-datepicker.min.js']
                        },
                        {
                            name: 'chosen',
                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.search', {
            url: "search?term",
            templateUrl: "app/search/search.results.html",
            controller: 'SearchController',
            controllerAs: 'searchCtrl',
            data: { pageTitle: 'Search Results' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'dotdotdot',
                            files: ['/Scripts/plugins/dotdotdot/jquery.dotdotdot.min.js']
                        },
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'ui.tree',
                            files: ['/Styles/plugins/uiTree/angular-ui-tree.min.css', '/Scripts/plugins/uiTree/angular-ui-tree.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.courses', {
            url: "courses",
            templateUrl: "app/courses/list/course.list.html",
            controller: 'CourseListController',
            controllerAs: 'courses'
        })
        .state('base.course', {
            abstract: true,
            url: "course/:id",
            template: '<div ui-view=""></div>'
        })
        .state('base.course.index', {
            url: "",
            templateUrl: "app/courses/view/course.html",
            controller: 'CourseController',
            controllerAs: 'courseCtrl',
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.tree',
                            files: ['/Styles/plugins/uiTree/angular-ui-tree.min.css', '/Scripts/plugins/uiTree/angular-ui-tree.min.js']
                        },
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'bootstrap.touchspin',
                            files: ['/Styles/plugins/touchspin/jquery.bootstrap-touchspin.min.css', '/Scripts/plugins/touchspin/jquery.bootstrap-touchspin.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.course.content', {
            url: "/:nodeId?contentId",
            templateUrl: "app/courses/content/course.content.html",
            controller: 'CourseContentController',
            controllerAs: 'contentCtrl',
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            serie: true,
                            name: 'angular-flot',
                            files: ['/Scripts/plugins/flot/jquery.flot.js', '/Scripts/plugins/flot/jquery.flot.time.js', '/Scripts/plugins/flot/jquery.flot.tooltip.min.js', '/Scripts/plugins/flot/jquery.flot.spline.js', '/Scripts/plugins/flot/jquery.flot.resize.js', '/Scripts/plugins/flot/jquery.flot.pie.js', '/Scripts/plugins/flot/jquery.flot.categories.js', '/Scripts/plugins/flot/curvedLines.js', '/Scripts/plugins/flot/angular-flot.js']
                        },
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'bootstrap',
                            files: ['/Scripts/plugins/bootstrap/bootstrap.min.js']
                        },
                        {
                            name: 'summernote',
                            files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                        },
                        {
                            name: 'bootstrap.touchspin',
                            files: ['/Styles/plugins/touchspin/jquery.bootstrap-touchspin.min.css', '/Scripts/plugins/touchspin/jquery.bootstrap-touchspin.min.js']
                        },
                        {
                            name: 'chosen',
                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        },
                        {
                            name: 'datePicker',
                            files: ['/Styles/plugins/datapicker/angular-datapicker.css', '/Scripts/plugins/datapicker/angular-datepicker.min.js']
                        },
                        {
                            name: 'jquery-ui',
                            files: ['/Scripts/plugins/ui-sortable/jquery-ui-1.10.4.sortable.min.js']
                        },
                        {
                            name: 'ui.sortable',
                            files: ['/Scripts/plugins/ui-sortable/sortable.js']
                        },
                        {
                            name: 'videojs-record',
                            files: ['/Scripts/plugins/videojs-record-2.4.1/plugins/thirdparty/video.js/dist/video-js.min.css', '/Scripts/plugins/videojs-record-2.4.1/css/videojs.record.min.css', '/Scripts/plugins/videojs-record-2.4.1/plugins/thirdparty/video.js/dist/video.min.js', '/Scripts/plugins/videojs-record-2.4.1/plugins/thirdparty/recordrtc/RecordRTC.min.js', '/Scripts/plugins/videojs-record-2.4.1/plugins/thirdparty/webrtc-adapter/out/adapter.js', '/Scripts/plugins/videojs-record-2.4.1/videojs.record.min.js']
                        },
                        {
                            name: 'azuremediaplayer',
                            files: ['/Styles/plugins/azuremedia/azuremediaplayer.2.3.8.min.css','/Scripts/plugins/azuremedia/azuremediaplayer.2.3.8.min.js']
                        },
                        {
                            files: ['/Scripts/plugins/pdfjs/pdf.js']
                        },
                        {
                            name: 'pdf',
                            files: ['/Scripts/plugins/pdfjs/angular-pdf.js']
                        }
                    ]);
                }
            }
        })
        .state('base.gradebook', {
            abstract: true,
            url: "gradebook",
            template: '<div ui-view=""></div>'
        })
        .state('base.gradebook.index', {
            url: "",
            templateUrl: "app/gradebook/gradebook.html",
            controller: 'GradebookController',
            controllerAs: 'gradebookCtrl',
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'chosen',
                            files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        },
                        {
                            serie: true,
                            files: ['/Scripts/plugins/dataTables/datatables.min.js', '/Styles/plugins/dataTables/datatables.min.css']
                        },
                        {
                            serie: true,
                            name: 'datatables',
                            files: ['/Scripts/plugins/dataTables/angular-datatables.min.js']
                        },
                        {
                            serie: true,
                            name: 'datatables.buttons',
                            files: ['/Scripts/plugins/dataTables/angular-datatables.buttons.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.feed', {
            url: "feed/:type/:id",
            templateUrl: "app/feed/feed.html",
            controller: 'FeedController',
            controllerAs: 'feedCtrl',
            data: { pageTitle: 'Social Feed' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'bootstrap',
                            files: ['/Scripts/plugins/bootstrap/bootstrap.min.js']
                        },
                        {
                            name: 'summernote',
                            files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                        },
                        {
                            name: 'bootstrap.touchspin',
                            files: ['/Styles/plugins/touchspin/jquery.bootstrap-touchspin.min.css', '/Scripts/plugins/touchspin/jquery.bootstrap-touchspin.min.js']
                        },
                        {
                            serie: true,
                            name: 'angular-flot',
                            files: ['/Scripts/plugins/flot/jquery.flot.js', '/Scripts/plugins/flot/jquery.flot.time.js', '/Scripts/plugins/flot/jquery.flot.tooltip.min.js', '/Scripts/plugins/flot/jquery.flot.spline.js', '/Scripts/plugins/flot/jquery.flot.resize.js', '/Scripts/plugins/flot/jquery.flot.pie.js', '/Scripts/plugins/flot/jquery.flot.categories.js', '/Scripts/plugins/flot/curvedLines.js', '/Scripts/plugins/flot/angular-flot.js']
                        }
                    ]);
                }
            }
        })
        .state('base.mailbox', {
            abstract: true,
            url: "mail/",
            templateUrl: "app/mailbox/mailbox.base.html",
            controller: 'MailboxBaseController',
            controllerAs: 'mailboxCtrl'
        })
        .state('base.mailbox.inbox', {
            url: "inbox?search",
            templateUrl: "app/mailbox/inbox.html",
            controller: 'InboxController',
            controllerAs: 'inboxCtrl',
            data: { pageTitle: 'My Inbox' },
            resolve: {
                inboxType: function () { return "Inbox"; },
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'dotdotdot',
                            files: ['/Scripts/plugins/dotdotdot/jquery.dotdotdot.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.mailbox.sent', {
            url: "sent?search",
            templateUrl: "app/mailbox/inbox.html",
            controller: 'InboxController',
            controllerAs: 'inboxCtrl',
            data: { pageTitle: 'My Sent Messages' },
            resolve: {
                inboxType: function () { return "Sent"; },
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'dotdotdot',
                            files: ['/Scripts/plugins/dotdotdot/jquery.dotdotdot.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.mailbox.drafts', {
            url: "sent?search",
            templateUrl: "app/mailbox/inbox.html",
            controller: 'InboxController',
            controllerAs: 'inboxCtrl',
            data: { pageTitle: 'My Draft Messages' },
            resolve: {
                inboxType: function () { return "Drafts"; },
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'dotdotdot',
                            files: ['/Scripts/plugins/dotdotdot/jquery.dotdotdot.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.mailbox.trash', {
            url: "trash?search",
            templateUrl: "app/mailbox/inbox.html",
            controller: 'InboxController',
            controllerAs: 'inboxCtrl',
            data: { pageTitle: 'My Deleted Messages' },
            resolve: {
                inboxType: function () { return "Trash"; },
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'dotdotdot',
                            files: ['/Scripts/plugins/dotdotdot/jquery.dotdotdot.min.js']
                        }
                    ]);
                }
            }
        })
        .state('base.mailbox.message', {
            url: "message/:type/:id",
            templateUrl: "app/mailbox/message.view.html",
            controller: 'MessageViewController',
            controllerAs: 'messageCtrl',
            data: { pageTitle: 'My Message' }
        })
        .state('base.mailbox.compose', {
            url: "compose?id&replyto&replyall&forward&type",
            templateUrl: "app/mailbox/message.compose.html",
            controller: 'MessageComposeController',
            controllerAs: 'composeCtrl',
            data: { pageTitle: 'New Message' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'bootstrap',
                            files: ['/Scripts/plugins/bootstrap/bootstrap.min.js']
                        },
                        {
                            name: 'summernote',
                            files: ['/Styles/plugins/summernote/summernote.min.css', '/Styles/plugins/summernote/summernote-bs3.min.css', '/Scripts/plugins/summernote/summernote.min.js', '/Scripts/plugins/summernote/angular-summernote.min.js']
                        },
                        {
                            name: 'jasny',
                            files: ['/Scripts/plugins/jasny/jasny-bootstrap.min.js', '/Styles/plugins/jasny/jasny-bootstrap.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.timetables', {
            abstract: true,
            url: "timetables",
            template: '<div ui-view=""></div>'
        })
        .state('base.timetables.index', {
            url: "",
            templateUrl: "app/timetables/timetables.html",
            controller: 'TimetablesController',
            controllerAs: 'mytimetablesCtrl',
            data: { pageTitle: 'My Timetables' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.attendance', {
            abstract: true,
            url: "attendance",
            template: '<div ui-view=""></div>'
        })
        .state('base.attendance.index', {
            url: "",
            templateUrl: "app/attendance/attendance.html",
            controller: 'AttendanceController',
            controllerAs: 'attendanceCtrl',
            data: { pageTitle: 'Student Attendance' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        }
                    ]);
                }
            }
        })
        .state('base.planner', {
            abstract: true,
            url: "planner",
            template: '<div ui-view=""></div>'
        })
        .state('base.planner.index', {
            url: "",
            templateUrl: "app/planner/planner.html",
            controller: 'PlannerController',
            controllerAs: 'plannerCtrl',
            data: { pageTitle: 'My Planner' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        {
                            insertBefore: '#loadBefore',
                            files: ['/Styles/plugins/fullcalendar/fullcalendar.css', '/Scripts/plugins/fullcalendar/fullcalendar.min.js']
                        },
                        {
                            name: 'ui.calendar',
                            files: ['/Scripts/plugins/fullcalendar/calendar.js', '/Scripts/plugins/fullcalendar/gcal.js']
                        },
                        {
                            name: 'jquery-ui',
                            files: ['/Scripts/plugins/ui-sortable/jquery-ui-1.10.4.sortable.min.js']
                        },
                        {
                            name: 'ui.sortable',
                            files: ['/Scripts/plugins/ui-sortable/sortable.js']
                        }
                    ]);
                }
            }
        })
        .state('base.chatroom', {
            url: "chatroom/:id",
            templateUrl: "app/chatroom/chatroom.html",
            controller: 'ChatroomController',
            controllerAs: 'chatroomCtrl',
            data: { pageTitle: 'Chatroom' },
            resolve: {
                loadPlugin: function ($ocLazyLoad) {
                    /*$ocLazyLoad.load([
                        {
                            name: 'opentok',
                            files: ['/Scripts/plugins/opentok-angular/opentok.min.js']
                        },
                        {
                            name: 'opentok-layout-js',
                            files: ['/Scripts/plugins/opentok-layout-js/opentok-layout.min.js']
                        },
                        {
                            name: 'opentok-angular',
                            files: ['/Scripts/plugins/opentok-angular/opentok-angular.min.js']
                        }
                    ]);*/
                    return $ocLazyLoad.load([
                        {
                            name: 'ui.select',
                            files: ['/Scripts/plugins/ui-select/select.min.js', '/Styles/plugins/ui-select/select.min.css']
                        },
                        {
                            name: 'paper',
                            files: ['/Scripts/plugins/paper/dist/paper-core.min.js']
                        },
                        {
                            name: 'angular-bootstrap-colorpicker',
                            files: ['/Scripts/plugins/angular-bootstrap-colorpicker/css/colorpicker.min.css', '/Scripts/plugins/angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.min.js']
                        }
                    ]);
                }
            }
        });

        $urlRouterProvider.otherwise('/signin');
    }

})();

'use strict';

angular.module('lms')
    .filter('courseStatus', function () {
        return function (input) {
            if (input == 1)
                return "New";
            else if (input == 2)
                return "Published";
            else if (input == 3)
                return "Archived";
            return "";
        };
    })
    .filter('momentDate', function () {
        return function (input) {
            if (input)
                return moment(moment.utc(input).toDate()).format("DD/MM/YYYY");
            else
                return "";
        };
    })
    .filter('momentLongDate', function () {
        return function (input) {
            if (input)
                return moment(moment.utc(input).toDate()).format("Do MMM YYYY");
            else
                return "";
        };
    })
    .filter('momentDateText', function () {
        return function (input) {
            if (input) {
                var utcDate = moment.utc(input);
                var today = moment.utc().startOf('day');
                var yesterday = moment.utc().subtract(1, 'days').startOf('day');
                var tomorrow = moment.utc().add(1, 'days').startOf('day');
                var thisYear = moment.utc().startOf('year');
                if (utcDate.isSame(today, 'day'))
                    return moment(utcDate.toDate()).format("[Today]");
                else if (utcDate.isSame(yesterday, 'day'))
                    return moment(utcDate.toDate()).format("[Yesterday]");
                else if (utcDate.isSame(tomorrow, 'day'))
                    return moment(utcDate.toDate()).format("[Tomorrow]");
                else if (utcDate.isSame(thisYear, 'year'))
                    return moment(utcDate.toDate()).format("Do MMM");
                else
                    return moment(moment.utc(input).toDate()).format("DD/MM/YYYY");
            } else
                return "";
        };
    })
    .filter('momentDateTime', function () {
        return function (input) {
            if (input) {
                var utcDate = moment.utc(input);
                var today = moment.utc().startOf('day');
                var yesterday = moment.utc().subtract(1, 'days').startOf('day');
                var thisYear = moment.utc().startOf('year');
                if (utcDate.isSame(today, 'day'))
                    return moment(utcDate.toDate()).format("[Today] H:mm");
                else if (utcDate.isSame(yesterday, 'day'))
                    return moment(utcDate.toDate()).format("[Yesterday] H:mm");
                else if (utcDate.isSame(thisYear, 'year'))
                    return moment(utcDate.toDate()).format("Do MMM H:mm");
                else
                    return moment(utcDate.toDate()).format("DD/MM/YYYY H:mm");
            } else
                return "";
        };
    })
    .filter('momentDateFrom', function () {
        return function (input) {
            if (input)
                return moment(moment.utc(input).toDate()).fromNow();
            else
                return "";
        };
    })
    .filter('momentDayOfWeek', function () {
        return function (input) {
            if (input)
                return moment(moment.utc(input).toDate()).format("dddd");
            else
                return "";
        };
    })
    .filter('nodeName', function () {
        return function (node) {
            if (node)
                return node.nodeType + (node.nodeType != "" ? " " : "") +
                    node.number + (node.title != "" && (node.nodeType != "" || node.number > 0) ? ": " : "") + node.title;
            else
                return "";
        };
    })
    .filter('lang', function (LanguageResource) {
        return function (text) {
            if (LanguageResource[text])
                return LanguageResource[text];
            else
                return text;
        };
    });
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('lms')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function () {
                    $timeout(function () {
                        element.metisMenu();
                    });
                });

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })

    /**
     * icheck - Directive for custom checkbox icheck
     */
    .directive('icheck', function ($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var $element = angular.element(element);
                    var value;
                    value = $attrs['value'];

                    $scope.$watch($attrs['ngModel'], function (newValue) {
                        $element.iCheck('update');
                    })

                    return $element.iCheck({
                        checkboxClass: 'icheckbox_square-green',
                        radioClass: 'iradio_square-green'

                    }).on('ifChanged', function (event) {
                        if ($element.attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function () {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($element.attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function () {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
                });
            }
        };
    })

    /*
    * adding functionality to a button to pop up the new course modal
    */
    .directive('newCourse', function ($uibModal) {
        return {
            link: function (scope, element) {
                var onClick = function () {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/courses/new/newcourse.modal.html',
                        controller: 'NewCourseModalController',
                        controllerAs: 'newcourse',
                        resolve: {
                            loadPlugin: function ($ocLazyLoad) {
                                return $ocLazyLoad.load([
                                    {
                                        name: 'chosen',
                                        files: ['/Styles/plugins/chosen/chosen.css', '/Scripts/plugins/chosen/chosen.min.js', '/Scripts/plugins/chosen/chosen.jquery.min.js']
                                    }
                                ]);
                            }
                        }
                    });
                };
                angular.element(element).on("click", onClick);
            }
        };
    })

    /**
     * fullScroll - Directive for slimScroll with 100%
     */
    .directive('fullScroll', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                $timeout(function () {
                    element.slimscroll({
                        height: '100%',
                        railOpacity: 0.9
                    });

                });
            }
        };
    })

    /**
     * slimScroll - Directive for slimScroll with custom height
     */
    .directive('slimScroll', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                boxHeight: '@'
            },
            link: function (scope, element) {
                $timeout(function () {
                    element.slimscroll({
                        height: scope.boxHeight,
                        railOpacity: 0.9
                    });

                });
            }
        };
    })

    /**
    * chatSlimScroll - Directive for slim scroll for small chat
    */
    .directive('chatSlimScroll', function ($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function(){
                    element.slimscroll({
                        height: '234px',
                        railOpacity: 0.4
                    });

                });
            }
        };
    })

    /**
     * touchSpin - Directive for Bootstrap TouchSpin
     */
    .directive('touchSpin', function () {
        return {
            restrict: 'A',
            scope: {
                spinOptions: '='
            },
            link: function (scope, element, attrs) {
                scope.$watch(scope.spinOptions, function () {
                    render();
                });
                var render = function () {
                    angular.element(element).TouchSpin(scope.spinOptions);
                };
            }
        }
    })

    .directive("fileModel", function () {
        return {
            restrict: 'A',
            scope: {
                setFileData: "&"
            },
            link: function (scope, ele, attrs) {
                ele.on('change', function () {
                    scope.$apply(function () {
                        var val;
                        if (ele[0].files.length > 1)
                            val = ele[0].files;
                        else
                            val = ele[0].files[0];
                        scope.setFileData({ value: val });
                    });
                });
            }
        }
    })

    .directive("fileRequired", function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, ele, attrs, ngModel) {
                ngModel.$validators.file = function (modelValue, viewValue) {
                    return modelValue != undefined && modelValue != null;
                };
            }
        }
    })

    .directive("arraySizeMin", function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, ele, attrs, ngModel) {
                ngModel.$validators.array = function (modelValue, viewValue) {
                    return modelValue != undefined && modelValue != null && modelValue instanceof Array && modelValue.length >= attrs.arraySizeMin;
                };
            }
        }
    })

    .directive("matchWith", function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: { matchWith: "=" },
            link: function (scope, ele, attrs, ngModel) {
                ngModel.$validators.matching = function (modelValue, viewValue) {
                    return modelValue != undefined && modelValue == scope.matchWith;
                };
            }
        }
    })

    .directive("embedScript", function () {
        var updateScript = function (element) {
            return function (src) {
                element.empty();
                var scriptTag = angular.element('<script/>')
                     .attr('src', src).attr('type', "text/javascript");
                element.append(scriptTag);
            };
        };

        return {
            restrict: "EA",
            scope: {
                src: "="
            },
            link: function (scope, element) {
                scope.$watch("src", updateScript(element));
            }
        }
    })

    .directive("onBsFileInputChange", function () {
        return {
            restrict: 'EA',
            scope: {
                onBsFileInputChange: "&"
            },
            link: function (scope, ele, attrs) {
                ele.on('change.bs.fileinput', function (e) {
                    scope.$apply(function () {
                        scope.onBsFileInputChange({ $event: e });
                    });
                });
            }
        }
    })

    .directive('imgPlaceholder', function () {
        return {
            link: function (scope,element,attrs) {
                var typeMap = {
                    user: "/Images/thumbnail-user.png"
                };
            element.bind('error', function () {
                  if (!element.attr("placeholder-applied")) {
                    if (typeMap[attrs.imgPlaceholder]) {
                      if (!element.attr("placeholder-applied"))
                        element.attr("placeholder-applied", "true");
                      element.attr("src", typeMap[attrs.imgPlaceholder])
                    }
                    else {
                      element.attr("placeholder-applied", "true")
                      element.attr("src", "/Images/thumbnail-default.png")
                    }
                  }
                });
            }
        };
    })

    .directive('bindMathjax', function ($sce) {
        return {
            link: function ($scope, $element, $attrs) {
                $scope.$watch($attrs.bindMathjax, function (value) {
                    if (value) {
                        $element.html(value);
                        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
                    }
                });
            }
        };
    })

    .directive('fullScreen', function ($window) {
        return {
            link: function ($scope, $element, $attrs) {
                $window.addEventListener('message', function (event) {
                    // handle messages received from iframe
                    if (typeof (event.data) !== 'undefined') {
                        var message = angular.fromJson(event.data);
                        if (message.callback == "fullscreen") $element.attr("class", 'full-screen');
                        else if (message.callback == "restorescreen") $element.attr("class", 'pdf-screen');
                    }
                });
            }
        };
    })

    .directive('adaptiveHeight', function ($window) {
        return {
            link: function ($scope, $element, $attrs) {
                $window.addEventListener('message', function (event) {
                    // handle messages received from iframe
                    if (typeof (event.data) !== 'undefined') {
                        var message = angular.fromJson(event.data);
                        if (message.callback == "changeHeight") $element.height(message.data.height);
                    }
                });
            }
        };
    })

    .directive('onEnter', function () {
        return {
            scope: {
                onEnter: "&"
            },
            link: function ($scope, $element) {
                var handler = function (e) {
                    if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
                        $scope.onEnter({});
                        return false;
                    } else
                        return true;
                };
                if ($element.context.nodeName == 'INPUT' || $element.context.nodeName == 'TEXTAREA') {
                    $element.on('keypress', handler);
                    $scope.$on('$destroy', function () {
                        $element.off('keypress', handler);
                    });
                } else {
                    $element.find('input').on('keypress', handler);
                    $scope.$on('$destroy', function () {
                        $element.find('input').off('keypress', handler);
                    });
                }
            }
        };
    })

    .directive('videoData', function () {
        return {
            restrict: 'A',
            scope: {
                videoData: '='
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch($scope.videoData, function () {
                    if ($scope.videoData.videoUrl) {
                        $element.show();
                        //$element.find("source").attr("src", $scope.videoData.videoUrl);
                        var options = {
                          techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
                          "nativeControlsForTouch": false,
                          autoplay: false,
                          controls: true,
                          width: "640",
                          height: "400",
                          poster: "",
                          "fluid": true
                        };
                        amp.options.flashSS.swf = "http://amp.azure.net/libs/amp/latest/techs/StrobeMediaPlayback.2.0.swf"
                        amp.options.silverlightSS.xap = "http://amp.azure.net/libs/amp/latest/techs/SmoothStreamingPlayer.xap"
                        $scope.player = amp($element.context, options, function () { });
                        $scope.player.src([{
                          src: $scope.videoData.videoUrl,
                          type: "application/vnd.ms-sstr+xml"
                        }]);
                    } else $element.hide();
                });
            }
        };
    })

    .directive('videoSrc', function () {
        return {
            restrict: 'A',
            scope: {
                videoSrc: '='
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch($scope.videoSrc, function () {
                    if ($scope.videoSrc) {
                        $element.show();
                        $element.find("source").attr("src", $scope.videoSrc);
                    } else $element.hide();
                });
            }
        };
    })

    .directive('audioData', function () {
        return {
            restrict: 'A',
            scope: {
                audioData: '='
            },
            link: function ($scope, $element, $attrs) {
                $scope.$watch($scope.audioData, function () {
                    if ($scope.audioData.audioUrl) {
                        $element.show();
                        $element.find("source").attr("src", $scope.audioData.audioUrl);
                    } else $element.hide();
                });
            }
        };
    })

    /**
     * truncate - Directive for truncate string
     */
    .directive('truncate', function($timeout) {
        return {
            restrict: 'A',
            scope: {
                truncateOptions: '='
            },
            link: function (scope, element) {
                $timeout(function () {
                    element.dotdotdot(scope.truncateOptions);
                });
            }
        };
    })

    /**
     * contentIcon - Directive for setting the content icon based on type
     */
    .directive('contentIcon', function () {
        var contentIcons = {
            Assessment: "question",
            Assignment: "check-square-o",
            AudioFile: "microphone",
            ExternalUrl: "link",
            LtiApp: "key",
            Javascript: "code",
            Pdf: "book",
            RichTextFormat: "file-text-o",
            VideoFile: "film"
        };
        return {
            restrict: 'A',
            scope: {
                contentIcon: '='
            },
            link: function (scope, element) {
                scope.$watch(scope.contentIcon, function () {
                    element.attr("class", "").addClass("fa fa-" + contentIcons[scope.contentIcon]);
                });
            }
        };
    })

    /**
     * clockPicker - Directive for clock picker plugin
     */
    .directive('clockPicker', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.clockpicker();
            }
        };
    })

    /**
     * onDelayedHover - execute onhover after a delay of n milliseconds
     */
    .directive('onDelayedHover', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                onDelayedHover: '&'
            },
            link: function (scope, element, attrs) {
                var timeout;
                var delay = attrs.hoverDelay || 1000;
                angular.element(element).on("mouseover", function () {
                    if (!timeout) {
                        timeout = $timeout(function () {
                            $timeout.cancel(timeout);
                            timeout = null;
                            scope.onDelayedHover({});
                        }, delay);
                    }
                });
                angular.element(element).on("mouseleave", function () {
                    $timeout.cancel(timeout);
                    timeout = null;
                });
            }
        };
    })

    /**
     * noPropagation - Directive for stopping propagation of event on click
     */
    .directive('noPropagation', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                });
            }
        };
    })

    .directive('lang', function (LanguageResource) {
        return {
            link: function (scope, element) {
                var text = angular.element(element).text();
                if (LanguageResource && LanguageResource[text])
                    angular.element(element).text(LanguageResource[text]);
            }
        };
    });

angular.module("lms").run(["$templateCache", function($templateCache) {$templateCache.put("app/attendance/attendance.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Student Attendance</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>Student Attendance</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"clients-list\"><div class=\"row\"><div class=\"col-md-6\"><ui-select id=\"courseId\" name=\"courseId\" ng-model=\"attendanceCtrl.departmentId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"attendanceCtrl.departmentIdChanged()\"><ui-select-match placeholder=\"Select a department\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"dept.departmentId as dept in attendanceCtrl.departments | filter: $select.search\"><div ng-bind-html=\"dept.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-6\"><ui-select id=\"courseId\" name=\"courseId\" ng-model=\"attendanceCtrl.groupId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"attendanceCtrl.groupIdChanged()\"><ui-select-match placeholder=\"Select a class or batch\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"group.departmentGroupId as group in attendanceCtrl.groups | filter: $select.search\"><div ng-bind-html=\"group.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div ng-if=\"!attendanceCtrl.loading && attendanceCtrl.students && attendanceCtrl.students.length\" class=\"text-right m-t-sm\"><button buttonspinner=\"\" ng-disabled=\"attendanceCtrl.saving\" type=\"button\" class=\"buttonspinner-button btn btn-primary\" data-style=\"expand-left\" ng-click=\"attendanceCtrl.save()\"><i class=\"fa fa-check\"></i> Save Attendance</button></div><div class=\"row m-t-sm\" ng-if=\"attendanceCtrl.dayTimeRows\"><div class=\"col-sm-8\"><strong>{{attendanceCtrl.displayDate | momentDateText}} ({{attendanceCtrl.displayDate | momentDayOfWeek}})</strong></div><div class=\"col-sm-4 text-right\"><div class=\"btn-group\"><button class=\"btn btn-default\" ng-click=\"attendanceCtrl.previousDay()\" title=\"Previous Day\"><i class=\"fa fa-chevron-left\"></i></button> <button class=\"btn btn-default\" ng-click=\"attendanceCtrl.setToday()\" title=\"Today\">Today</button> <button class=\"btn btn-default\" ng-click=\"attendanceCtrl.nextDay()\" title=\"Next Day\"><i class=\"fa fa-chevron-right\"></i></button></div></div></div><div ng-if=\"!attendanceCtrl.loading && attendanceCtrl.students && attendanceCtrl.students.length\"><table class=\"table table-striped table-bordered table-hover m-t-sm\"><thead><tr><th>Student</th><th>Overall<br>{{attendanceCtrl.displayDate | momentDateText}}<div class=\"m-t-xs\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-default btn-xs\" uib-dropdown-toggle=\"\">Bulk Actions <span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\" ng-click=\"attendanceCtrl.setBulkForTime(3)\">All Present</a></li><li><a href=\"\" ng-click=\"attendanceCtrl.setBulkForTime(1)\">All Absent</a></li></ul></div></div></th><th ng-repeat=\"timeRow in attendanceCtrl.dayTimeRows[attendanceCtrl.displayDateIndex]\"><div>{{timeRow.timeDisplay}}</div><div class=\"label label-primary\">{{timeRow.courseName}} <span ng-if=\"courseObj.node\">&nbsp;&gt;&nbsp;{{timeRow.node | nodeName}}</span></div><div class=\"m-t-xs\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-default btn-xs\" uib-dropdown-toggle=\"\">Bulk Actions <span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\" ng-click=\"attendanceCtrl.setBulkForTime(3, timeRow)\">All Present</a></li><li><a href=\"\" ng-click=\"attendanceCtrl.setBulkForTime(1, timeRow)\">All Absent</a></li></ul></div></div></th></tr></thead><tbody><tr ng-repeat=\"student in attendanceCtrl.students\"><td><img alt=\"{{student.firstName}} {{student.lastName}}\" ng-src=\"{{student.profilePicUrl}}\"> {{student.firstName}} {{student.lastName}}<div class=\"m-t-xs\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-default btn-xs\" uib-dropdown-toggle=\"\">Bulk Actions <span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\" ng-click=\"attendanceCtrl.setBulkForStudent(3, student)\">All Present</a></li><li><a href=\"\" ng-click=\"attendanceCtrl.setBulkForStudent(1, student)\">All Absent</a></li></ul></div></div></td><td><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-{{attendanceCtrl.statusDict[student.result.status].css}} btn-sm\" uib-dropdown-toggle=\"\">{{attendanceCtrl.statusDict[student.result.status].text}}&nbsp;<span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"status in attendanceCtrl.statusList\"><a href=\"\" ng-click=\"student.result.status=status.value\">{{status.text}}&nbsp;</a></li></ul></div><div class=\"m-t-xs\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-xs\" ng-class=\"{\'btn-info\':student.result.comments,\'btn-default\':!student.result.comments}\" uib-dropdown-toggle=\"\"><span ng-if=\"!student.result.comments\">+ Add comments</span><span ng-if=\"student.result.comments\" ng-bind-html=\"trustHtml(student.result.comments)\"></span>&nbsp;<span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><textarea ng-model=\"student.result.comments\" placeholder=\"Comments...\" no-propagation=\"\"></textarea></li></ul></div></div></td><td ng-repeat=\"item in student.row\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-{{attendanceCtrl.statusDict[item.result.status].css}} btn-sm\" uib-dropdown-toggle=\"\">{{attendanceCtrl.statusDict[item.result.status].text}}&nbsp;<span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"status in attendanceCtrl.statusList\"><a href=\"\" ng-click=\"item.result.status=status.value\">{{status.text}}&nbsp;</a></li></ul></div><div class=\"m-t-xs\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-xs\" ng-class=\"{\'btn-info\':item.result.comments,\'btn-default\':!item.result.comments}\" uib-dropdown-toggle=\"\"><span ng-if=\"!item.result.comments\">+ Add comments</span><span ng-if=\"item.result.comments\" ng-bind-html=\"trustHtml(item.result.comments)\"></span>&nbsp;<span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><textarea ng-model=\"item.result.comments\" placeholder=\"Comments...\" no-propagation=\"\"></textarea></li></ul></div></div></td></tr></tbody></table></div><div ng-if=\"!attendanceCtrl.loading && attendanceCtrl.students && attendanceCtrl.students.length\" class=\"text-right m-t-sm\"><button buttonspinner=\"\" ng-disabled=\"attendanceCtrl.saving\" type=\"button\" class=\"buttonspinner-button btn btn-primary\" data-style=\"expand-left\" ng-click=\"attendanceCtrl.save()\"><i class=\"fa fa-check\"></i> Save Attendance</button></div><div ng-if=\"attendanceCtrl.loading\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/auth/forgot.password.html","<toaster-container></toaster-container><div class=\"loginColumns animated fadeInDown\"><div class=\"row\"><div class=\"col-md-6\"><img alt=\"Logo\" class=\"img-nav-logo\" src=\"/Images/campus.jpg\"></div><div class=\"col-md-6\"><div class=\"ibox-content\"><form name=\"ForgotPwd\" class=\"m-t\" role=\"form\" novalidate=\"\"><div class=\"form-group\"><input id=\"email\" name=\"email\" type=\"email\" class=\"form-control\" placeholder=\"Email ID\" required=\"\" ng-model=\"forgotpwd.email\"><div validation-result=\"\" myform=\"ForgotPwd\" element=\"email\" required-text=\"Please specify an email id\"></div></div><button buttonspinner=\"\" ng-disabled=\"forgotpwd.sending\" type=\"submit\" ng-click=\"forgotpwd.send(ForgotPwd)\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary block full-width m-b\">Submit</button></form></div></div></div></div>");
$templateCache.put("app/auth/reset.password.html","<toaster-container></toaster-container><div class=\"loginColumns animated fadeInDown\"><div class=\"row\"><div class=\"col-md-6\"><img alt=\"Logo\" class=\"img-nav-logo\" src=\"/Images/campus.jpg\"></div><div class=\"col-md-6\"><div class=\"ibox-content\"><form name=\"ResetPwd\" class=\"m-t\" role=\"form\" novalidate=\"\"><div class=\"form-group\"><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\" ng-model=\"resetpwd.password\"><div validation-result=\"\" myform=\"ResetPwd\" element=\"password\" required-text=\"Please provide a password\"></div></div><div class=\"form-group\"><input id=\"confirmpassword\" name=\"confirmpassword\" type=\"password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\" match-with=\"resetpwd.password\" ng-model=\"resetpwd.confirmpassword\"><div validation-result=\"\" myform=\"ResetPwd\" element=\"confirmpassword\" required-text=\"Please provide a password confirmation\"></div><div validation-result=\"\" myform=\"ResetPwd\" element=\"confirmpassword\" matching-text=\"The confirmation does not match the password\"></div></div><button buttonspinner=\"\" ng-disabled=\"resetpwd.sending\" type=\"submit\" ng-click=\"resetpwd.send(ResetPwd)\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary block full-width m-b\">Reset</button></form></div></div></div></div>");
$templateCache.put("app/auth/signin.html","<toaster-container></toaster-container><div class=\"login-outer\"><div class=\"loginColumns animated fadeInDown\"><div class=\"row\"><div class=\"col-md-6\"><img alt=\"Logo\" class=\"img-nav-logo\" src=\"/Images/campus.jpg\"></div><div class=\"col-md-6\"><div class=\"ibox-content\"><form name=\"SignIn\" class=\"m-t\" role=\"form\" novalidate=\"\"><div class=\"form-group\"><input id=\"email\" name=\"email\" type=\"email\" class=\"form-control\" placeholder=\"Email ID\" required=\"\" ng-model=\"signin.email\"><div validation-result=\"\" myform=\"SignIn\" element=\"email\" required-text=\"Please specify an email id\"></div></div><div class=\"form-group\"><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\" ng-model=\"signin.password\"><div validation-result=\"\" myform=\"SignIn\" element=\"password\" required-text=\"Please provide a password\"></div></div><label><input icheck=\"\" type=\"checkbox\" ng-model=\"signin.rememberMe\"> Keep me always signed in</label> <button buttonspinner=\"\" ng-disabled=\"signin.isSigningIn\" type=\"submit\" ng-click=\"signin.signIn(SignIn)\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary block full-width m-b\">Sign In</button> <a ui-sref=\"forgotpassword\"><small>Forgot password?</small></a></form></div></div></div></div></div>");
$templateCache.put("app/auth/signin.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-key modal-icon\"></i><h4 class=\"modal-title\">Session Expired</h4><small class=\"font-bold\">It seems like your session may have expired. Please sign in again below:</small></div><div class=\"modal-body\"><div class=\"row\"><form name=\"signInForm\" role=\"form\" novalidate=\"\"><div class=\"form-group\"><label>Email</label> <input id=\"email\" name=\"email\" type=\"email\" class=\"form-control\" placeholder=\"Email ID\" required=\"\" ng-model=\"signinModal.email\"><div validation-result=\"\" myform=\"signInForm\" element=\"email\" required-text=\"Please specify an email id\"></div></div><div class=\"form-group\"><label>Password</label> <input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\" ng-model=\"signinModal.password\"><div validation-result=\"\" myform=\"signInForm\" element=\"password\" required-text=\"Please provide a password\"></div></div><div><label for=\"rememberMe\"><input icheck=\"\" name=\"rememberMe\" type=\"checkbox\" ng-model=\"signinModal.rememberMe\"> Keep me always signed in</label> <button buttonspinner=\"\" ng-disabled=\"signinModal.isSigningIn\" class=\"buttonspinner-button btn btn-sm btn-primary pull-right m-t-n-xs\" type=\"submit\" ng-click=\"signinModal.signIn(signInForm)\" data-style=\"expand-left\"><strong>Sign in</strong></button></div></form></div></div></div>");
$templateCache.put("app/auth/signout.html","<div class=\"loginColumns animated fadeInDown\"><div class=\"row\"><div class=\"col-md-offset-3 col-md-6\"><div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-sign-out modal-icon\"></i><h4 class=\"modal-title\">Signing out...</h4></div><div class=\"modal-body clearfix\"><div spinner-circle=\"\" class=\"pull-left m-r-xs\"></div>Please wait while you are signed out...</div></div></div></div></div>");
$templateCache.put("app/chatroom/chatroom.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Chat view</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>Chat view</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\" ng-if=\"!chatroomCtrl.id\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"newChatroom\" novalidate=\"\"><div class=\"form-group\"><label><strong>Add people to your chatroom</strong></label><ui-select id=\"people\" name=\"people\" multiple=\"\" ng-model=\"chatroomCtrl.chatroom.members\" theme=\"bootstrap\" title=\"People\" array-size-min=\"1\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"chatroomCtrl.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in chatroomCtrl.people | filter: $select.search\"><img img-placeholder=\"user\" alt=\"{{person.name}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{person.profilePicUrl}}\"> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div validation-result=\"\" myform=\"newChatroom\" element=\"people\" array-text=\"Please add at least one person\"></div></div><div class=\"form-group\" ng-show=\"chatroomCtrl.chatroom.members.length > 0\"><label><strong>Name your chatroom</strong></label> <input id=\"name\" name=\"name\" type=\"text\" class=\"form-control\" placeholder=\"Enter a name...\" ng-model=\"chatroomCtrl.chatroom.name\" required=\"\"><div validation-result=\"\" myform=\"newChatroom\" element=\"name\" required-text=\"Please specify a name\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"chatroomCtrl.create(newChatroom)\" ng-show=\"chatroomCtrl.chatroom.members.length > 0\">Start chatting!</button></form></div></div></div></div><div class=\"row\" ng-if=\"chatroomCtrl.id\"><div class=\"col-lg-12\"><div class=\"ibox chat-view\"><div class=\"ibox-title\"><h5>{{chatroomCtrl.chatroom.name}}</h5><div ibox-tools=\"\" disableclose=\"true\"><button ng-click=\"chatroomCtrl.showWhiteboard=true\" title=\"Show Whiteboard\" ng-hide=\"chatroomCtrl.showWhiteboard\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-desktop\"></i> Whiteboard</button> <button ng-click=\"chatroomCtrl.showWhiteboard=false\" title=\"Hide Whiteboard\" ng-show=\"chatroomCtrl.showWhiteboard\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-desktop\"></i> Hide Whiteboard</button></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-8\" ng-show=\"chatroomCtrl.showWhiteboard\"><ot-whiteboard width=\"580\" height=\"480\" on-draw=\"chatroomCtrl.submitDrawing(drawing)\"></ot-whiteboard></div><div ng-class=\"{\'col-md-9\':!chatroomCtrl.showWhiteboard,\'col-md-4\':chatroomCtrl.showWhiteboard}\"><div class=\"chat-discussion\"><div class=\"chat-message\" ng-class=\"{\'left\': message.userId != chatroomCtrl.me, \'right\': message.userId == chatroomCtrl.me}\" ng-repeat=\"message in chatroomCtrl.chatroom.messages\"><img class=\"message-avatar\" ng-if=\"message.userId == chatroomCtrl.me\" ng-src=\"{{chatroomCtrl.myPic}}\" alt=\"Me\"> <img class=\"message-avatar\" ng-if=\"message.userId != chatroomCtrl.me\" ng-src=\"{{chatroomCtrl.memberDict[message.userId].profilePicUrl}}\" alt=\"{{chatroomCtrl.memberDict[message.userId].name}}\"><div class=\"message\"><a class=\"message-author\" href=\"#\" ng-if=\"message.userId == chatroomCtrl.me\">Me</a> <a class=\"message-author\" href=\"#\" ng-if=\"message.userId != chatroomCtrl.me\">{{chatroomCtrl.memberDict[message.userId].name}}</a> <span class=\"message-date\">{{message.dateSent | momentDateTime}}</span> <span class=\"message-content\" ng-bind-html=\"trustHtml(message.message)\"></span></div></div></div><div class=\"chat-message-form\"><form name=\"sendMessage\"><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-white btn-sm\" ng-click=\"chatroomCtrl.submitMessage(sendMessage)\" ng-disabled=\"chatroomCtrl.sending\"><i class=\"fa fa-check\"></i> Send</button> <textarea class=\"form-control message-input\" id=\"message\" name=\"message\" placeholder=\"Enter message text\" ng-model=\"chatroomCtrl.newMessage\" ng-disabled=\"chatroomCtrl.sending\" required=\"\"></textarea></div></form></div></div><div class=\"col-md-3\" ng-hide=\"chatroomCtrl.showWhiteboard\"><div class=\"chat-users\"><div class=\"users-list\"><div class=\"chat-user\" ng-repeat=\"user in chatroomCtrl.chatroom.members\"><span class=\"pull-right label label-primary\" ng-if=\"user.isOnline\">Online</span> <img class=\"chat-avatar\" ng-src=\"{{user.profilePicUrl}}\" alt=\"{{user.name}}\"><div class=\"chat-user-name\"><a href=\"#\">{{user.name}}</a></div></div></div></div><div class=\"chat-members-form border-top\" ng-if=\"chatroomCtrl.chatroom.ownerId && chatroomCtrl.chatroom.ownerId==chatroomCtrl.me\"><form name=\"addMembers\"><ui-select id=\"newMembers\" name=\"newMembers\" multiple=\"\" ng-model=\"chatroomCtrl.newMembers\" theme=\"bootstrap\" title=\"Add others to this chat...\" ng-disabled=\"chatroomCtrl.addingMembers\" class=\"no-borders\" array-size-min=\"1\"><ui-select-match placeholder=\"Type to add more people...\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"chatroomCtrl.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in chatroomCtrl.people | filter: $select.search\"><img img-placeholder=\"user\" alt=\"{{person.name}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{person.profilePicUrl}}\"> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div class=\"text-right p-w-xs\"><button type=\"submit\" class=\"btn btn-white btn-sm\" ng-click=\"chatroomCtrl.addMembers(addMembers)\" ng-disabled=\"chatroomCtrl.addingMembers\"><i class=\"fa fa-plus\"></i> Add</button></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/feed/create.feed.post.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-share-alt modal-icon\"></i><h4 class=\"modal-title\">Share to Feed</h4><small class=\"font-bold\">Edit the content below to share on the feed</small></div><form name=\"editCourse\" novalidate=\"\"><div class=\"modal-body\"><div summernote=\"\" class=\"summernote\" config=\"createFeedPostCtrl.summernoteOptions\" ng-model=\"createFeedPostCtrl.newPost.text\" on-image-upload=\"createFeedPostCtrl.imageUpload(files)\" editor=\"createFeedPostCtrl.editor\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"createFeedPostCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"createFeedPostCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"createFeedPostCtrl.ok()\" data-style=\"expand-left\">Save</button></div></form></div>");
$templateCache.put("app/feed/feed.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Social feed</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Social feed</li><li class=\"active\"><strong>{{feedCtrl.name}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"social-feed-box\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"social-body clearfix\"><div summernote=\"\" class=\"summernote\" config=\"feedCtrl.summernoteOptions\" ng-model=\"feedCtrl.newPost.text\" on-image-upload=\"feedCtrl.imageUpload(files)\" editor=\"feedCtrl.editor\"></div><ul class=\"todo-list m-t small-list\" ng-if=\"feedCtrl.newPost.postMessageType==\'Poll\'\"><li ng-repeat=\"choice in feedCtrl.newPost.poll.pollChoices\"><input type=\"text\" class=\"form-control\" placeholder=\"Poll choice...\" ng-model=\"choice.choiceContent\"></li><li><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Poll choice...\" ng-model=\"feedCtrl.newPollChoiceMessage\" on-enter=\"feedCtrl.addPollChoice()\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"feedCtrl.addPollChoice()\" title=\"Add New Choice\"><i class=\"fa fa-plus\"></i></button></span></div></li></ul><div class=\"clearfix m-t-xs\" ng-if=\"feedCtrl.newPost.postMessageType==\'Poll\'\"><div class=\"pull-left m-r-sm m-b-xs clearfix\"><label for=\"maxChoices\" class=\"pull-left\">Max choices allowed (0 for unlimited):</label><div class=\"pull-left m-l-xs\" style=\"width:112px\"><input type=\"text\" id=\"maxChoices\" name=\"maxChoices\" touch-spin=\"\" spin-options=\"feedCtrl.choiceOptions\" ng-model=\"feedCtrl.newPost.poll.maxChoices\" style=\"width:50px\"></div></div><div class=\"pull-left m-r-sm m-b-xs\"><label for=\"allowEdit\"><input icheck=\"\" name=\"allowEdit\" type=\"checkbox\" ng-model=\"feedCtrl.newPost.poll.allowEdit\"> Can students modify their choices?</label></div><div class=\"pull-left m-b-xs\"><label for=\"closedVoting\"><input icheck=\"\" name=\"closedVoting\" type=\"checkbox\" ng-model=\"feedCtrl.newPost.poll.closedVoting\"> Secret ballot?</label></div></div><div class=\"btn-group pull-left m-r-sm m-t-xs\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-sm\" uib-dropdown-toggle=\"\">{{feedCtrl.newPost.postMessageType}} <span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"javascript:;\" ng-click=\"feedCtrl.newPost.postMessageType=\'Text\'\">Text</a></li><li><a href=\"javascript:;\" ng-click=\"feedCtrl.pollSelected()\">Poll</a></li></ul></div><button class=\"btn btn-primary btn-sm pull-left m-t-xs\" ng-click=\"feedCtrl.submitPost()\"><i class=\"fa fa-check\"></i> Post this!</button></div></div><div class=\"social-feed-box\" ng-repeat=\"post in feedCtrl.posts\"><div class=\"pull-right social-action\" uib-dropdown=\"\"><button class=\"btn-white\" uib-dropdown-toggle=\"\"><i class=\"fa fa-angle-down\"></i></button><ul class=\"m-t-xs\" uib-dropdown-menu=\"\"><li><a href=\"\">Config</a></li></ul></div><div class=\"social-avatar\"><a href=\"\" class=\"pull-left\"><img img-placeholder=\"user\" alt=\"{{post.name}}\" ng-src=\"{{post.profilePicUrl}}\"></a><div class=\"media-body\"><a href=\"\">{{feedCtrl.myUserId == post.postedBy ? \'Me\' : post.name}}</a> <small class=\"text-muted\">{{post.datePosted | momentDateFrom}}</small></div></div><div class=\"social-body\"><p ng-bind-html=\"trustHtml(post.text)\"></p><div ng-if=\"post.postMessageType==\'Poll\'\"><div class=\"row m-t-xs m-b-sm\" ng-if=\"post.poll.iVoted || feedCtrl.myUserId == post.postedBy\"><div class=\"col-xs-6 col-sm-8\"><div class=\"flot-chart\"><div flot=\"\" class=\"flot-chart-content\" dataset=\"post.poll.flotBarData\" options=\"post.poll.flotBarOptions\"></div></div></div><div class=\"col-xs-6 col-sm-4\"><div class=\"flot-chart\"><div flot=\"\" class=\"flot-chart-content\" dataset=\"post.poll.flotPieData\" options=\"feedCtrl.flotPieOptions\"></div></div></div></div><div ng-repeat=\"choice in post.poll.pollChoices\" class=\"m-b-xs\"><button ng-bind-html=\"trustHtml(choice.choiceContent)\" class=\"btn btn-sm fill-width\" ng-class=\"{\'btn-primary\':choice.selected,\'btn-default\':!choice.selected}\" ng-click=\"feedCtrl.selectPollChoice(post, choice)\" ng-disabled=\"post.voting\"></button></div><button buttonspinner=\"\" ng-disabled=\"post.voting\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-sm btn-primary m-b-xs\" ng-click=\"feedCtrl.submitPollChoices(post)\" ng-if=\"post.poll.isTransient\"><i class=\"fa fa-check\"></i> Submit my vote</button></div><div class=\"btn-group\"><button class=\"btn btn-xs\" ng-class=\"{\'btn-white\':!post.iLike,\'btn-primary\':post.iLike}\" ng-show=\"post.likeCount\"><i class=\"fa fa-thumbs-up\"></i> {{post.likeCount}}</button> <button class=\"btn btn-white btn-xs\" ng-click=\"feedCtrl.likePost(post)\" ng-disabled=\"post.likeSaving || post.iLike\">Like this!</button> <button class=\"btn btn-xs\" ng-class=\"{\'btn-white\':!post.iDislike,\'btn-primary\':post.iDislike}\" ng-show=\"post.dislikeCount\"><i class=\"fa fa-thumbs-down\"></i> {{post.dislikeCount}}</button> <button class=\"btn btn-white btn-xs\" ng-click=\"feedCtrl.dislikePost(post)\" ng-disabled=\"post.likeSaving || post.iDislike\">Dislike this!</button> <button class=\"btn btn-white btn-xs\" ng-click=\"feedCtrl.loadComments(post)\"><i class=\"fa fa-comments\"></i> {{post.commentCount}} {{post.commentCount == 1 ? \'Comment\' : \'Comments\'}}</button></div></div><div class=\"social-footer\" ng-if=\"post.showComments\"><div ng-if=\"post.loadingComments\" spinner-wave=\"\"></div><small class=\"social-comment\" ng-if=\"!post.loadingComments && post.comments && post.comments.length < post.commentCount\"><a href=\"\" ng-click=\"feedCtrl.loadMoreComments(post)\">Show older comments...</a></small><div class=\"social-comment\" ng-repeat=\"comment in post.comments\"><a href=\"\" class=\"pull-left\"><img img-placeholder=\"user\" alt=\"{{comment.name}}\" ng-src=\"{{comment.profilePicUrl}}\"></a><div class=\"media-body\"><a href=\"\">{{feedCtrl.myUserId == comment.userId ? \'Me\' : comment.name}}</a> {{comment.comment}}<br><a href=\"\" ng-click=\"feedCtrl.likeComment(comment)\" class=\"small\"><i class=\"fa fa-thumbs-up\"></i> {{comment.likeCount}} Like this!</a> - <small class=\"text-muted\">{{comment.dateCommented | momentDateFrom}}</small></div></div><div class=\"social-comment\"><a href=\"\" class=\"pull-left\"><img img-placeholder=\"user\" alt=\"{{main.user.userName}}\" ng-src=\"{{main.user.profilePic}}\"></a><div class=\"media-body\" comment-block=\"\" comment-text=\"post.newComment\" on-submit=\"feedCtrl.postComment(post)\" is-disabled=\"post.savingComment\"></div></div></div></div><div ng-if=\"!feedCtrl.loaded\" spinner-wave=\"\"></div></div></div></div>");
$templateCache.put("app/gradebook/gradebook.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Gradebook</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>Gradebook</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h2></h2><p>View and edit student grades</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"clients-list\"><div class=\"row\"><div class=\"col-md-6\"><ui-select id=\"courseId\" name=\"courseId\" ng-model=\"gradebookCtrl.courseId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"gradebookCtrl.courseIdChanged()\"><ui-select-match placeholder=\"Select a course\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"course.courseId as course in gradebookCtrl.courses | filter: $select.search\"><div ng-bind-html=\"course.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-6\" ng-if=\"global.isAdmin || global.isEducator\"><ui-select id=\"userId\" name=\"userId\" ng-model=\"gradebookCtrl.userId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"gradebookCtrl.loadGradebook()\"><ui-select-match placeholder=\"Select a student\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"user.userId as user in gradebookCtrl.users | filter: $select.search\"><div ng-bind-html=\"user.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div ng-if=\"!gradebookCtrl.loading && gradebookCtrl.currentOutline && gradebookCtrl.currentOutline.length\" class=\"datatable-hide-filter\"><table datatable=\"ng\" dt-options=\"gradebookCtrl.dtOptions\" dt-column-defs=\"gradebookCtrl.dtColumnDefs\" class=\"table table-striped table-bordered table-hover\"><thead><tr><th></th><th></th><th>Score</th><th>Grade</th><th>Passed?</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"content in gradebookCtrl.currentOutline | orderBy : \'index\'\"><td>{{index}}</td><td ng-if=\"!content.contentId\"><span ng-repeat=\"x in gradebookCtrl.getArray(content.nodeLevel - 1)\">&nbsp;&nbsp;</span><strong>{{content.nodeType}} {{content.nodeNumber}}<span ng-show=\"content.nodeType || content.nodeNumber\">:</span> {{content.nodeTitle}}</strong></td><td ng-if=\"content.contentId\"><span ng-repeat=\"x in gradebookCtrl.getArray(content.nodeLevel)\">&nbsp;&nbsp;</span><i content-icon=\"content.type\"></i> {{content.name}}</td><td><div ng-if=\"!content.gradeRow.inEdit && content.gradeRow && content.gradeRow.entryType==\'Reading\' && content.gradeRow.type==\'Pdf\'\">{{content.gradeRow.score}} / {{content.gradeRow.contentTotal}} pages</div><div ng-if=\"content.gradeRow.inEdit && content.gradeRow && content.gradeRow.entryType==\'Reading\' && content.gradeRow.type==\'Pdf\'\"><div class=\"input-group\" style=\"max-width:100px\"><input id=\"score\" name=\"score\" type=\"text\" class=\"form-control\" style=\"width:50px\" ng-model=\"content.gradeRow.score\"> <span class=\"input-group-addon\">/ {{content.gradeRow.contentTotal}} pages</span></div></div><div ng-if=\"!content.gradeRow.inEdit && content.gradeRow && content.gradeRow.entryType==\'Reading\' && content.gradeRow.type!=\'Pdf\'\"><span class=\"label label-primary\" ng-if=\"content.gradeRow.viewed\">Viewed</span> <span class=\"label label-danger\" ng-if=\"!content.gradeRow.viewed\">Not Viewed</span></div><div ng-if=\"content.gradeRow.inEdit && content.gradeRow && content.gradeRow.entryType==\'Reading\' && content.gradeRow.type!=\'Pdf\'\"><label for=\"viewed\"><input icheck=\"\" name=\"viewed\" type=\"checkbox\" ng-model=\"content.gradeRow.viewed\"> Viewed?</label></div><div ng-if=\"!content.gradeRow.inEdit && content.gradeRow && content.gradeRow.entryType==\'Competitive\'\">{{content.gradeRow.score}} / {{content.gradeRow.contentTotal}} ({{(content.gradeRow.percentage * 100) | number : 0}} %)</div><div ng-if=\"content.gradeRow.inEdit && content.gradeRow && content.gradeRow.entryType==\'Competitive\'\"><div class=\"input-group\" style=\"max-width:60px\"><input id=\"score\" name=\"score\" type=\"text\" class=\"form-control\" style=\"width:50px\" ng-model=\"content.gradeRow.score\"> <span class=\"input-group-addon\">/ {{content.gradeRow.contentTotal}}</span></div></div></td><td><div class=\"client-status\" ng-if=\"!content.gradeRow.inEdit && content.gradeRow\">{{content.gradeRow.grade}}</div><div ng-if=\"content.gradeRow.inEdit\"><ui-select id=\"grade\" name=\"grade\" ng-model=\"content.gradeRow.grade\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Grade\">{{$select.selected.grade}}</ui-select-match><ui-select-choices repeat=\"grading.grade as grading in gradebookCtrl.gradings | filter: $select.search\"><div ng-bind-html=\"grading.grade | highlight: $select.search\"></div></ui-select-choices></ui-select></div></td><td><div class=\"client-status\" ng-if=\"!content.gradeRow.inEdit && content.gradeRow\"><span class=\"label label-primary\" ng-if=\"content.gradeRow.passed\">Passed</span> <span class=\"label label-danger\" ng-if=\"!content.gradeRow.passed && content.gradeRow.entryType==\'Reading\'\">Incomplete</span> <span class=\"label label-danger\" ng-if=\"!content.gradeRow.passed && content.gradeRow.entryType==\'Competitive\'\">Failed</span></div><div ng-if=\"content.gradeRow.inEdit\"><label for=\"passed\"><input icheck=\"\" name=\"passed\" type=\"checkbox\" ng-model=\"content.gradeRow.passed\"> Passed?</label></div></td><td ng-if=\"global.isAdmin || global.isEducator\" class=\"text-right\"><a ng-if=\"!content.gradeRow.inEdit\" class=\"btn btn-white btn-xs\" ng-click=\"gradebookCtrl.edit(content)\" title=\"Edit Score and Grade\"><span class=\"fa fa-pencil\"></span></a> <a ng-if=\"content.gradeRow.inEdit\" class=\"btn btn-primary btn-xs\" ng-click=\"gradebookCtrl.save(content)\" title=\"Save Score and Grade\"><span class=\"fa fa-check\"></span></a> <a ng-if=\"content.gradeRow.inEdit\" class=\"btn btn-white btn-xs\" ng-click=\"gradebookCtrl.cancelEdit(content)\" title=\"Cancel Edit\"><span class=\"fa fa-times\"></span></a></td></tr></tbody></table></div><div ng-if=\"gradebookCtrl.loading\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/dashboard.html","<div class=\"wrapper wrapper-content\" ng-controller=\"DashboardController as dashboard\"><div class=\"row\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Courses</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{dashboard.summary.activeCourses}}</h1><small>Total Published</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Students</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{dashboard.summary.students}}</h1><small>Institution Total</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">Today</span><h5>Content Views</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{dashboard.summary.contentViews}}</h1><div class=\"stat-percent font-bold\" ng-class=\"{\'text-danger\': dashboard.summary.viewsPct < 0, \'text-navy\': dashboard.summary.viewsPct >= 0}\">{{dashboard.summary.viewsPct | number : 0}}% <i class=\"fa\" ng-class=\"{\'fa-level-down\': dashboard.summary.viewsPct < 0, \'fa-level-up\': dashboard.summary.viewsPct >= 0}\"></i></div><small>Compared to this month</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"label label-danger pull-right\">Today</span><h5>User logins</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{dashboard.summary.logins}}</h1><div class=\"stat-percent font-bold\" ng-class=\"{\'text-danger\': dashboard.summary.loginsPct < 0, \'text-navy\': dashboard.summary.loginsPct >= 0}\">{{dashboard.summary.loginsPct | number : 0}}% <i class=\"fa\" ng-class=\"{\'fa-level-down\': dashboard.summary.loginsPct < 0, \'fa-level-up\': dashboard.summary.loginsPct >= 0}\"></i></div><small>Compared to this month</small></div></div></div></div><div class=\"row\" ng-if=\"false && (global.isAdmin || global.isEducator)\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><select chosen=\"{width: \'20%\'}\" id=\"statsCourse\" name=\"statsCourse\" class=\"chosen-select pull-left\" style=\"width:20%;\" ng-model=\"dashboard.statsCourseId\" ng-options=\"course.courseId as course.name for course in dashboard.courses\" data-placeholder-text-single=\"\'Select a course\'\" no-results-text=\"\'No courses found\'\" ng-change=\"dashboard.loadStats()\"></select>&nbsp;<select chosen=\"{width: \'20%\'}\" id=\"statsType\" name=\"statsType\" class=\"chosen-select pull-left\" style=\"width:20%;\" ng-model=\"dashboard.statsType\" ng-options=\"type.value as type.text for type in dashboard.statsTitles\" data-placeholder-text-single=\"\'Select a statistic\'\" ng-change=\"dashboard.loadStats()\"></select><div class=\"pull-right\" ng-if=\"dashboard.statsType==\'ContentView\'\"><input date-range-picker=\"\" class=\"form-control date-picker input-xs\" type=\"text\" ng-model=\"dashboard.daterange\" options=\"dashboard.dateRangeOptions\"></div><div class=\"pull-right\"><div class=\"btn-group\" ng-if=\"dashboard.statsType==\'ContentView\'\"><button type=\"button\" class=\"btn btn-xs btn-white\" ng-class=\"{\'active\':dashboard.statsFreq==\'Daily\'}\" ng-click=\"dashboard.statsFreq=\'Daily\';dashboard.loadStats()\">Daily</button> <button type=\"button\" class=\"btn btn-xs btn-white\" ng-class=\"{\'active\':dashboard.statsFreq==\'Monthly\'}\" ng-click=\"dashboard.statsFreq=\'Monthly\';dashboard.loadStats()\">Monthly</button> <button type=\"button\" class=\"btn btn-xs btn-white\" ng-class=\"{\'active\':dashboard.statsFreq==\'Annual\'}\" ng-click=\"dashboard.statsFreq=\'Annual\';dashboard.loadStats()\">Annual</button></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div ng-class=\"{\'col-lg-9\':dashboard.statsType==\'ContentView\',\'col-lg-12\':dashboard.statsType!=\'ContentView\'}\"><div class=\"flot-chart\"><div flot=\"\" class=\"flot-chart-content\" dataset=\"dashboard.chart.flotData\" options=\"dashboard.chart.flotOptions\"></div></div></div><div class=\"col-lg-3\" ng-if=\"dashboard.statsType==\'ContentView\'\"><ul class=\"stat-list\"><li><h2 class=\"no-margins\">{{dashboard.contentViews.count}}</h2><small>Total views in period</small></li><li><h2 class=\"no-margins\">{{dashboard.contentViews.thisMonth}}</h2><small>Total views this month</small></li><li><h2 class=\"no-margins\">{{dashboard.contentViews.thisYear}}</h2><small>Total views this year</small></li></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"col-md-8\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>My Modules</h5><div ibox-tools=\"\"><button new-course=\"\" type=\"button\" class=\"btn btn-primary btn-xs\" title=\"New Module\"><i class=\"fa fa-plus\"></i> New Module</button></div></div><div class=\"ibox-content\"><table class=\"table table-hover no-margins\" ng-if=\"dashboard.courseLoaded\"><thead><tr><th>Module Name</th><th>Creator</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"course in dashboard.courses | orderBy:\'name\'\"><td><a ui-sref=\"base.course.index({id:course.courseId})\" title=\"{{course.courseCode ? course.courseCode +\" -=\"\" \"=\"\" +=\"\" course.name=\"\" :=\"\" course.name}}\"=\"\">{{course.courseCode ? course.courseCode + \" - \" + course.name : course.name}}</a></td><td>{{course.userCreated}}</td><td><span class=\"label\" ng-class=\"{\'label-warning\':course.status==1,\'label-primary\':course.status==2,\'label-danger\':course.status==3}\">{{course.status | courseStatus}}</span></td></tr></tbody></table><div ng-if=\"!dashboard.courseLoaded\" spinner-wave=\"\"></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5>Student Activity</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"feed-activity-list\" ng-if=\"dashboard.studentContentActivity\"><div class=\"feed-element\" ng-repeat=\"item in dashboard.studentContentActivity\"><a href=\"\" class=\"pull-left\"><i class=\"fa fa-{{dashboard.contentIcons[item.type]}}\"></i></a><div class=\"media-body\"><small class=\"pull-right\">{{item.eventDate | momentDateFrom}}</small> <strong>{{item.name}}</strong> {{item.eventType==\'View\' ? \'viewed\' : \'submitted\'}} <strong>{{item.contentName}} in {{item.courseName}}: {{item.nodeType}} {{item.nodeNumber}}<span ng-show=\"(item.nodeType || item.nodeNumber) && item.nodeTitle\">:</span> {{item.nodeTitle}}</strong>.<br></div></div></div><div spinner-wave=\"\" ng-if=\"!dashboard.studentContentActivity\"></div></div></div></div><div class=\"col-md-4\"><div class=\"ibox\" ng-if=\"dashboard.lastViewedNode\"><div class=\"ibox-title\"><h5>Last viewed lesson</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><a ui-sref=\"base.course.content({id:dashboard.lastViewedNode.courseId,nodeId:dashboard.lastViewedNode.courseNodeId})\" title=\"{{dashboard.lastViewedNode.courseName}} - {{dashboard.lastViewedNode.nodeName}}\">{{dashboard.lastViewedNode.courseName}} -> {{dashboard.lastViewedNode.nodeName}}</a></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Messages</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content ibox-heading\" ng-if=\"dashboard.mailLoaded\"><h3><i class=\"fa fa-envelope-o\"></i> New messages</h3><small ng-if=\"dashboard.mailUnread.length\"><i class=\"fa fa-time\"></i> You have {{dashboard.mailUnread.length}} new messages.</small> <small ng-if=\"!dashboard.mailUnread.length\"><i class=\"fa fa-time\"></i> You do not have any new messages.</small></div><div class=\"ibox-content\"><div class=\"feed-activity-list\" ng-if=\"dashboard.mailLoaded\"><div class=\"feed-element\" ng-repeat=\"item in dashboard.mailUnread\"><a href=\"\" ui-sref=\"base.mailbox.message({type:\'Inbox\',id:item.id})\"><small class=\"pull-right text-navy ng-hide\">1m ago</small><div class=\"pull-right\" ng-if=\"item.hasAttachments\"><i class=\"fa fa-paperclip\"></i></div><strong>{{item.sender}}</strong><div>{{item.subject}}</div><small class=\"text-muted\">{{item.dateSent}}</small></a></div></div><div ng-if=\"!dashboard.mailLoaded\" spinner-wave=\"\"></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5>My todo list</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><ul class=\"todo-list m-t small-list\" ng-if=\"dashboard.todosLoaded\"><li ng-repeat=\"todo in dashboard.todos\"><checkbox ng-model=\"todo.isDone\" ng-change=\"dashboard.todoDone(todo, $index)\" title=\"{{todo.message}}\"></checkbox><span class=\"m-l-xs\" ng-if=\"!todo.isDone\">{{todo.message}}</span><del class=\"m-l-xs\" ng-if=\"todo.isDone\">{{todo.message}}</del></li><li><textarea type=\"text\" class=\"form-control\" placeholder=\"Enter a to-do task...\" maxlength=\"200\" ng-model=\"dashboard.newTodo.message\" on-enter=\"dashboard.addTodo()\" ng-disabled=\"dashboard.savingTodo\"></textarea></li></ul><div ng-if=\"!dashboard.todosLoaded\" spinner-wave=\"\"></div></div></div></div></div><div class=\"row\" ng-if=\"!global.isAdmin && !global.isEducator\"><div class=\"col-md-8\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>My Modules</h5></div><div class=\"ibox-content\"><div ng-if=\"dashboard.courseLoaded\" class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\" ng-repeat=\"course in dashboard.courses | orderBy:\'name\'\"><a class=\"ibox-module-container\" ui-sref=\"base.course.index({id:course.courseId})\" title=\"{{course.courseCode ? course.courseCode +\" -=\"\" \"=\"\" +=\"\" course.name=\"\" :=\"\" course.name}}\"=\"\"><i class=\"fa fa-graduation-cap\"></i> <span>{{course.courseCode ? course.courseCode + \" - \" + course.name : course.name}}</span></a></div></div><div ng-if=\"!dashboard.courseLoaded\" spinner-wave=\"\"></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>My Next Targets</h5></div><div class=\"ibox-content\"><div ng-if=\"dashboard.courseLoaded\" class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\" ng-repeat=\"content in dashboard.nextContent\"><a ui-sref=\"base.course.content({id:content.courseId,nodeId:content.courseNodeId})\" title=\"{{content.contentName}}\" class=\"ibox-module-container\"><i class=\"fa fa-{{dashboard.contentIcons[content.contentType]}}\"></i> <small>{{content.courseName}}</small> <span>{{content.contentName}}</span></a></div></div><div ng-if=\"!dashboard.courseLoaded\" spinner-wave=\"\"></div></div></div></div><div class=\"col-md-4\"><div class=\"ibox\" ng-if=\"dashboard.lastViewedNode\"><div class=\"ibox-title\"><h5>Last viewed lesson</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><a ui-sref=\"base.course.content({id:dashboard.lastViewedNode.courseId,nodeId:dashboard.lastViewedNode.courseNodeId})\" title=\"{{dashboard.lastViewedNode.courseName}} - {{dashboard.lastViewedNode.nodeName}}\">{{dashboard.lastViewedNode.courseName}} -> {{dashboard.lastViewedNode.nodeName}}</a></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Messages</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content ibox-heading\" ng-if=\"dashboard.mailLoaded\"><h3><i class=\"fa fa-envelope-o\"></i> New messages</h3><small ng-if=\"dashboard.mailUnread.length\"><i class=\"fa fa-time\"></i> You have {{dashboard.mailUnread.length}} new messages.</small> <small ng-if=\"!dashboard.mailUnread.length\"><i class=\"fa fa-time\"></i> You do not have any new messages.</small></div><div class=\"ibox-content\"><div class=\"feed-activity-list\" ng-if=\"dashboard.mailLoaded\"><div class=\"feed-element\" ng-repeat=\"item in dashboard.mailUnread\"><a href=\"\" ui-sref=\"base.mailbox.message({type:\'Inbox\',id:item.id})\"><small class=\"pull-right text-navy ng-hide\">1m ago</small><div class=\"pull-right\" ng-if=\"item.hasAttachments\"><i class=\"fa fa-paperclip\"></i></div><strong>{{item.sender}}</strong><div>{{item.subject}}</div><small class=\"text-muted\">{{item.dateSent}}</small></a></div></div><div ng-if=\"!dashboard.mailLoaded\" spinner-wave=\"\"></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5>My todo list</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><ul class=\"todo-list m-t small-list\" ng-if=\"dashboard.todosLoaded\"><li ng-repeat=\"todo in dashboard.todos\"><checkbox ng-model=\"todo.isDone\" ng-change=\"dashboard.todoDone(todo, $index)\" title=\"{{todo.message}}\"></checkbox><span class=\"m-l-xs\" ng-if=\"!todo.isDone\">{{todo.message}}</span><del class=\"m-l-xs\" ng-if=\"todo.isDone\">{{todo.message}}</del></li><li><textarea type=\"text\" class=\"form-control\" placeholder=\"Enter a to-do task...\" maxlength=\"200\" ng-model=\"dashboard.newTodo.message\" on-enter=\"dashboard.addTodo()\" ng-disabled=\"dashboard.savingTodo\"></textarea></li></ul><div ng-if=\"!dashboard.todosLoaded\" spinner-wave=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/mailbox/inbox.html","<div class=\"mail-box-header\"><form name=\"searchMessages\" class=\"pull-right mail-search\" novalidate=\"\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" id=\"search\" name=\"search\" ng-model=\"inboxCtrl.searchText\" placeholder=\"Search messages...\" required=\"\"><div class=\"input-group-btn\"><a class=\"btn btn-sm btn-primary\" ui-sref=\"{{inboxCtrl.stateName}}({search:inboxCtrl.searchText})\" ng-disabled=\"!inboxCtrl.searchText\">Search</a></div></div></form><h2>{{inboxCtrl.pageTitle}} (<span ng-if=\"inboxCtrl.unreadCount\">{{inboxCtrl.unreadCount}}&nbsp;/&nbsp;</span>{{inboxCtrl.count}})</h2><div class=\"mail-tools tooltip-demo m-t-md\"><div class=\"btn-group pull-right\"><button class=\"btn btn-white btn-sm\" ng-click=\"inboxCtrl.loadPrev()\" ng-disabled=\"inboxCtrl.page==1\" title=\"View previous set of messages\"><i class=\"fa fa-arrow-left\"></i></button> <button class=\"btn btn-white btn-sm\" ng-click=\"inboxCtrl.loadNext()\" ng-disabled=\"inboxCtrl.page==inboxCtrl.pages\" title=\"View next set of messages\"><i class=\"fa fa-arrow-right\"></i></button></div><a ng-if=\"inboxCtrl.showSearch\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Back to Messages\" ui-sref=\"{{inboxCtrl.stateName}}({search:\'\'})\"><i class=\"fa fa-undo\"></i> Back to Messages</a> <button class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Refresh\" ng-click=\"inboxCtrl.refresh()\"><i class=\"fa fa-refresh\"></i> Refresh</button> <button class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Mark as read\"><i class=\"fa fa-eye\"></i></button> <button class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Mark as important\"><i class=\"fa fa-exclamation\"></i></button> <button class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Move to trash\"><i class=\"fa fa-trash-o\"></i></button></div></div><div class=\"mail-box\"><table class=\"table table-hover table-mail\"><tbody><tr ng-if=\"inboxCtrl.loaded\" ng-class=\"{\'read\':item.isRead,\'unread\':!item.isRead}\" ng-repeat=\"item in inboxCtrl.list\"><td class=\"check-mail\"><input icheck=\"\" type=\"checkbox\" ng-model=\"item.selected\"></td><td class=\"mail-ontact\" ng-if=\"item.sender\"><a ui-sref=\"base.mailbox.message({type:inboxCtrl.inboxType,id:item.id})\">{{item.sender}}</a><span class=\"label label-warning pull-right\" ng-if=\"item.categories\"></span></td><td class=\"mail-ontact\" ng-if=\"item.recipients\"><a ui-sref=\"base.mailbox.message({type:inboxCtrl.inboxType,id:item.id})\"><span ng-repeat=\"person in item.recipients\">{{person.Name}}<span ng-show=\"$index < (item.recipients.length-1)\">,&nbsp;</span></span></a><span class=\"label label-warning pull-right\" ng-if=\"item.categories\"></span></td><td class=\"mail-subject\"><a ng-if=\"!inboxCtrl.showSearch\" ui-sref=\"base.mailbox.message({type:inboxCtrl.inboxType,id:item.id})\" ng-bind-html=\"trustHtml(item.subject)\"></a> <a ng-if=\"inboxCtrl.showSearch\" ng-href=\"{{item.url}}\" ng-bind-html=\"trustHtml(item.subject)\"></a><div ng-if=\"inboxCtrl.showSearch\" class=\"mh-70\" truncate=\"\" truncate-options=\"inboxCtrl.truncateOptions\"><small ng-bind-html=\"trustHtml(item.bodySnippet)\"></small></div></td><td class=\"\"><i class=\"fa fa-paperclip\" ng-if=\"item.hasAttachments\"></i></td><td class=\"text-right mail-date\">{{item.dateSent | momentDateTime}}</td></tr><tr ng-if=\"inboxCtrl.loaded && !inboxCtrl.list.length\"><td class=\"text-center\" ng-hide=\"inboxCtrl.showSearch\"><i>There are no messages in this folder</i></td><td class=\"text-center\" ng-show=\"inboxCtrl.showSearch\"><i>Your search did not return any results</i></td></tr><tr ng-if=\"!inboxCtrl.loaded\"><td class=\"text-center\"><div spinner-wave=\"\">Loading your messages...</div></td></tr></tbody></table></div>");
$templateCache.put("app/mailbox/mailbox.base.html","<div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><div class=\"file-manager\"><a class=\"btn btn-block btn-primary compose-mail\" ui-sref=\"base.mailbox.compose\">Compose Mail</a><div class=\"space-25\"></div><h5>Folders</h5><ul class=\"folder-list m-b-md\" style=\"padding: 0\"><li><a ui-sref=\"base.mailbox.inbox({search:\'\'})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-inbox\"></i> Inbox <span class=\"label label-warning pull-right\" ng-show=\"mailboxCtrl.mailSummary.unreadCount\">{{mailboxCtrl.mailSummary.unreadCount}}</span></a></li><li><a ui-sref=\"base.mailbox.sent({search:\'\'})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-envelope-o\"></i> Sent Mail</a></li><li><a ui-sref=\"base.mailbox.inbox({search:\'\'})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-certificate\"></i> Important <span class=\"label label-danger pull-right\" ng-show=\"mailboxCtrl.mailSummary.importantCount\">{{mailboxCtrl.mailSummary.importantCount}}</span></a></li><li><a ui-sref=\"base.mailbox.drafts({search:\'\'})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file-text-o\"></i> Drafts <span class=\"label label-danger pull-right\" ng-show=\"mailboxCtrl.mailSummary.draftsCount\">{{mailboxCtrl.mailSummary.draftsCount}}</span></a></li><li><a ui-sref=\"base.mailbox.trash({search:\'\'})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-trash-o\"></i> Trash</a></li></ul><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-lg-9 animated fadeInRight\"><div ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/mailbox/message.compose.html","<div class=\"mail-box-header\"><div class=\"pull-right tooltip-demo\"><button buttonspinner=\"\" ng-disabled=\"composeCtrl.sending\" ng-click=\"composeCtrl.send()\" class=\"buttonspinner-button btn btn-sm btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Send message\"><i class=\"fa fa-reply\"></i> Send</button> <button ng-show=\"!composeCtrl.sending\" ng-click=\"composeCtrl.saveDraft()\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Save as draft\"><i class=\"fa fa-pencil\"></i> Save Draft</button> <button ng-show=\"!composeCtrl.sending\" ng-click=\"composeCtrl.discard()\" class=\"btn btn-danger btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Discard message\"><i class=\"fa fa-times\"></i> Discard</button></div><h2>Compose new message</h2></div><div class=\"mail-box\"><form class=\"form-horizontal\" name=\"newMessage\" ng-show=\"!composeCtrl.sending\"><div class=\"mail-body\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">To:</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"composeCtrl.message.recipients\" theme=\"bootstrap\" title=\"Recipients\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"composeCtrl.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in composeCtrl.people | filter: $select.search\"><i class=\"fa\" ng-class=\"{\'fa-user\':person.type==\'U\',\'fa-users\':person.type!=\'U\'}\"></i> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">CC:</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"composeCtrl.message.recipientsCc\" theme=\"bootstrap\" title=\"Recipients\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"composeCtrl.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in composeCtrl.people | filter: $select.search\"><i class=\"fa\" ng-class=\"{\'fa-user\':person.type==\'U\',\'fa-users\':person.type==\'G\'||person.type==\'D\'}\"></i> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">BCC:</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"composeCtrl.message.recipientsBcc\" theme=\"bootstrap\" title=\"Recipients\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"composeCtrl.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in composeCtrl.people | filter: $select.search\"><i class=\"fa\" ng-class=\"{\'fa-user\':person.type==\'U\',\'fa-users\':person.type==\'G\'||person.type==\'D\'}\"></i> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Subject:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"composeCtrl.message.subject\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Attachments:</label><div class=\"col-sm-10\"><ul class=\"tag-list\" style=\"padding: 0\"><li ng-repeat=\"file in composeCtrl.message.attachments\"><a href=\"javascript:;\"><i class=\"fa fa-paperclip\"></i> {{file.name || file.fileName}} <i class=\"fa fa-close\" ng-click=\"composeCtrl.removeAttachment(file)\" title=\"Remove {{file.name || file.fileName}}\"></i></a></li><li><div class=\"fileinput fileinput-new no-margins\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file\"><span class=\"fileinput-new\">Add attachment</span><span class=\"fileinput-exists\">Add attachment</span><input type=\"file\" id=\"fileUpload\" name=\"...\" multiple=\"true\" file-model=\"composeCtrl.files\" set-file-data=\"composeCtrl.addAttachments(value);\"></span></div></li></ul></div></div></div><div class=\"mail-text h-200\"><div summernote=\"\" class=\"summernote\" config=\"composeCtrl.summernoteOptions\" ng-model=\"composeCtrl.message.body\" on-image-upload=\"composeCtrl.imageUpload(files)\" editor=\"composeCtrl.editor\"></div><div class=\"clearfix\"></div></div></form><div spinner-wave=\"\" ng-if=\"composeCtrl.sending\"></div><div class=\"mail-body text-right tooltip-demo\"><button buttonspinner=\"\" ng-disabled=\"composeCtrl.sending\" ng-click=\"composeCtrl.send()\" class=\"buttonspinner-button btn btn-sm btn-primary\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Send message\"><i class=\"fa fa-reply\"></i> Send</button> <button ng-show=\"!composeCtrl.sending\" ng-click=\"composeCtrl.saveDraft()\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Save as draft\"><i class=\"fa fa-pencil\"></i> Save Draft</button> <button ng-show=\"!composeCtrl.sending\" ng-click=\"composeCtrl.discard()\" class=\"btn btn-danger btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Discard message\"><i class=\"fa fa-times\"></i> Discard</button></div><div class=\"clearfix\"></div></div>");
$templateCache.put("app/mailbox/message.view.html","<div class=\"mail-box-header\"><div class=\"pull-right tooltip-demo\"><a ui-sref=\"base.mailbox.compose({replyto:messageCtrl.id,type:messageCtrl.type})\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Reply\"><i class=\"fa fa-reply\"></i> Reply</a> <a ui-sref=\"base.mailbox.compose({replyall:messageCtrl.id,type:messageCtrl.type})\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Reply All\"><i class=\"fa fa-reply-all\"></i> Reply All</a> <a ui-sref=\"base.mailbox.compose({forward:messageCtrl.id,type:messageCtrl.type})\" class=\"btn btn-sm btn-white\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Forward\"><i class=\"fa fa-arrow-right\"></i> Forward</a> <button ng-click=\"messageCtrl.print()\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Print email\"><i class=\"fa fa-print\"></i></button> <button ng-click=\"messageCtrl.delete()\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Move to trash\"><i class=\"fa fa-trash-o\"></i></button></div><h2>View Message</h2><div class=\"mail-tools tooltip-demo m-t-md\"><h3><span class=\"font-noraml\">Subject:</span> {{messageCtrl.message.subject}}</h3><h5><span class=\"pull-right font-noraml\">{{messageCtrl.message.dateSent | momentDateTime}}</span> <span ng-if=\"messageCtrl.message.sender\"><span class=\"font-noraml\">From:</span> {{messageCtrl.message.sender}}</span><br><span class=\"font-noraml\">To:</span> <span ng-repeat=\"person in messageCtrl.message.recipients\">{{person.name}}<span ng-show=\"$index < (messageCtrl.message.recipients.length-1)\">,&nbsp;</span></span><br><span ng-if=\"messageCtrl.message.recipientsCc.length\"><span class=\"font-noraml\">CC:</span> <span ng-repeat=\"person in messageCtrl.message.recipientsCc\">{{person.name}}<span ng-show=\"$index < (messageCtrl.message.recipientsCc.length-1)\">,&nbsp;</span></span><br></span> <span ng-if=\"!messageCtrl.message.sender && messageCtrl.message.recipientsBcc.length\"><span class=\"font-noraml\">BCC:</span> <span ng-repeat=\"person in messageCtrl.message.recipientsBcc\">{{person.name}}<span ng-show=\"$index < (messageCtrl.message.recipientsBcc.length-1)\">,&nbsp;</span></span></span></h5></div></div><div class=\"mail-box\"><div class=\"mail-body\" ng-bind-html=\"trustHtml(messageCtrl.message.body)\"></div><div class=\"mail-attachment\" ng-if=\"messageCtrl.message.attachments.length\"><p><span><i class=\"fa fa-paperclip\"></i> {{messageCtrl.message.attachments.length}} {{messageCtrl.message.attachments.length == 1 ? \'attachment\' : \'attachments\' }}</span></p><div class=\"attachment\"><div class=\"file-box\" ng-repeat=\"attachment in messageCtrl.message.attachments\"><div class=\"file\"><a href=\"/Api/File/Attachment/{{attachment.messageAttachmentId}}\" target=\"_blank\"><span class=\"corner\"></span><div class=\"icon\"><i class=\"fa fa-file\"></i></div><div class=\"file-name\">{{attachment.fileName}}</div></a></div></div><div class=\"clearfix\"></div></div></div><div class=\"mail-body text-right tooltip-demo\"><a ui-sref=\"base.mailbox.compose({replyto:messageCtrl.id,type:messageCtrl.type})\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Reply\"><i class=\"fa fa-reply\"></i> Reply</a> <a ui-sref=\"base.mailbox.compose({replyall:messageCtrl.id,type:messageCtrl.type})\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Reply All\"><i class=\"fa fa-reply-all\"></i> Reply All</a> <a ui-sref=\"base.mailbox.compose({forward:messageCtrl.id,type:messageCtrl.type})\" class=\"btn btn-sm btn-white\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Forward\"><i class=\"fa fa-arrow-right\"></i> Forward</a> <button ng-click=\"messageCtrl.print()\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Print email\"><i class=\"fa fa-print\"></i> Print</button> <button ng-click=\"messageCtrl.delete()\" class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Move to trash\"><i class=\"fa fa-trash-o\"></i> Delete</button></div><div class=\"clearfix\"></div></div>");
$templateCache.put("app/planner/event.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-calendar modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"eventCtrl.event.eventId\">Edit Event</h4><h4 class=\"modal-title\" ng-if=\"!eventCtrl.event.eventId\">Create a New Planner Event</h4><small class=\"font-bold\"></small></div><form name=\"createEvent\" novalidate=\"\"><div class=\"modal-body\"><div ng-if=\"eventCtrl.loaded\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"title\" class=\"required\">Title</label> <input id=\"label\" name=\"label\" type=\"text\" ng-model=\"eventCtrl.event.title\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\" placeholder=\"Enter a title for the new event\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"createEvent\" element=\"title\" required-text=\"Please specify a title\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"description\">Description</label><div id=\"description\" name=\"description\" summernote-editor=\"eventCtrl.event.description\" config=\"eventCtrl.summernoteOptions\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"allDay\"><input icheck=\"\" id=\"allDay\" name=\"allDay\" type=\"checkbox\" ng-model=\"eventCtrl.event.allDay\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\"> All day event?</label></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group clearfix\"><label for=\"startDate\" class=\"required control-label\">Start date</label><div class=\"clearfix\"><div ng-class=\"{\'w-60-pct pull-left\':!eventCtrl.event.allDay}\"><div class=\"input-group date\"><input type=\"datetime\" id=\"eventDateDate\" name=\"eventDateDate\" class=\"form-control\" date-time=\"\" ng-model=\"eventCtrl.event.eventDateDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div validation-result=\"\" myform=\"createEvent\" element=\"eventDateDate\" required-text=\"Please specify a start date\"></div></div><div class=\"w-40-pct pull-left\" ng-if=\"!eventCtrl.event.allDay\"><div class=\"input-group\" clock-picker=\"\" data-autoclose=\"true\"><input id=\"eventDateTime\" name=\"eventDateTime\" type=\"text\" class=\"form-control\" ng-model=\"eventCtrl.event.eventDateTime\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\" required=\"\"> <span class=\"input-group-addon\"><span class=\"fa fa-clock-o\"></span></span></div></div></div></div></div><div class=\"col-sm-6\"><div class=\"form-group clearfix\"><label for=\"endDate\" class=\"control-label\">End date</label><div class=\"clearfix\"><div ng-class=\"{\'w-60-pct pull-left\':!eventCtrl.event.allDay}\"><div class=\"input-group date\"><input type=\"datetime\" id=\"endDateDate\" name=\"endDateDate\" class=\"form-control\" date-time=\"\" ng-model=\"eventCtrl.event.endDateDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div><div class=\"w-40-pct pull-left\" ng-if=\"!eventCtrl.event.allDay\"><div class=\"input-group\" clock-picker=\"\" data-autoclose=\"true\"><input id=\"endDateTime\" name=\"endDateTime\" type=\"text\" class=\"form-control\" ng-model=\"eventCtrl.event.endDateTime\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\"> <span class=\"input-group-addon\"><span class=\"fa fa-clock-o\"></span></span></div></div></div></div></div><div class=\"col-sm-12\" ng-if=\"eventCtrl.endDateError\"><label class=\"text-danger f-s-xs\">End date should be on or after the event date</label></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"url\">Event Url</label> <input id=\"url\" name=\"url\" type=\"url\" ng-model=\"eventCtrl.event.eventUrl\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\" placeholder=\"http://www.example.com/event.html\" class=\"form-control\"><div validation-result=\"\" myform=\"createEvent\" element=\"url\" url-text=\"Please specify a valid url\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"inviteeJson\">Invitees</label><ui-select multiple=\"\" ng-model=\"eventCtrl.event.inviteeJson\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\" theme=\"bootstrap\" title=\"Invitees\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"eventCtrl.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in eventCtrl.people\"><i class=\"fa\" ng-class=\"{\'fa-user\':person.type==\'U\',\'fa-users\':person.type!=\'U\'}\"></i> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group m-t-sm\"><label for=\"isRecurring\"><input icheck=\"\" id=\"isRecurring\" name=\"isRecurring\" type=\"checkbox\" ng-model=\"eventCtrl.event.isRecurring\" ng-disabled=\"eventCtrl.event.eventId && eventCtrl.myUserId != eventCtrl.event.createdBy\"> Recurring event?</label></div></div></div><div ng-if=\"eventCtrl.event.isRecurring\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"frequency\">Repeats</label><ui-select ng-model=\"eventCtrl.event.recurParamsJson.frequency\" search-enabled=\"false\" theme=\"bootstrap\" title=\"Invitees\"><ui-select-match placeholder=\"How frequently will this event occur?\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in eventCtrl.repeatFreqs | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"repeatEvery\" class=\"block\">Repeat every</label><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" id=\"repeatEvery\" name=\"repeatEvery\" touch-spin=\"\" spin-options=\"eventCtrl.dimensionsOptions\" ng-model=\"eventCtrl.event.recurParamsJson.repeatEvery\" style=\"width:50px\"></div><div class=\"pull-left\">&nbsp;{{eventCtrl.repeatEvery[eventCtrl.event.recurParamsJson.frequency]}}</div></div></div></div><div class=\"row\" ng-if=\"eventCtrl.event.recurParamsJson.frequency==\'W\'\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"\" class=\"block\">Repeat on</label> <label for=\"repeatMon\"><input icheck=\"\" id=\"repeatMon\" name=\"repeatMon\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatMon\"> Mon</label>&nbsp;&nbsp; <label for=\"repeatTue\"><input icheck=\"\" id=\"repeatTue\" name=\"repeatTue\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatTue\"> Tue</label>&nbsp;&nbsp; <label for=\"repeatWed\"><input icheck=\"\" id=\"repeatWed\" name=\"repeatWed\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatWed\"> Wed</label>&nbsp;&nbsp; <label for=\"repeatThu\"><input icheck=\"\" id=\"repeatThu\" name=\"repeatThu\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatThu\"> Thu</label>&nbsp;&nbsp; <label for=\"repeatFri\"><input icheck=\"\" id=\"repeatFri\" name=\"repeatFri\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatFri\"> Fri</label>&nbsp;&nbsp; <label for=\"repeatSat\"><input icheck=\"\" id=\"repeatSat\" name=\"repeatSat\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatSat\"> Sat</label>&nbsp;&nbsp; <label for=\"repeatSun\"><input icheck=\"\" id=\"repeatSun\" name=\"repeatSun\" type=\"checkbox\" ng-model=\"eventCtrl.event.recurParamsJson.repeatSun\"> Sun</label></div></div></div><div class=\"row\" ng-if=\"eventCtrl.event.recurParamsJson.frequency==\'M\'\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"\" class=\"block\">Repeat by</label> <label for=\"repeatByDM\"><input icheck=\"\" id=\"repeatByDM\" name=\"repeatBy\" type=\"radio\" value=\"DM\" ng-model=\"eventCtrl.event.recurParamsJson.repeatBy\"> day of the month</label>&nbsp;&nbsp; <label for=\"repeatByDW\"><input icheck=\"\" id=\"repeatByDW\" name=\"repeatBy\" type=\"radio\" value=\"DW\" ng-model=\"eventCtrl.event.recurParamsJson.repeatBy\"> day of the week</label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"repeatEnds\" class=\"block\">Ends</label> <label for=\"repeatEndsA\" class=\"block clearfix\"><div class=\"pull-left\"><input icheck=\"\" id=\"repeatEndsA\" name=\"repeatEnds\" type=\"radio\" value=\"After\" ng-model=\"eventCtrl.event.recurParamsJson.repeatEndsType\"></div><div class=\"pull-left m-l-xs\">after</div><div style=\"width:113px\" class=\"pull-left m-l-xs\"><input type=\"text\" id=\"repeatEndsAfter\" name=\"repeatEndsAfter\" touch-spin=\"\" spin-options=\"eventCtrl.dimensionsOptions\" ng-model=\"eventCtrl.event.recurParamsJson.repeatEndsAfter\" ng-disabled=\"eventCtrl.event.recurParamsJson.repeatEndsType != \'After\'\" style=\"width:50px\"></div><div class=\"pull-left m-l-xs\">occurances</div></label><br><label for=\"repeatEndsO\" class=\"block clearfix\"><div class=\"pull-left\"><input icheck=\"\" id=\"repeatEndsO\" name=\"repeatEnds\" type=\"radio\" value=\"On\" ng-model=\"eventCtrl.event.recurParamsJson.repeatEndsType\"></div><div class=\"pull-left m-l-xs m-r-xs\">on</div><div class=\"col-xs-8 col-sm-5\"><div class=\"input-group date\"><input type=\"datetime\" id=\"repeatEndsOnDate\" name=\"repeatEndsOnDate\" class=\"form-control\" date-time=\"\" ng-model=\"eventCtrl.event.recurParamsJson.repeatEndsOnDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" ng-disabled=\"eventCtrl.event.recurParamsJson.repeatEndsType != \'On\'\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></label></div></div></div></div></div><div ng-if=\"!eventCtrl.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"eventCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"eventCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"eventCtrl.ok(createEvent)\" data-style=\"expand-left\"><span ng-if=\"eventCtrl.event.eventId\">Save</span> <span ng-if=\"!eventCtrl.event.eventId\">Create</span></button></div></form></div>");
$templateCache.put("app/planner/event.view.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-calendar modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"eventCtrl.event.eventId\">{{eventCtrl.event.title}}</h4><small class=\"font-bold\" ng-bind-html=\"$root.trustHtml(eventCtrl.event.description)\"></small></div><form name=\"createEvent\" novalidate=\"\"><div class=\"modal-body\"><div ng-if=\"eventCtrl.loaded\"><div class=\"row\"><div class=\"col-md-12\"><p ng-if=\"eventCtrl.event.allDay\">This is a full day event</p><p ng-if=\"!eventCtrl.event.allDay\"><strong>Time:</strong> {{eventCtrl.event.eventDateDate | momentDateText}} {{eventCtrl.event.eventDateTime}} to <span ng-if=\"eventCtrl.event.eventDateDate != eventCtrl.event.endDateDate\">{{eventCtrl.event.endDateDate | momentDateText}}</span> {{eventCtrl.event.endDateTime}}</p></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"url\">Event Url</label><p><a href=\"{{eventCtrl.event.eventUrl}}\" target=\"_blank\">{{eventCtrl.event.eventUrl}}</a></p></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"url\">Attachments</label><ul class=\"tag-list\" style=\"padding: 0\"><li ng-repeat=\"file in eventCtrl.event.eventAttachments\"><a ng-href=\"{{file.eventAttachmentId ? \'/Api/File/EventAttachment/\' + file.eventAttachmentId : \'javascript:;\'}}\" target=\"_blank\"><i class=\"fa fa-paperclip\"></i> {{file.name || file.fileName}} <i class=\"fa fa-close\" ng-click=\"eventCtrl.removeAttachment(file)\" title=\"Remove {{file.name || file.fileName}}\" no-propagation=\"\" ng-if=\"!eventCtrl.event.eventId || eventCtrl.myUserId == eventCtrl.event.createdBy\"></i></a></li><li ng-if=\"!eventCtrl.event.eventId || eventCtrl.myUserId == eventCtrl.event.createdBy\"><div class=\"fileinput fileinput-new no-margins\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file\"><span class=\"fileinput-new\">Add attachment</span><span class=\"fileinput-exists\">Add attachment</span><input type=\"file\" id=\"fileUpload\" name=\"...\" multiple=\"true\" file-model=\"eventCtrl.files\" set-file-data=\"eventCtrl.addAttachments(value);\"></span></div></li></ul></div></div></div></div><div ng-if=\"!eventCtrl.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"eventCtrl.cancel()\">Close</button></div></form></div>");
$templateCache.put("app/planner/planner.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>My Planner</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>My Planner</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h2></h2><p ng-if=\"!global.isStudent\">View timetables as well as calendar events that you have either created or been invited to</p><p ng-if=\"global.isStudent\">View your schedule of classes and events that you are a part of</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"clients-list\"><div class=\"m-b-xs\" ng-if=\"!plannerCtrl.loadingEvents\"><div ui-calendar=\"plannerCtrl.calendarConfig\" calendar=\"myCalendar1\" class=\"calendar\" ng-model=\"plannerCtrl.eventSources\"></div></div><button ng-if=\"!global.isStudent\" type=\"button\" class=\"btn btn-primary\" ng-click=\"plannerCtrl.newEvent()\"><i class=\"fa fa-plus\"></i> Add new event</button><div ng-if=\"plannerCtrl.loadingEvents\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/profile/change.password.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-key modal-icon\"></i><h4 class=\"modal-title\">Change Password</h4></div><form name=\"ChangePwd\" role=\"form\" novalidate=\"\"><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><input id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Current Password\" required=\"\" ng-model=\"changePwdModalCtrl.password\"><div validation-result=\"\" myform=\"ChangePwd\" element=\"password\" required-text=\"Please provide your current password\"></div></div><div class=\"form-group\"><input id=\"newpassword\" name=\"newpassword\" type=\"password\" class=\"form-control\" placeholder=\"New Password\" required=\"\" ng-model=\"changePwdModalCtrl.newpassword\"><div validation-result=\"\" myform=\"ChangePwd\" element=\"newpassword\" required-text=\"Please provide a new password\"></div></div><div class=\"form-group\"><input id=\"confirmpassword\" name=\"confirmpassword\" type=\"password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\" match-with=\"changePwdModalCtrl.newpassword\" ng-model=\"changePwdModalCtrl.confirmpassword\"><div validation-result=\"\" myform=\"ChangePwd\" element=\"confirmpassword\" required-text=\"Please provide a password confirmation\"></div><div validation-result=\"\" myform=\"ChangePwd\" element=\"confirmpassword\" matching-text=\"The confirmation does not match the password\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"changePwdModalCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"changePwdModalCtrl.changing\" type=\"submit\" ng-click=\"changePwdModalCtrl.change(ChangePwd)\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary\" title=\"Change Password\">Change Password</button></div></form></div>");
$templateCache.put("app/profile/profile.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Profile</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>Profile</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content\"><div class=\"row animated fadeInRight\"><div class=\"col-md-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Profile Detail</h5></div><div><div class=\"ibox-content p-xs border-left-right text-center\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" on-bs-file-input-change=\"profileCtrl.uploadPic($event)\"><div class=\"fileinput-new\"><img img-placeholder=\"user\" alt=\"My Profile Photo\" class=\"img-responsive\" ng-src=\"{{profileCtrl.me.profilePicUrl}}\"></div><div class=\"fileinput-preview fileinput-exists img-responsive\"></div><div class=\"m-t-sm\"><span class=\"btn btn-default btn-xs btn-file\" title=\"Change my profile photo\"><i class=\"fa fa-pencil\"></i> <span class=\"fileinput-new\">Select new image</span><span class=\"fileinput-exists\">Select new image</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"profileCtrl.file\" set-file-data=\"profileCtrl.file = value;\"></span></div><div class=\"m-t-sm\">ID No.: {{profileCtrl.me.studentId}}</div></div></div><div class=\"ibox-content profile-content\"><div class=\"user-button\"><div class=\"row\"><div class=\"col-md-6\"><button type=\"button\" class=\"btn btn-primary btn-sm btn-block\" title=\"Change Password\" ng-click=\"profileCtrl.changePassword()\"><i class=\"fa fa-key\"></i> Change Password</button></div></div></div></div></div></div></div><div class=\"col-md-8\"><form name=\"profileForm\" method=\"get\" class=\"form-horizontal\" novalidate=\"\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Personal Details</h5><div ibox-tools=\"\" disable-close=\"true\" ng-if=\"profileCtrl.loaded\"><a ng-click=\"profileCtrl.openEdit()\" title=\"Edit Profile\" ng-show=\"!profileCtrl.editProfileMode\"><i class=\"fa fa-pencil\"></i></a> <button ng-click=\"profileCtrl.cancelEdit()\" title=\"Cancel Edit\" ng-show=\"profileCtrl.editProfileMode\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-minus-circle\"></i> Cancel</button> <button type=\"submit\" buttonspinner=\"\" ng-disabled=\"profileCtrl.saving\" ng-click=\"profileCtrl.saveProfile(profileForm);\" data-style=\"expand-left\" title=\"Save changes\" ng-show=\"profileCtrl.editProfileMode\" class=\"buttonspinner-button btn btn-primary btn-xs\"><i class=\"fa fa-save\"></i> Save changes</button></div></div><div class=\"ibox-content\" ng-if=\"!profileCtrl.loaded\"><div spinner-wave=\"\"></div></div><div class=\"ibox-content\" ng-if=\"profileCtrl.loaded\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"email\">Email</label> <span class=\"block\">{{profileCtrl.me.email}}</span></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"city\" ng-class=\"{\'required\': profileCtrl.editProfileMode}\">City</label> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode\">{{profileCtrl.me.city || \'---\'}}</span> <input ng-if=\"profileCtrl.editProfileMode\" id=\"city\" name=\"city\" type=\"text\" ng-model=\"profileCtrl.me.city\" placeholder=\"City\" class=\"form-control\" required=\"\" maxlength=\"100\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"firstName\" ng-class=\"{\'required\': profileCtrl.editProfileMode}\">First name</label> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode\">{{profileCtrl.me.firstName || \'---\'}}</span> <input ng-if=\"profileCtrl.editProfileMode\" id=\"firstName\" name=\"firstName\" type=\"text\" ng-model=\"profileCtrl.me.firstName\" placeholder=\"First name\" class=\"form-control\" required=\"\" maxlength=\"50\"></div><div class=\"col-md-6\"><label for=\"lastName\" ng-class=\"{\'required\': profileCtrl.editProfileMode}\">Last name</label> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode\">{{profileCtrl.me.lastName || \'---\'}}</span> <input ng-if=\"profileCtrl.editProfileMode\" id=\"lastName\" name=\"lastName\" type=\"text\" ng-model=\"profileCtrl.me.lastName\" placeholder=\"Last name\" class=\"form-control\" required=\"\" maxlength=\"50\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"contactNo\" ng-class=\"{\'required\': profileCtrl.editProfileMode}\">Contact no.</label> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode\">{{profileCtrl.me.contactNo || \'---\'}}</span> <input ng-if=\"profileCtrl.editProfileMode\" id=\"contactNo\" name=\"contactNo\" type=\"text\" ng-model=\"profileCtrl.me.contactNo\" placeholder=\"Contact No.\" class=\"form-control\" required=\"\" maxlength=\"15\"></div><div class=\"col-md-6\"><label for=\"landlineNo\">Landline no.</label> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode\">{{profileCtrl.me.landlineNo || \'---\'}}</span> <input ng-if=\"profileCtrl.editProfileMode\" id=\"landlineNo\" name=\"landlineNo\" type=\"text\" ng-model=\"profileCtrl.me.landlineNo\" placeholder=\"Landline No.\" class=\"form-control\" maxlength=\"15\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"gender\" ng-class=\"{\'required\': profileCtrl.editProfileMode}\">Gender</label><div><label for=\"genderM\"><input icheck=\"\" id=\"genderM\" name=\"gender\" type=\"radio\" value=\"M\" ng-model=\"profileCtrl.me.gender\" ng-disabled=\"!profileCtrl.editProfileMode\"> Male</label> <label for=\"genderF\"><input icheck=\"\" id=\"genderF\" name=\"gender\" type=\"radio\" value=\"F\" ng-model=\"profileCtrl.me.gender\" ng-disabled=\"!profileCtrl.editProfileMode\"> Female</label> <label for=\"genderO\"><input icheck=\"\" id=\"genderO\" name=\"gender\" type=\"radio\" value=\"O\" ng-model=\"profileCtrl.me.gender\" ng-disabled=\"!profileCtrl.editProfileMode\"> Others</label></div></div><div class=\"col-md-6\"><label for=\"dateOfBirth\" class=\"control-label\">Date of birth (dd-mm-yyyy)</label> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode && profileCtrl.me.dateOfBirth\">{{profileCtrl.me.dateOfBirth | momentLongDate}}</span> <span class=\"block\" ng-if=\"!profileCtrl.editProfileMode && !profileCtrl.me.dateOfBirth\">---</span><div ng-if=\"profileCtrl.editProfileMode\" class=\"input-group date\"><input type=\"datetime\" id=\"dateOfBirth\" name=\"dateOfBirth\" class=\"form-control\" date-time=\"\" ng-model=\"profileCtrl.me.dateOfBirth\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div></div></div></form></div></div><div class=\"row animated fadeInRight\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Parents\' / Guardians\' Details</h5><div ibox-tools=\"\" disable-close=\"true\"></div></div><div class=\"ibox-content\" ng-if=\"!profileCtrl.loaded\"><div spinner-wave=\"\"></div></div><div class=\"ibox-content\" ng-if=\"profileCtrl.loaded\"><div ng-repeat=\"parent in profileCtrl.me.parents\"><div ng-if=\"!parent.inEdit\">{{parent.firstName}} {{parent.lastName}} <span ng-if=\"!parent.deleting\">&nbsp;&nbsp;<a ng-click=\"profileCtrl.openParentEdit(parent)\" title=\"Edit Parent\"><i class=\"fa fa-pencil\"></i></a>&nbsp;&nbsp;<a ng-click=\"profileCtrl.deleteParent(parent)\" title=\"Delete Parent\"><i class=\"fa fa-times\"></i></a></span><span ng-if=\"parent.deleting\">(Deleting...)</span></div><ng-form ng-if=\"parent.inEdit\" name=\"parentForm\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"relationship\" class=\"required\">Relationship</label><select chosen=\"\" id=\"relationship\" name=\"relationship\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"parent.relationship\" ng-options=\"reln.name as reln.name for reln in profileCtrl.relationships\" data-placeholder-text-single=\"\'Select a relationship\'\" required=\"\"></select></div><div class=\"col-md-6\"><label for=\"emailId\" class=\"required\">Email</label> <input id=\"emailId\" name=\"emailId\" type=\"text\" ng-model=\"parent.emailId\" placeholder=\"Email\" class=\"form-control\" required=\"\" maxlength=\"256\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"firstName\" class=\"required\">First name</label> <input id=\"firstName\" name=\"firstName\" type=\"text\" ng-model=\"parent.firstName\" placeholder=\"First name\" class=\"form-control\" required=\"\" maxlength=\"50\"></div><div class=\"col-md-6\"><label for=\"lastName\" class=\"required\">Last name</label> <input id=\"lastName\" name=\"lastName\" type=\"text\" ng-model=\"parent.lastName\" placeholder=\"Last name\" class=\"form-control\" required=\"\" maxlength=\"50\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"gender\">Gender</label><div><label for=\"genderM\"><input icheck=\"\" id=\"genderM\" name=\"gender-{{$index}}\" type=\"radio\" value=\"M\" ng-model=\"parent.gender\"> Male</label> <label for=\"genderF\"><input icheck=\"\" id=\"genderF\" name=\"gender-{{$index}}\" type=\"radio\" value=\"F\" ng-model=\"parent.gender\"> Female</label> <label for=\"genderO\"><input icheck=\"\" id=\"genderO\" name=\"gender-{{$index}}\" type=\"radio\" value=\"O\" ng-model=\"parent.gender\"> Others</label></div></div><div class=\"col-md-6\"><label for=\"mobileNo\" class=\"required\">Mobile No.</label> <input id=\"mobileNo\" name=\"mobileNo\" type=\"text\" ng-model=\"parent.mobileNo\" placeholder=\"Mobile No.\" class=\"form-control\" required=\"\" maxlength=\"15\"></div></div><div class=\"row\"><div class=\"col-md-12\"><button ng-click=\"profileCtrl.cancelEditParent(parent)\" title=\"Cancel Edit\" ng-show=\"parent.parentId\" class=\"btn btn-primary\"><i class=\"fa fa-minus-circle\"></i> Cancel</button> <button type=\"submit\" buttonspinner=\"\" ng-disabled=\"parent.saving\" ng-click=\"parentForm.$submitted=true;profileCtrl.saveParent(parentForm, parent);\" data-style=\"expand-left\" title=\"Save parent\" class=\"buttonspinner-button btn btn-primary\"><i class=\"fa fa-save\"></i> Save</button></div></div></ng-form><hr></div><button class=\"btn btn-primary\" ng-click=\"profileCtrl.addParent()\" title=\"Add parent\"><i class=\"fa fa-plus\"></i> Add Parent</button></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Addresses</h5><div ibox-tools=\"\" disable-close=\"true\"></div></div><div class=\"ibox-content\" ng-if=\"!profileCtrl.loaded\"><div spinner-wave=\"\"></div></div><div class=\"ibox-content\" ng-if=\"profileCtrl.loaded\"><div ng-repeat=\"address in profileCtrl.me.addresses\"><div ng-if=\"!address.inEdit\">{{address.main}}, {{address.city}} ({{address.label}}) <span ng-if=\"!address.deleting\">&nbsp;&nbsp;<a ng-click=\"profileCtrl.openAddressEdit(address)\" title=\"Edit Address\"><i class=\"fa fa-pencil\"></i></a>&nbsp;&nbsp;<a ng-click=\"profileCtrl.deleteAddress(address)\" title=\"Delete Address\"><i class=\"fa fa-times\"></i></a></span><span ng-if=\"address.deleting\">(Deleting...)</span></div><ng-form ng-if=\"address.inEdit\" name=\"addressForm\"><div class=\"row\"><div class=\"col-md-6\"><label for=\"label\" class=\"required\">Address type</label><select chosen=\"\" id=\"label\" name=\"label\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"address.label\" ng-options=\"t.label as t.label for t in profileCtrl.addressTypes\" data-placeholder-text-single=\"\'Select one\'\" required=\"\"></select></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"main\" class=\"required\">Address</label> <textarea id=\"main\" name=\"main\" type=\"text\" ng-model=\"address.main\" placeholder=\"No., Building/Society, Street\" class=\"form-control\" required=\"\"></textarea></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"city\" class=\"required\">City</label> <input id=\"city\" name=\"city\" type=\"text\" ng-model=\"address.city\" placeholder=\"City\" class=\"form-control\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"state\" class=\"required\">State</label><select chosen=\"\" id=\"state\" name=\"state\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"address.state\" ng-options=\"st.code as st.name for st in profileCtrl.states\" data-placeholder-text-single=\"\'Select one\'\" required=\"\"></select></div><div class=\"col-md-6\"><label for=\"zip\" class=\"required\">Pincode</label> <input id=\"zip\" name=\"zip\" type=\"text\" ng-model=\"address.zip\" placeholder=\"Pincode\" class=\"form-control\" required=\"\" maxlength=\"6\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><label for=\"phoneNo\">Phone No.</label> <input id=\"phoneNo\" name=\"phoneNo\" type=\"text\" ng-model=\"address.phoneNo\" placeholder=\"Phone No.\" class=\"form-control\" maxlength=\"15\"></div><div class=\"col-md-6\"><label for=\"altPhoneNo\">Alternative Phone No.</label> <input id=\"altPhoneNo\" name=\"altPhoneNo\" type=\"text\" ng-model=\"address.altPhoneNo\" placeholder=\"Alternative Phone No.\" class=\"form-control\" maxlength=\"15\"></div></div><div class=\"row\"><div class=\"col-md-12\"><button ng-click=\"profileCtrl.cancelEditAddress(address)\" title=\"Cancel Edit\" ng-show=\"address.userAddressId\" class=\"btn btn-primary\"><i class=\"fa fa-minus-circle\"></i> Cancel</button> <button type=\"submit\" buttonspinner=\"\" ng-disabled=\"address.saving\" ng-click=\"addressForm.$submitted=true;profileCtrl.saveAddress(addressForm, address);\" data-style=\"expand-left\" title=\"Save address\" class=\"buttonspinner-button btn btn-primary\"><i class=\"fa fa-save\"></i> Save</button></div></div></ng-form><hr></div><button class=\"btn btn-primary\" ng-click=\"profileCtrl.addAddress()\" title=\"Add address\"><i class=\"fa fa-plus\"></i> Add Address</button></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Qualifications</h5><div ibox-tools=\"\" disable-close=\"true\"></div></div><div class=\"ibox-content\" ng-if=\"!profileCtrl.loaded\"><div spinner-wave=\"\"></div></div><div class=\"ibox-content\" ng-if=\"profileCtrl.loaded\"><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><thead><tr><th>Type</th><th>Institution</th><th>Year of Passing</th><th>Semester</th><th>Percentage</th><th></th></tr></thead><tbody><tr ng-if=\"!qualification.inEdit\" ng-repeat=\"qualification in profileCtrl.me.qualifications | orderBy:[\'passYear\',\'qualType\']\"><td>{{qualification.qualType}}</td><td>{{qualification.institutionName}}</td><td>{{qualification.passYear}}</td><td>{{qualification.semester}}</td><td>{{qualification.percentage}}</td><td><span ng-if=\"!qualification.deleting\"><a ng-click=\"profileCtrl.openQualificationEdit(qualification)\" title=\"Edit Qualification\"><i class=\"fa fa-pencil\"></i></a>&nbsp;&nbsp;<a ng-click=\"profileCtrl.deleteQualification(qualification)\" title=\"Delete Qualification\"><i class=\"fa fa-times\"></i></a></span><span ng-if=\"qualification.deleting\">(Deleting...)</span></td></tr><tr ng-if=\"qualification.inEdit\" ng-repeat=\"qualification in profileCtrl.me.qualifications | orderBy:[\'passYear\',\'qualType\']\" ng-form=\"qualificationForm\"><td><input id=\"qualType\" name=\"qualType\" type=\"text\" ng-model=\"qualification.qualType\" placeholder=\"Qualification\" class=\"form-control\" maxlength=\"100\" required=\"\"></td><td><input id=\"institutionName\" name=\"institutionName\" type=\"text\" ng-model=\"qualification.institutionName\" placeholder=\"Institution\" class=\"form-control\" maxlength=\"100\" required=\"\"></td><td><select chosen=\"\" id=\"passYear\" name=\"passYear\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"qualification.passYear\" ng-options=\"t.year as t.year for t in profileCtrl.passYears\" data-placeholder-text-single=\"\'Select...\'\" required=\"\"></select></td><td><input id=\"semester\" name=\"semester\" type=\"text\" ng-model=\"qualification.semester\" placeholder=\"Semester\" class=\"form-control\" maxlength=\"50\" required=\"\"></td><td><input id=\"percentage\" name=\"percentage\" type=\"text\" ng-model=\"qualification.percentage\" placeholder=\"Percentage\" class=\"form-control\" required=\"\"></td><td><span ng-if=\"!qualification.saving\"><a ng-click=\"qualificationForm.$submitted=true;profileCtrl.saveQualification(qualificationForm, qualification);\" title=\"Save Qualification\"><i class=\"fa fa-save\"></i></a>&nbsp;&nbsp;<a ng-click=\"profileCtrl.cancelEditQualification(qualification)\" title=\"Cancel Edit\" ng-show=\"qualification.userQualificationId\"><i class=\"fa fa-minus-circle\"></i></a></span><div spinner-wave=\"\" ng-if=\"qualification.saving\"></div></td></tr></tbody></table></div></div><button class=\"btn btn-primary\" ng-click=\"profileCtrl.addQualification()\" title=\"Add qualification\"><i class=\"fa fa-plus\"></i> Add Qualification</button></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Activities</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div><div class=\"feed-activity-list\"><div class=\"feed-element\" ng-repeat=\"post in profileCtrl.activities\"><a href=\"\" class=\"pull-left\"><img class=\"img-circle\" img-placeholder=\"user\" alt=\"{{profileCtrl.me.title}} {{profileCtrl.me.firstName}} {{profileCtrl.me.lastName}}\" ng-src=\"{{profileCtrl.me.profilePicUrl}}\"></a><div class=\"media-body\"><small class=\"pull-right\">{{post.datePosted | momentDateFrom}}</small> Posted in <a ui-sref=\"base.feed({type:post.postType,id:post.departmentId || post.departmentGroupId || post.courseId})\"><strong ng-if=\"post.postType==\'Institution\'\">General Feed</strong> <strong ng-if=\"post.postType==\'Department\'\">{{post.departmentName}}</strong> <strong ng-if=\"post.postType==\'Group\'\">{{post.groupName}}</strong> <strong ng-if=\"post.postType==\'Course\'\">{{post.courseName}}</strong></a><div class=\"well\"><p ng-bind-html=\"trustHtml(post.text)\"></p></div></div></div></div><button class=\"btn btn-primary btn-block m\" ng-if=\"profileCtrl.showMorePosts\" ng-click=\"profileCtrl.getActivities()\" title=\"Show more activities\"><i class=\"fa fa-arrow-down\"></i> Show More</button></div></div></div></div></div></div>");
$templateCache.put("app/search/search.results.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Search results</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>Search results: {{searchCtrl.searchText}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\"><div class=\"row animated fadeInRight\"><div ng-class=\"{\'col-lg-12\':!searchCtrl.addOpen,\'col-xs-6\':searchCtrl.addOpen}\"><div class=\"animated fadeInRight\"><div class=\"ibox-content forum-container\" ng-if=\"searchCtrl.searchText && !searchCtrl.loading\"><div class=\"forum-title\"><div ng-hide=\"searchCtrl.addOpen\" class=\"pull-right forum-desc\"><small>Total results: {{searchCtrl.totalResults}}</small></div><h3>{{searchCtrl.searchText}}</h3></div><hr><div ng-hide=\"searchCtrl.addOpen\" class=\"forum-title\" ng-if=\"searchCtrl.totalLocal\"><div class=\"pull-right forum-desc\"><small>Total results: {{searchCtrl.totalLocal}}</small></div><h4>Local Results</h4></div><div ng-hide=\"searchCtrl.addOpen\" class=\"forum-item item-clickable\" ng-repeat=\"item in searchCtrl.results.list\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"forum-icon\"><i content-icon=\"item.contentType\"></i></div><a ng-href=\"{{item.url}}\" ng-bind-html=\"trustHtml(item.title)\" class=\"forum-item-title\"></a><div><a ui-sref=\"base.course.index({id:item.courseId})\" ng-bind-html=\"trustHtml(item.courseName)\"></a> -> <a ui-sref=\"base.course.content({id:item.courseId, nodeId:item.nodeId})\" ng-bind-html=\"trustHtml(item.nodeName)\"></a></div><div class=\"forum-sub-title mh-100\" truncate=\"\" truncate-options=\"searchCtrl.truncateOptions\" ng-bind-html=\"trustHtml(item.contentSnippet)\"></div></div></div></div><div class=\"forum-title\" ng-if=\"searchCtrl.youtubeResults.pageInfo.totalResults\"><div ng-hide=\"searchCtrl.addOpen\" class=\"pull-right forum-desc\"><small>Total results: {{searchCtrl.youtubeResults.pageInfo.totalResults}}</small></div><h4><i class=\"fa fa-youtube modal-icon\"></i> Results from Youtube</h4></div><youtube-snippet ng-repeat=\"item in searchCtrl.youtubeResults.items\" item=\"item\" compressed=\"searchCtrl.addOpen\"><button ng-hide=\"searchCtrl.addOpen\" class=\"btn btn-primary btn-sm m-t-xs\" title=\"Preview this video\"><i class=\"fa fa-play\"></i> Open/Preview</button> <button ng-if=\"global.isAdmin || global.isEducator\" ng-hide=\"searchCtrl.addOpen\" class=\"btn btn-primary btn-sm m-t-xs\" ng-click=\"searchCtrl.add(\'Youtube\', item); $event.stopPropagation();\" title=\"Add this video to course content\"><i class=\"fa fa-plus\"></i> Add to Course Content</button></youtube-snippet><div spinner-wave=\"\" ng-if=\"searchCtrl.loadingMoreYoutube\">Searching...</div><button class=\"btn btn-white btn-xs\" type=\"button\" ng-click=\"searchCtrl.moreYoutube(searchCtrl.youtubeResults.nextPageToken)\" ng-if=\"!searchCtrl.loadingMoreYoutube && searchCtrl.youtubeResults.nextPageToken\" title=\"More from Youtube\">More from Youtube...</button><div class=\"forum-title\" ng-if=\"searchCtrl.vimeoResults.total\"><div class=\"pull-right forum-desc\"><small>Total results: {{searchCtrl.vimeoResults.total}}</small></div><h4><i class=\"fa fa-vimeo modal-icon\"></i> Results from Vimeo</h4></div><vimeo-snippet ng-repeat=\"item in searchCtrl.vimeoResults.data\" item=\"item\" compressed=\"searchCtrl.addOpen\"><button ng-hide=\"searchCtrl.addOpen\" class=\"btn btn-primary btn-sm m-t-xs\" title=\"Preview this video\"><i class=\"fa fa-play\"></i> Open/Preview</button> <button ng-if=\"global.isAdmin || global.isEducator\" ng-hide=\"searchCtrl.addOpen\" class=\"btn btn-primary btn-sm m-t-xs\" ng-click=\"searchCtrl.add(\'Vimeo\', item); $event.stopPropagation();\" title=\"Add this video to course content\"><i class=\"fa fa-plus\"></i> Add to Course Content</button></vimeo-snippet><div spinner-wave=\"\" ng-if=\"searchCtrl.loadingMoreVimeo\">Searching...</div><button class=\"btn btn-white btn-xs\" type=\"button\" ng-click=\"searchCtrl.moreVimeo(searchCtrl.vimeoResults.paging.next)\" ng-if=\"!searchCtrl.loadingMoreVimeo && searchCtrl.vimeoResults.paging.next\" title=\"More from Vimeo\">More from Vimeo...</button><div class=\"forum-title\" ng-if=\"searchCtrl.totalWikipedia\"><div class=\"pull-right forum-desc\"><small>Total results: {{searchCtrl.totalWikipedia}}</small></div><h4><i class=\"fa fa-globe modal-icon\"></i> Results from Wikipedia</h4></div><wikipedia-snippet ng-repeat=\"(key, item) in searchCtrl.wikipediaResults.query.pages\" item=\"item\" compressed=\"searchCtrl.addOpen\"><button ng-hide=\"searchCtrl.addOpen\" class=\"btn btn-primary btn-sm m-t-xs\" title=\"Preview this article\"><i class=\"fa fa-play\"></i> Open/Preview</button> <button ng-if=\"global.isAdmin || global.isEducator\" ng-hide=\"searchCtrl.addOpen\" class=\"btn btn-primary btn-sm m-t-xs\" ng-click=\"searchCtrl.add(\'Wikipedia\', item); $event.stopPropagation();\" title=\"Add this article to course content\"><i class=\"fa fa-plus\"></i> Add to Course Content</button></wikipedia-snippet></div><div spinner-wave=\"\" ng-if=\"searchCtrl.loading\">Searching...</div></div></div><div ng-if=\"(global.isAdmin || global.isEducator) && searchCtrl.addOpen\" class=\"col-xs-6\"><div class=\"ibox\"><div class=\"ibox-title clearfix\"><div class=\"pull-left\" style=\"width:90%\"><ui-select id=\"courseId\" name=\"courseId\" ng-model=\"searchCtrl.addToCourseId\" on-select=\"searchCtrl.courseSelected($item)\" style=\"width:100%\" theme=\"bootstrap\" title=\"Course\"><ui-select-match placeholder=\"Select a course\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"course as course in searchCtrl.courses | filter: $select.search\"><span ng-bind-html=\"course.name | highlight: $select.search\"></span></ui-select-choices></ui-select><ui-select ng-if=\"searchCtrl.courseNodes\" id=\"courseNodeId\" name=\"courseNodeId\" ng-model=\"searchCtrl.addToCourseNodeId\" on-select=\"searchCtrl.courseNodeSelected($item)\" style=\"width:100%\" class=\"m-t-xs\" theme=\"bootstrap\" title=\"Course Structure\"><ui-select-match placeholder=\"Select a structure node\">{{$select.selected | nodeName}}</ui-select-match><ui-select-choices repeat=\"node as node in searchCtrl.courseNodes | filter: $select.search\"><span>{{node | nodeName}}</span></ui-select-choices></ui-select></div><div class=\"pull-right\"><div ibox-tools=\"\" closebox=\"searchCtrl.addOpen=false\"></div></div></div><div class=\"ibox-content\"><div class=\"alert alert-warning\" ng-if=\"searchCtrl.contentList\">Click \"Add Selected\" below to add the selected items to your content list. Once the items are added, you can drag them around to finalize the sequence. Click \"Save\" to confirm.</div><button ng-if=\"searchCtrl.contentList\" class=\"btn btn-primary m-b-xs\" ng-click=\"searchCtrl.addSelected()\" title=\"Add the selected items to this course\'s content\"><i class=\"fa fa-plus\"></i> Add Selected</button> <button buttonspinner=\"\" ng-disabled=\"searchCtrl.saving\" ng-if=\"searchCtrl.unsavedList\" class=\"buttonspinner-button btn btn-primary m-b-xs\" data-style=\"expand-left\" ng-click=\"searchCtrl.save()\" title=\"Confirm and save the selected items to this course\'s content\"><i class=\"fa fa-check\"></i> Save</button><div ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"true\" ng-if=\"!searchCtrl.loadingContent && searchCtrl.contentList\"><ol ui-tree-nodes=\"\" ng-model=\"searchCtrl.contentList\"><li ui-tree-node=\"\" ng-repeat=\"content in searchCtrl.contentList\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\"><i content-icon=\"content.type\"></i> {{content.name}}</div></li></ol></div><button buttonspinner=\"\" ng-disabled=\"searchCtrl.saving\" ng-if=\"searchCtrl.unsavedList\" class=\"buttonspinner-button btn btn-primary m-b-xs\" data-style=\"expand-left\" ng-click=\"searchCtrl.save()\" title=\"Confirm and save the selected items to this course\'s content\"><i class=\"fa fa-check\"></i> Save</button> <a ui-sref=\"base.course.content({id:searchCtrl.currentCourseId,nodeId:searchCtrl.currentNodeId})\" ng-if=\"searchCtrl.contentList\" class=\"btn btn-primary m-b-xs\" title=\"Navigate to Course Content\">Navigate to Course Content <i class=\"fa fa-angle-right\"></i></a><div spinner-wave=\"\" ng-if=\"searchCtrl.loadingContent\">Loading...</div></div></div></div></div></div>");
$templateCache.put("app/timetables/timetables.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>My Timetables</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>My Timetables</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h2></h2><p>View timetables for my classes and courses</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"clients-list\"><div class=\"row\"><div class=\"col-md-6\"><ui-select id=\"timetableId\" name=\"timetableId\" ng-model=\"mytimetablesCtrl.timetableId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"mytimetablesCtrl.timetableIdChanged()\"><ui-select-match placeholder=\"Select a timetable\"><span>{{$select.selected.label}}</span><span ng-if=\"$select.selected.label && $select.selected.startDate\">&nbsp;-&nbsp;</span> <span ng-if=\"$select.selected.startDate\">{{$select.selected.startDate | momentDate}} to {{$select.selected.endDate | momentDate}}</span></ui-select-match><ui-select-choices repeat=\"tt.timetableId as tt in mytimetablesCtrl.timetables | filter: $select.search\"><div><span ng-bind-html=\"tt.label | highlight: $select.search\"></span><span ng-if=\"tt.label && tt.startDate\">&nbsp;-&nbsp;</span> <span ng-if=\"tt.startDate\">{{tt.startDate | momentDate}} to {{tt.endDate | momentDate}}</span></div></ui-select-choices></ui-select></div><div class=\"col-md-6\"><ui-select id=\"courseId\" name=\"courseId\" ng-model=\"mytimetablesCtrl.departmentId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"mytimetablesCtrl.departmentIdChanged()\"><ui-select-match placeholder=\"Select a department\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"dept.departmentId as dept in mytimetablesCtrl.departments | filter: $select.search\"><div ng-bind-html=\"dept.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div ng-if=\"!mytimetablesCtrl.loadingTimetable && mytimetablesCtrl.timetable && mytimetablesCtrl.timetable.length\"><table class=\"table table-striped table-bordered table-hover m-t-sm\"><thead><tr><th></th><th>Monday</th><th>Tuesday</th><th>Wednesday</th><th>Thursday</th><th>Friday</th><th>Saturday</th><th>Sunday</th></tr></thead><tbody><tr ng-repeat=\"timeRow in mytimetablesCtrl.timetable\"><td><strong ng-if=\"timeRow.shortName\">{{timeRow.shortName}}<br></strong> {{timeRow.text}}</td><td ng-repeat=\"day in timeRow.days\"><ul ng-model=\"day.courses\" class=\"unstyled no-paddings\"><li class=\"m-b-xs\" ng-repeat=\"courseObj in day.courses\"><div class=\"label label-primary\">{{courseObj.courseName}} <span ng-if=\"courseObj.node\">&nbsp;&gt;&nbsp;{{courseObj.node | nodeName}}</span></div></li></ul></td></tr></tbody></table></div><div ng-if=\"mytimetablesCtrl.loadingTimetable\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/comment.block.html","<button class=\"btn btn-white btn-sm\" ng-click=\"submitClicked()\" ng-disabled=\"isDisabled\"><i class=\"fa fa-check\"></i> Send</button> <textarea class=\"form-control\" placeholder=\"Write comment...\" ng-model=\"commentText\" ng-disabled=\"isDisabled\"></textarea>");
$templateCache.put("app/components/directives/course.content.edit.html","<div ng-if=\"content.type && content.type!=\'\' && content.type!=\'Javascript\' && !loading\"><div class=\"form-group\" ng-show=\"showPreInst || (content.preInstructions && content.preInstructions != \'\')\"><label for=\"preInstructions\" class=\"control-label\">Enter a pre-instruction (optional: this will help in indexing your content for searches)</label><div id=\"preInstructions\" summernote-editor=\"content.preInstructions\" config=\"summernoteOptions\"></div></div><p><a href=\"javascript:;\" ng-click=\"showPreInst=true\" ng-hide=\"showPreInst || (content.preInstructions && content.preInstructions != \'\')\">+ Add pre-instructions (optional: this will help in indexing your content for searches)</a></p><div class=\"form-group\" ng-show=\"showDesc || (content.description && content.description != \'\')\"><label for=\"description\" class=\"control-label\">Enter a description (optional: this will help in indexing your content for searches)</label><div id=\"description\" summernote-editor=\"content.description\" config=\"summernoteOptions\"></div></div><p><a href=\"javascript:;\" ng-click=\"showDesc=true\" ng-hide=\"showDesc || (content.description && content.description != \'\')\">+ Add a description (optional: this will help in indexing your content for searches)</a></p><div class=\"form-group\" ng-show=\"showPostInst || (content.postInstructions && content.postInstructions != \'\')\"><label for=\"postInstructions\" class=\"control-label\">Enter a post-instruction (optional: this will help in indexing your content for searches)</label><div id=\"postInstructions\" summernote-editor=\"content.postInstructions\" config=\"summernoteOptions\"></div></div><p><a href=\"javascript:;\" ng-click=\"showPostInst=true\" ng-hide=\"showPostInst || (content.postInstructions && content.postInstructions != \'\')\">+ Add post-instructions (optional: this will help in indexing your content for searches)</a></p></div><div ng-if=\"content.type==\'Pdf\' && !loading\"><div class=\"form-group\"><label class=\"control-label block\" ng-if=\"content.fileSize\">PDF File Uploaded: <span ng-if=\"content.fileSize < 1024\">< 1</span><span ng-if=\"content.fileSize >= 1024\">{{(content.fileSize / 1024) | number : 0}}</span> Kb</label> <label class=\"control-label block\" ng-if=\"content.fileSize\">Upload a new file below:</label><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file\"><span class=\"fileinput-new\">Choose PDF File to Upload</span> <span class=\"fileinput-exists\">Choose another File</span> <input ng-if=\"content.fileSize\" type=\"file\" id=\"pdfUpload\" name=\"pdfUpload\" ng-model=\"content.file\" file-model=\"content.file\" set-file-data=\"content.file = value;\"> <input ng-if=\"!content.fileSize\" type=\"file\" id=\"pdfUpload\" name=\"pdfUpload\" ng-model=\"content.file\" file-model=\"content.file\" set-file-data=\"content.file = value;\" file-required=\"\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\"><i class=\"fa fa-close\"></i></a></div><div validation-result=\"\" myform=\"myform\" element=\"pdfUpload\" file-text=\"Please select a file\" ng-if=\"!content.fileSize\"></div></div><div class=\"form-group\"><label for=\"password\" class=\"control-label\">Is the PDF document password protected? Enter the password below: (optional)</label> <input id=\"password\" name=\"password\" type=\"text\" class=\"form-control\" ng-model=\"content.password\" placeholder=\"{{content.contentId ? \'********\' : \'\'}}\"></div><div class=\"form-group\" ng-if=\"content.contentId\"><label for=\"deletePassword\"><input icheck=\"\" name=\"deletePassword\" type=\"checkbox\" ng-model=\"content.deletePassword\"> Delete existing password</label></div><div class=\"form-group\"><label for=\"watermark\" class=\"control-label\">If you wish to add a watermark, enter it below: (optional)</label> <input id=\"watermark\" name=\"watermark\" type=\"text\" class=\"form-control\" ng-model=\"content.watermark\"></div></div><div ng-if=\"content.type==\'RichTextFormat\' && !loading\"><label for=\"contentHtml\" class=\"control-label\">Main text content</label><div summernote-editor=\"content.contentHtml\" config=\"summernoteOptions\"></div><div class=\"btn-group\" ng-show=\"!htmlScope.saving\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"htmlScope.showUrl=true;\" title=\"Import from URL\" ng-show=\"!htmlScope.showUrl\">Import from URL</button><div class=\"input-group\" ng-if=\"htmlScope.showUrl\"><input type=\"text\" class=\"form-control\" placeholder=\"Enter a url...\" ng-model=\"htmlScope.url\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"htmlScope.importUrl()\" title=\"Import!\">Import!</button></span></div></div><div class=\"btn-group\" ng-show=\"!htmlScope.saving\">&nbsp;</div><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" ng-show=\"!htmlScope.saving\"><span class=\"btn btn-default btn-file\"><span class=\"fileinput-new\">Import from Html File Upload</span> <span class=\"fileinput-exists\">Choose another File</span><input type=\"file\" name=\"...\" file-model=\"htmlScope.file\" set-file-data=\"htmlScope.file = value;\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\"><i class=\"fa fa-close\"></i></a> <button type=\"button\" class=\"btn btn-primary fileinput-exists\" ng-click=\"htmlScope.uploadFile()\" title=\"Confirm Upload!\">Confirm Upload!</button></div><div spinner-wave=\"\" ng-if=\"htmlScope.saving\">Importing Html...</div></div><div ng-if=\"content.type==\'LtiApp\' && !loading\"><label for=\"ltiApp\">LTI App</label><ui-select id=\"ltiApp\" name=\"ltiApp\" ng-model=\"content.ltiAppId\" on-select=\"ltiScope.onLtiSelected($item)\" theme=\"bootstrap\" style=\"width:100%\" ng-required=\"true\"><ui-select-match placeholder=\"Choose an app...\">{{$select.selected.appName}}</ui-select-match><ui-select-choices repeat=\"item.ltiAppId as item in ltiScope.getLtiApps() | filter: $select.search\"><img ng-src=\"item.iconUrl\" align=\"left\"> <strong><span ng-bind-html=\"item.appName | highlight: $select.search\"></span></strong><br><span ng-bind-html=\"item.appDescription | highlight: $select.search\"></span></ui-select-choices></ui-select><div validation-result=\"\" myform=\"myform\" element=\"ltiApp\" required-text=\"Please select an app\"></div><div class=\"form-group\"><label for=\"ltiAppEndpoint\" ng-show=\"content.ltiAppId\">Url</label><div class=\"input-group\" ng-show=\"content.ltiAppId\"><span class=\"input-group-addon\">{{ltiApp.endpoint}}</span> <input id=\"ltiAppEndpoint\" name=\"ltiAppEndpoint\" type=\"text\" class=\"form-control\" ng-model=\"content.endpointExtension\"></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-6\"><div class=\"form-group\"><label for=\"widthValue\" class=\"col-sm-6 col-md-3 control-label\">Width</label><div class=\"col-sm-6 col-md-9 clearfix\"><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" id=\"widthValue\" name=\"widthValue\" touch-spin=\"\" spin-options=\"ltiScope.dimensionsOptions\" ng-model=\"content.widthValue\" style=\"width:50px\"></div><div style=\"width:80px\" class=\"pull-left m-l-xs\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-repeat=\"unit in ltiScope.dimensionUnits\" ng-model=\"content.widthUnit\" uib-btn-radio=\"unit\">{{unit}}</label></div></div></div></div></div><div class=\"col-sm-6 col-md-6\"><div class=\"form-group\"><label for=\"heightValue\" class=\"col-sm-6 col-md-3 control-label\">Height</label><div class=\"col-sm-6 col-md-9 clearfix\"><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" id=\"heightValue\" name=\"heightValue\" touch-spin=\"\" spin-options=\"ltiScope.dimensionsOptions\" ng-model=\"content.heightValue\" style=\"width:50px\"></div><div style=\"width:80px\" class=\"pull-left m-l-xs\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-repeat=\"unit in ltiScope.dimensionUnits\" ng-model=\"content.heightUnit\" uib-btn-radio=\"unit\">{{unit}}</label></div></div></div></div></div></div><div class=\"alert alert-info\">LTI Apps load inside an iframe. Please give a default height and use the window.postMessage function to update the iframe\'s height dynamically. The expected json format is:<br>{callback:\'changeHeight\',data:{height:\'00px\'}}</div></div><div ng-if=\"content.type==\'ExternalUrl\' && !loading\"><div class=\"form-group\"><label><span class=\"badge badge-primary\">1</span> Add using a tool</label><div class=\"m-t-xs\"><button ng-click=\"urlScope.openTool(\'Youtube\')\" class=\"btn btn-outline btn-primary dim\" title=\"Youtube\"><i class=\"fa fa-youtube-square\"></i> Youtube</button> <button ng-click=\"urlScope.openTool(\'Vimeo\')\" class=\"btn btn-outline btn-primary dim\" title=\"Vimeo\"><i class=\"fa fa-vimeo-square\"></i> Vimeo</button> <button ng-click=\"urlScope.openTool(\'Wikipedia\')\" class=\"btn btn-outline btn-primary dim\" title=\"Wikipedia\"><i class=\"fa fa-globe\"></i> Wikipedia</button></div><hr></div><div class=\"form-group\"><label for=\"url\" class=\"control-label\"><span class=\"badge badge-primary\">2</span> Enter a Url</label> <input id=\"url\" name=\"url\" type=\"url\" class=\"form-control\" ng-model=\"content.url\" placeholder=\"http://www.example.com/\" required=\"\"><div validation-result=\"\" myform=\"myform\" element=\"url\" required-text=\"Please enter a url for the web page\"></div><div validation-result=\"\" myform=\"myform\" element=\"url\" url-text=\"Please enter a valid web page url\"></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-6\"><div class=\"form-group\"><label for=\"widthValue\" class=\"col-sm-6 col-md-3 control-label\">Width</label><div class=\"col-sm-6 col-md-9 clearfix\"><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" id=\"widthValue\" name=\"widthValue\" touch-spin=\"\" spin-options=\"ltiScope.dimensionsOptions\" ng-model=\"content.widthValue\" style=\"width:50px\"></div><div style=\"width:80px\" class=\"pull-left m-l-xs\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-repeat=\"unit in ltiScope.dimensionUnits\" ng-model=\"content.widthUnit\" uib-btn-radio=\"unit\">{{unit}}</label></div></div></div></div></div><div class=\"col-sm-6 col-md-6\"><div class=\"form-group\"><label for=\"heightValue\" class=\"col-sm-6 col-md-3 control-label\">Height</label><div class=\"col-sm-6 col-md-9 clearfix\"><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" id=\"heightValue\" name=\"heightValue\" touch-spin=\"\" spin-options=\"ltiScope.dimensionsOptions\" ng-model=\"content.heightValue\" style=\"width:50px\"></div><div style=\"width:80px\" class=\"pull-left m-l-xs\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-repeat=\"unit in ltiScope.dimensionUnits\" ng-model=\"content.heightUnit\" uib-btn-radio=\"unit\">{{unit}}</label></div></div></div></div></div></div></div><div ng-if=\"content.type==\'Javascript\' && !loading\"><label for=\"externalScript\">External Script</label><ui-select id=\"externalScript\" name=\"externalScript\" ng-model=\"content.externalScriptId\" on-select=\"scriptScope.onScriptSelected($item)\" theme=\"bootstrap\" style=\"width:100%\" ng-required=\"true\"><ui-select-match placeholder=\"Choose an external script...\">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat=\"item.externalScriptId as item in scriptScope.getScripts() | filter: $select.search\"><span ng-bind-html=\"item.title | highlight: $select.search\"></span></ui-select-choices></ui-select><div validation-result=\"\" myform=\"myform\" element=\"externalScript\" required-text=\"Please select a script\"></div></div><div ng-if=\"content.type==\'Assessment\' && !loading\"><uib-tabset active=\"assessmentScope.activeTab\" ng-class=\"{\'nav-tabs-hidden\':!content.contentId}\"><uib-tab select=\"assessmentTabSelected(\'Settings\')\"><uib-tab-heading><i class=\"fa fa-cog\"></i> Settings</uib-tab-heading><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><label for=\"label\" class=\"col-sm-3 control-label\">Display label</label><div class=\"col-sm-9 col-md-6\"><input name=\"label\" type=\"text\" class=\"form-control\" ng-model=\"content.label\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"correctAnswerPoints\" class=\"col-sm-6 control-label\">Points for correct answer</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" name=\"correctAnswerPoints\" touch-spin=\"\" spin-options=\"assessmentScope.maxAttemptsOptions\" ng-model=\"content.correctAnswerPoints\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"wrongAnswerPoints\" class=\"col-sm-6 control-label\">Points deducted for wrong answer</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" name=\"wrongAnswerPoints\" touch-spin=\"\" spin-options=\"assessmentScope.maxAttemptsOptions\" ng-model=\"content.wrongAnswerPoints\" style=\"width:50px\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"durationType\" class=\"col-sm-4 control-label\">Duration based on</label><div class=\"col-sm-8\"><ui-select ng-model=\"content.durationType\" search-enabled=\"false\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in assessmentScope.durationTypeOptions | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-show=\"content.durationType && content.durationType != \'NonTimed\'\"><label for=\"duration\" class=\"col-sm-4 control-label\">Duration (minutes)</label><div class=\"col-sm-8\"><div style=\"width:130px\"><input type=\"text\" name=\"duration\" touch-spin=\"\" spin-options=\"assessmentScope.durationOptions\" ng-model=\"content.duration\" style=\"width:70px\"></div></div></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><label for=\"forwardOnly\"><input icheck=\"\" name=\"forwardOnly\" type=\"checkbox\" ng-model=\"content.forwardOnly\"> Disallow student from moving back and forth through questions</label></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><label for=\"allowViewSolutions\"><input icheck=\"\" name=\"allowViewSolutions\" type=\"checkbox\" ng-model=\"content.allowViewSolutions\"> Allow student to view solutions at the end</label></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><label for=\"allowResume\"><input icheck=\"\" name=\"allowResume\" type=\"checkbox\" ng-model=\"content.allowResume\"> Allow students to pause and resume assessment at a later time</label></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"maxAttempts\" class=\"col-sm-6 control-label\">Maximum attempts allowed<br>(0 for unlimited)</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" name=\"maxAttempts\" touch-spin=\"\" spin-options=\"assessmentScope.maxAttemptsOptions\" ng-model=\"content.maxAttempts\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\" ng-show=\"content.maxAttempts != 1\"><div class=\"form-group\"><label for=\"durationType\" class=\"col-sm-4 control-label\">Final score based on</label><div class=\"col-sm-8\"><ui-select ng-model=\"content.scoreType\" search-enabled=\"false\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in assessmentScope.scoreTypeOptions | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div></div></uib-tab><uib-tab ng-repeat=\"section in content.sections\" select=\"assessmentScope.assessmentTabSelected(\'Section\', section)\"><uib-tab-heading>{{section.title}} <span class=\"label label-warning\" ng-if=\"!section.assessmentSectionId\">NEW</span></uib-tab-heading><div class=\"panel-body\"><div class=\"btn-group\"><button ng-click=\"section.activeScreenId=-1\" title=\"Section settings\" class=\"btn btn-sm\" ng-class=\"{\'btn-primary\':section.activeScreenId==-1,\'btn-white\':section.activeScreenId>-1}\"><i class=\"fa fa-cog\"></i></button> <button ng-repeat=\"screen in section.screens\" ng-click=\"assessmentScope.showScreen(section, screen, $index)\" title=\"{{screen.assessmentScreenId ? screen.screenLayout == \'Question\' ? screen.questionNumber : \'i\' : \'New\'}}\" class=\"btn btn-sm font-bold\" ng-class=\"{\'btn-primary\':section.activeScreenId==$index,\'btn-white\':section.activeScreenId!=$index}\">{{screen.assessmentScreenId ? screen.screenLayout == \'Question\' ? screen.questionNumber : \'i\' : \'*\'}}</button> <button ng-click=\"assessmentScope.addSectionScreen(section)\" title=\"Add new question or info screen\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-plus\"></i></button></div><div class=\"form-horizontal\" ng-show=\"!section.loading && section.activeScreenId==-1\"><div class=\"form-group\"><label for=\"sectionTitle\" class=\"col-sm-3 control-label\">Title</label><div class=\"col-sm-9 col-md-6\"><input name=\"sectionTitle\" type=\"text\" class=\"form-control\" ng-model=\"section.title\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"sectionCorrectAnswerPoints\" class=\"col-sm-6 control-label\">Points for correct answer</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" name=\"sectionCorrectAnswerPoints\" touch-spin=\"\" spin-options=\"assessmentScope.maxAttemptsOptions\" ng-model=\"section.correctAnswerPoints\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"sectionWrongAnswerPoints\" class=\"col-sm-6 control-label\">Points deducted for wrong answer</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" name=\"sectionWrongAnswerPoints\" touch-spin=\"\" spin-options=\"assessmentScope.maxAttemptsOptions\" ng-model=\"section.wrongAnswerPoints\" style=\"width:50px\"></div></div></div></div></div><div class=\"form-group\" ng-show=\"content.durationType == \'Section\'\"><label for=\"sectionDuration\" class=\"col-sm-3 control-label\">Duration (minutes)</label><div class=\"col-sm-9\"><div style=\"width:130px\"><input type=\"text\" name=\"sectionDuration\" touch-spin=\"\" spin-options=\"assessmentScope.durationOptions\" ng-model=\"section.duration\" style=\"width:70px\"></div></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><label for=\"sectionShuffleQuestions\"><input icheck=\"\" name=\"sectionShuffleQuestions\" type=\"checkbox\" ng-model=\"section.shuffleQuestions\"> Randomly shuffle order of questions</label></div></div></div><div class=\"form-horizontal\" ng-show=\"section.activeScreenId>=0\"><div class=\"form-group\" ng-if=\"!section.activeScreen.assessmentScreenId\"><label for=\"screenLayout\" class=\"col-sm-3 control-label\">New screen type</label><div class=\"col-sm-4\"><ui-select ng-model=\"section.activeScreen.screenLayout\" search-enabled=\"false\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in assessmentScope.screenLayoutOptions | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div ng-if=\"section.activeScreen.screenLayout==\'TextOnly\' && !section.activeScreen.loading\"><div summernote-editor=\"section.activeScreen.textContent\" config=\"summernoteQuestionOptions\"></div></div><div ng-if=\"section.activeScreen.screenLayout==\'Question\' && !section.activeScreen.loading\"><div class=\"form-group\"><label for=\"questionType\" class=\"col-sm-3 control-label\">Question type</label><div class=\"col-sm-4\"><ui-select id=\"questionType\" name=\"questionType\" ng-model=\"section.activeScreen.contentQuestion.questionType\" on-select=\"assessmentScope.questiontypeSelected($item, section)\" search-enabled=\"false\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in assessmentScope.questionTypeOptions | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"section.activeScreen.contentQuestion.questionType==\'Matching\'\"><label for=\"matchingOrderBy\" class=\"col-sm-3 control-label\">Sort answer choices</label><div class=\"col-sm-4\"><ui-select id=\"matchingOrderBy\" name=\"matchingOrderBy\" ng-model=\"section.activeScreen.contentQuestion.matchingOrderBy\" search-enabled=\"false\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in assessmentScope.matchingOrderByOptions | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label for=\"questionContent\" class=\"control-label\">Question text</label><div id=\"questionContent\" name=\"questionContent\" summernote-editor=\"section.activeScreen.contentQuestion.questionContent\" config=\"summernoteQuestionOptions\"></div></div><div ng-if=\"section.activeScreen.contentQuestion.questionType==\'MultipleChoiceSingleAnswer\' || section.activeScreen.contentQuestion.questionType==\'MultipleChoiceMultipleAnswers\'\"><div class=\"form-group\" ng-repeat=\"answer in section.activeScreen.contentQuestion.contentMultipleChoiceAnswers\"><label for=\"isCorrect-{{$index}}\"><input icheck=\"\" id=\"isCorrect-{{$index}}\" name=\"isCorrect\" type=\"radio\" ng-if=\"section.activeScreen.contentQuestion.questionType==\'MultipleChoiceSingleAnswer\'\" ng-value=\"$index\" ng-model=\"section.activeScreen.contentQuestion.selectedAnswer\"><input icheck=\"\" id=\"isCorrect-{{$index}}\" name=\"isCorrect\" type=\"checkbox\" ng-if=\"section.activeScreen.contentQuestion.questionType==\'MultipleChoiceMultipleAnswers\'\" ng-model=\"answer.isCorrect\"></label> <label for=\"answerContent\" class=\"control-label\">Answer choice {{($index + 1)}}</label> <button class=\"btn btn-primary btn-xs\" ng-click=\"assessmentScope.removeAnswerChoice(section.activeScreen.contentQuestion.contentMultipleChoiceAnswers, $index)\" title=\"Remove answer choice\"><i class=\"fa fa-trash\"></i> Remove</button><div id=\"answerContent\" name=\"answerContent\" summernote-editor=\"answer.answerContent\" config=\"summernoteQuestionOptions\"></div></div><button class=\"btn btn-primary btn-sm\" ng-click=\"assessmentScope.addMultipleChoiceAnswer(section.activeScreen.contentQuestion.contentMultipleChoiceAnswers)\" title=\"Add another answer choice\"><i class=\"fa fa-plus\"></i> Add another answer</button></div><div ng-if=\"section.activeScreen.contentQuestion.questionType==\'Matching\'\"><div class=\"row\" ng-repeat=\"option in section.activeScreen.contentQuestion.contentMatchingOptions\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"questionContent\" class=\"control-label\">Left side option text</label><div id=\"optionContent\" name=\"optionContent\" summernote-editor=\"option.optionContent\" config=\"summernoteQuestionOptions\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"questionContent\" class=\"control-label\">Right side matching answer text</label><div id=\"answerContent\" name=\"answerContent\" summernote-editor=\"option.contentMatchingAnswer.answerContent\" config=\"summernoteQuestionOptions\"></div><button class=\"btn btn-primary btn-xs\" ng-click=\"assessmentScope.removeAnswerChoice(section.activeScreen.contentQuestion.contentMatchingOptions, $index)\" title=\"Remove matching pair\"><i class=\"fa fa-trash\"></i> Remove</button></div></div></div><button class=\"btn btn-primary btn-sm\" ng-click=\"assessmentScope.addMatchingOption(section.activeScreen.contentQuestion.contentMatchingOptions)\" title=\"Add another matching pair\"><i class=\"fa fa-plus\"></i> Add another matching pair</button></div><div class=\"form-group\" ng-if=\"section.activeScreen.contentQuestion.questionType==\'Recording\'\"><label for=\"maxLength\" class=\"control-label\">Maximum duration (minutes)</label><div style=\"width:100px\"><input type=\"text\" id=\"maxLength\" name=\"maxLength\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"section.activeScreen.contentQuestion.assessmentRecordings[0].maxLength\" style=\"width:50px\"></div></div><div class=\"form-group\"><label for=\"solution\" class=\"control-label\">Solution</label><div id=\"solution\" name=\"solution\" summernote-editor=\"section.activeScreen.contentQuestion.solution\" config=\"summernoteQuestionOptions\"></div></div></div><div spinner-wave=\"\" ng-if=\"section.activeScreen.loading\"></div></div><div spinner-wave=\"\" ng-if=\"section.loading\"></div></div></uib-tab><button class=\"btn btn-default btn-sm\" ng-click=\"assessmentScope.addAssessmentSection()\"><i class=\"fa fa-plus\"></i></button></uib-tabset></div><div ng-if=\"content.type==\'Assignment\' && !loading\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"dueDate\" class=\"col-sm-6 control-label\">Due date</label><div class=\"col-sm-6 input-group date\"><input type=\"datetime\" id=\"dueDate\" name=\"dueDate\" class=\"form-control\" date-time=\"\" ng-model=\"content.dueDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"maximumPoints\" class=\"col-sm-6 control-label\">Total points</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"maximumPoints\" name=\"maximumPoints\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"content.maximumPoints\" style=\"width:50px\"></div></div></div></div></div><div ng-repeat=\"part in content.parts\"><div ng-if=\"part.type == \'Number\'\" class=\"clearfix\"><div class=\"pull-left\"><i class=\"fa fa-slack fa-2x\"></i>&nbsp;</div><div class=\"pull-left\" style=\"width:100px\"><input type=\"text\" id=\"partNumber\" name=\"partNumber\" touch-spin=\"\" spin-options=\"assignmentScope.numberOptions\" ng-model=\"part.assignmentPartNumber.partNumber\" style=\"width:50px\"></div></div><div ng-if=\"part.type == \'Text\'\"><div class=\"row\"><div class=\"col-md-12\"><div summernote-editor=\"part.assignmentPartText.textContent\" config=\"summernoteOptions\"></div></div></div></div><div ng-if=\"part.type == \'Essay\'\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"maximumPoints\" class=\"col-sm-6 control-label\">Word limit</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"wordLimit\" name=\"wordLimit\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"part.assignmentPartEssay.wordLimit\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"maximumPoints\" class=\"col-sm-6 control-label\">Maximum points</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"maximumPoints\" name=\"maximumPoints\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"part.assignmentPartEssay.maximumPoints\" style=\"width:50px\"></div></div></div></div></div></div><div ng-if=\"part.type == \'Upload\'\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group clearfix\"><label for=\"extensionsAllowed\" class=\"col-sm-3 control-label\">Type of Upload</label><div class=\"col-sm-3\"><ui-select id=\"extensionsAllowed\" name=\"extensionsAllowed\" ng-model=\"part.assignmentPartUpload.extensionsAllowed\" search-enabled=\"false\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in assignmentScope.fileTypeOptions\"><span ng-bind-html=\"item.text\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"maximumPoints\" class=\"col-sm-6 control-label\">Maximum file size (Kb)</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"maxFileSize\" name=\"maxFileSize\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"part.assignmentPartUpload.maxFileSize\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"maximumPoints\" class=\"col-sm-6 control-label\">Maximum points</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"maximumPoints\" name=\"maximumPoints\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"part.assignmentPartUpload.maximumPoints\" style=\"width:50px\"></div></div></div></div></div></div><div ng-if=\"part.type == \'File\'\"><div class=\"row\"><div class=\"col-md-12\"><label ng-show=\"part.assignmentPartFile.fileName\">{{part.assignmentPartFile.fileName}} ({{part.assignmentPartFile.fileType}} | <span ng-if=\"part.assignmentPartFile.fileSize < 1024\">< 1</span><span ng-if=\"part.assignmentPartFile.fileSize >= 1024\">{{(part.assignmentPartFile.fileSize / 1024) | number : 0}}</span> Kb)</label><div class=\"form-group\"><label for=\"fileUpload\">Upload a new file:</label><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-default btn-file\"><span class=\"fileinput-new\">Select file</span><span class=\"fileinput-exists\">Change</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"part.assignmentPartFile.file\" set-file-data=\"part.assignmentPartFile.file = value;\"></span> <a href=\"#\" class=\"input-group-addon btn btn-default fileinput-exists\" data-dismiss=\"fileinput\">Remove</a></div></div></div></div></div><div ng-if=\"part.type == \'Recording\'\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group clearfix\"><label for=\"maxLength\" class=\"col-sm-6 control-label\">Maximum duration (minutes)</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"maxLength\" name=\"maxLength\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"part.assignmentPartRecording.maxLength\" style=\"width:50px\"></div></div></div></div></div></div><hr ng-show=\"content.parts.length > 1 && $index < (content.parts.length - 1)\"></div><p><button class=\"btn btn-success\" type=\"button\" ng-click=\"assignmentScope.addPart(\'Number\')\"><i class=\"fa fa-slack\"></i>&nbsp;Add Number Label</button> <button class=\"btn btn-success\" type=\"button\" ng-click=\"assignmentScope.addPart(\'Text\')\"><i class=\"fa fa-font\"></i>&nbsp;Add Static Text</button> <button class=\"btn btn-success\" type=\"button\" ng-click=\"assignmentScope.addPart(\'File\')\"><i class=\"fa fa-download\"></i>&nbsp;Upload File for Student to Download</button></p><p><button class=\"btn btn-primary\" type=\"button\" ng-click=\"assignmentScope.addPart(\'Essay\')\"><i class=\"fa fa-align-left\"></i>&nbsp;Add Student Essay Entry</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"assignmentScope.addPart(\'Upload\')\"><i class=\"fa fa-upload\"></i>&nbsp;Add Student Upload Entry</button></p></div><div ng-if=\"content.type==\'VideoFile\' && !loading\"><div class=\"form-group\"><label class=\"control-label block\" ng-if=\"content.videoUrl\">Video Uploaded: {{content.fileName}}</label> <label class=\"control-label block\" ng-if=\"content.videoUrl\">Upload a new video below:</label><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file\"><span class=\"fileinput-new\">Choose Video File to Upload</span> <span class=\"fileinput-exists\">Choose another File</span> <input ng-if=\"content.videoUrl\" type=\"file\" id=\"videoUpload\" name=\"videoUpload\" ng-model=\"content.file\" file-model=\"content.file\" set-file-data=\"content.file = value;\"> <input ng-if=\"!content.videoUrl\" type=\"file\" id=\"videoUpload\" name=\"videoUpload\" ng-model=\"content.file\" file-model=\"content.file\" set-file-data=\"content.file = value;\" file-required=\"\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\"><i class=\"fa fa-close\"></i></a></div><div validation-result=\"\" myform=\"myform\" element=\"videoUpload\" file-text=\"Please select a file\" ng-if=\"!content.videoUrl\"></div></div></div><div ng-if=\"content.type==\'AudioFile\' && !loading\"><div class=\"form-group\"><label class=\"control-label block\" ng-if=\"content.audioUrl\">Audio Uploaded: {{content.fileName}}</label> <label class=\"control-label block\" ng-if=\"content.audioUrl\">Upload a new audio below:</label><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file\"><span class=\"fileinput-new\">Choose Audio File to Upload</span> <span class=\"fileinput-exists\">Choose another File</span> <input ng-if=\"content.audioUrl\" type=\"file\" id=\"audioUpload\" name=\"audioUpload\" ng-model=\"content.file\" file-model=\"content.file\" set-file-data=\"content.file = value;\"> <input ng-if=\"!content.audioUrl\" type=\"file\" id=\"audioUpload\" name=\"audioUpload\" ng-model=\"content.file\" file-model=\"content.file\" set-file-data=\"content.file = value;\" file-required=\"\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\"><i class=\"fa fa-close\"></i></a></div><div validation-result=\"\" myform=\"myform\" element=\"audioUpload\" file-text=\"Please select a file\" ng-if=\"!content.audioUrl\"></div></div></div><div spinner-wave=\"\" ng-if=\"loading\"></div>");
$templateCache.put("app/components/directives/course.content.view.html","<div ng-if=\"content.type==\'RichTextFormat\'\"><div class=\"clearfix\" ng-bind-html=\"$root.trustHtml(content.contentHtml)\"></div></div><div ng-if=\"content.type==\'Pdf\'\"><pdf-viewer pdf-url=\"getPdfUrl()\"></pdf-viewer></div><div ng-if=\"content.type==\'LtiApp\'\"><div ng-if=\"content.popout\" class=\"text-center\"><p>This page cannot be opened inline. Please click the button below to open this page in a new window.</p><a ng-href=\"{{\'/LtiApp/\' + content.contentId + \'?emailId=\' + userEmail + \'&otp=\' + content.userOtp}}\" target=\"_blank\" class=\"btn btn-primary\">Open in new window...</a></div><iframe ng-if=\"!content.popout\" ng-src=\"{{\'/LtiApp/\' + content.contentId + \'?emailId=\' + userEmail + \'&otp=\' + content.userOtp}}\" frameborder=\"0\" title=\"{{content.name}}\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\" adaptive-height=\"\" style=\"{{content.widthValue ? \'width:\' + content.widthValue + content.widthUnit + \';\' : \'\'}}{{content.heightValue ? \'height:\' + content.heightValue + content.heightUnit + \';\' : \'\'}}\"></iframe></div><div ng-if=\"content.type==\'ExternalUrl\'\"><div ng-if=\"content.popout\" class=\"text-center\"><p>This web page cannot be opened inline. Please click the button below to open this page in a new window.</p><a ng-href=\"{{$root.trustUrl(content.url)}}\" target=\"_blank\" class=\"btn btn-primary\">Open in new window...</a></div><iframe ng-if=\"!content.popout\" ng-src=\"{{$root.trustUrl(content.url)}}\" frameborder=\"0\" title=\"{{content.name}}\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\" adaptive-height=\"\" style=\"{{content.widthValue ? \'width:\' + content.widthValue + content.widthUnit + \';\' : \'\'}}{{content.heightValue ? \'height:\' + content.heightValue + content.heightUnit + \';\' : \'\'}}\"></iframe></div><div ng-if=\"content.type==\'Assessment\'\"><div class=\"row\"><div class=\"col-lg-8\"><div ng-if=\"content.forwardOnly\">Once you\'ve answered a question, you cannot return to it. You can only move forward to the next question.</div><div ng-if=\"content.sections.length == 1\"><strong>No. of questions:</strong> {{content.sections[0].questionCount}}<br><strong>Points for correct answers:</strong> {{content.sections[0].correctAnswerPoints | number : 0}}<br><strong>Points deducted for wrong answers:</strong> {{content.sections[0].wrongAnswerPoints | number : 0}}<br></div><div ng-if=\"content.durationType==\'Assessment\'\"><strong>Duration:</strong> {{content.duration}} mins</div><div ng-if=\"content.durationType==\'NonTimed\'\">There is no time limit.</div><strong ng-if=\"content.sections.length > 1\">Sections</strong><table ng-if=\"content.sections.length > 1\" class=\"table table-hover\"><tbody><tr><th><strong>Title</strong></th><th><strong>Questions</strong></th><th><strong>Points for correct answers</strong></th><th><strong>Points deducted for wrong answers</strong></th><th ng-if=\"content.durationType==\'Section\'\"><strong>Duration</strong></th></tr><tr ng-repeat=\"section in content.sections\"><td class=\"project-title\">{{section.title}}</td><td class=\"project-title\">{{section.questionCount}} question(s)</td><td class=\"project-title\">{{section.correctAnswerPoints | number : 0}}</td><td class=\"project-title\">{{section.wrongAnswerPoints | number : 0}}</td><td ng-if=\"content.durationType==\'Section\'\" class=\"project-title\">{{section.duration}} mins</td></tr></tbody></table><strong ng-if=\"isEduAdmin && content.submissions.length\">Student submissions</strong><table ng-if=\"isEduAdmin && content.submissions.length\" class=\"table table-hover\"><tbody><tr ng-repeat=\"submission in content.submissions\"><td class=\"project-title\">{{submission.name}}</td><td class=\"project-title\">{{submission.score}} / {{submission.totalPoints}}</td><td class=\"project-title\">{{(submission.pctPoints * 100) | number : 0}} %</td><td><button ng-click=\"reviewAssessment(submission)\" class=\"btn btn-white btn-sm\"><i class=\"fa fa-folder\"></i> View / Review</button></td></tr></tbody></table><strong ng-if=\"isStudent && content.attempts.length\">Past attempts</strong><table ng-if=\"isStudent && content.attempts.length\" class=\"table table-hover\"><tbody><tr ng-repeat=\"attempt in content.attempts\"><td class=\"project-status\"><span class=\"label\" ng-class=\"{\'label-warning\':attempt.status!=\'Ended\',\'label-primary\':attempt.status==\'Ended\'}\">{{attempt.status == \'Ended\' ? \'Completed\' : \'In Progress\'}}</span></td><td class=\"project-title\">Taken - {{attempt.dateStarted | momentDateText}}</td><td class=\"project-actions\"><button ng-click=\"startAssessment(attempt.userAssessmentLogId)\" class=\"btn btn-white btn-sm\" ng-if=\"attempt.status != \'Ended\'\"><i class=\"fa fa-folder\"></i> Resume</button></td></tr></tbody></table></div></div><div class=\"text-center\" ng-if=\"isStudent\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"startAssessment()\" title=\"{{(\'Start {0}\').replace(\'{0}\', content.label)}}\">{{(\'Start {0}\').replace(\'{0}\', content.label)}}</button></div></div><div ng-if=\"content.type==\'Javascript\'\"><embed-script src=\"content.url\"></embed-script></div><div ng-if=\"content.type==\'Assignment\'\"><section ng-if=\"!isStudent\"><h3>Student Submissions</h3><span ng-if=\"!content.submissionsCount\"><em>This assignment has not yet been submitted by any student</em></span><table class=\"table table-hover no-margins\"><thead><tr><th>Student</th><th>Date Submitted</th><th>Reviewer</th><th>Results</th><th></th></tr></thead><tbody><tr ng-repeat=\"submission in content.submissions[assignmentScope.currentSubmissionPage]\"><td>{{submission.student}}</td><td>{{submission.dateSubmitted | momentDateTime}}</td><td ng-if=\"submission.reviewer\">{{submission.reviewer}}</td><td ng-if=\"submission.reviewer\">{{submission.pointsAwarded | number : 0}} / {{submission.maximumPoints | number : 0}}</td><td ng-if=\"!submission.reviewer\" colspan=\"2\"><em>Not yet reviewed</em></td><td><button ng-click=\"assignmentScope.openSubmission(submission.assignmentSubmissionId, submission)\" class=\"btn btn-white btn-sm\"><i class=\"fa fa-folder\"></i> View</button></td></tr></tbody></table><div spinner-wave=\"\" ng-if=\"assignmentScope.loadingSubmissions\"></div><uib-pagination total-items=\"content.submissionsCount\" items-per-page=\"10\" ng-model=\"assignmentScope.currentSubmissionPage\" ng-change=\"assignmentScope.loadSubmissions()\" max-size=\"5\" force-ellipses=\"true\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></section><section ng-if=\"!isStudent && assignmentScope.currentSubmission && !assignmentScope.loadingSubmission\"><hr><h3>Submission: {{assignmentScope.currentSubmission.student}} - {{assignmentScope.currentSubmission.dateSubmitted | momentDateTime}}</h3><h4 ng-if=\"assignmentScope.currentSubmission.reviewer\">Review: {{assignmentScope.currentSubmission.reviewer}} - {{assignmentScope.currentSubmission.dateReviewed | momentDateTime}}</h4><form name=\"reviewAssignment\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"pointsAwarded\" class=\"col-sm-6 control-label\">Points given</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"pointsAwarded\" name=\"pointsAwarded\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"assignmentScope.currentSubmission.pointsAwarded\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><label class=\"control-label\">Total points:</label>&nbsp;<label>{{content.maximumPoints}}</label></div></div><div class=\"row\"><div class=\"col-md-12\"><label>Overall Review Notes:</label><div summernote=\"\" class=\"summernote\" config=\"summernoteOptions\" ng-model=\"assignmentScope.currentSubmission.reviewerNotes\"></div></div></div><hr ng-show=\"content.parts.length\"><div ng-repeat=\"part in content.parts\" ng-if=\"part.type != \'File\'\"><div ng-if=\"part.type == \'Number\'\" class=\"clearfix\"><i class=\"fa fa-slack fa-2x\"></i>&nbsp;<label class=\"lead m-b-none\">{{part.assignmentPartNumber.partNumber}}</label></div><div ng-if=\"part.type == \'Text\'\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"clearfix\" ng-bind-html=\"$root.trustHtml(part.assignmentPartText.textContent)\"></div></div></div></div><div ng-if=\"part.type == \'Essay\'\"><h3>Essay Submission:</h3><div class=\"row\"><div class=\"col-md-12\"><div class=\"clearfix\" ng-bind-html=\"$root.trustHtml(assignmentScope.currentSubmission.essays[part.assignmentPartId].essayContent)\"></div></div></div><hr class=\"hr-line-dashed\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"pointsAwarded-{{part.assignmentPartId}}\" class=\"col-sm-6 control-label\">Points given</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"pointsAwarded-{{part.assignmentPartId}}\" name=\"pointsAwarded-{{part.assignmentPartId}}\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"assignmentScope.currentSubmission.essays[part.assignmentPartId].pointsAwarded\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"control-label\">Maximum points:</label>&nbsp;<label>{{part.assignmentPartEssay.maximumPoints}}</label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label>Review Notes:</label><div summernote=\"\" class=\"summernote\" config=\"summernoteOptions\" ng-model=\"assignmentScope.currentSubmission.essays[part.assignmentPartId].reviewerNotes\"></div></div></div></div><div ng-if=\"part.type == \'Upload\'\"><h3>Upload Submission:</h3><div class=\"row\"><div class=\"col-md-12\"><label ng-show=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileName\">File Submitted ({{assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileType}} | <span ng-if=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileSize < 1024\">< 1</span><span ng-if=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileSize >= 1024\">{{(assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileSize / 1024) | number : 0}}</span> Kb)</label>&nbsp;-&nbsp;<div class=\"m-t-sm m-b-sm\"><a ng-show=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileName\" href=\"{{cdnBase}}/Api/File/AssignmentSubmission/{{assignmentScope.currentSubmission.assignmentSubmissionId}}/{{part.assignmentPartId}}\" class=\"btn btn-success\" target=\"_blank\" title=\"Download Submitted File\"><i class=\"fa fa-download\"></i>&nbsp;Download</a> <button ng-disabled=\"assignmentScope.copyingImage\" ng-click=\"assignmentScope.shareSubmission(assignmentScope.currentSubmission.assignmentSubmissionId, part.assignmentPartId)\" ng-show=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].fileName\" class=\"btn btn-primary\" title=\"Share Image\"><i class=\"fa fa-share-alt\"></i>&nbsp;Share to Feed</button></div><div class=\"submission-image\"><img src=\"{{cdnBase}}/Api/File/AssignmentSubmission/{{assignmentScope.currentSubmission.assignmentSubmissionId}}/{{part.assignmentPartId}}\"></div></div></div><hr class=\"hr-line-dashed\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"pointsAwarded-{{part.assignmentPartId}}\" class=\"col-sm-6 control-label\">Points given</label><div class=\"col-sm-6\"><div style=\"width:100px\"><input type=\"text\" id=\"pointsAwarded-{{part.assignmentPartId}}\" name=\"pointsAwarded-{{part.assignmentPartId}}\" touch-spin=\"\" spin-options=\"assignmentScope.pointsOptions\" ng-model=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].pointsAwarded\" style=\"width:50px\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"control-label\">Maximum points:</label>&nbsp;<label>{{part.assignmentPartUpload.maximumPoints}}</label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label>Review Notes:</label><div summernote=\"\" class=\"summernote\" config=\"summernoteOptions\" ng-model=\"assignmentScope.currentSubmission.uploads[part.assignmentPartId].reviewerNotes\"></div></div></div></div><hr ng-show=\"content.parts.length > 1 && $index < (content.parts.length - 1)\"></div><p><button buttonspinner=\"\" ng-disabled=\"assignmentScope.savingReview\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary\" type=\"button\" ng-click=\"assignmentScope.saveReview()\"><i class=\"fa fa-check\"></i>&nbsp;Save Review</button></p></form></section><div spinner-wave=\"\" ng-if=\"assignmentScope.loadingSubmission\"></div><form name=\"submitAssignment\" ng-hide=\"!isStudent && (assignmentScope.loadingSubmission || assignmentScope.currentSubmission)\"><h3 ng-if=\"!isStudent\">Preview</h3><h4 ng-if=\"content.submission.reviewed\">{{(\'Reviewed by {0}\').replace(\'{0}\', content.submission.reviewer)}}</h4><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\">Due date:</label>&nbsp;<label>{{content.dueDate | momentDate}}</label></div><div class=\"col-md-6\"><label class=\"control-label\">Total points:</label>&nbsp;<label><strong ng-if=\"content.submission.reviewed\">{{content.submission.pointsAwarded}}&nbsp;/&nbsp;</strong>{{content.maximumPoints}}</label></div></div><div class=\"row\" ng-if=\"content.submission.reviewed\"><div class=\"col-md-12 border-left\"><label class=\"control-label\">Overall reviewer comments:</label><div ng-bind-html=\"$root.trustHtml(content.submission.reviewerNotes)\" class=\"text-danger clearfix\"></div></div></div><hr ng-show=\"content.parts.length\"><div ng-repeat=\"part in content.parts\"><div ng-if=\"part.type == \'Number\'\" class=\"clearfix\"><i class=\"fa fa-slack fa-2x\"></i>&nbsp;<label class=\"lead m-b-none\">{{part.assignmentPartNumber.partNumber}}</label></div><div ng-if=\"part.type == \'Text\'\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"clearfix\" ng-bind-html=\"$root.trustHtml(part.assignmentPartText.textContent)\"></div></div></div></div><div ng-if=\"part.type == \'Essay\'\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"control-label\">Word limit:</label>&nbsp;<label>{{part.assignmentPartEssay.wordLimit}}</label></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"control-label\" ng-if=\"!content.submission.reviewed\">Maximum points:</label><label class=\"control-label\" ng-if=\"content.submission.reviewed\">Points:</label>&nbsp;<label><strong ng-if=\"content.submission.reviewed\">{{content.submission.essays[part.assignmentPartId].pointsAwarded}}&nbsp;/&nbsp;</strong>{{part.assignmentPartEssay.maximumPoints}}</label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-if=\"!content.submission.submitted\" summernote=\"\" class=\"summernote\" config=\"summernoteOptions\" ng-model=\"content.submission.essays[part.assignmentPartId].essayContent\"></div><div ng-if=\"content.submission.submitted\" class=\"clearfix\" ng-bind-html=\"$root.trustHtml(content.submission.essays[part.assignmentPartId].essayContent)\"></div></div></div><div class=\"row\" ng-if=\"content.submission.reviewed\"><div class=\"col-md-12 border-left\"><label class=\"control-label\">Reviewer comments:</label><div ng-bind-html=\"$root.trustHtml(content.submission.essays[part.assignmentPartId].reviewerNotes)\" class=\"text-danger clearfix\"></div></div></div><button buttonspinner=\"\" ng-if=\"!content.submission.submitted\" ng-disabled=\"content.saving\" ng-hide=\"content.submitting\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-success btn-sm\" type=\"button\" ng-click=\"assignmentScope.save()\"><i class=\"fa fa-save\"></i>&nbsp;Save</button></div><div ng-if=\"part.type == \'Upload\'\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"control-label\">Maximum file size (Kb):</label>&nbsp;<label>{{part.assignmentPartUpload.maxFileSize}}</label></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label class=\"control-label\" ng-if=\"!content.submission.reviewed\">Maximum points:</label><label class=\"control-label\" ng-if=\"content.submission.reviewed\">Points:</label>&nbsp;<label><strong ng-if=\"content.submission.reviewed\">{{content.submission.uploads[part.assignmentPartId].pointsAwarded}}&nbsp;/&nbsp;</strong>{{part.assignmentPartUpload.maximumPoints}}</label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"submission-image-panel\" ng-if=\"part.assignmentPartUpload.extensionsAllowed==\'Image\'\"><div class=\"m-b-sm\" ng-if=\"content.submission.uploads[part.assignmentPartId].fileName\"><label>Image Submitted ({{content.submission.uploads[part.assignmentPartId].fileType}} | <span ng-if=\"content.submission.uploads[part.assignmentPartId].fileSize < 1024\">< 1</span><span ng-if=\"content.submission.uploads[part.assignmentPartId].fileSize >= 1024\">{{(content.submission.uploads[part.assignmentPartId].fileSize / 1024) | number : 0}}</span> Kb)</label><div class=\"submission-image\"><img src=\"{{cdnBase}}/Api/File/MyAssignmentSubmission/{{content.contentId}}/{{userId}}/{{part.assignmentPartId}}?t={{ts}}\"></div></div><div class=\"form-group\" ng-if=\"!content.submission.submitted\"><label for=\"fileUpload\">{{content.submission.uploads[part.assignmentPartId].fileName ? \'Re-upload a new image here\' : \'Upload your image here\'}}</label><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-default btn-file\"><span class=\"fileinput-new\">Select file</span><span class=\"fileinput-exists\">Change</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"content.submission.uploads[part.assignmentPartId].file\" set-file-data=\"content.submission.uploads[part.assignmentPartId].file = value;assignmentScope.save();\"></span> <a href=\"#\" class=\"input-group-addon btn btn-default fileinput-exists\" data-dismiss=\"fileinput\">Remove</a></div></div></div><div ng-if=\"part.assignmentPartUpload.extensionsAllowed!=\'Image\'\"><div class=\"m-b-sm\" ng-if=\"content.submission.uploads[part.assignmentPartId].fileName\"><label>File Submitted ({{content.submission.uploads[part.assignmentPartId].fileType}} | <span ng-if=\"content.submission.uploads[part.assignmentPartId].fileSize < 1024\">< 1</span><span ng-if=\"content.submission.uploads[part.assignmentPartId].fileSize >= 1024\">{{(content.submission.uploads[part.assignmentPartId].fileSize / 1024) | number : 0}}</span> Kb)</label></div><div class=\"form-group\" ng-if=\"!content.submission.submitted\"><label for=\"fileUpload\">{{content.submission.uploads[part.assignmentPartId].fileName ? \'Re-upload a new file here\' : \'Upload your file here\'}}</label><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-default btn-file\"><span class=\"fileinput-new\">Select file</span><span class=\"fileinput-exists\">Change</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"content.submission.uploads[part.assignmentPartId].file\" set-file-data=\"content.submission.uploads[part.assignmentPartId].file = value;assignmentScope.save();\"></span> <a href=\"#\" class=\"input-group-addon btn btn-default fileinput-exists\" data-dismiss=\"fileinput\">Remove</a></div></div></div></div></div><div class=\"row\" ng-if=\"content.submission.reviewed\"><div class=\"col-md-12 border-left\"><label class=\"control-label\">Reviewer comments:</label><div ng-bind-html=\"$root.trustHtml(content.submission.uploads[part.assignmentPartId].reviewerNotes)\" class=\"text-danger clearfix\"></div></div></div></div><div ng-if=\"part.type == \'File\'\"><a ng-show=\"part.assignmentPartFile.fileName\" href=\"{{cdnBase}}/Api/File/Assignment/{{content.contentId}}/{{part.assignmentPartId}}\" class=\"btn btn-success\" target=\"_blank\"><i class=\"fa fa-download\"></i>&nbsp;Download {{content.name}}-{{part.sequenceNumber}}.{{part.assignmentPartFile.fileType}} ({{part.assignmentPartFile.fileType}} | <span ng-if=\"part.assignmentPartFile.fileSize < 1024\">< 1</span><span ng-if=\"part.assignmentPartFile.fileSize >= 1024\">{{(part.assignmentPartFile.fileSize / 1024) | number : 0}}</span> Kb)</a></div><div ng-if=\"part.type == \'Recording\'\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\" ng-if=\"!content.submission.submitted && (!content.submission.recordings || !content.submission.recordings[part.assignmentPartId] || !content.submission.recordings[part.assignmentPartId].url || content.submission.recordings[part.assignmentPartId].rerecord) && !content.submission.recordings[part.assignmentPartId].upload\"><video-js max-length=\"part.assignmentPartRecording.maxLength\" on-recorded=\"assignmentScope.onRecordingDone(data, part.assignmentPartId)\"></video-js><p ng-if=\"assignmentScope.recordings[part.assignmentPartId]\">Video recorded. Please click Save or Submit Assignment below to upload the video.</p><p ng-if=\"content.submission.recordings[part.assignmentPartId].rerecord\" class=\"m-t-sm\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"assignmentScope.cancelReRecord(part.assignmentPartId)\">Cancel</button></p></div><div class=\"text-center m-b-lg\" ng-if=\"content.submission.recordings && content.submission.recordings[part.assignmentPartId] && content.submission.recordings[part.assignmentPartId].upload && !content.submission.recordings[part.assignmentPartId].upload.done\"><strong>{{content.submission.recordings[part.assignmentPartId].upload.alert || \'Please wait while your video is being uploaded:\'}}</strong><br><uib-progressbar value=\"content.submission.recordings[part.assignmentPartId].upload.progress\" type=\"warning\" class=\"progress-striped active\" title=\"{{content.submission.recordings[part.assignmentPartId].upload.progress | number : 0}}% uploaded\"><span style=\"color:white; white-space:nowrap;\">{{content.submission.recordings[part.assignmentPartId].upload.progress | number : 0}}%</span></uib-progressbar></div><div class=\"m-b-lg\" spinner-wave=\"\" ng-if=\"content.submission.recordings && content.submission.recordings[part.assignmentPartId].upload && content.submission.recordings[part.assignmentPartId].upload.done && !content.submission.recordings[part.assignmentPartId].url\">Upload complete, processing your video...<br><i>This might take a while. You can go ahead and carry out other tasks. We will notify you on screen and via email when your video has been processed.</i></div><div ng-if=\"content.submission.recordings && content.submission.recordings[part.assignmentPartId].url && !content.submission.recordings[part.assignmentPartId].rerecord\"><p ng-if=\"!content.submission.submitted\">Recording saved. You may re-record the video until you submit the assignment. <button class=\"btn btn-success\" type=\"button\" ng-click=\"assignmentScope.reRecord(part.assignmentPartId)\">Re-record</button></p></div></div></div><div class=\"row\" ng-if=\"content.submission.reviewed\"><div class=\"col-md-12 border-left\"><label class=\"control-label\">Reviewer comments:</label><div ng-bind-html=\"$root.trustHtml(content.submission.recordings[part.assignmentPartId].reviewerNotes)\" class=\"text-danger clearfix\"></div></div></div></div><hr ng-show=\"content.parts.length > 1 && $index < (content.parts.length - 1)\"></div><div ng-if=\"isStudent && (!content.submission || !content.submission.submitted)\"><hr><button buttonspinner=\"\" ng-disabled=\"content.submitting\" ng-hide=\"content.saving\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary\" type=\"button\" ng-click=\"assignmentScope.submit()\"><i class=\"fa fa-check\"></i>&nbsp;Submit Assignment</button></div></form></div><div ng-if=\"content.type==\'VideoFile\'\"><div class=\"text-center\" ng-if=\"isEduAdmin && content.upload && !content.upload.done\"><strong>{{content.upload.alert || \'Please wait while your video is being uploaded:\'}}</strong><br><uib-progressbar value=\"content.upload.progress\" type=\"warning\" class=\"progress-striped active\" title=\"{{content.upload.progress | number : 0}}% uploaded\"><span style=\"color:white; white-space:nowrap;\">{{content.upload.progress | number : 0}}%</span></uib-progressbar></div><div spinner-wave=\"\" ng-if=\"isEduAdmin && ((content.upload && content.upload.done && !content.published) || (!content.upload && !content.published))\">Upload complete, processing your video...<br><i>This might take a while. You can go ahead and carry out other tasks. We will notify you on screen and via email when your video has been processed.</i></div><div ng-if=\"(isEduAdmin && content.published && content.videoUrl) || (!isEduAdmin && content.videoUrl)\"><div class=\"azuremediaplayer amp-default-skin\"><video video-data=\"content\" controls=\"\"><source src=\"\"></video></div></div></div><div ng-if=\"content.type==\'AudioFile\'\"><div class=\"text-center\" ng-if=\"isEduAdmin && content.upload && !content.upload.done\"><strong>{{content.upload.alert || \'Please wait while your audio is being uploaded:\'}}</strong><br><uib-progressbar value=\"content.upload.progress\" type=\"warning\" class=\"progress-striped active\" title=\"{{content.upload.progress | number : 0}}% uploaded\"><span style=\"color:white; white-space:nowrap;\">{{content.upload.progress | number : 0}}%</span></uib-progressbar></div><div spinner-wave=\"\" ng-if=\"isEduAdmin && ((content.upload && content.upload.done && !content.published) || (!content.upload && !content.published))\">Upload complete, processing your audio...<br><i>This might take a while. You can go ahead and carry out other tasks. We will notify you on screen and via email when your audio has been processed.</i></div><audio audio-data=\"content\" controls=\"\"><source src=\"\"></audio></div>");
$templateCache.put("app/components/directives/iboxtools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><span ng-transclude=\"\"></span> <a ng-click=\"showhide()\" title=\"Toggle visibility\"><i class=\"fa\" ng-class=\"{\'fa-chevron-down\': defaultHidden, \'fa-chevron-up\': !defaultHidden}\"></i></a> <a ng-click=\"fullscreen()\" title=\"Expand or restore\" ng-if=\"canExpand\"><i class=\"fa fa-expand\"></i></a><a ng-click=\"closebox()\" title=\"Remove\" ng-if=\"!disableClose\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/directives/pdf.viewer.html","<ng-pdf template-url=\"./app/components/directives/pdf.viewer.template.html\" scale=\"page-fit\"></ng-pdf><canvas class=\"m-t-md\" id=\"pdf-canvas\"></canvas>");
$templateCache.put("app/components/directives/pdf.viewer.template.html","<nav ng-class=\"getNavStyle(scroll)\"><div class=\"row\"><div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-12\"><button ng-click=\"goPrevious()\" class=\"btn btn-primary\"><span>&lt;</span></button> <button ng-click=\"goNext()\" class=\"btn btn-primary\"><span>&gt;</span></button> <button ng-click=\"zoomIn()\" class=\"btn btn-primary\"><span>+</span></button> <button ng-click=\"fit()\" class=\"btn btn-primary\"><span>100%</span></button> <button ng-click=\"zoomOut()\" class=\"btn btn-primary\"><span>-</span></button></div><div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon\">Page:</span> <input type=\"text\" class=\"form-control\" ng-model=\"pageNum\" min=\"1\"> <span class=\"input-group-addon\">/ {{pageCount}}</span></div></div></div></nav><hr>{{loading}}");
$templateCache.put("app/components/directives/recipients.html","<ui-select multiple=\"\" ng-model=\"recipientList\" theme=\"bootstrap\" title=\"Recipients\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in people | filter: $select.search\"><i class=\"fa\" ng-class=\"{\'fa-user\':person.type==\'U\',\'fa-users\':person.type==\'G\'||person.type==\'D\'}\"></i> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select>");
$templateCache.put("app/components/directives/spinner.circle.html","<div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div>");
$templateCache.put("app/components/directives/spinner.wave.html","<div class=\"sk-spinner sk-spinner-wave\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div><div class=\"text-center\"><span ng-transclude=\"\"></span></div>");
$templateCache.put("app/components/directives/summernote.editor.html","<div summernote=\"\" class=\"summernote\" config=\"config\" ng-model=\"summernoteEditor\" on-image-upload=\"imageUpload(files)\" editor=\"editor\"></div>");
$templateCache.put("app/components/directives/validation.result.html","<div class=\"m-t-xs\" ng-show=\"myform[element].$invalid && myform.$submitted\"><small class=\"text-danger\" ng-if=\"requiredText && myform[element].$error.required\">{{requiredText}}</small> <small class=\"text-danger\" ng-if=\"emailText && myform[element].$error.email\">{{emailText}}</small> <small class=\"text-danger\" ng-if=\"urlText && myform[element].$error.url\">{{urlText}}</small> <small class=\"text-danger\" ng-if=\"fileText && myform[element].$error.file\">{{fileText}}</small> <small class=\"text-danger\" ng-if=\"arrayText && myform[element].$error.array\">{{arrayText}}</small> <small class=\"text-danger\" ng-if=\"matchingText && myform[element].$error.matching\">{{matchingText}}</small></div>");
$templateCache.put("app/components/directives/videojs.html","<video class=\"video-js vjs-default-skin\"></video>");
$templateCache.put("app/components/common/content.html","<toaster-container></toaster-container><div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div><div class=\"small-chat-box ng-small-chat fadeInRight animated\" ng-show=\"(global.myState.name!=\'base.chatroom\' || (global.myState.name==\'base.chatroom\' && global.myParams.id != global.activeChat.id)) && global.activeChat && global.activeChat.openChat\"><div class=\"heading\" draggable=\"true\"><small class=\"pull-right\"><i class=\"fa fa-close\" ng-click=\"global.activeChat.openChat=false\"></i></small> <small class=\"pull-right m-r-xs\"><a ui-sref=\"base.chatroom({id:global.activeChat.id})\"><i class=\"fa fa-square-o\"></i></a></small> {{global.activeChat.name}}</div><div class=\"content\" chat-slim-scroll=\"\"><div ng-class=\"{\'left\': message.userId != global.user.userId, \'right\': message.userId == global.user.userId}\" ng-repeat=\"message in global.activeChat.messages\"><div class=\"author-name\">{{message.userId == global.user.userId ? \'Me\' : global.chatUsers[message.userId].name}} <small class=\"chat-date\">{{message.dateSent | momentDateTime}}</small></div><div class=\"chat-message active\" ng-bind-html=\"trustHtml(message.message)\"></div></div></div><div class=\"form-chat\"><div class=\"input-group input-group-sm\"><input type=\"text\" class=\"form-control\" ng-model=\"global.activeChat.newMessage\" on-enter=\"global.sendMessage(global.activeChat)\"> <span class=\"input-group-btn\"><button ng-disabled=\"global.activeChat.sending\" class=\"btn btn-primary\" type=\"button\" title=\"Send Message\" ng-click=\"global.sendMessage(global.activeChat)\">Send</button></span></div></div></div><div id=\"small-chat\" ng-click=\"chat.openChat = !chat.openChat;global.activeChat=chat;chat.newCount=0\" ng-repeat=\"(id, chat) in global.activeChats\" ng-show=\"global.myState.name!=\'base.chatroom\' || (global.myState.name==\'base.chatroom\' && global.myParams.id != chat.id)\"><span class=\"badge badge-warning pull-right\" ng-show=\"chat.newCount\">{{chat.newCount}}</span> <a class=\"open-small-chat\"><i class=\"fa fa-comments\"></i></a></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\"></div><div><strong>Copyright Core LMS</strong> &copy; {{main.currentYear}}</div></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div ng-if=\"main.user.role!=\'\'\" class=\"profile-element\" uib-dropdown=\"\"><img img-placeholder=\"user\" alt=\"{{main.user.userName}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{main.user.profilePic}}\"> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{main.user.userName}}</strong></span> <span class=\"text-muted text-xs block\"><b class=\"caret\"></b> {{main.user.designation}}</span> <span ng-if=\"main.user.studentId\" class=\"text-xs block\">ID No.: {{main.user.studentId}}</span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a ui-sref=\"base.profile\" lang=\"\">Profile</a></li><li><a ui-sref=\"base.mailbox.inbox\" lang=\"\">Messages</a></li><li class=\"divider\"></li><li><a href=\"\" ng-click=\"main.signOut()\" lang=\"\">Sign Out</a></li></ul></div><div class=\"logo-element\"><img img-placeholder=\"user\" alt=\"{{main.user.userName}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{main.user.profilePic}}\"></div></li><li ui-sref-active=\"active\"><a ui-sref=\"base.main\"><i class=\"fa fa-university\"></i> <span class=\"nav-label\" lang=\"\">Home</span></a></li><li ui-sref-active=\"active\" ng-if=\"main.user.role==\'SuperAdmin\'\"><a href=\"#\"><i class=\"fa fa-cog\"></i> <span class=\"nav-label\" lang=\"\">Manage</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'manage\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"base.manage.settings\" lang=\"\">Institution Settings</a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.manage.admins\" lang=\"\">System Admins</a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.manage.users\" lang=\"\">Departments and Users</a></li><li ng-if=\"false\" ui-sref-active=\"active\"><a ui-sref=\"base.manage.themes\" lang=\"\">Themes and Scripts</a></li><li ng-if=\"false\" ui-sref-active=\"active\"><a ui-sref=\"base.manage.timetables\" lang=\"\">Timetables</a></li><li ng-if=\"false\" ui-sref-active=\"active\"><a ui-sref=\"base.manage.apps\" lang=\"\">External Apps</a></li><li ng-if=\"false\" ui-sref-active=\"active\"><a ui-sref=\"base.manage.oauthusers\" lang=\"\">External OAuth Users</a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.manage.emailtemplates\" lang=\"\">Email Templates</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"base.profile\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\" lang=\"\">My Profile</span></a></li><li ui-sref-active=\"active\" ng-if=\"false && main.user.role!=\'\'\"><a ui-sref=\"base.mailbox.inbox\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\" lang=\"\">Messages</span><span class=\"label label-warning pull-right\">0/15</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.courses\"><i class=\"fa fa-graduation-cap\"></i> <span class=\"nav-label\" lang=\"\">Modules</span> <span ng-if=\"main.currentCourse()\" class=\"fa arrow\"></span></a><ul ng-if=\"main.currentCourse()\" class=\"nav nav-second-level expand\" ng-class=\"{in: $state.includes(\'course\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"base.course.index({id:main.currentCourse().courseId})\">{{main.currentCourse().name}}</a></li><li ui-sref-active=\"active\" ng-repeat=\"node in main.currentCourseStructure()\"><a ui-sref=\"base.course.content({id:main.currentCourse().courseId,nodeId:node.id})\"><i class=\"fa fa-caret-right\"></i> <span>{{node | nodeName}}</span></a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"false && main.user.role!=\'\' && main.user.role!=\'SuperAdmin\'\"><a ui-sref=\"base.timetables.index\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\" lang=\"\">Schedule</span></a></li><li ui-sref-active=\"active\" ng-if=\"false && main.user.role==\'Educator\'\"><a ui-sref=\"base.attendance.index\"><i class=\"fa fa-check-square-o\"></i> <span class=\"nav-label\" lang=\"\">Classrooms</span></a></li><li ui-sref-active=\"active\" ng-if=\"false && main.user.role!=\'\'\"><a ui-sref=\"base.gradebook.index\"><i class=\"fa fa-book\"></i> <span class=\"nav-label\" lang=\"\">Feedback</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.planner.index\"><i class=\"fa fa-calendar\"></i> <span class=\"nav-label\" lang=\"\">{{main.user.role==\'\' ? \'My Classes\' : \'Planner\' }}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.feed({type:\'Institution\',id:\'\'})\"><i class=\"fa fa-comment\"></i> <span class=\"nav-label\" lang=\"\">Social Feed</span></a></li><li ui-sref-active=\"active\" ng-if=\"false && main.user.role!=\'\'\"><a href=\"#\"><i class=\"fa fa-comment\"></i> <span class=\"nav-label\" lang=\"\">Social Feeds</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level expand\" ng-class=\"{in: $state.includes(\'feed\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"base.feed({type:\'Institution\',id:\'\'})\" lang=\"\">General Feed</a></li><li ui-sref-active=\"active\" ng-repeat=\"(key, value) in global.feeds.departments\"><a ui-sref=\"base.feed({type:\'Department\',id:key})\">{{value}}</a></li><li ui-sref-active=\"active\" ng-repeat=\"(key, value) in global.feeds.groups\"><a ui-sref=\"base.feed({type:\'Group\',id:key})\">{{value}}</a></li><li ui-sref-active=\"active\" ng-repeat=\"(key, value) in global.feeds.courses\"><a ui-sref=\"base.feed({type:\'Course\',id:key})\">{{value}}</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"false && main.user.role!=\'\'\"><a href=\"#\"><i class=\"fa fa-comments\"></i> <span class=\"nav-label\" lang=\"\">Direct Chats</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level expand\" ng-class=\"{in: $state.includes(\'chatroom\')}\"><li ui-sref-active=\"active\" ng-repeat=\"chatroom in global.chatrooms\"><a ui-sref=\"base.chatroom({id:chatroom.chatroomId})\">{{chatroom.name}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"base.chatroom({id:\'\'})\">+ New Chat</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form class=\"navbar-form-custom\" ng-if=\"false && main.user.role!=\'\'\"><div class=\"form-group\"><input type=\"text\" ng-model=\"global.globalSearch\" on-enter=\"global.onGlobalSearch()\" placeholder=\"Search for something...\" class=\"form-control top-search-input\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right pull-right\"><li uib-dropdown=\"\" ng-if=\"false\"><a uib-dropdown-toggle=\"\" href=\"\"><b class=\"caret\"></b> <span>{{main.currentLocale ? main.currentLocale.short : \'--\'}}</span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li ng-repeat=\"locale in main.locales\"><a href=\"#\" ng-click=\"main.changeMyLocale(locale.key)\">{{locale.name}}</a></li></ul></li><li uib-dropdown=\"\" ng-if=\"main.user.role==\'\'\"><a uib-dropdown-toggle=\"\" href=\"\"><b class=\"caret\"></b> <span>{{main.user.userName}}</span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a ui-sref=\"base.profile\" lang=\"\">Profile</a></li></ul></li><li><a href=\"\" ng-click=\"main.signOut()\" title=\"Sign Out\"><i class=\"fa fa-sign-out\"></i> <span lang=\"\">Sign out</span></a></li></ul></nav></div>");
$templateCache.put("app/courses/content/course.content.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>{{contentCtrl.node.nodeName}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li><a ui-sref=\"base.courses\">Courses</a></li><li><a ui-sref=\"base.course.index({id:contentCtrl.courseId})\">{{contentCtrl.node.courseName}}</a></li><li class=\"active\"><strong>{{contentCtrl.node.nodeName}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\" ng-if=\"contentCtrl.loaded && (global.isAdmin || global.isEducator)\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><ng-form name=\"editContent\"><div class=\"input-group\" ng-show=\"!contentCtrl.newContent.saving\"><span class=\"input-group-btn content-type-select\"><ui-select id=\"contentType\" name=\"contentType\" ng-model=\"contentCtrl.newContent.type\" on-select=\"contentCtrl.newContentTypeSelected($item)\" theme=\"bootstrap\" style=\"width:150px\" ng-required=\"true\"><ui-select-match placeholder=\"Content Type...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in contentCtrl.contentTypes | filter: $select.search\"><div class=\"select-title\"><i class=\"fa fa-{{item.icon}}\"></i> <span ng-bind-html=\"item.text | highlight: $select.search\"></span></div><div class=\"select-desc text-wrap\" ng-bind-html=\"$root.trustHtml(item.desc)\"></div></ui-select-choices></ui-select></span> <input id=\"title\" name=\"title\" type=\"text\" class=\"form-control\" placeholder=\"Enter a title...\" ng-model=\"contentCtrl.newContent.name\" required=\"\"> <span class=\"input-group-btn min-tablet\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"editContent.$submitted=true;contentCtrl.addNew(editContent);\" title=\"Add New Content\"><span class=\"only-desktop\">Add new content block!</span> <span class=\"only-tablet\">Add!</span></button></span></div><button type=\"submit\" class=\"btn btn-primary only-mobile\" ng-click=\"editContent.$submitted=true;contentCtrl.addNew(editContent);\" title=\"Add New Content\">Add new content block!</button><div validation-result=\"\" myform=\"editContent\" element=\"contentType\" required-text=\"Please select a content type\"></div><div validation-result=\"\" myform=\"editContent\" element=\"title\" required-text=\"Please specify a title\"></div><div content-edit=\"\" content=\"contentCtrl.newContent\" ng-show=\"!contentCtrl.newContent.saving\" myform=\"editContent\"></div><div spinner-wave=\"\" ng-if=\"contentCtrl.newContent.saving\">Saving...</div></ng-form></div></div></div></div><div ng-if=\"contentCtrl.dragDirty\"><button buttonspinner=\"\" ng-disabled=\"contentCtrl.saving\" type=\"button\" class=\"buttonspinner-button btn btn-primary btn-sm\" data-style=\"expand-left\" ng-click=\"contentCtrl.saveDragOrder()\" title=\"Save New Sequence\">Save New Sequence</button> <i class=\"fa fa-level-down\"></i></div><div class=\"connectPanels\" ui-sortable=\"contentCtrl.sortableOptions\" ng-model=\"contentCtrl.node.content\"><div class=\"row\" ng-repeat=\"item in contentCtrl.node.content\" ng-if=\"contentCtrl.loaded && (global.isAdmin || global.isEducator || (global.isStudent && item.contentId==contentCtrl.currentViewContent))\" ng-hide=\"global.isStudent && item.type==\'Javascript\'\"><div class=\"col-lg-12\"><div class=\"ibox\"><ng-form name=\"editContent\"><div class=\"alert alert-warning m-b-none hide-on-fullscreen\" ng-if=\"!item.editing && item.preInstructions\" ng-bind-html=\"trustHtml(item.preInstructions)\"></div><div class=\"ibox-title\" ng-if=\"global.isAdmin || global.isEducator\"><h5 ng-if=\"global.isAdmin || global.isEducator\">{{item.name}}</h5><div ibox-tools=\"\" closebox=\"contentCtrl.deleteContent(item)\" can-expand=\"true\" default-hidden=\"item.defaultHidden\" on-expand=\"contentCtrl.onContentExpanded(isExpanded, item)\" on-toggle=\"contentCtrl.onContentToggled(isHidden, item)\" ng-if=\"global.isAdmin || global.isEducator\"><div ng-if=\"item.type!=\'Javascript\'\" ng-show=\"item.editing && !item.saving\" uib-tooltip=\"Set whether or not to show the title bar to students\" class=\"pull-left m-l-xs\"><label for=\"showHeader\"><input icheck=\"\" name=\"showHeader\" type=\"checkbox\" ng-model=\"item.showHeader\"> Show title bar?</label></div><div ng-if=\"item.type!=\'Javascript\'\" ng-hide=\"item.editing\" class=\"pull-left m-l-xs\"><span class=\"label label-primary\" ng-show=\"item.showHeader\">Show title bar</span> <span class=\"label label-danger\" ng-show=\"!item.showHeader\">Hide title bar</span></div><a ng-click=\"contentCtrl.editContent(item)\" title=\"Edit Content\" ng-show=\"!item.editing\"><i class=\"fa fa-pencil\"></i></a> <button ng-click=\"contentCtrl.cancelEditContent(item, $index)\" title=\"Cancel Content Edit\" ng-show=\"item.editing\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-minus-circle\"></i> Cancel</button> <button type=\"submit\" buttonspinner=\"\" ng-disabled=\"item.saving\" ng-click=\"editContent.$submitted=true;contentCtrl.saveContent(editContent, item);\" data-style=\"expand-left\" title=\"Save changes\" ng-show=\"item.editing\" class=\"buttonspinner-button btn btn-primary btn-xs\"><i class=\"fa fa-save\"></i> Save changes</button></div></div><div class=\"ibox-title\" ng-if=\"global.isStudent && item.type!=\'Javascript\'\"><h5 ng-if=\"global.isStudent && item.showHeader\">{{item.name}}</h5><div ibox-tools=\"\" can-expand=\"true\" default-hidden=\"item.defaultHidden\" on-expand=\"contentCtrl.onContentExpanded(isExpanded, item)\" on-toggle=\"contentCtrl.onContentToggled(isHidden, item)\" disableclose=\"true\" ng-if=\"item.loaded && global.isStudent\"><button type=\"button\" ng-click=\"contentCtrl.viewPrevContent($index);\" data-style=\"expand-left\" title=\"Previous\" ng-show=\"$index > 0\" class=\"btn btn-primary btn\">&lt; Previous</button> <button type=\"button\" ng-click=\"contentCtrl.viewNextContent($index);\" data-style=\"expand-left\" title=\"Next\" ng-show=\"$index < contentCtrl.node.content.length - 1\" class=\"btn btn-primary btn\">Next &gt;</button></div></div><div class=\"ibox-content\" ng-style=\"item.defaultStyle\"><div class=\"alert alert-info hide-on-fullscreen\" ng-if=\"!item.editing && item.description\" ng-bind-html=\"trustHtml(item.description)\"></div><div class=\"text-center\" ng-if=\"!item.loaded && !item.editing && item.type != \'Assessment\'\"><button ng-hide=\"item.loading\" ng-click=\"contentCtrl.openContent(item)\" class=\"btn btn-primary\">Open...</button></div><div content-view=\"\" content=\"item\" ng-if=\"item.loaded && !item.editing\"></div><div content-edit=\"\" content=\"item\" ng-if=\"item.loaded && item.editing && (global.isAdmin || global.isEducator)\" ng-hide=\"item.saving\" myform=\"editContent\"></div><div spinner-wave=\"\" ng-if=\"(item.loading && !item.loaded) || item.saving\"></div></div><div class=\"ibox-footer\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"clearfix m-b-xs\"><div ng-show=\"item.editing && !item.saving\" uib-tooltip=\"Set whether or not this content is available for students\" class=\"pull-left\"><label for=\"available\"><input icheck=\"\" name=\"available\" type=\"checkbox\" ng-model=\"item.available\"> Available?</label></div><div ng-hide=\"item.editing\" class=\"pull-left\"><span class=\"label label-primary\" ng-show=\"item.available\">Available</span> <span class=\"label label-danger\" ng-show=\"!item.available\">Not available</span></div><div ng-if=\"item.type!=\'Javascript\' && item.type!=\'Assessment\'\" ng-show=\"item.editing && !item.saving\" uib-tooltip=\"Set whether or not this content should open automatically on page load\" class=\"pull-left m-l-sm\"><label for=\"autoLoad\"><input icheck=\"\" name=\"autoLoad\" type=\"checkbox\" ng-model=\"item.autoLoad\"> Auto-open?</label></div><div ng-if=\"item.type!=\'Javascript\' && item.type!=\'Assessment\'\" ng-hide=\"item.editing\" class=\"pull-left m-l-sm\"><span class=\"label label-primary\" ng-show=\"item.autoLoad\">Auto-open</span> <span class=\"label label-warning\" ng-show=\"!item.autoLoad\">Open on request</span></div><div ng-if=\"item.type==\'Javascript\' || item.type==\'Assessment\'\" class=\"pull-left m-l-sm\"><span class=\"label label-primary\">Auto-open</span></div><div class=\"pull-left\" ng-if=\"item.loaded\">&nbsp;|&nbsp;<span ng-if=\"item.publishedRevision && item.publishedRevision != item.revisionNumber\">Published Revision: {{item.publishedRevision}}&nbsp;|&nbsp;</span><span ng-class=\"{\'label label-warning\':item.publishedRevision != item.revisionNumber}\">Latest Revision: {{item.revisionNumber}}</span></div><div class=\"pull-left\" ng-if=\"item.contentStats\">&nbsp;|&nbsp;<i class=\"fa fa-eye\" tooltip-placement=\"top\" uib-tooltip=\"Total views\" title=\"Total views\"></i> {{item.contentStats.viewCount}}&nbsp;&nbsp;<i class=\"fa fa-clock-o\" tooltip-placement=\"top\" uib-tooltip=\"Average time spent per view\" title=\"Average time spent per view\"></i> {{(item.contentStats.avgTimeSpent / 60) | number : 0}} minutes</div><div class=\"pull-left\" ng-if=\"item.userContentStats\">&nbsp;|&nbsp;<i class=\"fa fa-users\" tooltip-placement=\"top\" uib-tooltip=\"Number of students who have viewed\" title=\"Number of students who have viewed\"></i> {{item.userContentStats.userCount}}&nbsp;&nbsp;<i class=\"fa fa-clock-o\" tooltip-placement=\"top\" uib-tooltip=\"Average time spent by each student\" title=\"Average time spent by each student\"></i> {{(item.userContentStats.avgTimeSpent / 60) | number : 0}} minutes</div><div class=\"pull-left\" ng-if=\"item.pageStats\">&nbsp;|&nbsp;<strong>Page {{item.pageStats.pageNo}}:</strong>&nbsp;&nbsp;<i class=\"fa fa-eye\" tooltip-placement=\"top\" uib-tooltip=\"Total views for this page\" title=\"Total views for this page\"></i> {{item.pageStats.general.viewCount}}&nbsp;&nbsp;<i class=\"fa fa-clock-o\" tooltip-placement=\"top\" uib-tooltip=\"Average time spent per view on this page\" title=\"Average time spent per view on this page\"></i> {{(item.pageStats.general.avgTimeSpent / 60) | number : 0}} minutes&nbsp;&nbsp;<i class=\"fa fa-users\" tooltip-placement=\"top\" uib-tooltip=\"Number of students who have viewed this page\" title=\"Number of students who have viewed this page\"></i> {{item.pageStats.userStats.userCount}}&nbsp;&nbsp;<i class=\"fa fa-clock-o\" tooltip-placement=\"top\" uib-tooltip=\"Average time spent by each student on this page\" title=\"Average time spent by each student on this page\"></i> {{(item.pageStats.userStats.avgTimeSpent / 60) | number : 0}} minutes</div><div class=\"pull-left\" ng-if=\"item.type == \'Pdf\' && !item.moreStatsShown\">&nbsp;|&nbsp;<button ng-click=\"contentCtrl.showMoreStats(item)\" title=\"More details\" class=\"btn btn-primary btn-xs\">More details...</button></div></div><div ng-if=\"item.moreStatsShown\"><div class=\"flot-chart\" ng-show=\"item.pdfStats\"><div flot=\"\" class=\"flot-chart-content\" dataset=\"item.pdfStats\" options=\"contentCtrl.pdfStatsOptions\"></div></div><div spinner-wave=\"\" ng-if=\"!item.pdfStats\"></div></div></div><div class=\"alert alert-warning m-t-none hide-on-fullscreen\" ng-if=\"!item.editing && item.postInstructions\" ng-bind-html=\"trustHtml(item.postInstructions)\"></div></ng-form></div></div></div></div><div ng-if=\"contentCtrl.dragDirty\"><button buttonspinner=\"\" ng-disabled=\"contentCtrl.saving\" type=\"button\" class=\"buttonspinner-button btn btn-primary btn-sm\" data-style=\"expand-left\" ng-click=\"contentCtrl.saveDragOrder()\" title=\"Save New Sequence\">Save New Sequence</button> <i class=\"fa fa-level-up\"></i></div><div spinner-wave=\"\" ng-if=\"!contentCtrl.loaded\"></div></div>");
$templateCache.put("app/courses/content/review.assessment.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{reviewAssessmentCtrl.content.name}}</h4><small class=\"font-bold\">{{reviewAssessmentCtrl.content.label}}</small></div><div class=\"modal-body\"><form name=\"takeAssessment\" ng-if=\"reviewAssessmentCtrl.loaded\"><div ng-if=\"reviewAssessmentCtrl.userAssessment.sections.length > 1\"><div class=\"btn-group m-b-xs\"><button ng-repeat=\"section in reviewAssessmentCtrl.userAssessment.sections\" ng-click=\"reviewAssessmentCtrl.showSection(section, $index)\" ng-disabled=\"reviewAssessmentCtrl.content.forwardOnly\" title=\"{{section.title}}\" class=\"btn btn-sm font-bold\" ng-class=\"{\'btn-primary\':reviewAssessmentCtrl.userAssessment.activeSectionId==section.assessmentSectionId,\'btn-white\':reviewAssessmentCtrl.userAssessment.activeSectionId!=section.assessmentSectionId && !section.timedOut}\"><i class=\"fa fa-clock-o\" ng-if=\"section.timedOut\"></i> {{section.title}}</button></div></div><div ng-if=\"reviewAssessmentCtrl.activeSection && !reviewAssessmentCtrl.activeSection.timedOut\"><div class=\"btn-group\"><button ng-repeat=\"screen in reviewAssessmentCtrl.activeSection.screens\" ng-click=\"reviewAssessmentCtrl.showScreen(section, screen, $index)\" ng-disabled=\"reviewAssessmentCtrl.content.forwardOnly\" title=\"{{screen.screenLayout == \'Question\' ? (\'Question {0}\').replace(\'{0}\', screen.questionNumber) : \'Informational\'}}\" class=\"btn btn-sm font-bold\" ng-class=\"{\'btn-primary\':reviewAssessmentCtrl.userAssessment.activeScreenId==screen.assessmentScreenId,\'btn-white\':reviewAssessmentCtrl.userAssessment.activeScreenId!=screen.assessmentScreenId}\">{{screen.screenLayout == \'Question\' ? screen.questionNumber : \'i\'}}</button></div></div><hr><div ng-show=\"reviewAssessmentCtrl.activeScreen && reviewAssessmentCtrl.activeScreen.loaded && !reviewAssessmentCtrl.loadingScreen && !reviewAssessmentCtrl.showEnd && !reviewAssessmentCtrl.activeSection.timedOut\"><div ng-if=\"reviewAssessmentCtrl.activeScreen.screenLayout==\'TextOnly\'\"><p bind-mathjax=\"reviewAssessmentCtrl.activeScreen.textContent\"></p></div><div ng-if=\"reviewAssessmentCtrl.activeScreen.screenLayout==\'Question\'\"><p bind-mathjax=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionContent\"></p><hr><div ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceSingleAnswer\' || reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceMultipleAnswers\'\"><div class=\"form-group clearfix\" ng-repeat=\"answer in reviewAssessmentCtrl.activeScreen.contentQuestion.contentMultipleChoiceAnswers\"><div class=\"pull-left m-xxs\"><label for=\"isCorrect-{{$index}}\"><input icheck=\"\" id=\"isCorrect-{{$index}}\" name=\"isCorrect\" type=\"radio\" disabled=\"\" readonly=\"\" ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceSingleAnswer\'\" ng-value=\"$index\" ng-model=\"reviewAssessmentCtrl.activeScreen.contentQuestion.selectedAnswer\"><input icheck=\"\" id=\"isCorrect-{{$index}}\" name=\"isCorrect\" type=\"checkbox\" disabled=\"\" readonly=\"\" ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceMultipleAnswers\'\" ng-model=\"answer.isCorrect\"></label></div><div bind-mathjax=\"answer.answerContent\" class=\"position-relative m-l-lg\"></div></div></div><div ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'Matching\'\"><div class=\"row\" ng-repeat=\"option in reviewAssessmentCtrl.activeScreen.contentQuestion.contentMatchingOptions\"><div class=\"col-md-6\"><div class=\"form-group\"><div bind-mathjax=\"option.optionContent\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><ui-select id=\"answer\" name=\"answer\" disabled=\"\" readonly=\"\" ng-model=\"option.contentMatchingAnswer.matchingAnswerKey\" theme=\"bootstrap\" title=\"Matching answer\"><ui-select-match placeholder=\"No answer given\"><span bind-mathjax=\"$select.selected.answerContent\"></span></ui-select-match><ui-select-choices repeat=\"answer.matchingAnswerKey as answer in reviewAssessmentCtrl.activeScreen.contentQuestion.matchingAnswers | filter: {answerContent: $select.search}\"><span bind-mathjax=\"answer.answerContent\"></span></ui-select-choices></ui-select></div></div></div></div><div ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'OpenEnded\'\"><div bind-mathjax=\"reviewAssessmentCtrl.activeScreen.contentQuestion.answerGiven\"></div></div><div ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.questionType==\'Recording\'\"><div class=\"row\"><div class=\"col-md-6\"><div ng-if=\"!reviewAssessmentCtrl.activeScreen.contentQuestion.answerGiven\">No recording submitted</div><div ng-if=\"reviewAssessmentCtrl.activeScreen.contentQuestion.answerGiven\"><video controls=\"\"><source src=\"{{reviewAssessmentCtrl.activeScreen.contentQuestion.answerGiven}}\" type=\"video/webm\"></video></div></div></div></div><hr><p>Correct? <label for=\"isAnswerCorrect\"><input icheck=\"\" id=\"isAnswerCorrect\" name=\"isAnswerCorrect\" type=\"checkbox\" ng-model=\"reviewAssessmentCtrl.activeScreen.contentQuestion.result.isCorrect\"></label></p><p>Points: <span class=\"touchspin-wrapper\"><input type=\"text\" id=\"score\" name=\"score\" touch-spin=\"\" spin-options=\"numberOptions\" ng-model=\"reviewAssessmentCtrl.activeScreen.contentQuestion.result.score\" style=\"width:50px\"></span></p><p><button buttonspinner=\"\" ng-disabled=\"reviewAssessmentCtrl.submitting\" type=\"button\" class=\"buttonspinner-button btn btn-primary\" ng-show=\"reviewAssessmentCtrl.isDirty(reviewAssessmentCtrl.activeScreen.assessmentScreenId, reviewAssessmentCtrl.activeScreen.contentQuestion.result)\" ng-click=\"reviewAssessmentCtrl.gradeScreen()\" data-style=\"expand-left\">Save Result</button></p></div></div></form><div spinner-wave=\"\" ng-if=\"!reviewAssessmentCtrl.loaded || reviewAssessmentCtrl.loadingScreen\">Loading...</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"reviewAssessmentCtrl.close()\">Close</button> <button type=\"button\" class=\"btn btn-success\" ng-show=\"!reviewAssessmentCtrl.showEnd && !reviewAssessmentCtrl.loadingScreen && reviewAssessmentCtrl.activeScreen\" ng-click=\"reviewAssessmentCtrl.nextScreen()\">Next &gt;</button></div></div>");
$templateCache.put("app/courses/content/take.assessment.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{takeAssessmentCtrl.content.name}}</h4><small class=\"font-bold\">{{takeAssessmentCtrl.content.label}}</small></div><div class=\"modal-body\"><form name=\"takeAssessment\" ng-if=\"takeAssessmentCtrl.loaded && !takeAssessmentCtrl.submitting\"><div class=\"row\" ng-if=\"takeAssessmentCtrl.content.durationType !== \'NonTimed\'\"><div class=\"col-md-7 col-sm-6 col-xs-4\"></div><div class=\"col-md-5 col-sm-6 col-xs-8\"><timer id=\"asmtTimer\" countdown=\"takeAssessmentCtrl.timeLeft\" max-time-unit=\"\'hour\'\" interval=\"1000\" autostart=\"false\"><div class=\"row\"><div class=\"col-xs-4 text-center\"><h4 ng-show=\"hhours && hhours != \'00\'\" class=\"no-margins\">{{hhours}}</h4></div><div class=\"col-xs-4 text-center\"><h4 class=\"no-margins\">{{mminutes}}</h4></div><div class=\"col-xs-4 text-center\"><h4 class=\"no-margins\">{{sseconds}}</h4></div></div><div class=\"row\"><div class=\"col-xs-4 text-center\"><span ng-show=\"hhours && hhours != \'00\'\">hour{{hourS}}</span></div><div class=\"col-xs-4 text-center\">minute{{minutesS}}</div><div class=\"col-xs-4 text-center\">second{{secondsS}}</div></div></timer></div><hr></div><div ng-if=\"takeAssessmentCtrl.content.durationType == \'NonTimed\'\" ng-hide=\"true\"><timer id=\"asmtTimer\" interval=\"1000\" autostart=\"false\"></timer></div><div ng-if=\"takeAssessmentCtrl.userAssessment.sections.length > 1\"><div class=\"btn-group m-b-xs\"><button ng-repeat=\"section in takeAssessmentCtrl.userAssessment.sections\" ng-click=\"takeAssessmentCtrl.showSection(section, $index)\" ng-disabled=\"takeAssessmentCtrl.content.forwardOnly\" title=\"{{section.title}}\" class=\"btn btn-sm font-bold\" ng-class=\"{\'btn-primary\':takeAssessmentCtrl.userAssessment.activeSectionId==section.assessmentSectionId,\'btn-white\':takeAssessmentCtrl.userAssessment.activeSectionId!=section.assessmentSectionId && !section.timedOut}\"><i class=\"fa fa-clock-o\" ng-if=\"section.timedOut\"></i> {{section.title}}</button></div></div><div ng-if=\"takeAssessmentCtrl.activeSection && !takeAssessmentCtrl.activeSection.timedOut\"><div class=\"btn-group\"><button ng-repeat=\"screen in takeAssessmentCtrl.activeSection.screens\" ng-click=\"takeAssessmentCtrl.showScreen(section, screen, $index)\" ng-disabled=\"takeAssessmentCtrl.content.forwardOnly\" title=\"{{screen.screenLayout == \'Question\' ? (\'Question {0}\').replace(\'{0}\', screen.questionNumber) : \'Informational\'}}\" class=\"btn btn-sm font-bold\" ng-class=\"{\'btn-primary\':takeAssessmentCtrl.userAssessment.activeScreenId==screen.assessmentScreenId,\'btn-white\':takeAssessmentCtrl.userAssessment.activeScreenId!=screen.assessmentScreenId}\">{{screen.screenLayout == \'Question\' ? screen.questionNumber : \'i\'}}</button></div></div><hr><div ng-show=\"takeAssessmentCtrl.activeScreen && takeAssessmentCtrl.activeScreen.loaded && !takeAssessmentCtrl.loadingScreen && !takeAssessmentCtrl.showEnd && !takeAssessmentCtrl.activeSection.timedOut\"><div ng-if=\"takeAssessmentCtrl.activeScreen.screenLayout==\'TextOnly\'\"><p bind-mathjax=\"takeAssessmentCtrl.activeScreen.textContent\"></p></div><div ng-if=\"takeAssessmentCtrl.activeScreen.screenLayout==\'Question\'\"><p bind-mathjax=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionContent\"></p><hr><div ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceSingleAnswer\' || takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceMultipleAnswers\'\"><div class=\"form-group clearfix\" ng-repeat=\"answer in takeAssessmentCtrl.activeScreen.contentQuestion.contentMultipleChoiceAnswers\"><div class=\"pull-left m-xxs\"><label for=\"isCorrect-{{$index}}\"><input icheck=\"\" id=\"isCorrect-{{$index}}\" name=\"isCorrect\" type=\"radio\" ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceSingleAnswer\'\" ng-value=\"$index\" ng-model=\"takeAssessmentCtrl.activeScreen.contentQuestion.selectedAnswer\"><input icheck=\"\" id=\"isCorrect-{{$index}}\" name=\"isCorrect\" type=\"checkbox\" ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'MultipleChoiceMultipleAnswers\'\" ng-model=\"answer.isCorrect\"></label></div><div bind-mathjax=\"answer.answerContent\" class=\"position-relative m-l-lg\"></div></div></div><div ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'Matching\'\"><div class=\"row\" ng-repeat=\"option in takeAssessmentCtrl.activeScreen.contentQuestion.contentMatchingOptions\"><div class=\"col-md-6\"><div class=\"form-group\"><div bind-mathjax=\"option.optionContent\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><ui-select id=\"answer\" name=\"answer\" ng-model=\"option.contentMatchingAnswer.matchingAnswerKey\" theme=\"bootstrap\" title=\"Matching answer\"><ui-select-match placeholder=\"Select the matching answer\"><span bind-mathjax=\"$select.selected.answerContent\"></span></ui-select-match><ui-select-choices repeat=\"answer.matchingAnswerKey as answer in takeAssessmentCtrl.activeScreen.contentQuestion.matchingAnswers | filter: {answerContent: $select.search}\"><span bind-mathjax=\"answer.answerContent\"></span></ui-select-choices></ui-select></div></div></div></div><div ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'OpenEnded\'\"><div id=\"answerGiven\" name=\"answerGiven\" summernote-editor=\"takeAssessmentCtrl.activeScreen.contentQuestion.answerGiven\" config=\"takeAssessmentCtrl.summernoteAnswerOptions\"></div></div><div ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.questionType==\'Recording\'\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\" ng-if=\"!takeAssessmentCtrl.activeScreen.contentQuestion.answerGiven || takeAssessmentCtrl.activeScreen.contentQuestion.rerecord\"><video-js max-length=\"takeAssessmentCtrl.activeScreen.contentQuestion.maxLength\" on-recorded=\"takeAssessmentCtrl.onRecordingDone(data, takeAssessmentCtrl.activeScreen.contentQuestion)\"></video-js><p ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.rerecord\" class=\"m-t-sm\"><button class=\"btn btn-success\" type=\"button\" ng-click=\"takeAssessmentCtrl.cancelReRecord(takeAssessmentCtrl.activeScreen.contentQuestion)\">Cancel</button></p></div><div ng-if=\"takeAssessmentCtrl.activeScreen.contentQuestion.answerGiven && !takeAssessmentCtrl.activeScreen.contentQuestion.rerecord\"><p>Recording saved. You may re-record the video until you submit the assessment. <button class=\"btn btn-success\" type=\"button\" ng-click=\"takeAssessmentCtrl.reRecord(takeAssessmentCtrl.activeScreen.contentQuestion)\">Re-record</button></p><video controls=\"\"><source src=\"{{takeAssessmentCtrl.activeScreen.contentQuestion.answerGiven}}\" type=\"video/webm\"></video></div></div></div></div></div></div><div ng-if=\"takeAssessmentCtrl.activeSection.timedOut\"><label>This section has timed out. You cannot attempt any more questions from this section.</label></div><div ng-if=\"takeAssessmentCtrl.showEnd\"><label>You have reached the end. Your answers will be submitted shortly...</label></div></form><div spinner-wave=\"\" ng-if=\"!takeAssessmentCtrl.loaded || takeAssessmentCtrl.loadingScreen\">Loading...</div><div spinner-wave=\"\" ng-if=\"takeAssessmentCtrl.submitting\">Submitting your answers. Please wait...</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-if=\"takeAssessmentCtrl.content.allowResume\" ng-click=\"takeAssessmentCtrl.close()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"takeAssessmentCtrl.submitting\" type=\"button\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"takeAssessmentCtrl.submit()\" data-style=\"expand-left\">Submit</button> <button type=\"button\" class=\"btn btn-success\" ng-show=\"!takeAssessmentCtrl.showEnd && !takeAssessmentCtrl.loadingScreen && takeAssessmentCtrl.activeScreen\" ng-click=\"takeAssessmentCtrl.nextScreen()\">Next &gt;</button></div></div>");
$templateCache.put("app/courses/list/course.list.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>My Courses</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li class=\"active\"><strong>My Courses</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 ng-if=\"global.isAdmin || global.isEducator\">Courses that I have created or have access to</h5><h5 ng-if=\"global.isStudent\">Courses that I have access to</h5><div class=\"ibox-tools\"><a new-course=\"\" ng-if=\"global.isAdmin || global.isEducator\" href=\"\" class=\"btn btn-primary btn-xs\">Create new course</a></div></div><div class=\"ibox-content\"><div class=\"row m-b-sm m-t-sm\"><div class=\"col-md-1\"><button type=\"button\" id=\"loading-example-btn\" class=\"btn btn-white btn-sm\"><i class=\"fa fa-refresh\"></i> Refresh</button></div><div class=\"col-md-11\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search\" class=\"input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\">Go!</button></span></div></div></div><div class=\"project-list\"><table ng-if=\"courses.loaded\" class=\"table table-hover\"><tbody><tr ng-repeat=\"course in courses.courses | orderBy:[\'departmentName\',\'name\']\"><td class=\"project-status\" ng-if=\"global.isAdmin || global.isEducator\"><span class=\"label\" ng-class=\"{\'label-warning\':course.status==1,\'label-primary\':course.status==2,\'label-danger\':course.status==3}\">{{course.status | courseStatus}}</span></td><td class=\"project-title\"><a ui-sref=\"base.course.index({id:course.courseId})\" title=\"{{course.courseCode ? course.courseCode +\" -=\"\" \"=\"\" +=\"\" course.name=\"\" :=\"\" course.name}}\"=\"\">{{course.courseCode ? course.courseCode + \" - \" + course.name : course.name}}</a><br><small ng-if=\"global.isAdmin || global.isEducator\">{{course.departmentName}} - Created {{course.createdDate | momentDateText}}</small> <small ng-if=\"!global.isAdmin && !global.isEducator\">{{course.departmentName}}</small></td><td class=\"project-people\"><a href=\"\" ng-repeat=\"user in course.educators\" ng-if=\"global.isAdmin || global.isEducator\"><img alt=\"{{user.title + \' \' + user.firstName + \' \' + user.lastName}}\" class=\"img-circle\" ng-src=\"{{user.profilePic}}\" img-placeholder=\"user\"></a> <a href=\"\" ng-if=\"!global.isAdmin && !global.isEducator\"><img alt=\"{{course.primaryEducatorName}}\" class=\"img-circle\" ng-src=\"{{course.primaryEducatorPic}}\" img-placeholder=\"user\"></a></td><td class=\"project-actions\"><a ui-sref=\"base.course.index({id:course.courseId})\" class=\"btn btn-white btn-sm\"><i class=\"fa fa-folder\"></i> View</a></td></tr></tbody></table><div ng-if=\"!courses.loaded\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/courses/new/course.copy.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-graduation-cap modal-icon\"></i><h4 class=\"modal-title\">Copy an Existing Course</h4><small class=\"font-bold\">Enter the name and department for the copied course.</small></div><form name=\"copyCourse\" novalidate=\"\"><div class=\"modal-body\"><div ng-if=\"copycourse.loaded\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"courseCode\">Course code</label> <input id=\"courseCode\" name=\"courseCode\" type=\"text\" ng-model=\"copycourse.course.courseCode\" placeholder=\"Course code\" class=\"form-control\"></div></div><div class=\"col-md-9\"><div class=\"form-group\"><label for=\"courseName\" class=\"required\">Course name</label> <input id=\"courseName\" name=\"courseName\" type=\"text\" ng-model=\"copycourse.course.name\" placeholder=\"Enter a name for the new course\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"copyCourse\" element=\"courseName\" required-text=\"Please specify a name\"></div></div></div></div><div class=\"input-group\"><label for=\"department\" class=\"required\">Department</label></div><select chosen=\"\" id=\"department\" name=\"department\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"copycourse.course.departmentId\" ng-options=\"dept.departmentId as dept.name for dept in copycourse.departments\" data-placeholder-text-single=\"\'Select a department\'\" no-results-text=\"\'No departments found\'\" required=\"\"></select><div validation-result=\"\" myform=\"copyCourse\" element=\"department\" required-text=\"Please specify a department\"></div></div><div ng-if=\"!copycourse.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"copycourse.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"copycourse.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"copycourse.ok(copyCourse)\" data-style=\"expand-left\">Copy</button></div></form></div>");
$templateCache.put("app/courses/new/newcourse.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-graduation-cap modal-icon\"></i><h4 class=\"modal-title\">Create a New Course</h4><small class=\"font-bold\">Enter details below to start creating a new course.</small></div><form name=\"createCourse\" novalidate=\"\"><div class=\"modal-body\"><div ng-if=\"newcourse.loaded\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"courseCode\">Course code</label> <input id=\"courseCode\" name=\"courseCode\" type=\"text\" ng-model=\"newcourse.course.courseCode\" placeholder=\"Course code\" class=\"form-control\"></div></div><div class=\"col-md-9\"><div class=\"form-group\"><label for=\"courseName\" class=\"required\">Course name</label> <input id=\"courseName\" name=\"courseName\" type=\"text\" ng-model=\"newcourse.course.name\" placeholder=\"Enter a name for the new course\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"createCourse\" element=\"courseName\" required-text=\"Please specify a name\"></div></div></div></div><div class=\"input-group\"><label for=\"department\" class=\"required\">Department</label></div><select chosen=\"\" id=\"department\" name=\"department\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"newcourse.course.departmentId\" ng-options=\"dept.departmentId as dept.name for dept in newcourse.departments\" data-placeholder-text-single=\"\'Select a department\'\" no-results-text=\"\'No departments found\'\" required=\"\"></select><div validation-result=\"\" myform=\"createCourse\" element=\"department\" required-text=\"Please specify a department\"></div></div><div ng-if=\"!newcourse.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"newcourse.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"newcourse.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"newcourse.ok(createCourse)\" data-style=\"expand-left\">Create</button></div></form></div>");
$templateCache.put("app/courses/urltools/vimeo.snippet.html","<div class=\"search-checkbox\"><input icheck=\"\" type=\"checkbox\" ng-model=\"item.selected\"></div><div class=\"forum-item item-clickable\" ng-click=\"item.showPreview=!item.showPreview\" title=\"{{item.name}}\"><div class=\"row\"><div ng-hide=\"compressed\" class=\"col-md-3 col-sm-3 col-xs-5\"><img ng-src=\"{{$root.trustUrl(item.pictures.sizes[0].link)}}\" class=\"img-thumbnail\"></div><div ng-class=\"{\'col-md-9 col-sm-9 col-xs-7\':!compressed,\'col-md-12\':compressed}\"><span class=\"forum-item-title\">{{item.name}}</span><div class=\"forum-sub-title no-margins mh-100\" truncate=\"\" truncate-options=\"truncateOptions\">{{item.description}}</div><div ng-transclude=\"\"></div></div></div><div ng-hide=\"compressed\" class=\"row m-t-sm\" ng-if=\"item.showPreview\"><div class=\"col-md-12\"><iframe width=\"100%\" height=\"250\" title=\"{{item.name}}\" ng-src=\"{{$root.trustUrl(extractUrl(item.embed.html))}}\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\"></iframe></div></div></div>");
$templateCache.put("app/courses/urltools/vimeo.tool.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-vimeo modal-icon\"></i><h4 class=\"modal-title\">Vimeo</h4><small class=\"font-bold\">Add or edit external content from Vimeo.</small></div><form name=\"editTool\" ng-if=\"!vimeoToolCtrl.loading\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><div class=\"input-group\" ng-show=\"!contentCtrl.newContent.saving\"><input id=\"searchText\" name=\"searchText\" type=\"text\" ng-model=\"vimeoToolCtrl.searchText\" on-enter=\"vimeoToolCtrl.search()\" placeholder=\"Search...\" class=\"form-control\" required=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vimeoToolCtrl.search()\" title=\"Execute search\">Go!</button></span></div><div validation-result=\"\" myform=\"editTool\" element=\"searchText\" required-text=\"Please specify a search term\"></div></div><div ng-if=\"vimeoToolCtrl.lastSearchText\"><div class=\"forum-container no-padding\"><div class=\"forum-title\"><div class=\"pull-right forum-desc\"><small>Total found: {{vimeoToolCtrl.resp.total}}</small></div><h3>Search results: {{vimeoToolCtrl.lastSearchText}}</h3></div><div class=\"btn-group\" ng-if=\"vimeoToolCtrl.resp.data && vimeoToolCtrl.resp.data.length\"><button class=\"btn btn-white btn-xs\" type=\"button\" title=\"First\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.first)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.first\">First</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Previous\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.previous)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.previous\">Previous</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Next\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.next)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.next\">Next</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Last\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.last)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.last\">Last</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><vimeo-snippet ng-repeat=\"item in vimeoToolCtrl.resp.data\" item=\"item\"><button class=\"btn btn-primary btn-sm\" title=\"Preview this video\"><i class=\"fa fa-play\"></i> Preview</button> <button class=\"btn btn-primary btn-sm\" ng-click=\"vimeoToolCtrl.select(item); $event.stopPropagation();\" title=\"Select this video\"><i class=\"fa fa-check\"></i> Select</button></vimeo-snippet></div><div class=\"btn-group\" ng-if=\"vimeoToolCtrl.resp.data && vimeoToolCtrl.resp.data.length\"><button class=\"btn btn-white btn-xs\" type=\"button\" title=\"First\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.first)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.first\">First</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Previous\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.previous)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.previous\">Previous</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Next\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.next)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.next\">Next</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Last\" ng-click=\"vimeoToolCtrl.search(vimeoToolCtrl.resp.paging.last)\" ng-disabled=\"!vimeoToolCtrl.resp.paging.last\">Last</button></div></div></div><div ng-if=\"vimeoToolCtrl.resp.data && !vimeoToolCtrl.resp.data.length\"><em>No results were found matching your search. Please try a different search.</em></div><div ng-if=\"vimeoToolCtrl.searching\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vimeoToolCtrl.cancel()\">Close</button></div></form></div>");
$templateCache.put("app/courses/urltools/wikipedia.snippet.html","<div class=\"search-checkbox\"><input icheck=\"\" type=\"checkbox\" ng-model=\"item.selected\"></div><div class=\"forum-item item-clickable\" ng-click=\"item.showPreview=!item.showPreview\" title=\"{{item.title}}\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"forum-icon\"><i class=\"fa fa-file-text-o\"></i></div><span class=\"forum-item-title\">{{item.title}}</span><div ng-transclude=\"\"></div></div></div><div ng-hide=\"compressed\" class=\"row m-t-sm\" ng-if=\"item.showPreview\"><div class=\"col-md-12\"><iframe width=\"100%\" height=\"500\" title=\"{{item.title}}\" ng-src=\"{{$root.trustUrl(item.fullurl)}}\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\"></iframe></div></div></div>");
$templateCache.put("app/courses/urltools/wikipedia.tool.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-globe modal-icon\"></i><h4 class=\"modal-title\">Wikipedia</h4><small class=\"font-bold\">Add or edit external content from Wikipedia.</small></div><form name=\"editTool\" ng-if=\"!wikipediaToolCtrl.loading\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><div class=\"input-group\" ng-show=\"!contentCtrl.newContent.saving\"><input id=\"searchText\" name=\"searchText\" type=\"text\" ng-model=\"wikipediaToolCtrl.searchText\" on-enter=\"wikipediaToolCtrl.search()\" placeholder=\"Wikipedia page title...\" class=\"form-control\" required=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"wikipediaToolCtrl.search()\" title=\"Execute search\">Go!</button></span></div><div validation-result=\"\" myform=\"editTool\" element=\"searchText\" required-text=\"Please specify a search term\"></div></div><div ng-if=\"wikipediaToolCtrl.lastSearchText\"><div class=\"forum-container no-padding\"><div class=\"forum-title\"><div class=\"pull-right forum-desc\"><small>Total found: {{wikipediaToolCtrl.resp.total}}</small></div><h3>Search results: {{wikipediaToolCtrl.lastSearchText}}</h3></div><div><wikipedia-snippet ng-repeat=\"(key, item) in wikipediaToolCtrl.resp.query.pages\" item=\"item\"><button class=\"btn btn-primary btn-sm\" title=\"Preview this article\" ng-if=\"wikipediaToolCtrl.resp.total>1\"><i class=\"fa fa-play\"></i> Preview</button> <button class=\"btn btn-primary btn-sm\" ng-click=\"wikipediaToolCtrl.select(item); $event.stopPropagation();\" title=\"Select this article\"><i class=\"fa fa-check\"></i> Select</button></wikipedia-snippet></div></div></div><div ng-if=\"wikipediaToolCtrl.resp && !wikipediaToolCtrl.resp.total\"><em>No results were found matching your search. Please try a different search.</em></div><div ng-if=\"wikipediaToolCtrl.searching\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"wikipediaToolCtrl.cancel()\">Close</button></div></form></div>");
$templateCache.put("app/courses/urltools/youtube.snippet.html","<div class=\"search-checkbox\"><input icheck=\"\" type=\"checkbox\" ng-model=\"item.selected\"></div><div class=\"forum-item item-clickable\" ng-click=\"item.showPreview=!item.showPreview\" title=\"{{item.snippet.title}}\"><div class=\"row\"><div ng-hide=\"compressed\" class=\"col-md-3 col-sm-3 col-xs-5\"><img ng-src=\"{{$root.trustUrl(item.snippet.thumbnails.default.url)}}\" class=\"img-thumbnail\"></div><div ng-class=\"{\'col-md-9 col-sm-9 col-xs-7\':!compressed,\'col-md-12\':compressed}\"><span class=\"forum-item-title\">{{item.snippet.title}}</span><div class=\"forum-sub-title no-margins\">{{item.snippet.description}}</div><div ng-transclude=\"\"></div></div></div><div ng-hide=\"compressed\" class=\"row m-t-sm\" ng-if=\"item.showPreview\"><div class=\"col-md-12\"><iframe width=\"100%\" height=\"250\" title=\"{{item.snippet.title}}\" ng-src=\"{{$root.trustUrl(\'https://www.youtube.com/embed/\' + item.id.videoId + \'?rel=0\')}}\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\"></iframe></div></div></div>");
$templateCache.put("app/courses/urltools/youtube.tool.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-youtube modal-icon\"></i><h4 class=\"modal-title\">Youtube</h4><small class=\"font-bold\">Add or edit external content from Youtube.</small></div><form name=\"editTool\" ng-if=\"!youtubeToolCtrl.loading\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><div class=\"input-group\" ng-show=\"!contentCtrl.newContent.saving\"><input id=\"searchText\" name=\"searchText\" type=\"text\" ng-model=\"youtubeToolCtrl.searchText\" on-enter=\"youtubeToolCtrl.search()\" placeholder=\"Search...\" class=\"form-control\" required=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"youtubeToolCtrl.search()\" title=\"Execute search\">Go!</button></span></div><div validation-result=\"\" myform=\"editTool\" element=\"searchText\" required-text=\"Please specify a search term\"></div></div><div ng-if=\"youtubeToolCtrl.lastSearchText\"><div class=\"forum-container no-padding\"><div class=\"forum-title\"><div class=\"pull-right forum-desc\"><small>Total found: {{youtubeToolCtrl.resp.pageInfo.totalResults}}</small></div><h3>Search results: {{youtubeToolCtrl.lastSearchText}}</h3></div><div class=\"btn-group\" ng-if=\"youtubeToolCtrl.resp.items && youtubeToolCtrl.resp.items.length\"><button class=\"btn btn-white btn-xs\" type=\"button\" title=\"First\" ng-click=\"youtubeToolCtrl.search()\">First</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Previous\" ng-click=\"youtubeToolCtrl.search(youtubeToolCtrl.resp.prevPageToken)\" ng-disabled=\"!youtubeToolCtrl.resp.prevPageToken\">Previous</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Next\" ng-click=\"youtubeToolCtrl.search(youtubeToolCtrl.resp.nextPageToken)\" ng-disabled=\"!youtubeToolCtrl.resp.nextPageToken\">Next</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><youtube-snippet ng-repeat=\"item in youtubeToolCtrl.resp.items\" item=\"item\"><button class=\"btn btn-primary btn-sm\" title=\"Preview this video\"><i class=\"fa fa-play\"></i> Preview</button> <button class=\"btn btn-primary btn-sm\" ng-click=\"youtubeToolCtrl.select(item); $event.stopPropagation();\" title=\"Select this video\"><i class=\"fa fa-check\"></i> Select</button></youtube-snippet></div><div class=\"btn-group\" ng-if=\"youtubeToolCtrl.resp.items && youtubeToolCtrl.resp.items.length\"><button class=\"btn btn-white btn-xs\" type=\"button\" title=\"First\" ng-click=\"youtubeToolCtrl.search()\">First</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Previous\" ng-click=\"youtubeToolCtrl.search(youtubeToolCtrl.resp.prevPageToken)\" ng-disabled=\"!youtubeToolCtrl.resp.prevPageToken\">Previous</button> <button class=\"btn btn-white btn-xs\" type=\"button\" title=\"Next\" ng-click=\"youtubeToolCtrl.search(youtubeToolCtrl.resp.nextPageToken)\" ng-disabled=\"!youtubeToolCtrl.resp.nextPageToken\">Next</button></div></div></div><div ng-if=\"youtubeToolCtrl.resp.items && !youtubeToolCtrl.resp.items.length\"><em>No results were found matching your search. Please try a different search.</em></div><div ng-if=\"youtubeToolCtrl.searching\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"youtubeToolCtrl.cancel()\">Close</button></div></form></div>");
$templateCache.put("app/courses/view/course.edit.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-graduation-cap modal-icon\"></i><h4 class=\"modal-title\">{{courseEditCtrl.course.name}}</h4><small class=\"font-bold\">Edit your course</small></div><form name=\"editCourse\" novalidate=\"\"><div class=\"modal-body\"><div ng-if=\"courseEditCtrl.loaded\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"courseCode\">Course code</label> <input id=\"courseCode\" name=\"courseCode\" type=\"text\" ng-model=\"courseEditCtrl.course.courseCode\" placeholder=\"Course code\" class=\"form-control\"></div></div><div class=\"col-md-9\"><div class=\"form-group\"><label for=\"courseName\" class=\"required\">Course name</label> <input id=\"courseName\" name=\"courseName\" type=\"text\" ng-model=\"courseEditCtrl.course.name\" placeholder=\"Enter a name for the course\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editCourse\" element=\"courseName\" required-text=\"Please specify a name\"></div></div></div></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"department\" class=\"required\">Department</label></div><select chosen=\"\" id=\"department\" name=\"department\" ng-change=\"courseEditCtrl.onDepartmentsChanged()\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"courseEditCtrl.course.departmentId\" ng-options=\"dept.departmentId as dept.name for dept in courseEditCtrl.departments\" data-placeholder-text-single=\"\'Select a department\'\" no-results-text=\"\'No departments found\'\" required=\"\"></select><div validation-result=\"\" myform=\"editCourse\" element=\"department\" required-text=\"Please specify a department\"></div></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"primaryEducator\" class=\"required\">Primary educator / lecturer</label></div><ui-select id=\"primaryEducator\" name=\"primaryEducator\" ng-model=\"courseEditCtrl.course.primaryEducator\" theme=\"bootstrap\" style=\"width:100%\" required=\"\"><ui-select-match placeholder=\"Select an educator\">{{$select.selected.title}} {{$select.selected.firstName}} {{$select.selected.lastName}}</ui-select-match><ui-select-choices repeat=\"user.userId as user in courseEditCtrl.educators | filter: $select.search\"><div><img alt=\"{{user.title + \' \' + user.firstName + \' \' + user.lastName}}\" class=\"img-circle\" ng-src=\"{{user.profilePic}}\"> {{user.title}} {{user.firstName}} {{user.lastName}}</div></ui-select-choices></ui-select><div validation-result=\"\" myform=\"editCourse\" element=\"primaryEducator\" required-text=\"Please select the primary educator for this course\"></div></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"classes\">Classes / Batches</label></div><ui-select id=\"classes\" name=\"classes\" multiple=\"\" ng-model=\"courseEditCtrl.course.classIds\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one or more classes/batches\">{{$item.departmentName}}: {{$item.name}}</ui-select-match><ui-select-choices repeat=\"group.departmentGroupId as group in courseEditCtrl.groups | filter: {name: $select.search}\" group-by=\"\'departmentName\'\"><div ng-bind-html=\"group.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"roEducators\">Educators / collaborators with read-only access</label></div><ui-select id=\"roEducators\" name=\"roEducators\" multiple=\"\" ng-model=\"courseEditCtrl.course.roEducators\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one or more educators\">{{$item.title}} {{$item.firstName}} {{$item.lastName}}</ui-select-match><ui-select-choices repeat=\"user.userId as user in courseEditCtrl.educators | filter: $select.search\"><div><img alt=\"{{user.title + \' \' + user.firstName + \' \' + user.lastName}}\" class=\"img-circle\" ng-src=\"{{user.profilePic}}\"> {{user.title}} {{user.firstName}} {{user.lastName}}</div></ui-select-choices></ui-select></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"wrEducators\">Educators / collaborators with full / write access</label></div><ui-select id=\"wrEducators\" name=\"wrEducators\" multiple=\"\" ng-model=\"courseEditCtrl.course.wrEducators\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one or more educators\">{{$item.title}} {{$item.firstName}} {{$item.lastName}}</ui-select-match><ui-select-choices repeat=\"user.userId as user in courseEditCtrl.educators | filter: $select.search\"><div><img alt=\"{{user.title + \' \' + user.firstName + \' \' + user.lastName}}\" class=\"img-circle\" ng-src=\"{{user.profilePic}}\"> {{user.title}} {{user.firstName}} {{user.lastName}}</div></ui-select-choices></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"startDate\" class=\"col-sm-5 control-label required\">Start date</label><div class=\"col-sm-7 input-group date\"><input type=\"datetime\" id=\"startDate\" name=\"startDate\" class=\"form-control\" date-time=\"\" ng-model=\"courseEditCtrl.course.startDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span><div validation-result=\"\" myform=\"editCourse\" element=\"startDate\" required-text=\"Please specify a start date\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"endDate\" class=\"col-sm-5 control-label required\">End date</label><div class=\"col-sm-7 input-group date\"><input type=\"datetime\" id=\"endDate\" name=\"endDate\" class=\"form-control\" date-time=\"\" ng-model=\"courseEditCtrl.course.endDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span><div validation-result=\"\" myform=\"editCourse\" element=\"endDate\" required-text=\"Please specify an end date\"></div></div></div></div></div><div class=\"input-group\"><label for=\"description\">Description</label></div><textarea id=\"description\" name=\"description\" ng-model=\"courseEditCtrl.course.description\" class=\"form-control\"></textarea></div><div ng-if=\"!courseEditCtrl.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"courseEditCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"courseEditCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"courseEditCtrl.ok(editCourse)\" data-style=\"expand-left\">Save</button></div></form></div>");
$templateCache.put("app/courses/view/course.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>{{courseCtrl.course.courseCode ? courseCtrl.course.courseCode + \" - \" + courseCtrl.course.name : courseCtrl.course.name}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li><a ui-sref=\"base.courses\">Courses</a></li><li class=\"active\"><strong>{{courseCtrl.course.courseCode ? courseCtrl.course.courseCode + \" - \" + courseCtrl.course.name : courseCtrl.course.name}}</strong></li></ol></div></div><div class=\"row\"><div ng-class=\"{\'col-lg-9\':global.isAdmin || global.isEducator || courseCtrl.course.description || (courseCtrl.course.resources && courseCtrl.course.resources.length), \'col-lg-12\':global.isStudent && !courseCtrl.course.description && (!courseCtrl.course.resources || !courseCtrl.course.resources.length)}\"><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-content\" ng-if=\"courseCtrl.loaded && courseCtrl.course && !courseCtrl.isPublishing\"><div class=\"row\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"col-lg-12\"><div class=\"alert alert-warning\" ng-if=\"courseCtrl.course.status == 2 && courseCtrl.course.isDirty\">There are new changes to this course. Please click re-publish to publish the new changes.</div><div class=\"m-b-md\"><button ng-click=\"courseCtrl.publish()\" ng-if=\"courseCtrl.course.status < 3\" class=\"btn btn-success btn-xs pull-right\"><span ng-if=\"courseCtrl.course.status == 1\">Publish this course</span> <span ng-if=\"courseCtrl.course.status == 2\">Re-publish this course</span></button> <button ng-click=\"courseCtrl.edit()\" ng-if=\"courseCtrl.course.status < 3\" class=\"btn btn-white btn-xs pull-right m-r-xs\">Edit course</button> <button ng-click=\"courseCtrl.copy()\" class=\"btn btn-primary btn-xs pull-right m-r-xs\"><i class=\"fa fa-copy\"></i> Copy</button> <button ng-click=\"courseCtrl.openShare()\" ng-if=\"courseCtrl.course.status < 3\" class=\"btn btn-primary btn-xs pull-right m-r-xs\"><i class=\"fa fa-share-alt\"></i> Share</button><h2>{{courseCtrl.course.courseCode ? courseCtrl.course.courseCode + \" - \" + courseCtrl.course.name : courseCtrl.course.name}}</h2></div><dl class=\"dl-horizontal\"><dt>Status:</dt><dd><span class=\"label label-primary\">{{courseCtrl.course.status | courseStatus}}</span></dd></dl></div></div><div class=\"row\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"col-lg-5\"><dl class=\"dl-horizontal\"><dt>Created by:</dt><dd>{{courseCtrl.course.userCreated}}</dd><dt>Students:</dt><dd>{{courseCtrl.course.numStudents}}</dd><dt>Current Version:</dt><dd>{{courseCtrl.course.currentRevision}}</dd><dt ng-if=\"courseCtrl.course.publishedRevision\">Published Version:</dt><dd ng-if=\"courseCtrl.course.publishedRevision\">{{courseCtrl.course.publishedRevision}}</dd></dl></div><div class=\"col-lg-7\" id=\"cluster_info\"><dl class=\"dl-horizontal\"><dt>Primary Educator:</dt><dd>{{courseCtrl.course.primaryEducatorName}}</dd><dt>Educators/Collaborators:</dt><dd class=\"project-people\"><a href=\"\" ng-repeat=\"educator in courseCtrl.course.educators\"><img img-placeholder=\"user\" alt=\"{{educator.title + \' \' + educator.firstName + \' \' + educator.lastName}}\" class=\"img-circle\" ng-src=\"{{educator.profilePic}}\"></a></dd></dl></div></div><div class=\"row\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"col-lg-12\"><dl class=\"dl-horizontal\"><dt>Classes / Batches:</dt><dd><span ng-repeat=\"class in courseCtrl.course.classes\">{{class.name}}<span ng-if=\"($index + 1) < courseCtrl.course.classes.length\">,&nbsp;</span></span></dd></dl></div></div><div class=\"row m-t-sm\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"col-lg-12\"><div class=\"panel blank-panel ui-tab\"><uib-tabset><uib-tab heading=\"Course structure\" active=\"tab.active\" class=\"dsads\"><script type=\"text/ng-template\" id=\"nodes_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\"> <div ng-show=\"!node.inEdit\"> <a class=\"pull-right btn btn-white btn-xs\" data-nodrag ng-click=\"courseCtrl.structure.remove(this)\" title=\"Delete Item\"><span class=\"fa fa-trash\"></span></a> <a class=\"pull-right btn btn-white btn-xs\" data-nodrag ng-click=\"courseCtrl.structure.newSubItem(this)\" title=\"Add New Sub-Item\"><span class=\"fa fa-plus\"></span></a> <a class=\"pull-right btn btn-white btn-xs\" data-nodrag ui-sref=\"base.course.content({id:courseCtrl.courseId,nodeId:node.id})\" ng-disabled=\"!node.id\" title=\"Open and Edit Content\"><span class=\"fa fa-folder-open-o\"></span></a> <a ng-if=\"!node.isHidden\" class=\"pull-right btn btn-white btn-xs\" data-nodrag ng-click=\"courseCtrl.structure.setHide(this, true)\" title=\"Hide Item\"><span class=\"fa fa-eye\"></span></a> <a ng-if=\"node.isHidden\" class=\"pull-right btn btn-white btn-xs\" data-nodrag ng-click=\"courseCtrl.structure.setHide(this, false)\" title=\"Unhide Item\"><span class=\"fa fa-eye-slash\"></span></a> <a class=\"pull-right btn btn-white btn-xs\" data-nodrag ng-click=\"node.inEdit=true\" title=\"Edit Item\"><span class=\"fa fa-pencil\"></span></a> <a class=\"btn btn-primary btn-xs\" data-nodrag ng-click=\"course.structure.toggle(this)\"><span class=\"fa\" ng-class=\"{\'fa-angle-down\': collapsed, \'fa-angle-right\': !collapsed}\"></span></a> {{node.nodeType}} {{node.number}}<span ng-show=\"(node.nodeType || node.number) && node.title\">:</span> {{node.title}} </div> <div ng-show=\"node.inEdit\"> <div class=\"input-group\"> <span class=\"input-group-btn\"> <ui-select data-nodrag tagging=\"courseCtrl.addNewNodeType\" tagging-label=\"New Type or Label...\" ng-model=\"node.nodeType\" theme=\"bootstrap\" style=\"width:150px\"> <ui-select-match placeholder=\"Type/Label...\">{{$select.selected}}</ui-select-match> <ui-select-choices repeat=\"item in courseCtrl.nodeTypes | filter: $select.search\"> <div ng-bind-html=\"item | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </span> <span class=\"input-group-btn\"><input data-nodrag type=\"text\" touch-spin spin-options=\"courseCtrl.spinOptions\" ng-model=\"node.number\" style=\"width:40px\"></span> <input data-nodrag type=\"text\" class=\"form-control\" placeholder=\"Enter a title (optional)\" ng-model=\"node.title\"> <span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"courseCtrl.structure.saveItem(this)\" title=\"Save Item\">Go!</button> </span> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ol></script><div ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"global.isAdmin || global.isEducator\" callbacks=\"courseCtrl.treeOptions\"><ol ui-tree-nodes=\"\" ng-model=\"courseCtrl.structure.data\"><li ng-if=\"courseCtrl.structure.isTransient\"><div class=\"tree-node tree-node-content clearfix\"><button buttonspinner=\"\" ng-disabled=\"courseCtrl.structure.saving\" type=\"button\" class=\"buttonspinner-button btn btn-primary btn-sm pull-right\" data-style=\"expand-left\" ng-click=\"courseCtrl.saveStructure()\" title=\"Save Course Structure\">Save Course Structure</button></div></li><li ng-repeat=\"node in courseCtrl.structure.data\" ui-tree-node=\"\" ng-include=\"\'nodes_renderer.html\'\"></li><li ng-if=\"courseCtrl.structure.isTransient\"><div class=\"tree-node tree-node-content clearfix\"><button buttonspinner=\"\" ng-disabled=\"courseCtrl.structure.saving\" type=\"button\" class=\"buttonspinner-button btn btn-primary btn-sm pull-right\" data-style=\"expand-left\" ng-click=\"courseCtrl.saveStructure()\" title=\"Save Course Structure\">Save Course Structure</button></div></li></ol></div></uib-tab><uib-tab heading=\"Students\" select=\"courseCtrl.getStudents()\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" ng-if=\"!courseCtrl.loadingStudents\"><tbody><tr ng-repeat=\"student in courseCtrl.students | filter: users.filter | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{student.firstName}} {{student.lastName}}\" ng-src=\"{{student.profilePic}}\"></td><td><a href=\"#\" class=\"client-link\">{{student.firstName}} {{student.lastName}}</a></td><td><span ng-repeat=\"group in student.groups\">{{group}}<span ng-if=\"($index + 1) < student.groups.length\">,&nbsp;</span></span></td><td class=\"contact-type\"><i class=\"fa fa-envelope\"></i></td><td>{{student.emailId}}</td><td class=\"client-status\"><span class=\"label label-primary\"></span></td></tr></tbody></table><div ng-if=\"courseCtrl.loadingStudents\" spinner-wave=\"\"></div></div></uib-tab><uib-tab heading=\"Student activity\" select=\"courseCtrl.getStudentNodeActivity()\"><div class=\"feed-activity-list\" ng-if=\"courseCtrl.studentNodeActivity\"><div class=\"feed-element\" ng-repeat=\"item in courseCtrl.studentNodeActivity\"><a href=\"\" class=\"pull-left\"><img img-placeholder=\"user\" alt=\"{{item.name}}\" class=\"img-circle\" ng-src=\"{{item.profilePicUrl}}\"></a><div class=\"media-body\"><small class=\"pull-right\">{{item.dateViewed | momentDateFrom}}</small> <strong>{{item.name}}</strong> viewed <strong>{{item.nodeType}} {{item.nodeNumber}}<span ng-show=\"(item.nodeType || item.nodeNumber) && item.nodeTitle\">:</span> {{item.nodeTitle}}</strong>.<br></div></div></div><div spinner-wave=\"\" ng-if=\"!courseCtrl.studentNodeActivity\"></div></uib-tab><uib-tab heading=\"Latest activity\" select=\"courseCtrl.getCourseActivity()\"><div class=\"feed-activity-list\" ng-if=\"courseCtrl.courseActivity\"><div class=\"feed-element\" ng-repeat=\"item in courseCtrl.courseActivity\"><a href=\"\" class=\"pull-left\"><img img-placeholder=\"user\" alt=\"{{item.name}}\" class=\"img-circle\" ng-src=\"{{item.profilePicUrl}}\"></a><div class=\"media-body\"><small class=\"pull-right\">{{item.dateChanged | momentDateFrom}}</small> <span ng-if=\"item.changeEntity==\'Course\' && item.changeAction==\'Create\'\"><strong>{{item.name}}</strong> created a new course, <strong>{{item.changeTitle}}</strong>.</span> <span ng-if=\"item.changeEntity==\'Course\' && item.changeAction==\'Edit\'\"><strong>{{item.name}}</strong> made changes to the course, <strong>{{item.changeTitle}}</strong>.</span> <span ng-if=\"item.changeEntity==\'Course\' && item.changeAction==\'Publish\'\"><strong>{{item.name}}</strong> published the course, <strong>{{item.changeTitle}}</strong>.</span> <span ng-if=\"item.changeEntity==\'Course\' && item.changeAction==\'Republish\'\"><strong>{{item.name}}</strong> re-published the course, <strong>{{item.changeTitle}}</strong>.</span> <span ng-if=\"item.changeEntity==\'Course\' && item.changeAction==\'Structure\'\"><strong>{{item.name}}</strong> edited the course structure of <strong>{{item.changeTitle}}</strong>.</span> <span ng-if=\"item.changeEntity.indexOf(\'CourseContent\')>=0 && item.changeAction==\'Create\'\"><strong>{{item.name}}</strong> created a new <strong>{{courseCtrl.contentTypes[item.changeEntity.replace(\'CourseContent\',\'\')]}}</strong> titled <strong>{{item.changeTitle}}</strong>.</span> <span ng-if=\"item.changeEntity.indexOf(\'CourseContent\')>=0 && item.changeAction==\'Edit\'\"><strong>{{item.name}}</strong> made changes to <strong>{{item.changeTitle}}</strong>.</span><div class=\"well\" ng-if=\"item.subList.length\"><div ng-repeat=\"subitem in item.subList\"><span ng-if=\"subitem.changeEntity==\'CourseNode\' && subitem.changeAction==\'Create\'\">- Created a new node, <strong>{{subitem.changeTitle}}</strong>.<br></span> <span ng-if=\"subitem.changeEntity==\'CourseNode\' && subitem.changeAction==\'Edit\'\">- Made changes to <strong>{{subitem.changeTitle}}</strong>.<br></span> <span ng-if=\"subitem.changeEntity==\'CourseNode\' && subitem.changeAction==\'Move\'\">- Moved <strong>{{subitem.changeTitle}}</strong>.<br></span></div></div></div></div></div><div spinner-wave=\"\" ng-if=\"!courseCtrl.courseActivity\"></div></uib-tab></uib-tabset></div></div></div><div class=\"row\" ng-if=\"!global.isAdmin && !global.isEducator\"><div class=\"col-lg-12\"><script type=\"text/ng-template\" id=\"nodes_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\" ui-sref=\"base.course.content({id:courseCtrl.courseId,nodeId:node.id})\"> <div ng-show=\"!node.inEdit\"> {{node.nodeType}} {{node.number}}<span ng-show=\"(node.nodeType || node.number) && node.title\">:</span> {{node.title}} </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ol></script><div ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"global.isAdmin || global.isEducator\" callbacks=\"courseCtrl.treeOptions\"><ol ui-tree-nodes=\"\" ng-model=\"courseCtrl.structure.data\"><li ng-repeat=\"node in courseCtrl.structure.data\" ui-tree-node=\"\" ng-include=\"\'nodes_renderer.html\'\"></li></ol></div></div></div></div><div class=\"ibox-content\" ng-if=\"!courseCtrl.loaded\"><div spinner-wave=\"\"></div></div><div class=\"ibox-content\" ng-if=\"courseCtrl.isPublishing\"><div spinner-wave=\"\">Please wait while we are publishing your course</div></div></div></div></div><div class=\"col-lg-3\" ng-if=\"global.isAdmin || global.isEducator || courseCtrl.course.description || (courseCtrl.course.resources && courseCtrl.course.resources.length)\"><div class=\"wrapper wrapper-content project-manager\" ng-if=\"courseCtrl.loaded\"><h4>Course description</h4><p class=\"small\" ng-bind-html=\"trustHtml(courseCtrl.course.description)\"></p><h4 ng-if=\"global.isAdmin || global.isEducator || (courseCtrl.course.resources && courseCtrl.course.resources.length)\">Course resources</h4><ul ng-if=\"global.isAdmin || global.isEducator || (courseCtrl.course.resources && courseCtrl.course.resources.length)\" class=\"list-unstyled project-files\"><li ng-repeat=\"resource in courseCtrl.course.resources\"><a href=\"/Api/File/CourseResource/{{resource.courseResourceId}}\" ng-if=\"resource.type==\'File\'\" target=\"_blank\" title=\"Open {{resource.name}}\"><i class=\"fa fa-file\"></i> {{resource.name}}</a> <a href=\"{{resource.link}}\" ng-if=\"resource.type==\'Link\'\" target=\"_blank\" title=\"Open {{resource.name}}\"><i class=\"fa fa-link\"></i> {{resource.name}}</a> <a href=\"\" ng-click=\"courseCtrl.deleteFile(resource)\" title=\"Delete {{resource.name}}\" ng-if=\"global.isAdmin || global.isEducator\" class=\"no-margins\"><i class=\"fa fa-close\"></i></a></li></ul><div class=\"text-center m-t-md\" ng-if=\"global.isAdmin || global.isEducator\"><div class=\"fileinput fileinput-new no-margins\" data-provides=\"fileinput\"><span class=\"btn btn-primary btn-xs btn-file\"><span class=\"fileinput-new\">Add files</span><span class=\"fileinput-exists\">Add files</span><input type=\"file\" id=\"fileUpload\" name=\"...\" multiple=\"true\" file-model=\"courseCtrl.files\" set-file-data=\"courseCtrl.addFiles(value);\"></span></div></div></div></div></div>");
$templateCache.put("app/courses/view/course.share.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-graduation-cap modal-icon\"></i><h4 class=\"modal-title\">Share this Course</h4><small class=\"font-bold\">Share your course syllabus with students or other educators via email.</small><br><small>Note: The information shown here is as per the lastest published version. To share any changes made after the last publish, you must re-publish this course.</small></div><form name=\"shareCourse\" novalidate=\"\"><div class=\"modal-body\"><div ng-if=\"shareCourseModal.loaded\"><div><label>Course name</label> {{shareCourseModal.courseTitle}}</div><div><label>Published version</label> {{shareCourseModal.course.publishedRevision}}</div><div class=\"form-group\"><label for=\"sharewith\" class=\"required\">Share with</label><ui-select id=\"sharewith\" name=\"sharewith\" multiple=\"\" ng-model=\"shareCourseModal.message.recipients\" theme=\"bootstrap\" title=\"Recipients\" array-size-min=\"1\"><ui-select-match placeholder=\"Select a person in the list or search a name\">{{$item.name}}</ui-select-match><ui-select-choices refresh=\"shareCourseModal.getPeople($select.search)\" refresh-delay=\"100\" repeat=\"person as person in shareCourseModal.people | filter: $select.search\"><i class=\"fa\" ng-class=\"{\'fa-user\':person.type==\'U\',\'fa-users\':person.type!=\'U\'}\"></i> <span ng-bind-html=\"person.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div validation-result=\"\" myform=\"shareCourse\" element=\"sharewith\" array-text=\"Please add at least one person or group\"></div></div><div class=\"form-group\"><label for=\"subject\" class=\"required\">Subject</label> <input id=\"subject\" name=\"subject\" type=\"text\" ng-model=\"shareCourseModal.message.subject\" placeholder=\"Subject...\" class=\"form-control\" required=\"\"></div><div class=\"form-group\"><label for=\"body\" class=\"required\">Message</label><div id=\"body\" name=\"body\" summernote-editor=\"shareCourseModal.message.body\" config=\"shareCourseModal.summernoteOptions\"></div></div></div><div ng-if=\"!shareCourseModal.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"shareCourseModal.cancel()\">Close</button> <a href=\"/Api/Course/{{shareCourseModal.course.courseId}}/Syllabus/Download\" target=\"_blank\" class=\"btn btn-white\">Preview Attachment</a> <button buttonspinner=\"\" ng-disabled=\"shareCourseModal.sharing\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"shareCourseModal.ok(shareCourse)\" data-style=\"expand-left\">Share</button></div></form></div>");
$templateCache.put("app/manage/apps/manage.apps.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>External Apps</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>External Apps</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>External apps available for my institution</h5><div class=\"ibox-tools\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-sm\" uib-dropdown-toggle=\"\"><i class=\"fa fa-plus\"></i> Add new app <span class=\"caret\"></span></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"\">From repository</a></li><li><a href=\"\" ng-click=\"appsCtrl.addNewApp()\">Enter new details</a></li></ul></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-4\" ng-if=\"!appsCtrl.loadingLtiApps\" ng-repeat=\"app in appsCtrl.ltiApps\"><div class=\"contact-box\"><a href=\"\" ng-click=\"appsCtrl.openApp(app)\"><div class=\"col-sm-4\"><div class=\"text-center\"><img alt=\"{{app.appName}}\" class=\"img-circle m-t-xs img-responsive\" ng-src=\"{{app.iconUrl}}\"></div></div><div class=\"col-sm-8\"><h3><strong>{{app.appName}}</strong></h3><p>{{app.appDescription}}</p></div><div class=\"clearfix\"></div></a><div class=\"row\"><div class=\"col-sm-12\"><strong>Direct LTI Access Url:</strong><br><a href=\"{{appsCtrl.baseUrl + app.ltiAppId}}\" target=\"_blank\">{{appsCtrl.baseUrl + app.ltiAppId}}</a></div></div></div></div><div class=\"col-lg-12\" ng-if=\"appsCtrl.loadingLtiApps\"><div spinner-wave=\"\"></div></div></div></div>");
$templateCache.put("app/manage/apps/manage.apps.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-cog modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"!appModalCtrl.app.ltiAppId\">Create a new External App</h4><h4 class=\"modal-title\" ng-if=\"appModalCtrl.app.ltiAppId\">{{appModalCtrl.app.appName}}</h4><small class=\"font-bold\">Enter your External App details below.</small></div><form name=\"editLtiApp\" ng-if=\"!appModalCtrl.loading\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label for=\"appName\" class=\"required\">App name</label> <input id=\"appName\" name=\"appName\" type=\"text\" ng-model=\"appModalCtrl.app.appName\" placeholder=\"Enter a name for the app\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editLtiApp\" element=\"appName\" required-text=\"Please specify a name\"></div></div><div class=\"form-group\"><label for=\"appDescription\">Description</label><textarea id=\"appDescription\" name=\"appDescription\" ng-model=\"appModalCtrl.app.appDescription\" placeholder=\"Enter a description\" class=\"form-control\"></textarea></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"ltiKey\" class=\"required\">LTI Key</label> <input id=\"ltiKey\" name=\"ltiKey\" type=\"text\" ng-model=\"appModalCtrl.app.ltiKey\" placeholder=\"Enter the LTI key for authenticating with this app\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editLtiApp\" element=\"ltiKey\" required-text=\"Please specify an LTI key\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"ltiSecret\" class=\"required\">LTI Secret</label> <input ng-if=\"!appModalCtrl.app.ltiAppId\" id=\"ltiSecret\" name=\"ltiSecret\" type=\"text\" ng-model=\"appModalCtrl.app.ltiSecret\" placeholder=\"Enter the LTI secret for authenticating with this app\" class=\"form-control\" required=\"\"><input ng-if=\"appModalCtrl.app.ltiAppId\" id=\"ltiSecret\" name=\"ltiSecret\" type=\"text\" ng-model=\"appModalCtrl.app.ltiSecret\" placeholder=\"********\" class=\"form-control\"><div validation-result=\"\" myform=\"editLtiApp\" element=\"ltiSecret\" required-text=\"Please specify an LTI secret\" ng-if=\"!appModalCtrl.app.ltiAppId\"></div></div></div></div><div class=\"form-group\"><label for=\"endpoint\" class=\"required\">App LTI endpoint</label> <input id=\"endpoint\" name=\"endpoint\" type=\"url\" ng-model=\"appModalCtrl.app.endpoint\" placeholder=\"Enter the endpoint/url to connect to this app\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editLtiApp\" element=\"endpoint\" required-text=\"Please specify an LTI endpoint\"></div><div validation-result=\"\" myform=\"editLtiApp\" element=\"endpoint\" url-text=\"Please specify a valid endpoint url\"></div></div><div class=\"form-group\"><label for=\"customParams\">Custom parameters</label><textarea id=\"customParams\" name=\"customParams\" ng-model=\"appModalCtrl.app.customParams\" placeholder=\"Enter any additional parameters to pass to the LTI endpoint (optional)\" class=\"form-control\"></textarea></div><div><label for=\"keepPrivate\"><input icheck=\"\" id=\"keepPrivate\" name=\"keepPrivate\" type=\"checkbox\" ng-model=\"appModalCtrl.app.privateInfo\"> Do not send user sensitive data to this app</label></div><div><label for=\"isActive\"><input icheck=\"\" id=\"isActive\" name=\"isActive\" type=\"checkbox\" ng-model=\"appModalCtrl.app.isActive\"> Make this app active</label></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"appModalCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"appModalCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"appModalCtrl.ok(editLtiApp)\" data-style=\"expand-left\">Save</button></div></form><div ng-if=\"appModalCtrl.loading\" spinner-wave=\"\"></div></div>");
$templateCache.put("app/manage/oauthusers/manage.oauth.users.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>External OAuth Users</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>External OAuth Users</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h2>Give external users access to view and edit courses and content</h2><p>Generate secure credentials for external providers / contributors and customize what they have access to</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search...\" class=\"input form-control\" ng-model=\"oauthUsersCtrl.filter\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn btn-primary\"><i class=\"fa fa-search\"></i> Search</button></span></div><div class=\"clients-list\"><div class=\"p-xxs no-margins clearfix\"><button ng-click=\"oauthUsersCtrl.newUser()\" type=\"button\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"New User\"><i class=\"fa fa-plus\"></i> Add a new user</button></div><div class=\"full-height-scroll\" full-scroll=\"\" ng-if=\"!oauthUsersCtrl.loading && oauthUsersCtrl.users.length > 0\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"user in oauthUsersCtrl.users | filter: oauthUsersCtrl.filter | orderBy:[\'name\']\"><td><a ng-click=\"oauthUsersCtrl.openUser(user.oAuthId)\" class=\"client-link\">{{user.name}}</a></td><td>{{user.allowedDomains}}</td><td class=\"client-status\"><span class=\"label label-primary\" ng-if=\"user.isActive\">Active</span><span class=\"label label-danger\" ng-if=\"!user.isActive\">Inactive</span></td></tr></tbody></table></div></div><div ng-if=\"oauthUsersCtrl.loading\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/manage/oauthusers/oauth.user.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-cog modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"!oauthUserCtrl.user.oAuthId\">Create a new External OAuth User</h4><h4 class=\"modal-title\" ng-if=\"oauthUserCtrl.user.oAuthId\">{{oauthUserCtrl.user.name}}</h4><small class=\"font-bold\">Enter the external user\'s details below.</small></div><form name=\"editOAuthUser\" ng-if=\"!oauthUserCtrl.loading\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label for=\"name\" class=\"required\">Name</label> <input id=\"name\" name=\"name\" type=\"text\" ng-model=\"oauthUserCtrl.user.name\" placeholder=\"Enter a name for this user\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editOAuthUser\" element=\"name\" required-text=\"Please specify a name\"></div></div><div class=\"form-group\"><label for=\"ltiKey\">OAuth Key / Secret</label> (These will be automatically generated) <span ng-if=\"oauthUserCtrl.user.oAuthId\">&nbsp;&nbsp;<button buttonspinner=\"\" ng-disabled=\"oauthUserCtrl.resetting\" class=\"buttonspinner-button btn btn-white\" ng-click=\"oauthUserCtrl.resetOAuth()\" data-style=\"expand-left\" title=\"Reset the Key / Secret\"><i class=\"fa fa-refresh\"></i> Reset the Key / Secret</button> &nbsp;&nbsp;<a ng-href=\"/Api/ManageOAuth/User/{{oauthUserCtrl.user.oAuthId}}/Credentials\" target=\"_blank\" class=\"btn btn-primary\" title=\"Download the Key / Secret\"><i class=\"fa fa-download\"></i> Download the Key / Secret</a></span> <span class=\"block\" ng-if=\"!oauthUserCtrl.user.oAuthId\">********************</span> <small class=\"text-danger block\" ng-if=\"oauthUserCtrl.user.oAuthId\">(Ensure that the OAuth Key and Secret are sent to the external user using secure means. If the Key/Secret are compromised, they should be Reset.)</small></div><div class=\"form-group\"><label for=\"allowedDomains\">Allowed domains</label><textarea id=\"allowedDomains\" name=\"allowedDomains\" ng-model=\"oauthUserCtrl.user.allowedDomains\" placeholder=\"If this user should only access the API from certain domains, enter these one or more domains, either comma-separated or on separate lines. Leave this input blank to allow access from any domain. The domain should not contain the protocol (http:// or https://). (optional)\" class=\"form-control\"></textarea></div><div><label for=\"isActive\"><input icheck=\"\" id=\"isActive\" name=\"isActive\" type=\"checkbox\" ng-model=\"oauthUserCtrl.user.isActive\"> Make user active</label></div><div><div class=\"form-group\"><label for=\"permissions\">Permissions / Allow access to</label><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"permission in oauthUserCtrl.permissionTypes\"><td>{{permission.name}}</td><td><select chosen=\"{width: \'100%\'}\" id=\"accessLevel\" name=\"accessLevel\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"oauthUserCtrl.permissions[permission.value].accessLevel\" ng-options=\"level.value as level.name for level in oauthUserCtrl.accessLevels\" data-placeholder-text-single=\"\'No access\'\"></select></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"oauthUserCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"oauthUserCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"oauthUserCtrl.ok(editOAuthUser)\" data-style=\"expand-left\">Save</button></div></form><div ng-if=\"oauthUserCtrl.loading\" spinner-wave=\"\"></div></div>");
$templateCache.put("app/manage/settings/email.templates.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Email Templates</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>Email Templates</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"form-group\"><ui-select id=\"templateKey\" name=\"templateKey\" ng-model=\"templatesCtrl.templateKey\" on-select=\"templatesCtrl.templateKeySelected($item)\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select template...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in templatesCtrl.templateKeys | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></div><form name=\"emailTemplates\" novalidate=\"\" ng-show=\"!templatesCtrl.waiting\" ng-if=\"templatesCtrl.template\"><div class=\"form-group\" ng-if=\"templatesCtrl.templateKey!=\'main\'\"><label for=\"subject\" class=\"control-label required\">Subject</label> <input id=\"subject\" name=\"subject\" type=\"text\" class=\"form-control\" ng-model=\"templatesCtrl.template.subject\" required=\"\"><div validation-result=\"\" myform=\"emailTemplates\" element=\"subject\" required-text=\"Please specify a subject\"></div></div><div class=\"form-group\"><label for=\"templateContent\" class=\"control-label required\">Email Body</label><div id=\"templateContent\" name=\"templateContent\" summernote=\"\" class=\"summernote\" config=\"templatesCtrl.summernoteOptions\" ng-model=\"templatesCtrl.template.templateContent\" on-image-upload=\"templatesCtrl.imageUpload(files)\" editor=\"templatesCtrl.editor\"></div></div><button buttonspinner=\"\" ng-disabled=\"templatesCtrl.saving\" type=\"submit\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"templatesCtrl.save(emailTemplates)\" title=\"Save Template\">Save Template</button></form><div spinner-wave=\"\" ng-if=\"templatesCtrl.waiting\"></div></div></div></div></div></div>");
$templateCache.put("app/manage/settings/manage.settings.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>General Institution Settings</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>General Institution Settings</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>General Institution Settings</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><form name=\"settingsForm\" method=\"get\" class=\"form-horizontal\" ng-show=\"!settingsCtrl.loadingSettings\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" for=\"name\">Name</label><div class=\"col-sm-10\"><input id=\"name\" name=\"name\" type=\"text\" class=\"form-control\" ng-model=\"settingsCtrl.settings.name\" maxlength=\"200\" required=\"\"><div validation-result=\"\" myform=\"settingsForm\" element=\"name\" required-text=\"Please specify a name\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" for=\"hostDomain\">Domain</label><div class=\"col-sm-10\"><input id=\"hostDomain\" name=\"hostDomain\" type=\"text\" class=\"form-control\" ng-model=\"settingsCtrl.settings.hostDomain\" maxlength=\"200\" required=\"\"> <span class=\"help-block m-b-none\">Enter the fully qualified domain name (e.g., <strong>www.myinstitution.com</strong>, without http or https)</span><div validation-result=\"\" myform=\"settingsForm\" element=\"hostDomain\" required-text=\"Please specify a domain name\"></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" for=\"timeZoneId\">Time Zone</label><div class=\"col-sm-10\"><select chosen=\"{width: \'100%\'}\" id=\"timeZoneId\" name=\"timeZoneId\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"settingsCtrl.settings.timeZoneId\" ng-options=\"tz.id as tz.name for tz in settingsCtrl.timeZones\" data-placeholder-text-single=\"\'Select a time zone\'\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\" for=\"locale\">Default Language</label><div class=\"col-sm-10\"><select chosen=\"{width: \'100%\'}\" id=\"locale\" name=\"locale\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"settingsCtrl.settings.defaultLocale\" ng-options=\"tz.key as tz.name for tz in settingsCtrl.locales\" data-placeholder-text-single=\"\'Select a language\'\"></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" for=\"grading\">Grading</label><div class=\"col-sm-10 clearfix\"><div class=\"datatable-hide-controls\"><table datatable=\"ng\" dt-options=\"settingsCtrl.dtOptions\" dt-column-defs=\"settingsCtrl.dtColumnDefs\" class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Grade</th><th>Min Points</th><th>Max Points</th><th></th></tr></thead><tbody><tr ng-repeat=\"grading in settingsCtrl.settings.institutionGrades\"><td><input id=\"grade-{{$index}}\" name=\"grade-{{$index}}\" type=\"text\" class=\"form-control\" ng-model=\"grading.grade\" maxlength=\"3\" required=\"\"><div validation-result=\"\" myform=\"settingsForm\" element=\"grade-{{$index}}\" required-text=\"Please enter a grade\"></div></td><td><span ng-show=\"grading.minPoints>=0\">{{ grading.minPoints == 0 ? grading.minPoints : \'&gt;\' + grading.minPoints }}</span></td><td><div style=\"max-width:150px\"><input id=\"maxPoints-{{$index}}\" type=\"text\" name=\"maxPoints-{{$index}}\" touch-spin=\"\" spin-options=\"settingsCtrl.spinOptions\" ng-model=\"grading.maxPoints\" ng-change=\"settingsCtrl.maxPointsChanged(grading)\" required=\"\"></div><div validation-result=\"\" myform=\"settingsForm\" element=\"maxPoints-{{$index}}\" required-text=\"Please enter the max points\"></div></td><td><button class=\"btn btn-danger\" ng-click=\"settingsCtrl.removeGrading($index, grading)\" ng-if=\"$index>0\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div><button class=\"btn btn-primary pull-right\" ng-click=\"settingsCtrl.addGrading()\" title=\"Add new grading\"><i class=\"fa fa-plus\"></i> Add new</button></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" for=\"passPercentage\">Pass Percentage</label><div class=\"col-sm-10\"><div style=\"max-width:150px\"><input id=\"passPercentage\" type=\"text\" name=\"passPercentage\" touch-spin=\"\" spin-options=\"settingsCtrl.spinOptions\" ng-model=\"settingsCtrl.settings.passPercentage\" required=\"\"></div><span class=\"help-block m-b-none\">Enter the percentage at which graded assessments and assignments will be marked as passed in the gradebook</span><div validation-result=\"\" myform=\"settingsForm\" element=\"passPercentage\" required-text=\"Please specify a pass percentage\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><label for=\"takeDayAttendance\"><input icheck=\"\" id=\"takeDayAttendance\" name=\"takeDayAttendance\" type=\"checkbox\" ng-model=\"settingsCtrl.settings.takeDayAttendance\"> Take overall attendance for entire day</label></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label required\" for=\"grading\">Periods / Time Slots</label><div class=\"col-sm-10 clearfix\"><div class=\"datatable-hide-controls\"><table datatable=\"ng\" dt-options=\"settingsCtrl.dtLiteOptions\" dt-column-defs=\"settingsCtrl.dtTSColumnDefs\" class=\"table table-striped table-bordered table-hover\"><thead><tr><th></th><th>Short Name<br><em>(optional)</em></th><th>Start Time</th><th>End Time</th><th>Take Attendance</th><th>Non-Academic Period</th><th></th></tr></thead><tbody><tr ng-repeat=\"timeSlot in settingsCtrl.settings.institutionTimeSlots\"><td>{{timeSlot.institutionTimeSlotId}}</td><td><input id=\"shortName\" name=\"shortName\" type=\"text\" class=\"form-control\" ng-model=\"timeSlot.shortName\" maxlength=\"30\"></td><td><div class=\"input-group\" clock-picker=\"\" data-autoclose=\"true\"><input id=\"startTime-{{$index}}\" name=\"startTime-{{$index}}\" type=\"text\" class=\"form-control\" ng-model=\"timeSlot.startTime\" required=\"\"> <span class=\"input-group-addon\"><span class=\"fa fa-clock-o\"></span></span></div><div validation-result=\"\" myform=\"settingsForm\" element=\"startTime-{{$index}}\" required-text=\"Please enter a start time\"></div></td><td><div class=\"input-group\" clock-picker=\"\" data-autoclose=\"true\"><input id=\"endTime-{{$index}}\" name=\"endTime-{{$index}}\" type=\"text\" class=\"form-control\" ng-model=\"timeSlot.endTime\" required=\"\"> <span class=\"input-group-addon\"><span class=\"fa fa-clock-o\"></span></span></div><div validation-result=\"\" myform=\"settingsForm\" element=\"endTime-{{$index}}\" required-text=\"Please enter an end time\"></div></td><td><label for=\"takeAttendance\"><input icheck=\"\" id=\"takeAttendance\" name=\"takeAttendance\" type=\"checkbox\" ng-model=\"timeSlot.takeAttendance\"></label></td><td><label for=\"nonAcademic\"><input icheck=\"\" id=\"nonAcademic\" name=\"nonAcademic\" type=\"checkbox\" ng-model=\"timeSlot.nonAcademic\"></label></td><td><button class=\"btn btn-danger\" ng-click=\"settingsCtrl.removeTimeSlot($index, timeSlot)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div><button class=\"btn btn-primary pull-right\" ng-click=\"settingsCtrl.addTimeSlot()\" title=\"Add new period or time slot\"><i class=\"fa fa-plus\"></i> Add new</button></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Institution Logo</label><div class=\"col-sm-10\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" on-bs-file-input-change=\"settingsCtrl.uploadLogo($event, main)\"><div class=\"fileinput-new\"><img alt=\"Institution Logo\" class=\"img-responsive\" ng-src=\"{{settingsCtrl.settings.profilePicUrl}}\"></div><div class=\"fileinput-preview fileinput-exists img-responsive\"></div><div><span class=\"btn btn-default btn-xs btn-file\" title=\"Select new logo\"><i class=\"fa fa-pencil\"></i> <span class=\"fileinput-new\">Select new logo</span><span class=\"fileinput-exists\">Select new logo</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"settingsCtrl.file\" set-file-data=\"settingsCtrl.file = value;\"></span></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Google Analytics Code</label><div class=\"col-sm-10\"><ui-codemirror ui-codemirror-opts=\"settingsCtrl.codeEditorOptions\" ng-model=\"settingsCtrl.settings.gaCode\"></ui-codemirror></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button buttonspinner=\"\" ng-disabled=\"settingsCtrl.savingSettings\" type=\"submit\" data-style=\"expand-left\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"settingsCtrl.saveSettings(settingsForm.$valid)\">Save changes</button></div></div></form><div spinner-wave=\"\" ng-if=\"settingsCtrl.loadingSettings\"></div></div></div></div></div></div>");
$templateCache.put("app/manage/themes/manage.themes.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Themes and Scripts</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>Themes and Scripts</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h2>Change your layout and theme, and include third-party javascript</h2><p>Choose from side or top menu and pick from various color options to customize your experience. You may also upload your logo here. Upload/insert third party javascript code to enhance the application or add custom functionality.</p></div></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Top navigation, centered content layout</h4><div class=\"m-t-md\"><div class=\"p-lg\"><a ui-sref=\"dashboards_top.dashboard_4\"><img class=\"img-responsive img-shadow\" src=\"img/dashbard4_2.jpg\" alt=\"\"></a></div></div><div class=\"text-center\"><button class=\"btn btn-primary\" title=\"Preview\" ng-click=\"themesCtrl.previewLayout(\'top\')\">Preview</button></div></div></div></div><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Left side navigation layout</h4><div class=\"m-t-md\"><div class=\"p-lg\"><a ui-sref=\"dashboards.dashboard_4_1\"><img class=\"img-responsive img-shadow\" src=\"img/dashbard4_1.jpg\" alt=\"\"></a></div></div><div class=\"text-center\"><button class=\"btn btn-primary\" title=\"Preview\" ng-click=\"themesCtrl.previewLayout(\'left\')\">Preview</button></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Dark Blue Sidebar + Green Theme</h4><div class=\"m-t-md\"><div class=\"p-lg\"><a ui-sref=\"dashboards_top.dashboard_4\"><img class=\"img-responsive img-shadow\" src=\"img/dashbard4_2.jpg\" alt=\"\"></a></div></div><div class=\"text-center\"><button class=\"btn btn-primary\" title=\"Preview\" ng-click=\"main.theme=\'\';\">Preview</button></div></div></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Dark Blue Sidebar + Turquoise Theme</h4><div class=\"m-t-md\"><div class=\"p-lg\"><a ui-sref=\"dashboards_top.dashboard_4\"><img class=\"img-responsive img-shadow\" src=\"img/dashbard4_2.jpg\" alt=\"\"></a></div></div><div class=\"text-center\"><button class=\"btn btn-primary\" title=\"Preview\" ng-click=\"main.theme=\'skin-2\';\">Preview</button></div></div></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Blue Sidebar + Blue Theme</h4><div class=\"m-t-md\"><div class=\"p-lg\"><a ui-sref=\"dashboards_top.dashboard_4\"><img class=\"img-responsive img-shadow\" src=\"img/dashbard4_2.jpg\" alt=\"\"></a></div></div><div class=\"text-center\"><button class=\"btn btn-primary\" title=\"Preview\" ng-click=\"main.theme=\'skin-1\';\">Preview</button></div></div></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Yellow Sidebar + Yellow Theme</h4><div class=\"m-t-md\"><div class=\"p-lg\"><a ui-sref=\"dashboards_top.dashboard_4\"><img class=\"img-responsive img-shadow\" src=\"img/dashbard4_2.jpg\" alt=\"\"></a></div></div><div class=\"text-center\"><button class=\"btn btn-primary\" title=\"Preview\" ng-click=\"main.theme=\'skin-3\';\">Preview</button></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h4 class=\"m-b-xxs\">Institution Logo</h4><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\" on-bs-file-input-change=\"themesCtrl.uploadLogo($event,main)\"><div class=\"fileinput-new\"><img alt=\"Institution Logo\" class=\"img-responsive\" ng-src=\"{{themesCtrl.logoUrl}}\"></div><div class=\"fileinput-preview fileinput-exists img-responsive\"></div><div><span class=\"btn btn-default btn-xs btn-file\" title=\"Select new logo\"><i class=\"fa fa-pencil\"></i> <span class=\"fileinput-new\">Select new logo</span><span class=\"fileinput-exists\">Select new logo</span><input type=\"file\" id=\"logoUpload\" name=\"logoUpload\" ng-model=\"themesCtrl.file\" file-model=\"themesCtrl.file\" set-file-data=\"themesCtrl.file = value;\"></span></div></div></div></div></div></div><div class=\"row\" ng-if=\"themesCtrl.loaded\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><form name=\"addNewScript\" novalidate=\"\"><div class=\"input-group\" ng-show=\"!themesCtrl.saving\"><span class=\"input-group-btn\"><ui-select id=\"newType\" name=\"newType\" ng-model=\"themesCtrl.newScript.type\" on-select=\"themesCtrl.scriptTypeSelected($item)\" theme=\"bootstrap\" style=\"width:150px\" ng-required=\"true\"><ui-select-match placeholder=\"Script Source...\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"item.value as item in themesCtrl.scriptTypes | filter: $select.search\"><span ng-bind-html=\"item.text | highlight: $select.search\"></span></ui-select-choices></ui-select></span> <input id=\"newTitle\" name=\"newTitle\" type=\"text\" class=\"form-control\" placeholder=\"Enter a title...\" ng-model=\"themesCtrl.newScript.title\" required=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"themesCtrl.addNew(addNewScript)\" title=\"Add New Content\">Add new script!</button></span></div><div validation-result=\"\" myform=\"addNewScript\" element=\"newType\" required-text=\"Please specify a source\"></div><div validation-result=\"\" myform=\"addNewScript\" element=\"newTitle\" required-text=\"Please specify a title\"></div><div class=\"form-group\"><label for=\"enabled\"><input icheck=\"\" id=\"enabled\" name=\"enabled\" type=\"checkbox\" ng-model=\"themesCtrl.newScript.enabled\"> Enable script</label></div><ui-codemirror ui-codemirror-opts=\"themesCtrl.codeEditorOptions\" ng-model=\"themesCtrl.newScript.rawContent\" ng-if=\"themesCtrl.newScript.type==\'Code\'\"></ui-codemirror><div ng-if=\"themesCtrl.newScript.type==\'File\'\"><label for=\"fileUpload\" class=\"required\">Specify a file below:</label><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-default btn-file\"><span class=\"fileinput-new\">Select file</span><span class=\"fileinput-exists\">Change</span><input type=\"file\" id=\"fileUpload\" name=\"fileUpload\" ng-model=\"themesCtrl.newScript.file\" file-model=\"themesCtrl.newScript.file\" set-file-data=\"themesCtrl.newScript.file = value;\" file-required=\"\"></span> <a href=\"#\" class=\"input-group-addon btn btn-default fileinput-exists\" data-dismiss=\"fileinput\">Remove</a></div><div validation-result=\"\" myform=\"addNewScript\" element=\"fileUpload\" file-text=\"Please select a file\"></div></div><div class=\"form-group\" ng-if=\"themesCtrl.newScript.type==\'Url\'\"><label for=\"externalUrl\" class=\"control-label required\">Url</label> <input id=\"externalUrl\" name=\"externalUrl\" type=\"url\" class=\"form-control\" ng-model=\"themesCtrl.newScript.externalUrl\" required=\"\"><div validation-result=\"\" myform=\"addNewScript\" element=\"externalUrl\" required-text=\"Please specify a url\" url-text=\"Please specify a valid url\"></div></div><div class=\"form-group clearfix\" ng-if=\"themesCtrl.newScript.type==\'Url\'\"><label for=\"updateFrequencyDays\" class=\"control-label pull-left\">Check for updated script every:&nbsp;</label><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" name=\"updateFrequencyDays\" touch-spin=\"\" spin-options=\"themesCtrl.frequencyOptions\" ng-model=\"themesCtrl.newScript.updateFrequencyDays\" style=\"width:50px\"></div><label class=\"control-label pull-left\">&nbsp;{{themesCtrl.newScript.updateFrequencyDays == 1 ? \'day\' : \'days\'}} (0 for never)</label></div><div spinner-wave=\"\" ng-if=\"themesCtrl.saving\">Saving...</div></form></div></div></div></div><div class=\"row\" ng-repeat=\"item in themesCtrl.scripts\" ng-if=\"themesCtrl.loaded\"><div class=\"col-lg-12\"><div class=\"ibox\"><ng-form name=\"editScript\"><div class=\"ibox-title\"><h5>{{item.title}}</h5><div ibox-tools=\"\" closebox=\"themesCtrl.deleteContent(item)\"><a ng-click=\"themesCtrl.editScript(item)\" title=\"Edit Script\" ng-show=\"!item.editing\"><i class=\"fa fa-pencil\"></i></a> <button ng-click=\"themesCtrl.cancelEditScript(item)\" title=\"Cancel Script Edit\" ng-show=\"item.editing\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-minus-circle\"></i> Cancel</button> <button ng-click=\"editScript.$submitted=true;themesCtrl.saveScript(editScript, item);\" type=\"submit\" title=\"Save changes\" ng-show=\"item.editing\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-save\"></i> Save changes</button></div></div><div class=\"ibox-content\" ng-show=\"!item.saving\"><div ng-if=\"item.type==\'Url\'\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3\"><label for=\"externalUrl\" ng-class=\"{\'required\':item.editing}\">Url:</label></div><div class=\"col-md-9\" ng-if=\"!item.editing\">{{item.externalUrl}}</div><div class=\"col-md-9\" ng-if=\"item.editing\"><input id=\"externalUrl\" name=\"externalUrl\" type=\"url\" class=\"form-control\" ng-model=\"item.externalUrl\" required=\"\"><div validation-result=\"\" myform=\"editScript\" element=\"externalUrl\" required-text=\"Please specify a url\" url-text=\"Please specify a valid url\"></div></div></div></div><div class=\"row\" ng-show=\"!item.editing\"><div class=\"col-md-3\">&nbsp;</div><div class=\"col-md-9\" ng-if=\"item.updateFrequencyDays\"><label>Check for updated script {{item.updateFrequencyDays == 1 ? \'daily\' : \'every \' + item.updateFrequencyDays + \' days\'}}</label></div><div class=\"col-md-9\" ng-if=\"!item.updateFrequencyDays\"><label>Never check for updates to this script</label></div></div><div class=\"form-group clearfix\" ng-if=\"item.editing\"><label for=\"updateFrequencyDays\" class=\"control-label pull-left\">Check for updated script every:&nbsp;</label><div style=\"width:113px\" class=\"pull-left\"><input type=\"text\" name=\"updateFrequencyDays\" touch-spin=\"\" spin-options=\"themesCtrl.frequencyOptions\" ng-model=\"item.updateFrequencyDays\" style=\"width:50px\"></div><label class=\"control-label pull-left\">&nbsp;{{item.updateFrequencyDays == 1 ? \'day\' : \'days\'}} (0 for never)</label></div><div class=\"row\"><div class=\"col-md-3\"><label>Last updated on:</label></div><div class=\"col-md-9\">{{item.lastUpdated}}</div></div></div><div ng-if=\"item.type==\'Code\'\"><ui-codemirror ui-codemirror-opts=\"themesCtrl.codeEditorOptions\" ng-model=\"item.rawContent\" read-only=\"!item.editing\"></ui-codemirror></div><div ng-if=\"item.type==\'File\'\"><label ng-show=\"!item.editing\">Uploaded File (<span ng-if=\"item.fileSize < 1024\">< 1</span><span ng-if=\"item.fileSize >= 1024\">{{(item.fileSize / 1024) | number : 0}}</span> Kb)</label><div ng-if=\"item.editing\"><label for=\"fileUpload\" class=\"required\">Upload a new file:</label><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><div class=\"form-control\" data-trigger=\"fileinput\"><i class=\"glyphicon glyphicon-file fileinput-exists\"></i> <span class=\"fileinput-filename\"></span></div><span class=\"input-group-addon btn btn-default btn-file\"><span class=\"fileinput-new\">Select file</span><span class=\"fileinput-exists\">Change</span><input type=\"file\" id=\"fileUpload\" name=\"fileUpload\" ng-model=\"item.file\" file-model=\"item.file\" set-file-data=\"item.file = value;\" file-required=\"\"></span> <a href=\"#\" class=\"input-group-addon btn btn-default fileinput-exists\" data-dismiss=\"fileinput\">Remove</a></div><div validation-result=\"\" myform=\"editScript\" element=\"fileUpload\" file-text=\"Please select a file\"></div></div></div></div><div class=\"ibox-content\" ng-if=\"item.saving\"><div spinner-wave=\"\"></div></div><div class=\"ibox-footer\"><div ng-show=\"!item.editing\">{{item.enabled ? \'Enabled\' : \'Disabled\'}}</div><div class=\"form-group\" ng-show=\"item.editing\"><label for=\"enabled\"><input icheck=\"\" id=\"enabled\" name=\"enabled\" type=\"checkbox\" ng-model=\"item.enabled\"> Enable script</label></div></div></ng-form></div></div></div><div spinner-wave=\"\" ng-if=\"!themesCtrl.loaded\"></div></div>");
$templateCache.put("app/manage/timetables/manage.timetables.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Timetables</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>Timetables</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight blog\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content text-center p-md\"><h2></h2><p>View and edit timetables for classes and courses</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"clients-list\"><div class=\"row\"><div class=\"col-md-6\"><ui-select id=\"timetableId\" name=\"timetableId\" ng-model=\"timetablesCtrl.timetableId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"timetablesCtrl.timetableIdChanged()\"><ui-select-match placeholder=\"Select a timetable\"><span>{{$select.selected.label}}</span><span ng-if=\"$select.selected.label && $select.selected.startDate\">&nbsp;-&nbsp;</span> <span ng-if=\"$select.selected.startDate\">{{$select.selected.startDate | momentDate}} to {{$select.selected.endDate | momentDate}}</span></ui-select-match><ui-select-choices repeat=\"tt.timetableId as tt in timetablesCtrl.timetables | filter: $select.search\"><div><span ng-bind-html=\"tt.label | highlight: $select.search\"></span><span ng-if=\"tt.label && tt.startDate\">&nbsp;-&nbsp;</span> <span ng-if=\"tt.startDate\">{{tt.startDate | momentDate}} to {{tt.endDate | momentDate}}</span></div></ui-select-choices></ui-select></div><div class=\"col-md-6\"><ui-select id=\"courseId\" name=\"courseId\" ng-model=\"timetablesCtrl.departmentId\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"timetablesCtrl.departmentIdChanged()\"><ui-select-match placeholder=\"Select a department\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"dept.departmentId as dept in timetablesCtrl.departments | filter: $select.search\"><div ng-bind-html=\"dept.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div ng-if=\"!timetablesCtrl.loadingTimetable && timetablesCtrl.timetable && timetablesCtrl.timetable.length\"><table class=\"table table-striped table-bordered table-hover m-t-sm\"><thead><tr><th></th><th>Monday</th><th>Tuesday</th><th>Wednesday</th><th>Thursday</th><th>Friday</th><th>Saturday</th><th>Sunday</th></tr></thead><tbody><tr ng-repeat=\"timeRow in timetablesCtrl.timetable\"><td><strong ng-if=\"timeRow.shortName\">{{timeRow.shortName}}<br></strong> {{timeRow.text}}</td><td ng-repeat=\"day in timeRow.days\"><ul ng-if=\"!timeRow.nonAcademic\" ui-sortable=\"day.sortableOptions\" ng-model=\"day.courses\" data-day=\"{{day.day}}\" data-row-id=\"{{timeRow.id}}\" class=\"unstyled no-paddings items-container\"><li ng-if=\"!day.courses.length\">&nbsp;</li><li class=\"m-b-xs sortable\" ng-repeat=\"courseObj in day.courses\"><div class=\"btn-group\"><div class=\"btn btn-primary btn-sm\" tooltip-placement=\"top\" uib-tooltip-html=\"courseObj.groupNames\">{{courseObj.courseName}} <span ng-if=\"courseObj.node\">&nbsp;&gt;&nbsp;{{courseObj.node | nodeName}}</span></div><div class=\"btn btn-primary btn-sm\" ng-click=\"timetablesCtrl.removeItem(day.courses, $index, courseObj)\" title=\"Remove from timetable\"><span class=\"fa fa-close\"></span></div></div></li></ul><div ng-if=\"!timeRow.nonAcademic\" class=\"btn-group\" uib-dropdown=\"\"><button ng-click=\"timetablesCtrl.loadCourses()\" class=\"btn btn-default btn-sm\" title=\"Add course to timetable\" uib-dropdown-toggle=\"\"><i class=\"fa fa-plus\"></i></button><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-if=\"timetablesCtrl.loadingCourses\"><a href=\"#\"><div spinner-wave=\"\"></div></a></li><li ng-repeat=\"course in timetablesCtrl.courses[timetablesCtrl.departmentId]\" ng-class=\"{\'dropdown-submenu\':course.nodeCount}\"><a href=\"\" ng-click=\"timetablesCtrl.addCourse(course, timeRow, day)\" on-delayed-hover=\"timetablesCtrl.loadCourseNodes(course)\" hover-delay=\"500\" class=\"clearfix\" title=\"Add course to timetable\">{{course.name}} <button class=\"btn btn-default btn-xs\" ng-click=\"timetablesCtrl.loadCourseNodes(course)\" title=\"Open course structure\" no-propagation=\"\"><span class=\"fa fa-caret-right\"></span></button></a><ul class=\"dropdown-menu block\" ng-show=\"course.nodeCount && course.showNodes\" ng-mouseleave=\"course.showNodes=false\"><li ng-if=\"course.loadingNodes\"><a href=\"#\"><div spinner-wave=\"\"></div></a></li><li ng-repeat=\"courseNode in course.courseNodes\"><a href=\"\" ng-click=\"timetablesCtrl.addCourseNode(course, courseNode, timeRow, day)\" title=\"Add lesson to timetable\">{{courseNode | nodeName}}</a></li></ul></li></ul></div></td></tr></tbody></table></div><div ng-if=\"timetablesCtrl.loadingTimetable\" spinner-wave=\"\"></div></div></div></div></div></div></div>");
$templateCache.put("app/manage/timetables/new.timetable.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-graduation-cap modal-icon\"></i><h4 class=\"modal-title\">Create a New Timetable</h4><small class=\"font-bold\">This could be for a new year, term, semester, ...</small></div><form name=\"createTimetable\" novalidate=\"\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"label\" class=\"required\">Label</label> <input id=\"label\" name=\"label\" type=\"text\" ng-model=\"newTimetableCtrl.timetable.label\" placeholder=\"Enter a label for the new timetable\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"createTimetable\" element=\"label\" required-text=\"Please specify a label\"></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group clearfix\"><label for=\"startDate\" class=\"control-label\">Start date</label><div class=\"input-group date\"><input type=\"datetime\" id=\"startDate\" name=\"startDate\" class=\"form-control\" date-time=\"\" ng-model=\"newTimetableCtrl.timetable.startDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div validation-result=\"\" myform=\"createTimetable\" element=\"startDate\" required-text=\"Please specify a start date\"></div></div></div><div class=\"col-sm-6\"><div class=\"form-group clearfix\"><label for=\"endDate\" class=\"control-label\">End date</label><div class=\"input-group date\"><input type=\"datetime\" id=\"endDate\" name=\"endDate\" class=\"form-control\" date-time=\"\" ng-model=\"newTimetableCtrl.timetable.endDate\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" required=\"\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span></div><div validation-result=\"\" myform=\"createTimetable\" element=\"endDate\" required-text=\"Please specify a end date\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"newTimetableCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"newTimetableCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"newTimetableCtrl.ok(createTimetable)\" data-style=\"expand-left\">Create</button></div></form></div>");
$templateCache.put("app/manage/users/addresses.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-user modal-icon\"></i><h4 class=\"modal-title\">Addresses / Contact Details</h4><small class=\"font-bold\">Enter this student\'s addresses and contact details below.</small></div><div class=\"modal-body\"><div ng-repeat=\"address in addressesCtrl.addresses\"><ng-form name=\"editUser\"><div class=\"row m-b-sm\" ng-if=\"!address.inEdit\"><div class=\"col-md-12\"><strong>{{address.label}}</strong><span ng-if=\"address.sendMail\">&nbsp;(use as Postal Address)</span><br><i class=\"fa fa-envelope\"></i> {{address.main}}, {{address.city}},<br>{{address.state}}, {{address.zip}}<br><i class=\"fa fa-phone\" ng-if=\"address.altPhoneNo || address.phoneNo\"></i> {{address.phoneNo}}<span ng-if=\"address.altPhoneNo && address.phoneNo\">&nbsp;/&nbsp;</span> {{address.altPhoneNo}}</div></div><div class=\"row\" ng-if=\"address.inEdit\"><div class=\"col-md-12 m-b-sm\"><input id=\"label\" name=\"label\" type=\"text\" placeholder=\"Title or label\" class=\"form-control input-sm\" ng-model=\"address.label\" maxlength=\"30\"></div></div><div class=\"row\" ng-if=\"address.inEdit\"><div class=\"col-md-12 m-b-sm\"><textarea id=\"main\" name=\"main\" type=\"text\" placeholder=\"#, Building, Street address...\" class=\"form-control input-sm\" ng-model=\"address.main\" required=\"\"></textarea><div validation-result=\"\" myform=\"editUser\" element=\"main\" required-text=\"Please specify the full street address\"></div></div></div><div class=\"row\" ng-if=\"address.inEdit\"><div class=\"col-sm-6 col-md-8 m-b-sm\"><input id=\"city\" name=\"city\" type=\"text\" placeholder=\"City *\" class=\"form-control input-sm\" ng-model=\"address.city\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"city\" required-text=\"Please specify the city\"></div></div><div class=\"col-sm-3 col-md-2 m-b-sm\"><input id=\"state\" name=\"state\" type=\"text\" placeholder=\"State *\" class=\"form-control input-sm\" ng-model=\"address.state\" maxlength=\"3\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"state\" required-text=\"Please specify the state (max 3 letters)\"></div></div><div class=\"col-sm-3 col-md-2 m-b-sm\"><input id=\"zip\" name=\"zip\" type=\"text\" placeholder=\"Zip *\" class=\"form-control input-sm\" ng-model=\"address.zip\" maxlength=\"15\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"zip\" required-text=\"Please specify the Zip / Postal Code\"></div></div></div><div class=\"row\" ng-if=\"address.inEdit\"><div class=\"col-sm-6 m-b-sm\"><input id=\"phoneNo\" name=\"phoneNo\" type=\"text\" placeholder=\"Phone\" class=\"form-control input-sm\" ng-model=\"address.phoneNo\" maxlength=\"15\"></div><div class=\"col-sm-6 m-b-sm\"><input id=\"altPhoneNo\" name=\"altPhoneNo\" type=\"text\" placeholder=\"Alt Phone\" class=\"form-control input-sm\" ng-model=\"address.altPhoneNo\" maxlength=\"15\"></div></div><div class=\"row\" ng-if=\"address.inEdit\"><div class=\"col-md-12\"><label for=\"sendMail\"><input icheck=\"\" name=\"sendMail\" type=\"checkbox\" ng-model=\"address.sendMail\"> Use this address for postal mail?</label></div></div><div class=\"row\"><div class=\"col-md-12\"><a ng-if=\"!address.inEdit\" class=\"btn btn-white btn-xs m-r-sm m-b-xs\" ng-click=\"addressesCtrl.editAddress(address)\" title=\"Edit Address or Guardian\"><span class=\"fa fa-pencil\"></span> Edit</a> <a buttonspinner=\"\" ng-disabled=\"address.deleting\" ng-if=\"!address.inEdit\" class=\"buttonspinner-button btn btn-danger btn-xs m-b-xs\" data-style=\"expand-left\" ng-click=\"addressesCtrl.removeAddress($index, address)\" title=\"Delete Address or Guardian\"><span class=\"fa fa-trash\"></span> Delete</a> <a buttonspinner=\"\" ng-disabled=\"address.saving\" ng-if=\"address.inEdit\" class=\"buttonspinner-button btn btn-primary btn-xs m-r-sm m-b-xs\" data-style=\"expand-left\" ng-click=\"addressesCtrl.saveAddress(editUser, address)\" title=\"Save Address or Guardian\"><span class=\"fa fa-check\"></span> Save</a> <a ng-if=\"address.inEdit\" class=\"btn btn-white btn-xs m-b-xs\" ng-click=\"addressesCtrl.cancelEditAddress($index, address)\" title=\"Cancel Edit\"><span class=\"fa fa-times\"></span> Cancel</a></div></div><hr></ng-form></div><button ng-if=\"addressesCtrl.loaded\" class=\"btn btn-primary btn-sm\" ng-click=\"addressesCtrl.addAddress()\" title=\"Add New Address or Contact Details\"><i class=\"fa fa-plus\"></i> Add new <span class=\"min-tablet\">address</span></button><div ng-if=\"!addressesCtrl.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"addressesCtrl.cancel()\">Close</button></div></div>");
$templateCache.put("app/manage/users/csv.import.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-upload modal-icon\"></i><h4 class=\"modal-title\">Importing CSV</h4></div><div class=\"modal-body\"><div ng-if=\"csvModalCtrl.uploading\" spinner-wave=\"\"></div><div ng-if=\"!csvModalCtrl.uploading\"><strong>Total Rows:</strong> {{csvModalCtrl.result.totalRows}}<br><strong>Header Row Found:</strong> {{csvModalCtrl.result.headerFound ? \'Yes\' : \'No\'}}<br><strong>Valid Data Rows:</strong> {{csvModalCtrl.result.validRows}}<br><br><strong>Rows Added ({{csvModalCtrl.result.newRows.length}}):</strong><br><span ng-repeat=\"row in csvModalCtrl.result.newRows\">{{row}}<br></span> <span ng-if=\"!csvModalCtrl.result.newRows.length\">No new rows added<br></span><br><strong>Existing Rows Updated ({{csvModalCtrl.result.updatedRows.length}}):</strong><br><span ng-repeat=\"row in csvModalCtrl.result.updatedRows\">{{row}}<br></span> <span ng-if=\"!csvModalCtrl.result.updatedRows.length\">No existing rows updated<br></span><br><span class=\"label label-success\">Import Completed</span></div></div><div class=\"modal-footer\" ng-if=\"!csvModalCtrl.uploading\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"csvModalCtrl.cancel()\">Close</button></div></div>");
$templateCache.put("app/manage/users/department.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-graduation-cap modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"!deptCtrl.department.departmentId\">Create a new department</h4><h4 class=\"modal-title\" ng-if=\"deptCtrl.department.departmentId\">{{deptCtrl.department.name}}</h4><small class=\"font-bold\">Enter your department details below.</small></div><form name=\"editDepartment\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label for=\"departmentName\" class=\"required\">Department name</label> <input id=\"departmentName\" name=\"departmentName\" type=\"text\" ng-model=\"deptCtrl.department.name\" placeholder=\"Enter a name for the department\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editDepartment\" element=\"departmentName\" required-text=\"Please specify a name\"></div></div><div class=\"form-group\"><label for=\"departmentLocation\">Location</label><input id=\"departmentLocation\" name=\"departmentLocation\" type=\"text\" ng-model=\"deptCtrl.department.location\" placeholder=\"Enter the address/location of the department on campus\" class=\"form-control\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"deptCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"deptCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"deptCtrl.ok(editDepartment)\" data-style=\"expand-left\">Save</button></div></form></div>");
$templateCache.put("app/manage/users/group.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-users modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"!groupCtrl.group.departmentGroupId\">Create a new class / batch</h4><h4 class=\"modal-title\" ng-if=\"groupCtrl.group.departmentGroupId\">{{groupCtrl.group.name}}</h4><small class=\"font-bold\">Enter your class / batch details below.</small></div><form name=\"editGroup\" novalidate=\"\"><div class=\"modal-body\"><div class=\"form-group\"><label for=\"groupName\" class=\"required\">Class / Batch name</label> <input id=\"groupName\" name=\"groupName\" type=\"text\" ng-model=\"groupCtrl.group.name\" placeholder=\"Enter a name for the class or batch\" class=\"form-control\" required=\"\"><div validation-result=\"\" myform=\"editGroup\" element=\"groupName\" required-text=\"Please specify a name\"></div></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"department\" class=\"required\">Department</label></div><select chosen=\"{width: \'100%\'}\" id=\"department\" name=\"department\" class=\"chosen-select\" style=\"width:100%;\" ng-change=\"groupCtrl.onDepartmentChanged()\" ng-model=\"groupCtrl.group.departmentId\" ng-options=\"dept.departmentId as dept.name for dept in groupCtrl.departments\" data-placeholder-text-single=\"\'Select a department\'\" no-results-text=\"\'No departments found\'\" required=\"\"></select><div validation-result=\"\" myform=\"editGroup\" element=\"department\" required-text=\"Please specify a department\"></div></div><div class=\"form-group\"><div class=\"input-group\"><label for=\"courses\">Courses</label></div><ui-select id=\"courses\" name=\"courses\" multiple=\"\" ng-model=\"groupCtrl.group.courseIds\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one or more courses\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"course.courseId as course in groupCtrl.courses | filter: {name: $select.search}\"><div ng-bind-html=\"course.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"groupCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"groupCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"groupCtrl.ok(editGroup)\" data-style=\"expand-left\">Save</button></div></form></div>");
$templateCache.put("app/manage/users/manage.admins.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>System Admins</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>System Admins</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search...\" class=\"input form-control\" ng-model=\"adminsCtrl.filter\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn btn-primary\"><i class=\"fa fa-search\"></i> Search</button></span></div><div class=\"clients-list\"><div class=\"p-xxs no-margins clearfix\"><button ng-click=\"adminsCtrl.newAdmin()\" type=\"button\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"New Admin\"><i class=\"fa fa-plus\"></i> New</button> <a href=\"/Api/Admins/Csv\" target=\"_blank\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"Download Admins as CSV\"><i class=\"fa fa-download\"></i> Download as CSV</a><div class=\"pull-left m-r-xs\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file btn-xs\"><span class=\"fileinput-new\">Import from CSV</span><span class=\"fileinput-exists\">Change CSV File</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"adminsCtrl.adminsCsv\" set-file-data=\"adminsCtrl.adminsCsv = value;\"></span></div></div><button ng-click=\"adminsCtrl.uploadCsv()\" class=\"pull-left btn btn-primary btn-xs\" title=\"Upload CSV to Import Admins\" ng-show=\"adminsCtrl.adminsCsv\"><i class=\"fa fa-upload\"></i> Confirm CSV Upload</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" ng-if=\"!adminsCtrl.loadingAdmins\"><tbody><tr ng-repeat=\"admin in adminsCtrl.admins | filter: adminsCtrl.filter | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{admin.firstName}} {{admin.lastName}}\" ng-src=\"{{admin.profilePic}}\"></td><td><a ng-click=\"adminsCtrl.openAdmin(admin.userId)\" class=\"client-link\">{{admin.firstName}} {{admin.lastName}}</a></td><td class=\"contact-type\"><i class=\"fa fa-envelope\"></i></td><td>{{admin.emailId}}</td><td class=\"client-status\"><span class=\"label label-primary\">Active</span></td></tr></tbody></table><div ng-if=\"adminsCtrl.loadingAdmins\" spinner-wave=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/manage/users/manage.users.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Departments and Users</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"base.main\">Home</a></li><li>Manage</li><li class=\"active\"><strong>Departments and Users</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div ng-class=\"{\'col-sm-8\':users.openSection,\'col-sm-12\':!users.openSection}\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search...\" class=\"input form-control\" ng-model=\"users.filter\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn btn-primary\"><i class=\"fa fa-search\"></i> Search</button></span></div><div class=\"clients-list\"><ul class=\"nav nav-tabs\"><li ng-class=\"{\'active\' : tab == 1}\"><a ng-click=\"tab = 1\" ng-init=\"tab = 1\"><i class=\"fa fa-briefcase\"></i> <span ng-if=\"!users.openSection\">Departments</span></a></li><li ng-class=\"{\'active\' : tab == 2}\"><a ng-click=\"tab = 2;users.getEducators();\"><i class=\"fa fa-user\"></i> <span ng-if=\"!users.openSection\">Educators</span></a></li><li ng-class=\"{\'active\' : tab == 3}\"><a ng-click=\"tab = 3;users.getGroups();\"><i class=\"fa fa-users\"></i> <span ng-if=\"!users.openSection\">Classes / Batches</span></a></li><li ng-class=\"{\'active\' : tab == 4}\"><a ng-click=\"tab = 4;users.getStudents();\"><i class=\"fa fa-user\"></i> <span ng-if=\"!users.openSection\">Students</span></a></li></ul><div class=\"tab-content\"><div id=\"tab-1\" class=\"tab-pane active\" ng-show=\"tab == 1\"><div class=\"p-xxs no-margins clearfix\"><button ng-click=\"users.newDepartment()\" type=\"button\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"New Department\"><i class=\"fa fa-plus\"></i> New</button> <a href=\"/Api/Departments/Csv\" target=\"_blank\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"Download Departments as CSV\"><i class=\"fa fa-download\"></i> Download as CSV</a><div class=\"pull-left m-r-xs\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file btn-xs\"><span class=\"fileinput-new\">Import from CSV</span><span class=\"fileinput-exists\">Change CSV File</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"users.departmentsCsv\" set-file-data=\"users.departmentsCsv = value;\"></span></div></div><button ng-click=\"users.uploadCsv(\'Departments\')\" class=\"pull-left btn btn-primary btn-xs\" title=\"Upload CSV to Import Departments\" ng-show=\"users.departmentsCsv\"><i class=\"fa fa-upload\"></i> Confirm CSV Upload</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" ng-if=\"!users.loadingDepartments\"><tbody><tr ng-repeat=\"department in users.departments | filter: users.filter | orderBy:\'name\'\"><td><a ng-click=\"users.historyStack=[];users.openDepartment(department.departmentId)\" class=\"client-link\" title=\"{{department.name}}\">{{department.name}}</a></td><td>{{department.location}}</td><td class=\"client-status\"><span class=\"label label-primary\">Active</span></td></tr></tbody></table><div ng-if=\"users.loadingDepartments\" spinner-wave=\"\"></div></div></div></div><div id=\"tab-2\" class=\"tab-pane active\" ng-show=\"tab == 2\"><div class=\"p-xxs no-margins clearfix\"><button ng-click=\"users.newEducator()\" type=\"button\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"New Educator\"><i class=\"fa fa-plus\"></i> New</button> <a href=\"/Api/Educators/Csv\" target=\"_blank\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"Download Educators as CSV\"><i class=\"fa fa-download\"></i> Download as CSV</a><div class=\"pull-left m-r-xs\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file btn-xs\"><span class=\"fileinput-new\">Import from CSV</span><span class=\"fileinput-exists\">Change CSV File</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"users.educatorsCsv\" set-file-data=\"users.educatorsCsv = value;\"></span></div></div><button ng-click=\"users.uploadCsv(\'Educators\')\" class=\"pull-left btn btn-primary btn-xs\" title=\"Upload CSV to Import Educators\" ng-show=\"users.educatorsCsv\"><i class=\"fa fa-upload\"></i> Confirm CSV Upload</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" ng-if=\"!users.loadingEducators\"><tbody><tr ng-repeat=\"educator in users.educators | filter: users.filter | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{educator.title}} {{educator.firstName}} {{educator.lastName}}\" ng-src=\"{{educator.profilePic}}\"></td><td><a ng-click=\"users.historyStack=[];users.openEducator(educator.userId)\" class=\"client-link\">{{educator.title}} {{educator.firstName}} {{educator.lastName}}</a></td><td><span ng-repeat=\"dept in educator.departmentObjs\">{{dept.name}}<span ng-if=\"($index + 1) < educator.departmentObjs.length\">,&nbsp;</span></span></td><td class=\"contact-type\"><i class=\"fa fa-envelope\"></i></td><td>{{educator.emailId}}</td><td class=\"client-status\"><span class=\"label label-primary\">Active</span></td></tr></tbody></table><div ng-if=\"users.loadingEducators\" spinner-wave=\"\"></div></div></div></div><div id=\"tab-3\" class=\"tab-pane active\" ng-show=\"tab == 3\"><div class=\"p-xxs no-margins clearfix\"><button ng-click=\"users.newGroup()\" type=\"button\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"New Class/Batch\"><i class=\"fa fa-plus\"></i> New</button> <a href=\"/Api/Groups/Csv\" target=\"_blank\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"Download Classes/Batches as CSV\"><i class=\"fa fa-download\"></i> Download as CSV</a><div class=\"pull-left m-r-xs\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file btn-xs\"><span class=\"fileinput-new\">Import from CSV</span><span class=\"fileinput-exists\">Change CSV File</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"users.groupsCsv\" set-file-data=\"users.groupsCsv = value;\"></span></div></div><button ng-click=\"users.uploadCsv(\'Groups\')\" class=\"pull-left btn btn-primary btn-xs\" title=\"Upload CSV to Import Classes/Batches\" ng-show=\"users.groupsCsv\"><i class=\"fa fa-upload\"></i> Confirm CSV Upload</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" ng-if=\"!users.loadingGroups\"><tbody><tr ng-repeat=\"group in users.groups | filter: users.filter | orderBy:\'name\'\"><td><a ng-click=\"users.historyStack=[];users.openGroup(group.departmentGroupId)\" class=\"client-link\">{{group.name}}</a></td><td>{{group.departmentName}}</td><td class=\"client-status\"><span class=\"label label-primary\">{{group.studentCount}} <span ng-if=\"group.studentCount==1\">student</span><span ng-if=\"group.studentCount!=1\">students</span></span></td></tr></tbody></table><div ng-if=\"users.loadingGroups\" spinner-wave=\"\"></div></div></div></div><div id=\"tab-4\" class=\"tab-pane active\" ng-show=\"tab == 4\"><div class=\"p-xxs no-margins clearfix\"><button ng-click=\"users.newStudent()\" type=\"button\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"New Student\"><i class=\"fa fa-plus\"></i> New</button> <a href=\"/Api/Students/Csv\" target=\"_blank\" class=\"pull-left m-r-xs btn btn-primary btn-xs\" title=\"Download Students as CSV\"><i class=\"fa fa-download\"></i> Download as CSV</a><div class=\"pull-left m-r-xs\"><div class=\"fileinput fileinput-new input-group\" data-provides=\"fileinput\"><span class=\"btn btn-default btn-file btn-xs\"><span class=\"fileinput-new\">Import from CSV</span><span class=\"fileinput-exists\">Change CSV File</span><input type=\"file\" id=\"fileUpload\" name=\"...\" file-model=\"users.studentsCsv\" set-file-data=\"users.studentsCsv = value;\"></span></div></div><button ng-click=\"users.uploadCsv(\'Students\')\" class=\"pull-left btn btn-primary btn-xs\" title=\"Upload CSV to Import Students\" ng-show=\"users.studentsCsv\"><i class=\"fa fa-upload\"></i> Confirm CSV Upload</button></div><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" ng-if=\"!users.loadingStudents\"><tbody><tr ng-repeat=\"student in users.students | filter: users.filter | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{student.firstName}} {{student.lastName}}\" ng-src=\"{{student.profilePic}}\"></td><td><a ng-click=\"users.historyStack=[];users.openStudent(student.userId)\" class=\"client-link\">{{student.firstName}} {{student.lastName}}</a></td><td><span ng-repeat=\"dept in student.departmentObjs\">{{dept.name}}<span ng-if=\"($index + 1) < student.departmentObjs.length\">,&nbsp;</span></span></td><td class=\"contact-type\"><i class=\"fa fa-envelope\"></i></td><td>{{student.emailId}}</td><td class=\"client-status\"><span class=\"label label-primary\">Active</span></td></tr></tbody></table><div ng-if=\"users.loadingStudents\" spinner-wave=\"\"></div></div></div></div></div></div></div></div></div><div class=\"col-sm-4\" ng-if=\"users.openSection\"><div class=\"ibox\"><div class=\"ibox-title\"><div ibox-tools=\"\" closebox=\"users.closeSection()\"><a href=\"\" ng-click=\"users.goBack()\" ng-if=\"users.historyStack.length\" class=\"pull-left\" title=\"Go Back\"><i class=\"fa fa-chevron-left\"></i> Back</a></div></div><div class=\"ibox-content\"><div class=\"tab-content\"><div ng-if=\"users.opening\" spinner-wave=\"\"></div><div class=\"tab-pane active\" ng-if=\"!users.opening && users.openSection == \'Department\'\"><div class=\"m-b-lg\"><button ng-click=\"users.editDepartment(users.department)\" class=\"btn btn-white btn-xs pull-right\" title=\"Edit Department\">edit</button><h2>{{users.department.name}}</h2><p>{{users.department.location}}</p></div><div><strong>Educators</strong><ui-select id=\"taEducators\" name=\"taEducators\" multiple=\"\" ng-model=\"users.taDeptEducators\" theme=\"bootstrap\" title=\"Add Educators\" on-select=\"users.onTAEducatorSelect()\"><ui-select-match placeholder=\"Type to search and add educators...\"></ui-select-match><ui-select-choices refresh=\"users.getTAEducators($select.search)\" refresh-delay=\"100\" repeat=\"person as person in users.taEducators | filter: $select.search\"><img img-placeholder=\"user\" alt=\"{{person.title + \' \' + person.firstName + \' \' + person.lastName}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{person.profilePicUrl}}\"> <span ng-bind-html=\"person.title + \' \' + person.firstName + \' \' + person.lastName | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"!users.department.educatorsCount\"><em>No educators in this department yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.department.educators | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{row.firstName}} {{row.lastName}}\" ng-src=\"{{row.profilePic}}\"></td><td><a ng-click=\"users.historyStack.push(\'Department\');users.openEducator(row.userId)\" class=\"client-link\">{{row.firstName}} {{row.lastName}}</a></td></tr></tbody></table></div><uib-pagination ng-if=\"users.department.educatorsCount > users.pageSize\" total-items=\"users.department.educatorsCount\" items-per-page=\"users.pageSize\" ng-model=\"users.currentPage[\'Department\'][\'Educators\']\" ng-change=\"users.loadPage(\'Department\',users.department.departmentId,\'Educators\')\" max-size=\"5\" force-ellipses=\"true\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination><hr><strong>Classes / Batches</strong><div ng-if=\"!users.department.groupsCount\"><em>No classes / batches in this department yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.department.groups | orderBy:[\'name\']\"><td><a ng-click=\"users.historyStack.push(\'Department\');users.openGroup(row.departmentGroupId)\" class=\"client-link\">{{row.name}}</a></td></tr></tbody></table></div><uib-pagination ng-if=\"users.department.groupsCount > users.pageSize\" total-items=\"users.department.groupsCount\" items-per-page=\"users.pageSize\" ng-model=\"users.currentPage[\'Department\'][\'Groups\']\" ng-change=\"users.loadPage(\'Department\',users.department.departmentId,\'Groups\')\" max-size=\"5\" force-ellipses=\"true\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination><hr><strong>Students</strong><ui-select id=\"taStudents\" name=\"taStudents\" multiple=\"\" ng-model=\"users.taDeptStudents\" theme=\"bootstrap\" title=\"Add Students\" on-select=\"users.onDeptTAStudentSelect()\"><ui-select-match placeholder=\"Type to search and add students...\"></ui-select-match><ui-select-choices refresh=\"users.getTAStudents($select.search)\" refresh-delay=\"100\" repeat=\"person as person in users.taStudents | filter: $select.search\"><img img-placeholder=\"user\" alt=\"{{person.firstName + \' \' + person.lastName}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{person.profilePicUrl}}\"> <span ng-bind-html=\"person.firstName + \' \' + person.lastName | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"!users.department.studentsCount\"><em>No students in this department yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.department.students | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{row.firstName}} {{row.lastName}}\" ng-src=\"{{row.profilePic}}\"></td><td><a ng-click=\"users.historyStack.push(\'Department\');users.openStudent(row.userId)\" class=\"client-link\">{{row.firstName}} {{row.lastName}}</a></td></tr></tbody></table></div><uib-pagination ng-if=\"users.department.studentsCount > users.pageSize\" total-items=\"users.department.studentsCount\" items-per-page=\"users.pageSize\" ng-model=\"users.currentPage[\'Department\'][\'Students\']\" ng-change=\"users.loadPage(\'Department\',users.department.departmentId,\'Students\')\" max-size=\"5\" force-ellipses=\"true\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div><div class=\"tab-pane active\" ng-if=\"!users.opening && users.openSection == \'Educator\'\"><div class=\"m-b-lg\"><button ng-click=\"users.editEducator(users.educator)\" class=\"btn btn-white btn-xs pull-right\" title=\"Edit Educator\">edit</button><h2>{{users.educator.title}} {{users.educator.firstName}} {{users.educator.lastName}}</h2><div class=\"m-b-sm\"><img alt=\"{{users.educator.title}} {{users.educator.firstName}} {{users.educator.lastName}}\" class=\"img-circle\" ng-src=\"{{educator.profilePic}}\" style=\"width: 62px\"></div></div><div><strong>Departments</strong><div ng-if=\"!users.educator.departmentsCount\"><em>This educator has not been assigned to any department yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.educator.departments | orderBy:[\'name\']\"><td><a ng-click=\"users.historyStack.push(\'Educator\');users.openDepartment(row.departmentId)\" class=\"client-link\">{{row.name}}</a></td></tr></tbody></table></div></div></div><div class=\"tab-pane active\" ng-if=\"!users.opening && users.openSection == \'Group\'\"><div class=\"m-b-lg\"><button ng-click=\"users.editGroup(users.group)\" class=\"btn btn-white btn-xs pull-right\" title=\"Edit Group\">edit</button><h2>{{users.group.name}}</h2><p>{{users.group.departmentName}}</p></div><div class=\"m-b-lg\"><strong>Students</strong><ui-select id=\"taStudents\" name=\"taStudents\" multiple=\"\" ng-model=\"users.taDeptStudents\" theme=\"bootstrap\" title=\"Add Students\" on-select=\"users.onGroupTAStudentSelect()\"><ui-select-match placeholder=\"Type to search and add students...\"></ui-select-match><ui-select-choices refresh=\"users.getTAStudents($select.search)\" refresh-delay=\"100\" repeat=\"person as person in users.taStudents | filter: $select.search\"><img img-placeholder=\"user\" alt=\"{{person.firstName + \' \' + person.lastName}}\" class=\"img-circle img-nav-profile\" ng-src=\"{{person.profilePicUrl}}\"> <span ng-bind-html=\"person.firstName + \' \' + person.lastName | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"!users.group.studentsCount\"><em>No students in this class/batch yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.group.students | orderBy:[\'firstName\',\'lastName\']\"><td class=\"client-avatar\"><img alt=\"{{row.firstName}} {{row.lastName}}\" ng-src=\"{{row.profilePic}}\"></td><td><a ng-click=\"users.historyStack.push(\'Group\');users.openStudent(row.userId)\" class=\"client-link\">{{row.firstName}} {{row.lastName}}</a></td></tr></tbody></table></div><uib-pagination ng-if=\"users.group.studentsCount > users.pageSize\" total-items=\"users.group.studentsCount\" items-per-page=\"users.pageSize\" ng-model=\"users.currentPage[\'Group\'][\'Students\']\" ng-change=\"users.loadPage(\'Group\',users.group.departmentGroupId,\'Students\')\" max-size=\"5\" force-ellipses=\"true\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div><div><strong>Courses</strong><div ng-if=\"!users.group.coursesCount\"><em>No courses assigned yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.group.courses | orderBy:[\'name\']\"><td><a ui-sref=\"base.course.index({id:row.courseId})\" class=\"client-link\">{{row.name}}</a></td></tr></tbody></table></div></div></div><div class=\"tab-pane active\" ng-if=\"!users.opening && users.openSection == \'Student\'\"><div class=\"m-b-lg\"><button ng-click=\"users.editStudent(users.student)\" class=\"btn btn-white btn-xs pull-right m-l-xs\" title=\"Edit Student\">edit</button><h2>{{users.student.firstName}} {{users.student.lastName}}</h2><div class=\"m-b-sm\"><img alt=\"{{users.student.firstName}} {{users.student.lastName}}\" class=\"img-circle\" ng-src=\"{{student.profilePic}}\" style=\"width: 62px\"></div><div class=\"m-b-sm\"><button ng-click=\"users.editParents(users.student.userId)\" class=\"btn btn-white btn-sm\" title=\"View and Edit Parents or Guardians\">View Parents / Guardians</button></div><div class=\"m-b-sm\"><button ng-click=\"users.editAddresses(users.student.userId)\" class=\"btn btn-white btn-sm\" title=\"View and Edit Addresses and Contact Details\">View Addresses / Contact Details</button></div></div><div><strong>Departments</strong><div ng-if=\"!users.student.departmentsCount\"><em>This student has not been assigned to any department yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.student.departments | orderBy:[\'name\']\"><td><a ng-click=\"users.historyStack.push(\'Student\');users.openDepartment(row.departmentId)\" class=\"client-link\">{{row.name}}</a></td></tr></tbody></table></div><hr><strong>Classes / Batches</strong><div ng-if=\"!users.student.groupsCount\"><em>This student has not been assigned to any class / batch yet</em></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover no-margins\"><tbody><tr ng-repeat=\"row in users.student.groups | orderBy:[\'name\']\"><td><a ng-click=\"users.historyStack.push(\'Student\');users.openGroup(row.departmentGroupId)\" class=\"client-link\">{{row.name}}</a></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/manage/users/parents.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-user modal-icon\"></i><h4 class=\"modal-title\">Parents / Guardians</h4><small class=\"font-bold\">Enter details of this student\'s parents and/or guardians below.</small></div><div class=\"modal-body\"><div ng-repeat=\"parent in parentsCtrl.parents\"><ng-form name=\"editUser\"><div class=\"row m-b-sm\" ng-if=\"!parent.inEdit\"><div class=\"col-md-12\"><strong>{{parent.firstName}} {{parent.lastName}}<span ng-if=\"parent.gender\">({{parent.gender}})</span>, <em>{{parent.relationship}}</em></strong><br><i class=\"fa fa-at\" ng-if=\"parent.emailId\"></i> {{parent.emailId}}<span ng-if=\"parent.emailId && (parent.mobileNo || parent.phoneNo || parent.altPhoneNo)\">,&nbsp;</span> <i class=\"fa fa-mobile\" ng-if=\"parent.mobileNo\"></i> {{parent.mobileNo}}<span ng-if=\"parent.mobileNo && parent.phoneNo\">&nbsp;/&nbsp;</span> <i class=\"fa fa-phone\" ng-if=\"parent.altPhoneNo || parent.phoneNo\"></i> {{parent.phoneNo}}<span ng-if=\"parent.altPhoneNo && (parent.emailId || parent.phoneNo)\">&nbsp;/&nbsp;</span> {{parent.altPhoneNo}}</div></div><div class=\"row\" ng-if=\"parent.inEdit\"><div class=\"col-sm-5 m-b-sm\"><input id=\"firstName\" name=\"firstName\" type=\"text\" placeholder=\"First Name *\" class=\"form-control input-sm\" ng-model=\"parent.firstName\" maxlength=\"50\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"firstName\" required-text=\"Please specify a first name\"></div></div><div class=\"col-sm-5 m-b-sm\"><input id=\"lastName\" name=\"lastName\" type=\"text\" placeholder=\"Last Name *\" class=\"form-control input-sm\" ng-model=\"parent.lastName\" maxlength=\"50\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"lastName\" required-text=\"Please specify a last name\"></div></div><div class=\"col-sm-2 m-b-sm\"><select chosen=\"\" id=\"gender\" name=\"gender\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"parent.gender\" ng-options=\"gender for gender in parentsCtrl.genders\" data-placeholder-text-single=\"\'Gender\'\"></select></div></div><div class=\"row\" ng-if=\"parent.inEdit\"><div class=\"col-sm-6 m-b-sm\"><input id=\"relationship\" name=\"relationship\" type=\"text\" placeholder=\"Relationship *\" class=\"form-control input-sm\" ng-model=\"parent.relationship\" maxlength=\"20\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"relationship\" required-text=\"Please specify relationship to student\"></div></div><div class=\"col-sm-6 m-b-sm\"><input id=\"emailId\" name=\"emailId\" type=\"email\" placeholder=\"Email\" class=\"form-control input-sm\" ng-model=\"parent.emailId\" maxlength=\"256\"></div></div><div class=\"row\" ng-if=\"parent.inEdit\"><div class=\"col-sm-4 m-b-sm\"><input id=\"mobileNo\" name=\"mobileNo\" type=\"text\" placeholder=\"Mobile\" class=\"form-control input-sm\" ng-model=\"parent.mobileNo\" maxlength=\"15\"></div><div class=\"col-sm-4 m-b-sm\"><input id=\"phoneNo\" name=\"phoneNo\" type=\"text\" placeholder=\"Phone\" class=\"form-control input-sm\" ng-model=\"parent.phoneNo\" maxlength=\"15\"></div><div class=\"col-sm-4 m-b-sm\"><input id=\"altPhoneNo\" name=\"altPhoneNo\" type=\"text\" placeholder=\"Alt Phone\" class=\"form-control input-sm\" ng-model=\"parent.altPhoneNo\" maxlength=\"15\"></div></div><div class=\"row\"><div class=\"col-md-12\"><a ng-if=\"!parent.inEdit\" class=\"btn btn-white btn-xs m-r-sm m-b-xs\" ng-click=\"parentsCtrl.editParent(parent)\" title=\"Edit Parent or Guardian\"><span class=\"fa fa-pencil\"></span> Edit</a> <a buttonspinner=\"\" ng-disabled=\"parent.deleting\" ng-if=\"!parent.inEdit\" class=\"buttonspinner-button btn btn-danger btn-xs m-b-xs\" data-style=\"expand-left\" ng-click=\"parentsCtrl.removeParent($index, parent)\" title=\"Delete Parent or Guardian\"><span class=\"fa fa-trash\"></span> Delete</a> <a buttonspinner=\"\" ng-disabled=\"parent.saving\" ng-if=\"parent.inEdit\" class=\"buttonspinner-button btn btn-primary btn-xs m-r-sm m-b-xs\" data-style=\"expand-left\" ng-click=\"parentsCtrl.saveParent(editUser, parent)\" title=\"Save Parent or Guardian\"><span class=\"fa fa-check\"></span> Save</a> <a ng-if=\"parent.inEdit\" class=\"btn btn-white btn-xs m-b-xs\" ng-click=\"parentsCtrl.cancelEditParent($index, parent)\" title=\"Cancel Edit\"><span class=\"fa fa-times\"></span> Cancel</a></div></div><hr></ng-form></div><button ng-if=\"parentsCtrl.loaded\" class=\"btn btn-primary btn-sm\" ng-click=\"parentsCtrl.addParent()\" title=\"Add New Parent or Guardian\"><i class=\"fa fa-plus\"></i> Add new <span class=\"min-tablet\">parent / guardian</span></button><div ng-if=\"!parentsCtrl.loaded\" spinner-wave=\"\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"parentsCtrl.cancel()\">Close</button></div></div>");
$templateCache.put("app/manage/users/user.modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-user modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"!userCtrl.user.userId\">Create a new user</h4><h4 class=\"modal-title\" ng-if=\"userCtrl.user.userId\">{{userCtrl.user.name}}</h4><small class=\"font-bold\">Enter the details below.</small></div><form name=\"editUser\" novalidate=\"\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-2\" ng-if=\"userCtrl.isEducator\"><div class=\"input-group\"><label for=\"title\">Title</label></div><select chosen=\"\" id=\"title\" name=\"title\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"userCtrl.user.title\" ng-options=\"title for title in userCtrl.titles\" data-placeholder-text-single=\"\'Title\'\"></select></div><div ng-class=\"{\'col-md-5\': userCtrl.isEducator, \'col-md-6\': !userCtrl.isEducator}\"><div class=\"form-group\"><label for=\"firstName\" class=\"required\">First name</label> <input id=\"firstName\" name=\"firstName\" type=\"text\" class=\"form-control\" placeholder=\"First name\" ng-model=\"userCtrl.user.firstName\" maxlength=\"50\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"firstName\" required-text=\"Please specify a first name\"></div></div></div><div ng-class=\"{\'col-md-5\': userCtrl.isEducator, \'col-md-6\': !userCtrl.isEducator}\"><div class=\"form-group\"><label for=\"lastName\" class=\"required\">Last name</label> <input id=\"lastName\" name=\"lastName\" type=\"text\" class=\"form-control\" placeholder=\"Last name\" ng-model=\"userCtrl.user.lastName\" maxlength=\"50\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"lastName\" required-text=\"Please specify a last name\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-if=\"!userCtrl.isEducator\"><div class=\"form-group\"><label for=\"studentId\" class=\"required\">Student ID</label> <input id=\"studentId\" name=\"studentId\" type=\"text\" class=\"form-control\" placeholder=\"Student ID\" ng-model=\"userCtrl.user.studentId\" maxlength=\"20\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"studentId\" required-text=\"Please specify a student id\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"input-group\"><label for=\"gender\">Gender</label></div><select chosen=\"\" id=\"gender\" name=\"gender\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"userCtrl.user.gender\" ng-options=\"gender for gender in userCtrl.genders\" data-placeholder-text-single=\"\'\'\"></select></div></div></div><div class=\"form-group\"><label for=\"emailId\" class=\"required\">Email</label> <input id=\"emailId\" name=\"emailId\" type=\"email\" ng-model=\"userCtrl.user.emailId\" ng-disabled=\"userCtrl.user.userId\" placeholder=\"Email\" class=\"form-control\" maxlength=\"256\" required=\"\"><div validation-result=\"\" myform=\"editUser\" element=\"lastName\" required-text=\"Please specify an email id\"></div></div><div class=\"row\" ng-if=\"!userCtrl.isAdmin\"><div class=\"col-md-12\"><div class=\"input-group\"><label for=\"departments\">Departments</label></div><select multiple=\"\" chosen=\"{width: \'100%\'}\" ng-change=\"userCtrl.onDepartmentsChanged()\" id=\"departments\" name=\"departments\" class=\"chosen-select\" style=\"width:100%;\" ng-model=\"userCtrl.user.departmentIds\" ng-options=\"dept.departmentId as dept.name for dept in userCtrl.departments\" data-placeholder-text-multiple=\"\'Select one or more departments\'\" no-results-text=\"\'No departments found\'\"></select></div></div><div class=\"row\" ng-if=\"!userCtrl.isAdmin && !userCtrl.isEducator && userCtrl.groups\"><div class=\"col-md-12\"><div class=\"input-group\"><label for=\"classes\">Classes / Batches</label></div><ui-select id=\"classes\" name=\"classes\" multiple=\"\" ng-model=\"userCtrl.user.groupIds\" theme=\"bootstrap\" style=\"width:100%\"><ui-select-match placeholder=\"Select one or more classes/batches\">{{$item.departmentName}}: {{$item.name}}</ui-select-match><ui-select-choices repeat=\"group.departmentGroupId as group in userCtrl.groups | filter: {name: $select.search}\" group-by=\"\'departmentName\'\"><div ng-bind-html=\"group.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"userCtrl.cancel()\">Close</button> <button buttonspinner=\"\" ng-disabled=\"userCtrl.saving\" type=\"submit\" class=\"buttonspinner-button btn btn-primary\" ng-click=\"userCtrl.ok(editUser)\" data-style=\"expand-left\">Save</button></div></form></div>");
$templateCache.put("app/components/directives/opentok-whiteboard/opentok-whiteboard.html","<div class=\"no-margins clearfix toolbar\"><div class=\"btn-group no-margins pull-left\"><button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'freehand\'\" ng-class=\"{selected:drawTool==\'freehand\'}\" title=\"Freehand\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'line\'\" ng-class=\"{selected:drawTool==\'line\'}\" title=\"Draw Straight Line\"><i class=\"fa fa-arrows-h\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'rect\'\" ng-class=\"{selected:drawTool==\'rect\'}\" title=\"Draw Rectangle\"><i class=\"fa fa-square-o\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'rect-fill\'\" ng-class=\"{selected:drawTool==\'rect-fill\'}\" title=\"Draw Filled Rectangle\"><i class=\"fa fa-square\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'circle\'\" ng-class=\"{selected:drawTool==\'circle\'}\" title=\"Draw Circle\"><i class=\"fa fa-circle-thin\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'circle-fill\'\" ng-class=\"{selected:drawTool==\'circle-fill\'}\" title=\"Draw Filled Circle\"><i class=\"fa fa-circle\"></i></button><div class=\"btn btn-white btn-sm no-border-radius\" colorpicker=\"\" ng-model=\"color\" style=\"background-color:{{color}}\" title=\"Change Outline Color\"><i class=\"fa\"></i></div><div class=\"btn btn-white btn-sm no-border-radius\" colorpicker=\"\" ng-model=\"fillcolor\" style=\"background-color:{{fillcolor}}\" title=\"Change Fill Color\"><i class=\"fa\"></i></div><button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"drawTool=\'eraser\'\" ng-class=\"{selected:drawTool==\'eraser\'}\" title=\"Eraser\"><i class=\"fa fa-eraser\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"capture()\" title=\"Export to PNG\"><i class=\"fa fa-download\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"undo()\" title=\"Undo\"><i class=\"fa fa-undo\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"redo()\" title=\"Redo\"><i class=\"fa fa-repeat\"></i></button> <button class=\"btn btn-white btn-sm no-border-radius\" type=\"button\" ng-click=\"clear()\" title=\"Clear Board\"><i class=\"fa fa-ban\"></i></button></div></div><canvas hidpi=\"off\"></canvas>");}]);